/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
  [_ in K]?: never
}
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string }
  String: { input: string; output: string }
  Boolean: { input: boolean; output: boolean }
  Int: { input: number; output: number }
  Float: { input: number; output: number }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any }
}

export type AiImage = {
  __typename?: 'AIImage'
  large: Scalars['String']['output']
  renditions: Array<AiImageRendition>
  roomConfidence?: Maybe<Scalars['Float']['output']>
  roomDescription: Scalars['String']['output']
  roomLabel: Scalars['String']['output']
  roomLabelConfirmed?: Maybe<Scalars['Boolean']['output']>
  roomLabelMargin?: Maybe<Scalars['Float']['output']>
  roomLabelPredicted?: Maybe<Scalars['String']['output']>
  /** Display rotation in degrees (0, 90, 180, 270) */
  rotation?: Maybe<Scalars['Int']['output']>
  small: Scalars['String']['output']
}

export type AiImageCreateInput = {
  large: Scalars['String']['input']
  renditions?: InputMaybe<Array<AiImageRenditionCreateInput>>
  roomConfidence?: InputMaybe<Scalars['Float']['input']>
  roomDescription: Scalars['String']['input']
  roomLabel: Scalars['String']['input']
  roomLabelConfirmed?: InputMaybe<Scalars['Boolean']['input']>
  roomLabelMargin?: InputMaybe<Scalars['Float']['input']>
  roomLabelPredicted?: InputMaybe<Scalars['String']['input']>
  rotation?: InputMaybe<Scalars['Int']['input']>
  small: Scalars['String']['input']
}

export type AiImageObjectEqualityInput = {
  large: Scalars['String']['input']
  renditions?: InputMaybe<Array<AiImageRenditionObjectEqualityInput>>
  roomConfidence?: InputMaybe<Scalars['Float']['input']>
  roomDescription: Scalars['String']['input']
  roomLabel: Scalars['String']['input']
  roomLabelConfirmed?: InputMaybe<Scalars['Boolean']['input']>
  roomLabelMargin?: InputMaybe<Scalars['Float']['input']>
  roomLabelPredicted?: InputMaybe<Scalars['String']['input']>
  rotation?: InputMaybe<Scalars['Int']['input']>
  small: Scalars['String']['input']
}

export type AiImageOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type AiImageRendition = {
  __typename?: 'AIImageRendition'
  height: Scalars['Int']['output']
  slot: Scalars['String']['output']
  url: Scalars['String']['output']
  width: Scalars['Int']['output']
}

export type AiImageRenditionCreateInput = {
  height: Scalars['Int']['input']
  slot: Scalars['String']['input']
  url: Scalars['String']['input']
  width: Scalars['Int']['input']
}

export type AiImageRenditionObjectEqualityInput = {
  height: Scalars['Int']['input']
  slot: Scalars['String']['input']
  url: Scalars['String']['input']
  width: Scalars['Int']['input']
}

export type AdImages = {
  __typename?: 'AdImages'
  large: Array<Scalars['String']['output']>
  small: Array<Scalars['String']['output']>
}

export type AdImagesCreateInput = {
  large?: InputMaybe<AdImagesCreatelargeInput>
  small?: InputMaybe<AdImagesCreatesmallInput>
}

export type AdImagesCreatelargeInput = {
  set: Array<Scalars['String']['input']>
}

export type AdImagesCreatesmallInput = {
  set: Array<Scalars['String']['input']>
}

export type AdImagesNullableCompositeFilter = {
  equals?: InputMaybe<AdImagesObjectEqualityInput>
  is?: InputMaybe<AdImagesWhereInput>
  isNot?: InputMaybe<AdImagesWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type AdImagesNullableCreateEnvelopeInput = {
  set?: InputMaybe<AdImagesCreateInput>
}

export type AdImagesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<AdImagesCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<AdImagesUpsertInput>
}

export type AdImagesObjectEqualityInput = {
  large?: InputMaybe<Array<Scalars['String']['input']>>
  small?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AdImagesOrderByInput = {
  large?: InputMaybe<SortOrder>
  small?: InputMaybe<SortOrder>
}

export type AdImagesUpdateInput = {
  large?: InputMaybe<AdImagesUpdatelargeInput>
  small?: InputMaybe<AdImagesUpdatesmallInput>
}

export type AdImagesUpdatelargeInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AdImagesUpdatesmallInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type AdImagesUpsertInput = {
  set: AdImagesCreateInput
  update: AdImagesUpdateInput
}

export type AdImagesWhereInput = {
  AND?: InputMaybe<Array<AdImagesWhereInput>>
  NOT?: InputMaybe<Array<AdImagesWhereInput>>
  OR?: InputMaybe<Array<AdImagesWhereInput>>
  large?: InputMaybe<StringNullableListFilter>
  small?: InputMaybe<StringNullableListFilter>
}

export type AddFavoriteInput = {
  propertyShortRef?: Scalars['String']['input']
}

export type Address = {
  __typename?: 'Address'
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  countryCode?: Maybe<Scalars['String']['output']>
  countryName?: Maybe<Scalars['String']['output']>
  county?: Maybe<Scalars['String']['output']>
  district?: Maybe<Scalars['String']['output']>
  label?: Maybe<Scalars['String']['output']>
  postalCode?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  stateCode?: Maybe<Scalars['String']['output']>
  street?: Maybe<Scalars['String']['output']>
}

export type AddressContext = {
  __typename?: 'AddressContext'
  address_number?: Maybe<Scalars['String']['output']>
  mapbox_id: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
  street_name?: Maybe<Scalars['String']['output']>
}

export type AddressContextCreateInput = {
  address_number?: InputMaybe<Scalars['String']['input']>
  mapbox_id: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  street_name?: InputMaybe<Scalars['String']['input']>
}

export type AddressContextNullableCompositeFilter = {
  equals?: InputMaybe<AddressContextObjectEqualityInput>
  is?: InputMaybe<AddressContextWhereInput>
  isNot?: InputMaybe<AddressContextWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type AddressContextNullableUpdateEnvelopeInput = {
  set?: InputMaybe<AddressContextCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<AddressContextUpsertInput>
}

export type AddressContextObjectEqualityInput = {
  address_number?: InputMaybe<Scalars['String']['input']>
  mapbox_id: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
  street_name?: InputMaybe<Scalars['String']['input']>
}

export type AddressContextOrderByInput = {
  address_number?: InputMaybe<SortOrder>
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  street_name?: InputMaybe<SortOrder>
}

export type AddressContextUpdateInput = {
  address_number?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapbox_id?: InputMaybe<StringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  street_name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type AddressContextUpsertInput = {
  set: AddressContextCreateInput
  update: AddressContextUpdateInput
}

export type AddressContextWhereInput = {
  AND?: InputMaybe<Array<AddressContextWhereInput>>
  NOT?: InputMaybe<Array<AddressContextWhereInput>>
  OR?: InputMaybe<Array<AddressContextWhereInput>>
  address_number?: InputMaybe<StringNullableFilter>
  mapbox_id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringNullableFilter>
  street_name?: InputMaybe<StringNullableFilter>
}

export type AddressCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  countryName?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  district?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  countryName?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  district?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export type AddressNullableCompositeFilter = {
  equals?: InputMaybe<AddressObjectEqualityInput>
  is?: InputMaybe<AddressWhereInput>
  isNot?: InputMaybe<AddressWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type AddressNullableUpdateEnvelopeInput = {
  set?: InputMaybe<AddressCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<AddressUpsertInput>
}

export type AddressObjectEqualityInput = {
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  countryCode?: InputMaybe<Scalars['String']['input']>
  countryName?: InputMaybe<Scalars['String']['input']>
  county?: InputMaybe<Scalars['String']['input']>
  district?: InputMaybe<Scalars['String']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  postalCode?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  stateCode?: InputMaybe<Scalars['String']['input']>
  street?: InputMaybe<Scalars['String']['input']>
}

export type AddressOrderByInput = {
  city?: InputMaybe<SortOrder>
  country?: InputMaybe<SortOrder>
  countryCode?: InputMaybe<SortOrder>
  countryName?: InputMaybe<SortOrder>
  county?: InputMaybe<SortOrder>
  district?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  postalCode?: InputMaybe<SortOrder>
  state?: InputMaybe<SortOrder>
  stateCode?: InputMaybe<SortOrder>
  street?: InputMaybe<SortOrder>
}

export type AddressUpdateInput = {
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  countryCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  countryName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  county?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  district?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  state?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  stateCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  street?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type AddressUpsertInput = {
  set: AddressCreateInput
  update: AddressUpdateInput
}

export type AddressWhereInput = {
  AND?: InputMaybe<Array<AddressWhereInput>>
  NOT?: InputMaybe<Array<AddressWhereInput>>
  OR?: InputMaybe<Array<AddressWhereInput>>
  city?: InputMaybe<StringNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  countryCode?: InputMaybe<StringNullableFilter>
  countryName?: InputMaybe<StringNullableFilter>
  county?: InputMaybe<StringNullableFilter>
  district?: InputMaybe<StringNullableFilter>
  label?: InputMaybe<StringNullableFilter>
  postalCode?: InputMaybe<StringNullableFilter>
  state?: InputMaybe<StringNullableFilter>
  stateCode?: InputMaybe<StringNullableFilter>
  street?: InputMaybe<StringNullableFilter>
}

export type AdminLoginResponse = {
  __typename?: 'AdminLoginResponse'
  accessToken: Scalars['String']['output']
  user: AdminUserModel
}

export type AdminUserAgencyAssocModel = {
  __typename?: 'AdminUserAgencyAssocModel'
  agencyId: Scalars['String']['output']
  agencyName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  userId?: Maybe<Scalars['String']['output']>
  userType: Scalars['String']['output']
}

export type AdminUserModel = {
  __typename?: 'AdminUserModel'
  active: Scalars['Boolean']['output']
  agency?: Maybe<Broker>
  agencyId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  loginHistory?: Maybe<Array<LoginHistoryModel>>
  permissions?: Maybe<Array<Scalars['String']['output']>>
  roles: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  userAgencies?: Maybe<Array<AdminUserAgencyAssocModel>>
  userPermissions?: Maybe<Array<UserPermissionModel>>
}

export type Advertiser = {
  __typename?: 'Advertiser'
  _count?: Maybe<AdvertiserCount>
  contact?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  propertyCardAds: Array<PropertyCardAd>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  website?: Maybe<Scalars['String']['output']>
}

export type AdvertiserPropertyCardAdsArgs = {
  cursor?: InputMaybe<PropertyCardAdWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyCardAdScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyCardAdOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyCardAdWhereInput>
}

export type AdvertiserCount = {
  __typename?: 'AdvertiserCount'
  propertyCardAds: Scalars['Int']['output']
}

export type AdvertiserCountPropertyCardAdsArgs = {
  where?: InputMaybe<PropertyCardAdWhereInput>
}

export type AdvertiserCreateNestedOneWithoutPropertyCardAdsInput = {
  connect?: InputMaybe<AdvertiserWhereUniqueInput>
  connectOrCreate?: InputMaybe<AdvertiserCreateOrConnectWithoutPropertyCardAdsInput>
  create?: InputMaybe<AdvertiserCreateWithoutPropertyCardAdsInput>
}

export type AdvertiserCreateOrConnectWithoutPropertyCardAdsInput = {
  create: AdvertiserCreateWithoutPropertyCardAdsInput
  where: AdvertiserWhereUniqueInput
}

export type AdvertiserCreateWithoutPropertyCardAdsInput = {
  contact?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type AdvertiserInput = {
  contact?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  type?: Scalars['String']['input']
  website?: InputMaybe<Scalars['String']['input']>
}

export type AdvertiserNullableRelationFilter = {
  is?: InputMaybe<AdvertiserWhereInput>
  isNot?: InputMaybe<AdvertiserWhereInput>
}

export type AdvertiserOrderByWithRelationInput = {
  contact?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  propertyCardAds?: InputMaybe<PropertyCardAdOrderByRelationAggregateInput>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  website?: InputMaybe<SortOrder>
}

export type AdvertiserUpdateInput = {
  contact?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
}

export type AdvertiserUpdateOneWithoutPropertyCardAdsNestedInput = {
  connect?: InputMaybe<AdvertiserWhereUniqueInput>
  connectOrCreate?: InputMaybe<AdvertiserCreateOrConnectWithoutPropertyCardAdsInput>
  create?: InputMaybe<AdvertiserCreateWithoutPropertyCardAdsInput>
  delete?: InputMaybe<AdvertiserWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<AdvertiserUpdateToOneWithWhereWithoutPropertyCardAdsInput>
  upsert?: InputMaybe<AdvertiserUpsertWithoutPropertyCardAdsInput>
}

export type AdvertiserUpdateToOneWithWhereWithoutPropertyCardAdsInput = {
  data: AdvertiserUpdateWithoutPropertyCardAdsInput
  where?: InputMaybe<AdvertiserWhereInput>
}

export type AdvertiserUpdateWithoutPropertyCardAdsInput = {
  contact?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type AdvertiserUpsertWithoutPropertyCardAdsInput = {
  create: AdvertiserCreateWithoutPropertyCardAdsInput
  update: AdvertiserUpdateWithoutPropertyCardAdsInput
  where?: InputMaybe<AdvertiserWhereInput>
}

export type AdvertiserWhereInput = {
  AND?: InputMaybe<Array<AdvertiserWhereInput>>
  NOT?: InputMaybe<Array<AdvertiserWhereInput>>
  OR?: InputMaybe<Array<AdvertiserWhereInput>>
  contact?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  propertyCardAds?: InputMaybe<PropertyCardAdListRelationFilter>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  website?: InputMaybe<StringNullableFilter>
}

export type AdvertiserWhereUniqueInput = {
  AND?: InputMaybe<Array<AdvertiserWhereInput>>
  NOT?: InputMaybe<Array<AdvertiserWhereInput>>
  OR?: InputMaybe<Array<AdvertiserWhereInput>>
  contact?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<StringFilter>
  propertyCardAds?: InputMaybe<PropertyCardAdListRelationFilter>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  website?: InputMaybe<StringNullableFilter>
}

export type AffectedRowsOutput = {
  __typename?: 'AffectedRowsOutput'
  count: Scalars['Int']['output']
}

export type AgencyContactInfoUpdateInput = {
  address?: InputMaybe<AddressInput>
  email?: InputMaybe<Scalars['String']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  whatsapp?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type AgencyDistributionModel = {
  __typename?: 'AgencyDistributionModel'
  agencyId: Scalars['String']['output']
  agencyName: Scalars['String']['output']
  managerCount: Scalars['Float']['output']
  regularUserCount: Scalars['Float']['output']
  userCount: Scalars['Float']['output']
}

/**
 * Audit-style event log for agency actions (properties, promotions, settings, etc.)
 * Always associated with a broker (agency); optionally associated with a property.
 */
export type AgencyHistory = {
  __typename?: 'AgencyHistory'
  actorEmail?: Maybe<Scalars['String']['output']>
  actorUserId?: Maybe<Scalars['String']['output']>
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  id: Scalars['String']['output']
  meta?: Maybe<Scalars['JSON']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type AgencyHistoryCreateManyBrokerInput = {
  actorEmail?: InputMaybe<Scalars['String']['input']>
  actorUserId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  meta?: InputMaybe<Scalars['JSON']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  type: Scalars['String']['input']
}

export type AgencyHistoryCreateManyBrokerInputEnvelope = {
  data: Array<AgencyHistoryCreateManyBrokerInput>
}

export type AgencyHistoryCreateManyPropertyInput = {
  actorEmail?: InputMaybe<Scalars['String']['input']>
  actorUserId?: InputMaybe<Scalars['String']['input']>
  brokerId: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  meta?: InputMaybe<Scalars['JSON']['input']>
  type: Scalars['String']['input']
}

export type AgencyHistoryCreateManyPropertyInputEnvelope = {
  data: Array<AgencyHistoryCreateManyPropertyInput>
}

export type AgencyHistoryCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<AgencyHistoryCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<AgencyHistoryCreateWithoutBrokerInput>>
  createMany?: InputMaybe<AgencyHistoryCreateManyBrokerInputEnvelope>
}

export type AgencyHistoryCreateNestedManyWithoutPropertyInput = {
  connect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<AgencyHistoryCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<AgencyHistoryCreateWithoutPropertyInput>>
  createMany?: InputMaybe<AgencyHistoryCreateManyPropertyInputEnvelope>
}

export type AgencyHistoryCreateOrConnectWithoutBrokerInput = {
  create: AgencyHistoryCreateWithoutBrokerInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryCreateOrConnectWithoutPropertyInput = {
  create: AgencyHistoryCreateWithoutPropertyInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryCreateWithoutBrokerInput = {
  actorEmail?: InputMaybe<Scalars['String']['input']>
  actorUserId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  meta?: InputMaybe<Scalars['JSON']['input']>
  property?: InputMaybe<PropertyCreateNestedOneWithoutAgencyHistoryInput>
  type: Scalars['String']['input']
}

export type AgencyHistoryCreateWithoutPropertyInput = {
  actorEmail?: InputMaybe<Scalars['String']['input']>
  actorUserId?: InputMaybe<Scalars['String']['input']>
  broker: BrokerCreateNestedOneWithoutAgencyHistoryInput
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  meta?: InputMaybe<Scalars['JSON']['input']>
  type: Scalars['String']['input']
}

export type AgencyHistoryFeedEntry = {
  __typename?: 'AgencyHistoryFeedEntry'
  createdAt: Scalars['DateTimeISO']['output']
  id: Scalars['String']['output']
  propertyId?: Maybe<Scalars['String']['output']>
  propertyRef?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type AgencyHistoryListRelationFilter = {
  every?: InputMaybe<AgencyHistoryWhereInput>
  none?: InputMaybe<AgencyHistoryWhereInput>
  some?: InputMaybe<AgencyHistoryWhereInput>
}

export type AgencyHistoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type AgencyHistoryOrderByWithRelationInput = {
  actorEmail?: InputMaybe<SortOrder>
  actorUserId?: InputMaybe<SortOrder>
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  meta?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
}

export enum AgencyHistoryScalarFieldEnum {
  ActorEmail = 'actorEmail',
  ActorUserId = 'actorUserId',
  BrokerId = 'brokerId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Meta = 'meta',
  PropertyId = 'propertyId',
  Type = 'type',
}

export type AgencyHistoryScalarWhereInput = {
  AND?: InputMaybe<Array<AgencyHistoryScalarWhereInput>>
  NOT?: InputMaybe<Array<AgencyHistoryScalarWhereInput>>
  OR?: InputMaybe<Array<AgencyHistoryScalarWhereInput>>
  actorEmail?: InputMaybe<StringNullableFilter>
  actorUserId?: InputMaybe<StringNullableFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  meta?: InputMaybe<JsonNullableFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  type?: InputMaybe<StringFilter>
}

export type AgencyHistoryUpdateManyMutationInput = {
  actorEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  actorUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  meta?: InputMaybe<Scalars['JSON']['input']>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type AgencyHistoryUpdateManyWithWhereWithoutBrokerInput = {
  data: AgencyHistoryUpdateManyMutationInput
  where: AgencyHistoryScalarWhereInput
}

export type AgencyHistoryUpdateManyWithWhereWithoutPropertyInput = {
  data: AgencyHistoryUpdateManyMutationInput
  where: AgencyHistoryScalarWhereInput
}

export type AgencyHistoryUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<AgencyHistoryCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<AgencyHistoryCreateWithoutBrokerInput>>
  createMany?: InputMaybe<AgencyHistoryCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<AgencyHistoryScalarWhereInput>>
  disconnect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  set?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  update?: InputMaybe<Array<AgencyHistoryUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<AgencyHistoryUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<AgencyHistoryUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type AgencyHistoryUpdateManyWithoutPropertyNestedInput = {
  connect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<AgencyHistoryCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<AgencyHistoryCreateWithoutPropertyInput>>
  createMany?: InputMaybe<AgencyHistoryCreateManyPropertyInputEnvelope>
  delete?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<AgencyHistoryScalarWhereInput>>
  disconnect?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  set?: InputMaybe<Array<AgencyHistoryWhereUniqueInput>>
  update?: InputMaybe<Array<AgencyHistoryUpdateWithWhereUniqueWithoutPropertyInput>>
  updateMany?: InputMaybe<Array<AgencyHistoryUpdateManyWithWhereWithoutPropertyInput>>
  upsert?: InputMaybe<Array<AgencyHistoryUpsertWithWhereUniqueWithoutPropertyInput>>
}

export type AgencyHistoryUpdateWithWhereUniqueWithoutBrokerInput = {
  data: AgencyHistoryUpdateWithoutBrokerInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryUpdateWithWhereUniqueWithoutPropertyInput = {
  data: AgencyHistoryUpdateWithoutPropertyInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryUpdateWithoutBrokerInput = {
  actorEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  actorUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  meta?: InputMaybe<Scalars['JSON']['input']>
  property?: InputMaybe<PropertyUpdateOneWithoutAgencyHistoryNestedInput>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type AgencyHistoryUpdateWithoutPropertyInput = {
  actorEmail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  actorUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneRequiredWithoutAgencyHistoryNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  meta?: InputMaybe<Scalars['JSON']['input']>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type AgencyHistoryUpsertWithWhereUniqueWithoutBrokerInput = {
  create: AgencyHistoryCreateWithoutBrokerInput
  update: AgencyHistoryUpdateWithoutBrokerInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryUpsertWithWhereUniqueWithoutPropertyInput = {
  create: AgencyHistoryCreateWithoutPropertyInput
  update: AgencyHistoryUpdateWithoutPropertyInput
  where: AgencyHistoryWhereUniqueInput
}

export type AgencyHistoryWhereInput = {
  AND?: InputMaybe<Array<AgencyHistoryWhereInput>>
  NOT?: InputMaybe<Array<AgencyHistoryWhereInput>>
  OR?: InputMaybe<Array<AgencyHistoryWhereInput>>
  actorEmail?: InputMaybe<StringNullableFilter>
  actorUserId?: InputMaybe<StringNullableFilter>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  meta?: InputMaybe<JsonNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  type?: InputMaybe<StringFilter>
}

export type AgencyHistoryWhereUniqueInput = {
  AND?: InputMaybe<Array<AgencyHistoryWhereInput>>
  NOT?: InputMaybe<Array<AgencyHistoryWhereInput>>
  OR?: InputMaybe<Array<AgencyHistoryWhereInput>>
  actorEmail?: InputMaybe<StringNullableFilter>
  actorUserId?: InputMaybe<StringNullableFilter>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  meta?: InputMaybe<JsonNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  type?: InputMaybe<StringFilter>
}

export type AgencyListingStatsDual = {
  __typename?: 'AgencyListingStatsDual'
  agency: ListingStatsSummary
  bostello: ListingStatsSummary
  brokerId: Scalars['String']['output']
}

export type AgencyOperationResponse = {
  __typename?: 'AgencyOperationResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AgencyPortalApplicationSettings = {
  __typename?: 'AgencyPortalApplicationSettings'
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  dateFormat: Scalars['String']['output']
  display: AgencyPortalDisplay
  id: Scalars['String']['output']
  integrations: AgencyPortalIntegrations
  language: Scalars['String']['output']
  notifications: AgencyPortalNotifications
  privacy: AgencyPortalPrivacy
  theme: Scalars['String']['output']
  timeFormat: Scalars['String']['output']
  timezone: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type AgencyPortalApplicationSettingsCreateInput = {
  broker: BrokerCreateNestedOneWithoutAgencyPortalApplicationSettingsInput
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  dateFormat?: InputMaybe<Scalars['String']['input']>
  display: AgencyPortalDisplayCreateEnvelopeInput
  id?: InputMaybe<Scalars['String']['input']>
  integrations: AgencyPortalIntegrationsCreateEnvelopeInput
  language?: InputMaybe<Scalars['String']['input']>
  notifications: AgencyPortalNotificationsCreateEnvelopeInput
  privacy: AgencyPortalPrivacyCreateEnvelopeInput
  theme?: InputMaybe<Scalars['String']['input']>
  timeFormat?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput = {
  connect?: InputMaybe<AgencyPortalApplicationSettingsWhereUniqueInput>
  connectOrCreate?: InputMaybe<AgencyPortalApplicationSettingsCreateOrConnectWithoutBrokerInput>
  create?: InputMaybe<AgencyPortalApplicationSettingsCreateWithoutBrokerInput>
}

export type AgencyPortalApplicationSettingsCreateOrConnectWithoutBrokerInput = {
  create: AgencyPortalApplicationSettingsCreateWithoutBrokerInput
  where: AgencyPortalApplicationSettingsWhereUniqueInput
}

export type AgencyPortalApplicationSettingsCreateWithoutBrokerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  dateFormat?: InputMaybe<Scalars['String']['input']>
  display: AgencyPortalDisplayCreateEnvelopeInput
  id?: InputMaybe<Scalars['String']['input']>
  integrations: AgencyPortalIntegrationsCreateEnvelopeInput
  language?: InputMaybe<Scalars['String']['input']>
  notifications: AgencyPortalNotificationsCreateEnvelopeInput
  privacy: AgencyPortalPrivacyCreateEnvelopeInput
  theme?: InputMaybe<Scalars['String']['input']>
  timeFormat?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type AgencyPortalApplicationSettingsNullableRelationFilter = {
  is?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
  isNot?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
}

export type AgencyPortalApplicationSettingsOrderByWithRelationInput = {
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  dateFormat?: InputMaybe<SortOrder>
  display?: InputMaybe<AgencyPortalDisplayOrderByInput>
  id?: InputMaybe<SortOrder>
  integrations?: InputMaybe<AgencyPortalIntegrationsOrderByInput>
  language?: InputMaybe<SortOrder>
  notifications?: InputMaybe<AgencyPortalNotificationsOrderByInput>
  privacy?: InputMaybe<AgencyPortalPrivacyOrderByInput>
  theme?: InputMaybe<SortOrder>
  timeFormat?: InputMaybe<SortOrder>
  timezone?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum AgencyPortalApplicationSettingsScalarFieldEnum {
  BrokerId = 'brokerId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DateFormat = 'dateFormat',
  Id = 'id',
  Language = 'language',
  Theme = 'theme',
  TimeFormat = 'timeFormat',
  Timezone = 'timezone',
  UpdatedAt = 'updatedAt',
}

export type AgencyPortalApplicationSettingsUpdateInput = {
  broker?: InputMaybe<BrokerUpdateOneRequiredWithoutAgencyPortalApplicationSettingsNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  dateFormat?: InputMaybe<StringFieldUpdateOperationsInput>
  display?: InputMaybe<AgencyPortalDisplayUpdateEnvelopeInput>
  integrations?: InputMaybe<AgencyPortalIntegrationsUpdateEnvelopeInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  notifications?: InputMaybe<AgencyPortalNotificationsUpdateEnvelopeInput>
  privacy?: InputMaybe<AgencyPortalPrivacyUpdateEnvelopeInput>
  theme?: InputMaybe<StringFieldUpdateOperationsInput>
  timeFormat?: InputMaybe<StringFieldUpdateOperationsInput>
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput = {
  connect?: InputMaybe<AgencyPortalApplicationSettingsWhereUniqueInput>
  connectOrCreate?: InputMaybe<AgencyPortalApplicationSettingsCreateOrConnectWithoutBrokerInput>
  create?: InputMaybe<AgencyPortalApplicationSettingsCreateWithoutBrokerInput>
  delete?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
  disconnect?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
  update?: InputMaybe<AgencyPortalApplicationSettingsUpdateToOneWithWhereWithoutBrokerInput>
  upsert?: InputMaybe<AgencyPortalApplicationSettingsUpsertWithoutBrokerInput>
}

export type AgencyPortalApplicationSettingsUpdateToOneWithWhereWithoutBrokerInput = {
  data: AgencyPortalApplicationSettingsUpdateWithoutBrokerInput
  where?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
}

export type AgencyPortalApplicationSettingsUpdateWithoutBrokerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  dateFormat?: InputMaybe<StringFieldUpdateOperationsInput>
  display?: InputMaybe<AgencyPortalDisplayUpdateEnvelopeInput>
  integrations?: InputMaybe<AgencyPortalIntegrationsUpdateEnvelopeInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  notifications?: InputMaybe<AgencyPortalNotificationsUpdateEnvelopeInput>
  privacy?: InputMaybe<AgencyPortalPrivacyUpdateEnvelopeInput>
  theme?: InputMaybe<StringFieldUpdateOperationsInput>
  timeFormat?: InputMaybe<StringFieldUpdateOperationsInput>
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type AgencyPortalApplicationSettingsUpsertWithoutBrokerInput = {
  create: AgencyPortalApplicationSettingsCreateWithoutBrokerInput
  update: AgencyPortalApplicationSettingsUpdateWithoutBrokerInput
  where?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
}

export type AgencyPortalApplicationSettingsWhereInput = {
  AND?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  dateFormat?: InputMaybe<StringFilter>
  display?: InputMaybe<AgencyPortalDisplayCompositeFilter>
  id?: InputMaybe<StringFilter>
  integrations?: InputMaybe<AgencyPortalIntegrationsCompositeFilter>
  language?: InputMaybe<StringFilter>
  notifications?: InputMaybe<AgencyPortalNotificationsCompositeFilter>
  privacy?: InputMaybe<AgencyPortalPrivacyCompositeFilter>
  theme?: InputMaybe<StringFilter>
  timeFormat?: InputMaybe<StringFilter>
  timezone?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type AgencyPortalApplicationSettingsWhereUniqueInput = {
  AND?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalApplicationSettingsWhereInput>>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  dateFormat?: InputMaybe<StringFilter>
  display?: InputMaybe<AgencyPortalDisplayCompositeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  integrations?: InputMaybe<AgencyPortalIntegrationsCompositeFilter>
  language?: InputMaybe<StringFilter>
  notifications?: InputMaybe<AgencyPortalNotificationsCompositeFilter>
  privacy?: InputMaybe<AgencyPortalPrivacyCompositeFilter>
  theme?: InputMaybe<StringFilter>
  timeFormat?: InputMaybe<StringFilter>
  timezone?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type AgencyPortalDisplay = {
  __typename?: 'AgencyPortalDisplay'
  compactMode: Scalars['Boolean']['output']
  defaultView: Scalars['String']['output']
  showAvatars: Scalars['Boolean']['output']
  showBadges: Scalars['Boolean']['output']
}

export type AgencyPortalDisplayCompositeFilter = {
  equals?: InputMaybe<AgencyPortalDisplayObjectEqualityInput>
  is?: InputMaybe<AgencyPortalDisplayWhereInput>
  isNot?: InputMaybe<AgencyPortalDisplayWhereInput>
}

export type AgencyPortalDisplayCreateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalDisplayCreateInput>
}

export type AgencyPortalDisplayCreateInput = {
  compactMode?: InputMaybe<Scalars['Boolean']['input']>
  defaultView?: InputMaybe<Scalars['String']['input']>
  showAvatars?: InputMaybe<Scalars['Boolean']['input']>
  showBadges?: InputMaybe<Scalars['Boolean']['input']>
}

export type AgencyPortalDisplayObjectEqualityInput = {
  compactMode: Scalars['Boolean']['input']
  defaultView: Scalars['String']['input']
  showAvatars: Scalars['Boolean']['input']
  showBadges: Scalars['Boolean']['input']
}

export type AgencyPortalDisplayOrderByInput = {
  compactMode?: InputMaybe<SortOrder>
  defaultView?: InputMaybe<SortOrder>
  showAvatars?: InputMaybe<SortOrder>
  showBadges?: InputMaybe<SortOrder>
}

export type AgencyPortalDisplayUpdateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalDisplayCreateInput>
  update?: InputMaybe<AgencyPortalDisplayUpdateInput>
}

export type AgencyPortalDisplayUpdateInput = {
  compactMode?: InputMaybe<BoolFieldUpdateOperationsInput>
  defaultView?: InputMaybe<StringFieldUpdateOperationsInput>
  showAvatars?: InputMaybe<BoolFieldUpdateOperationsInput>
  showBadges?: InputMaybe<BoolFieldUpdateOperationsInput>
}

export type AgencyPortalDisplayWhereInput = {
  AND?: InputMaybe<Array<AgencyPortalDisplayWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalDisplayWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalDisplayWhereInput>>
  compactMode?: InputMaybe<BoolFilter>
  defaultView?: InputMaybe<StringFilter>
  showAvatars?: InputMaybe<BoolFilter>
  showBadges?: InputMaybe<BoolFilter>
}

export type AgencyPortalIntegrations = {
  __typename?: 'AgencyPortalIntegrations'
  emailProvider?: Maybe<Scalars['String']['output']>
  kyeroFeedUrl?: Maybe<Scalars['String']['output']>
  mapboxToken?: Maybe<Scalars['String']['output']>
  smsProvider?: Maybe<Scalars['String']['output']>
}

export type AgencyPortalIntegrationsCompositeFilter = {
  equals?: InputMaybe<AgencyPortalIntegrationsObjectEqualityInput>
  is?: InputMaybe<AgencyPortalIntegrationsWhereInput>
  isNot?: InputMaybe<AgencyPortalIntegrationsWhereInput>
}

export type AgencyPortalIntegrationsCreateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalIntegrationsCreateInput>
}

export type AgencyPortalIntegrationsCreateInput = {
  emailProvider?: InputMaybe<Scalars['String']['input']>
  kyeroFeedUrl?: InputMaybe<Scalars['String']['input']>
  mapboxToken?: InputMaybe<Scalars['String']['input']>
  smsProvider?: InputMaybe<Scalars['String']['input']>
}

export type AgencyPortalIntegrationsObjectEqualityInput = {
  emailProvider?: InputMaybe<Scalars['String']['input']>
  kyeroFeedUrl?: InputMaybe<Scalars['String']['input']>
  mapboxToken?: InputMaybe<Scalars['String']['input']>
  smsProvider?: InputMaybe<Scalars['String']['input']>
}

export type AgencyPortalIntegrationsOrderByInput = {
  emailProvider?: InputMaybe<SortOrder>
  kyeroFeedUrl?: InputMaybe<SortOrder>
  mapboxToken?: InputMaybe<SortOrder>
  smsProvider?: InputMaybe<SortOrder>
}

export type AgencyPortalIntegrationsUpdateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalIntegrationsCreateInput>
  update?: InputMaybe<AgencyPortalIntegrationsUpdateInput>
}

export type AgencyPortalIntegrationsUpdateInput = {
  emailProvider?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  kyeroFeedUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapboxToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  smsProvider?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type AgencyPortalIntegrationsWhereInput = {
  AND?: InputMaybe<Array<AgencyPortalIntegrationsWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalIntegrationsWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalIntegrationsWhereInput>>
  emailProvider?: InputMaybe<StringNullableFilter>
  kyeroFeedUrl?: InputMaybe<StringNullableFilter>
  mapboxToken?: InputMaybe<StringNullableFilter>
  smsProvider?: InputMaybe<StringNullableFilter>
}

export type AgencyPortalNotifications = {
  __typename?: 'AgencyPortalNotifications'
  email: Scalars['Boolean']['output']
  push: Scalars['Boolean']['output']
  sms: Scalars['Boolean']['output']
}

export type AgencyPortalNotificationsCompositeFilter = {
  equals?: InputMaybe<AgencyPortalNotificationsObjectEqualityInput>
  is?: InputMaybe<AgencyPortalNotificationsWhereInput>
  isNot?: InputMaybe<AgencyPortalNotificationsWhereInput>
}

export type AgencyPortalNotificationsCreateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalNotificationsCreateInput>
}

export type AgencyPortalNotificationsCreateInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>
  push?: InputMaybe<Scalars['Boolean']['input']>
  sms?: InputMaybe<Scalars['Boolean']['input']>
}

export type AgencyPortalNotificationsObjectEqualityInput = {
  email: Scalars['Boolean']['input']
  push: Scalars['Boolean']['input']
  sms: Scalars['Boolean']['input']
}

export type AgencyPortalNotificationsOrderByInput = {
  email?: InputMaybe<SortOrder>
  push?: InputMaybe<SortOrder>
  sms?: InputMaybe<SortOrder>
}

export type AgencyPortalNotificationsUpdateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalNotificationsCreateInput>
  update?: InputMaybe<AgencyPortalNotificationsUpdateInput>
}

export type AgencyPortalNotificationsUpdateInput = {
  email?: InputMaybe<BoolFieldUpdateOperationsInput>
  push?: InputMaybe<BoolFieldUpdateOperationsInput>
  sms?: InputMaybe<BoolFieldUpdateOperationsInput>
}

export type AgencyPortalNotificationsWhereInput = {
  AND?: InputMaybe<Array<AgencyPortalNotificationsWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalNotificationsWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalNotificationsWhereInput>>
  email?: InputMaybe<BoolFilter>
  push?: InputMaybe<BoolFilter>
  sms?: InputMaybe<BoolFilter>
}

export type AgencyPortalPrivacy = {
  __typename?: 'AgencyPortalPrivacy'
  activityVisibility: Scalars['String']['output']
  dataSharing: Scalars['String']['output']
  profileVisibility: Scalars['String']['output']
}

export type AgencyPortalPrivacyCompositeFilter = {
  equals?: InputMaybe<AgencyPortalPrivacyObjectEqualityInput>
  is?: InputMaybe<AgencyPortalPrivacyWhereInput>
  isNot?: InputMaybe<AgencyPortalPrivacyWhereInput>
}

export type AgencyPortalPrivacyCreateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalPrivacyCreateInput>
}

export type AgencyPortalPrivacyCreateInput = {
  activityVisibility?: InputMaybe<Scalars['String']['input']>
  dataSharing?: InputMaybe<Scalars['String']['input']>
  profileVisibility?: InputMaybe<Scalars['String']['input']>
}

export type AgencyPortalPrivacyObjectEqualityInput = {
  activityVisibility: Scalars['String']['input']
  dataSharing: Scalars['String']['input']
  profileVisibility: Scalars['String']['input']
}

export type AgencyPortalPrivacyOrderByInput = {
  activityVisibility?: InputMaybe<SortOrder>
  dataSharing?: InputMaybe<SortOrder>
  profileVisibility?: InputMaybe<SortOrder>
}

export type AgencyPortalPrivacyUpdateEnvelopeInput = {
  set?: InputMaybe<AgencyPortalPrivacyCreateInput>
  update?: InputMaybe<AgencyPortalPrivacyUpdateInput>
}

export type AgencyPortalPrivacyUpdateInput = {
  activityVisibility?: InputMaybe<StringFieldUpdateOperationsInput>
  dataSharing?: InputMaybe<StringFieldUpdateOperationsInput>
  profileVisibility?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type AgencyPortalPrivacyWhereInput = {
  AND?: InputMaybe<Array<AgencyPortalPrivacyWhereInput>>
  NOT?: InputMaybe<Array<AgencyPortalPrivacyWhereInput>>
  OR?: InputMaybe<Array<AgencyPortalPrivacyWhereInput>>
  activityVisibility?: InputMaybe<StringFilter>
  dataSharing?: InputMaybe<StringFilter>
  profileVisibility?: InputMaybe<StringFilter>
}

export type AgencyStats = {
  __typename?: 'AgencyStats'
  agencyId: Scalars['String']['output']
  customerStats: CustomerStatsData
  propertyStats: PropertyStatsData
}

export type AgencyStatsModel = {
  __typename?: 'AgencyStatsModel'
  agencyId: Scalars['String']['output']
  agencyName: Scalars['String']['output']
  lastActivity: Scalars['String']['output']
  managerCount: Scalars['Float']['output']
  recentActivity: Array<RecentActivityModel>
  recentLogins: Scalars['Float']['output']
  totalUsers: Scalars['Float']['output']
  userCount: Scalars['Float']['output']
  userGrowth: UserGrowthModel
}

export type AgencyUserModel = {
  __typename?: 'AgencyUserModel'
  agencyId?: Maybe<Scalars['String']['output']>
  agencyName?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  permissions: Array<Scalars['String']['output']>
  role?: Maybe<Scalars['String']['output']>
  roles: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  userId: Scalars['ID']['output']
}

export type AgentLoginResponse = {
  __typename?: 'AgentLoginResponse'
  accessToken: Scalars['String']['output']
  agent: AgentModel
}

export type AgentModel = {
  __typename?: 'AgentModel'
  agency?: Maybe<Broker>
  createdAt: Scalars['DateTimeISO']['output']
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  integrations?: Maybe<IntegrationsModel>
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  permissions: Array<Scalars['String']['output']>
  picUrl?: Maybe<Scalars['String']['output']>
  roles: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  userId: Scalars['ID']['output']
}

export type AgentSignupResult = {
  __typename?: 'AgentSignupResult'
  agent: AgentModel
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type AggregateAvailablePaidExtras = {
  __typename?: 'AggregateAvailablePaidExtras'
  _avg?: Maybe<AvailablePaidExtrasAvgAggregate>
  _count?: Maybe<AvailablePaidExtrasCountAggregate>
  _max?: Maybe<AvailablePaidExtrasMaxAggregate>
  _min?: Maybe<AvailablePaidExtrasMinAggregate>
  _sum?: Maybe<AvailablePaidExtrasSumAggregate>
}

export type AggregateLead = {
  __typename?: 'AggregateLead'
  _avg?: Maybe<LeadAvgAggregate>
  _count?: Maybe<LeadCountAggregate>
  _max?: Maybe<LeadMaxAggregate>
  _min?: Maybe<LeadMinAggregate>
  _sum?: Maybe<LeadSumAggregate>
}

export type AggregateLocation = {
  __typename?: 'AggregateLocation'
  _count?: Maybe<LocationCountAggregate>
  _max?: Maybe<LocationMaxAggregate>
  _min?: Maybe<LocationMinAggregate>
}

export type AggregateMunicipality = {
  __typename?: 'AggregateMunicipality'
  _avg?: Maybe<MunicipalityAvgAggregate>
  _count?: Maybe<MunicipalityCountAggregate>
  _max?: Maybe<MunicipalityMaxAggregate>
  _min?: Maybe<MunicipalityMinAggregate>
  _sum?: Maybe<MunicipalitySumAggregate>
}

export type AggregateProperty = {
  __typename?: 'AggregateProperty'
  _avg?: Maybe<PropertyAvgAggregate>
  _count?: Maybe<PropertyCountAggregate>
  _max?: Maybe<PropertyMaxAggregate>
  _min?: Maybe<PropertyMinAggregate>
  _sum?: Maybe<PropertySumAggregate>
}

export type AggregateSubscription = {
  __typename?: 'AggregateSubscription'
  _avg?: Maybe<SubscriptionAvgAggregate>
  _count?: Maybe<SubscriptionCountAggregate>
  _max?: Maybe<SubscriptionMaxAggregate>
  _min?: Maybe<SubscriptionMinAggregate>
  _sum?: Maybe<SubscriptionSumAggregate>
}

export enum AiVisualsTier {
  None = 'none',
  Portfolio = 'portfolio',
  Unlimited = 'unlimited',
}

export type ApplicationSetting = {
  __typename?: 'ApplicationSetting'
  broker?: Maybe<Broker>
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  value: Scalars['String']['output']
}

export type ApplicationSettingBrokerArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type ApplicationSettingBrokerIdNameCompoundUniqueInput = {
  brokerId: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type ApplicationSettingCreateManyBrokerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  value: Scalars['String']['input']
}

export type ApplicationSettingCreateManyBrokerInputEnvelope = {
  data: Array<ApplicationSettingCreateManyBrokerInput>
}

export type ApplicationSettingCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<ApplicationSettingWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<ApplicationSettingCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<ApplicationSettingCreateWithoutBrokerInput>>
  createMany?: InputMaybe<ApplicationSettingCreateManyBrokerInputEnvelope>
}

export type ApplicationSettingCreateOrConnectWithoutBrokerInput = {
  create: ApplicationSettingCreateWithoutBrokerInput
  where: ApplicationSettingWhereUniqueInput
}

export type ApplicationSettingCreateWithoutBrokerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  value: Scalars['String']['input']
}

export type ApplicationSettingListRelationFilter = {
  every?: InputMaybe<ApplicationSettingWhereInput>
  none?: InputMaybe<ApplicationSettingWhereInput>
  some?: InputMaybe<ApplicationSettingWhereInput>
}

export type ApplicationSettingOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type ApplicationSettingOrderByWithRelationInput = {
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  value?: InputMaybe<SortOrder>
}

export enum ApplicationSettingScalarFieldEnum {
  BrokerId = 'brokerId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Name = 'name',
  UpdatedAt = 'updatedAt',
  Value = 'value',
}

export type ApplicationSettingScalarWhereInput = {
  AND?: InputMaybe<Array<ApplicationSettingScalarWhereInput>>
  NOT?: InputMaybe<Array<ApplicationSettingScalarWhereInput>>
  OR?: InputMaybe<Array<ApplicationSettingScalarWhereInput>>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  value?: InputMaybe<StringFilter>
}

export type ApplicationSettingUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  value?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type ApplicationSettingUpdateManyWithWhereWithoutBrokerInput = {
  data: ApplicationSettingUpdateManyMutationInput
  where: ApplicationSettingScalarWhereInput
}

export type ApplicationSettingUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<ApplicationSettingWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<ApplicationSettingCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<ApplicationSettingCreateWithoutBrokerInput>>
  createMany?: InputMaybe<ApplicationSettingCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<ApplicationSettingWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<ApplicationSettingScalarWhereInput>>
  disconnect?: InputMaybe<Array<ApplicationSettingWhereUniqueInput>>
  set?: InputMaybe<Array<ApplicationSettingWhereUniqueInput>>
  update?: InputMaybe<Array<ApplicationSettingUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<ApplicationSettingUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<ApplicationSettingUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type ApplicationSettingUpdateWithWhereUniqueWithoutBrokerInput = {
  data: ApplicationSettingUpdateWithoutBrokerInput
  where: ApplicationSettingWhereUniqueInput
}

export type ApplicationSettingUpdateWithoutBrokerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  value?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type ApplicationSettingUpsertWithWhereUniqueWithoutBrokerInput = {
  create: ApplicationSettingCreateWithoutBrokerInput
  update: ApplicationSettingUpdateWithoutBrokerInput
  where: ApplicationSettingWhereUniqueInput
}

export type ApplicationSettingWhereInput = {
  AND?: InputMaybe<Array<ApplicationSettingWhereInput>>
  NOT?: InputMaybe<Array<ApplicationSettingWhereInput>>
  OR?: InputMaybe<Array<ApplicationSettingWhereInput>>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  value?: InputMaybe<StringFilter>
}

export type ApplicationSettingWhereUniqueInput = {
  AND?: InputMaybe<Array<ApplicationSettingWhereInput>>
  NOT?: InputMaybe<Array<ApplicationSettingWhereInput>>
  OR?: InputMaybe<Array<ApplicationSettingWhereInput>>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  brokerId_name?: InputMaybe<ApplicationSettingBrokerIdNameCompoundUniqueInput>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  value?: InputMaybe<StringFilter>
}

export type AreaDescription = {
  __typename?: 'AreaDescription'
  createdAt: Scalars['String']['output']
  fullDescription: Scalars['String']['output']
  highlights: Array<Scalars['String']['output']>
  id: Scalars['String']['output']
  language: Scalars['String']['output']
  propertyId: Scalars['String']['output']
  summary: Scalars['String']['output']
}

export type ArticleSearchCardGql = {
  __typename?: 'ArticleSearchCardGql'
  documentId: Scalars['String']['output']
  language: Scalars['String']['output']
  locale: Scalars['String']['output']
  semanticScore?: Maybe<Scalars['Float']['output']>
  slug?: Maybe<Scalars['String']['output']>
  strapiId: Scalars['String']['output']
  summary?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  url: Scalars['String']['output']
}

export type AssetItemModel = {
  __typename?: 'AssetItemModel'
  key: Scalars['String']['output']
  lastModified?: Maybe<Scalars['DateTimeISO']['output']>
  size: Scalars['Float']['output']
  type: Scalars['String']['output']
  url: Scalars['String']['output']
}

export enum AssetListType {
  All = 'ALL',
  Images = 'IMAGES',
  Videos = 'VIDEOS',
}

export type AssignUserToAgencyInput = {
  agencyId: Scalars['String']['input']
  userId: Scalars['String']['input']
  userType: Scalars['String']['input']
}

export type AvailablePaidExtras = {
  __typename?: 'AvailablePaidExtras'
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  defaultPrice: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  label?: Maybe<Scalars['String']['output']>
  promoBannerUrl?: Maybe<Scalars['String']['output']>
  translations: Array<AvailablePaidExtrasTranslation>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type AvailablePaidExtrasAvgAggregate = {
  __typename?: 'AvailablePaidExtrasAvgAggregate'
  defaultPrice?: Maybe<Scalars['Float']['output']>
}

export type AvailablePaidExtrasAvgOrderByAggregateInput = {
  defaultPrice?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasCountAggregate = {
  __typename?: 'AvailablePaidExtrasCountAggregate'
  _all: Scalars['Int']['output']
  category: Scalars['Int']['output']
  createdAt: Scalars['Int']['output']
  currency: Scalars['Int']['output']
  defaultPrice: Scalars['Int']['output']
  description: Scalars['Int']['output']
  iconUrl: Scalars['Int']['output']
  id: Scalars['Int']['output']
  isActive: Scalars['Int']['output']
  label: Scalars['Int']['output']
  promoBannerUrl: Scalars['Int']['output']
  type: Scalars['Int']['output']
  updatedAt: Scalars['Int']['output']
}

export type AvailablePaidExtrasCountOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  defaultPrice?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  iconUrl?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  promoBannerUrl?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasCreateInput = {
  category?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  defaultPrice?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  iconUrl?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  promoBannerUrl?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationCreateInput>>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type AvailablePaidExtrasCreateManyInput = {
  category?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  defaultPrice?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  iconUrl?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  promoBannerUrl?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationCreateInput>>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type AvailablePaidExtrasGroupBy = {
  __typename?: 'AvailablePaidExtrasGroupBy'
  _avg?: Maybe<AvailablePaidExtrasAvgAggregate>
  _count?: Maybe<AvailablePaidExtrasCountAggregate>
  _max?: Maybe<AvailablePaidExtrasMaxAggregate>
  _min?: Maybe<AvailablePaidExtrasMinAggregate>
  _sum?: Maybe<AvailablePaidExtrasSumAggregate>
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  defaultPrice: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  label?: Maybe<Scalars['String']['output']>
  promoBannerUrl?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type AvailablePaidExtrasMaxAggregate = {
  __typename?: 'AvailablePaidExtrasMaxAggregate'
  category?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  defaultPrice?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Scalars['String']['output']>
  iconUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  promoBannerUrl?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

export type AvailablePaidExtrasMaxOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  defaultPrice?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  iconUrl?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  promoBannerUrl?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasMinAggregate = {
  __typename?: 'AvailablePaidExtrasMinAggregate'
  category?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  defaultPrice?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Scalars['String']['output']>
  iconUrl?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isActive?: Maybe<Scalars['Boolean']['output']>
  label?: Maybe<Scalars['String']['output']>
  promoBannerUrl?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
}

export type AvailablePaidExtrasMinOrderByAggregateInput = {
  category?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  defaultPrice?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  iconUrl?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  promoBannerUrl?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasOrderByWithAggregationInput = {
  _avg?: InputMaybe<AvailablePaidExtrasAvgOrderByAggregateInput>
  _count?: InputMaybe<AvailablePaidExtrasCountOrderByAggregateInput>
  _max?: InputMaybe<AvailablePaidExtrasMaxOrderByAggregateInput>
  _min?: InputMaybe<AvailablePaidExtrasMinOrderByAggregateInput>
  _sum?: InputMaybe<AvailablePaidExtrasSumOrderByAggregateInput>
  category?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  defaultPrice?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  iconUrl?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  promoBannerUrl?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  defaultPrice?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  iconUrl?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  promoBannerUrl?: InputMaybe<SortOrder>
  translations?: InputMaybe<AvailablePaidExtrasTranslationOrderByCompositeAggregateInput>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum AvailablePaidExtrasScalarFieldEnum {
  Category = 'category',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DefaultPrice = 'defaultPrice',
  Description = 'description',
  IconUrl = 'iconUrl',
  Id = 'id',
  IsActive = 'isActive',
  Label = 'label',
  PromoBannerUrl = 'promoBannerUrl',
  Type = 'type',
  UpdatedAt = 'updatedAt',
}

export type AvailablePaidExtrasScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AvailablePaidExtrasScalarWhereWithAggregatesInput>>
  NOT?: InputMaybe<Array<AvailablePaidExtrasScalarWhereWithAggregatesInput>>
  OR?: InputMaybe<Array<AvailablePaidExtrasScalarWhereWithAggregatesInput>>
  category?: InputMaybe<StringNullableWithAggregatesFilter>
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>
  currency?: InputMaybe<StringWithAggregatesFilter>
  defaultPrice?: InputMaybe<IntWithAggregatesFilter>
  description?: InputMaybe<StringNullableWithAggregatesFilter>
  iconUrl?: InputMaybe<StringNullableWithAggregatesFilter>
  id?: InputMaybe<StringWithAggregatesFilter>
  isActive?: InputMaybe<BoolWithAggregatesFilter>
  label?: InputMaybe<StringNullableWithAggregatesFilter>
  promoBannerUrl?: InputMaybe<StringNullableWithAggregatesFilter>
  type?: InputMaybe<StringWithAggregatesFilter>
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>
}

export type AvailablePaidExtrasSumAggregate = {
  __typename?: 'AvailablePaidExtrasSumAggregate'
  defaultPrice?: Maybe<Scalars['Int']['output']>
}

export type AvailablePaidExtrasSumOrderByAggregateInput = {
  defaultPrice?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasTranslation = {
  __typename?: 'AvailablePaidExtrasTranslation'
  description?: Maybe<Scalars['String']['output']>
  language: Scalars['String']['output']
}

export type AvailablePaidExtrasTranslationCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
}

export type AvailablePaidExtrasTranslationInput = {
  description?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
}

export type AvailablePaidExtrasTranslationObjectEqualityInput = {
  description?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
}

export type AvailablePaidExtrasTranslationOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type AvailablePaidExtrasUpdateInput = {
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  defaultPrice?: InputMaybe<IntFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  promoBannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationCreateInput>>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type AvailablePaidExtrasUpdateManyMutationInput = {
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  defaultPrice?: InputMaybe<IntFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  promoBannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationCreateInput>>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type AvailablePaidExtrasWhereInput = {
  AND?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  NOT?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  OR?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  category?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  defaultPrice?: InputMaybe<IntFilter>
  description?: InputMaybe<StringNullableFilter>
  iconUrl?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  isActive?: InputMaybe<BoolFilter>
  label?: InputMaybe<StringNullableFilter>
  promoBannerUrl?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationObjectEqualityInput>>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type AvailablePaidExtrasWhereUniqueInput = {
  AND?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  NOT?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  OR?: InputMaybe<Array<AvailablePaidExtrasWhereInput>>
  category?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  defaultPrice?: InputMaybe<IntFilter>
  description?: InputMaybe<StringNullableFilter>
  iconUrl?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<BoolFilter>
  label?: InputMaybe<StringNullableFilter>
  promoBannerUrl?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationObjectEqualityInput>>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type AvailablePaidExtrasWithUsage = {
  __typename?: 'AvailablePaidExtrasWithUsage'
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  defaultPrice: Scalars['Int']['output']
  description?: Maybe<Scalars['String']['output']>
  iconUrl?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isActive: Scalars['Boolean']['output']
  label?: Maybe<Scalars['String']['output']>
  promoBannerUrl?: Maybe<Scalars['String']['output']>
  translations: Array<TranslationOutput>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  usageCount: Scalars['Int']['output']
}

export enum BathroomQuality {
  Luxury = 'luxury',
  Modern = 'modern',
  NeedsUpdate = 'needs_update',
  Original = 'original',
  Updated = 'updated',
}

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>
}

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolFilter>
}

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolNullableFilter>
}

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedBoolNullableFilter>
  _min?: InputMaybe<NestedBoolNullableFilter>
  equals?: InputMaybe<Scalars['Boolean']['input']>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>
}

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedBoolFilter>
  _min?: InputMaybe<NestedBoolFilter>
  equals?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolWithAggregatesFilter>
}

export type BoundingBoxInput = {
  maxLat: Scalars['Float']['input']
  maxLng: Scalars['Float']['input']
  minLat: Scalars['Float']['input']
  minLng: Scalars['Float']['input']
}

export type Broker = {
  __typename?: 'Broker'
  _count?: Maybe<BrokerCount>
  agencyHistory: Array<AgencyHistory>
  agencyId?: Maybe<Scalars['String']['output']>
  agencyPortalApplicationSettings?: Maybe<AgencyPortalApplicationSettings>
  applicationSettings: Array<ApplicationSetting>
  bannerUrl?: Maybe<Scalars['String']['output']>
  /** Mautic contact id for broker lead notification emails (template send target), not the Mautic company id. */
  brokerLeadContactMauticId?: Maybe<Scalars['Int']['output']>
  contactInfo?: Maybe<ContactInfo>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  descriptions: Array<Description>
  email?: Maybe<Scalars['String']['output']>
  featureIds: Array<Scalars['String']['output']>
  featureOptions: Array<Feature>
  id: Scalars['String']['output']
  leadNotes: Array<LeadNote>
  leads: Array<Lead>
  locationIds: Array<Scalars['String']['output']>
  locationOptions: Array<Location>
  logoUrl?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  paidExtras: Array<PaidExtra>
  pictureUrl?: Maybe<Scalars['String']['output']>
  products: Array<Product>
  properties: Array<Property>
  propertyCardAds: Array<PropertyCardAd>
  propertyStats: PropertyStats
  propertyTypeIds: Array<Scalars['String']['output']>
  propertyTypeOptions: Array<PropertyType>
  services: Array<Scalars['String']['output']>
  settingsId?: Maybe<Scalars['String']['output']>
  sharedProperties: Array<Property>
  sharedPropertyIds: Array<Scalars['String']['output']>
  slugUrl?: Maybe<Scalars['String']['output']>
  subscriptions: Array<Subscription>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  userIds: Array<Scalars['String']['output']>
  users?: Maybe<Array<AgentModel>>
}

export type BrokerAgencyHistoryArgs = {
  cursor?: InputMaybe<AgencyHistoryWhereUniqueInput>
  distinct?: InputMaybe<Array<AgencyHistoryScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AgencyHistoryOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AgencyHistoryWhereInput>
}

export type BrokerAgencyPortalApplicationSettingsArgs = {
  where?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
}

export type BrokerApplicationSettingsArgs = {
  cursor?: InputMaybe<ApplicationSettingWhereUniqueInput>
  distinct?: InputMaybe<Array<ApplicationSettingScalarFieldEnum>>
  orderBy?: InputMaybe<Array<ApplicationSettingOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ApplicationSettingWhereInput>
}

export type BrokerFeatureOptionsArgs = {
  cursor?: InputMaybe<FeatureWhereUniqueInput>
  distinct?: InputMaybe<Array<FeatureScalarFieldEnum>>
  orderBy?: InputMaybe<Array<FeatureOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FeatureWhereInput>
}

export type BrokerLeadNotesArgs = {
  cursor?: InputMaybe<LeadNoteWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadNoteScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadNoteOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadNoteWhereInput>
}

export type BrokerLeadsArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type BrokerLocationOptionsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LocationWhereInput>
}

export type BrokerPaidExtrasArgs = {
  cursor?: InputMaybe<PaidExtraWhereUniqueInput>
  distinct?: InputMaybe<Array<PaidExtraScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PaidExtraOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PaidExtraWhereInput>
}

export type BrokerPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type BrokerPropertyCardAdsArgs = {
  cursor?: InputMaybe<PropertyCardAdWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyCardAdScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyCardAdOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyCardAdWhereInput>
}

export type BrokerPropertyTypeOptionsArgs = {
  cursor?: InputMaybe<PropertyTypeWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyTypeScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyTypeOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type BrokerSharedPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type BrokerSubscriptionsArgs = {
  cursor?: InputMaybe<SubscriptionWhereUniqueInput>
  distinct?: InputMaybe<Array<SubscriptionScalarFieldEnum>>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type BrokerCount = {
  __typename?: 'BrokerCount'
  agencyHistory: Scalars['Int']['output']
  applicationSettings: Scalars['Int']['output']
  featureOptions: Scalars['Int']['output']
  leadNotes: Scalars['Int']['output']
  leads: Scalars['Int']['output']
  locationOptions: Scalars['Int']['output']
  paidExtras: Scalars['Int']['output']
  properties: Scalars['Int']['output']
  propertyCardAds: Scalars['Int']['output']
  propertyTypeOptions: Scalars['Int']['output']
  sharedProperties: Scalars['Int']['output']
  subscriptions: Scalars['Int']['output']
}

export type BrokerCountAgencyHistoryArgs = {
  where?: InputMaybe<AgencyHistoryWhereInput>
}

export type BrokerCountApplicationSettingsArgs = {
  where?: InputMaybe<ApplicationSettingWhereInput>
}

export type BrokerCountFeatureOptionsArgs = {
  where?: InputMaybe<FeatureWhereInput>
}

export type BrokerCountLeadNotesArgs = {
  where?: InputMaybe<LeadNoteWhereInput>
}

export type BrokerCountLeadsArgs = {
  where?: InputMaybe<LeadWhereInput>
}

export type BrokerCountLocationOptionsArgs = {
  where?: InputMaybe<LocationWhereInput>
}

export type BrokerCountPaidExtrasArgs = {
  where?: InputMaybe<PaidExtraWhereInput>
}

export type BrokerCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type BrokerCountPropertyCardAdsArgs = {
  where?: InputMaybe<PropertyCardAdWhereInput>
}

export type BrokerCountPropertyTypeOptionsArgs = {
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type BrokerCountSharedPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type BrokerCountSubscriptionsArgs = {
  where?: InputMaybe<SubscriptionWhereInput>
}

export type BrokerCreateNestedManyWithoutFeatureOptionsInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutFeatureOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutFeatureOptionsInput>>
}

export type BrokerCreateNestedManyWithoutLocationOptionsInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutLocationOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutLocationOptionsInput>>
}

export type BrokerCreateNestedManyWithoutPropertyTypeOptionsInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutPropertyTypeOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutPropertyTypeOptionsInput>>
}

export type BrokerCreateNestedManyWithoutSharedPropertiesInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutSharedPropertiesInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutSharedPropertiesInput>>
}

export type BrokerCreateNestedOneWithoutAgencyHistoryInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutAgencyHistoryInput>
  create?: InputMaybe<BrokerCreateWithoutAgencyHistoryInput>
}

export type BrokerCreateNestedOneWithoutAgencyPortalApplicationSettingsInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutAgencyPortalApplicationSettingsInput>
  create?: InputMaybe<BrokerCreateWithoutAgencyPortalApplicationSettingsInput>
}

export type BrokerCreateNestedOneWithoutLeadNotesInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutLeadNotesInput>
  create?: InputMaybe<BrokerCreateWithoutLeadNotesInput>
}

export type BrokerCreateNestedOneWithoutLeadsInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutLeadsInput>
  create?: InputMaybe<BrokerCreateWithoutLeadsInput>
}

export type BrokerCreateNestedOneWithoutPaidExtrasInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutPaidExtrasInput>
  create?: InputMaybe<BrokerCreateWithoutPaidExtrasInput>
}

export type BrokerCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<BrokerCreateWithoutPropertiesInput>
}

export type BrokerCreateNestedOneWithoutSubscriptionsInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutSubscriptionsInput>
  create?: InputMaybe<BrokerCreateWithoutSubscriptionsInput>
}

export type BrokerCreateOrConnectWithoutAgencyHistoryInput = {
  create: BrokerCreateWithoutAgencyHistoryInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutAgencyPortalApplicationSettingsInput = {
  create: BrokerCreateWithoutAgencyPortalApplicationSettingsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutFeatureOptionsInput = {
  create: BrokerCreateWithoutFeatureOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutLeadNotesInput = {
  create: BrokerCreateWithoutLeadNotesInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutLeadsInput = {
  create: BrokerCreateWithoutLeadsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutLocationOptionsInput = {
  create: BrokerCreateWithoutLocationOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutPaidExtrasInput = {
  create: BrokerCreateWithoutPaidExtrasInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutPropertiesInput = {
  create: BrokerCreateWithoutPropertiesInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutPropertyTypeOptionsInput = {
  create: BrokerCreateWithoutPropertyTypeOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutSharedPropertiesInput = {
  create: BrokerCreateWithoutSharedPropertiesInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateOrConnectWithoutSubscriptionsInput = {
  create: BrokerCreateWithoutSubscriptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerCreateWithoutAgencyHistoryInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutAgencyPortalApplicationSettingsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutFeatureOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutLeadNotesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutLeadsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutLocationOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutPaidExtrasInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutPropertiesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutPropertyTypeOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutSharedPropertiesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  subscriptions?: InputMaybe<SubscriptionCreateNestedManyWithoutBrokerInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateWithoutSubscriptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutBrokerInput>
  agencyId?: InputMaybe<Scalars['String']['input']>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsCreateNestedOneWithoutBrokerInput>
  applicationSettings?: InputMaybe<ApplicationSettingCreateNestedManyWithoutBrokerInput>
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  brokerLeadContactMauticId?: InputMaybe<Scalars['Int']['input']>
  contactInfo?: InputMaybe<ContactInfoNullableCreateEnvelopeInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureOptions?: InputMaybe<FeatureCreateNestedManyWithoutBrokersInput>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutAgencyInput>
  leads?: InputMaybe<LeadCreateNestedManyWithoutBrokerInput>
  locationOptions?: InputMaybe<LocationCreateNestedManyWithoutBrokersInput>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutBrokerInput>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutBrokerInput>
  propertyCardAds?: InputMaybe<PropertyCardAdCreateNestedManyWithoutBrokerInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeCreateNestedManyWithoutBrokersInput>
  services?: InputMaybe<BrokerCreateservicesInput>
  settingsId?: InputMaybe<Scalars['String']['input']>
  sharedProperties?: InputMaybe<PropertyCreateNestedManyWithoutBrokersInput>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  userIds?: InputMaybe<BrokerCreateuserIdsInput>
}

export type BrokerCreateservicesInput = {
  set: Array<Scalars['String']['input']>
}

export type BrokerCreateuserIdsInput = {
  set: Array<Scalars['String']['input']>
}

export type BrokerFrontendRealEstateApplicationSettingRow = {
  __typename?: 'BrokerFrontendRealEstateApplicationSettingRow'
  brokerAgencyId?: Maybe<Scalars['String']['output']>
  brokerId: Scalars['String']['output']
  brokerName?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  value: Scalars['String']['output']
}

export type BrokerFrontendRealEstateOrderByInput = {
  agencyRefPatterns?: InputMaybe<Array<Scalars['String']['input']>>
  externalIdPatterns?: InputMaybe<Array<Scalars['String']['input']>>
  ownPropertiesFirst?: InputMaybe<Scalars['Boolean']['input']>
}

export type BrokerFrontendRealEstateOrderByOutput = {
  __typename?: 'BrokerFrontendRealEstateOrderByOutput'
  agencyRefPatterns: Array<Scalars['String']['output']>
  externalIdPatterns: Array<Scalars['String']['output']>
  ownPropertiesFirst: Scalars['Boolean']['output']
}

export type BrokerFrontendRealEstatePropertyFlowInput = {
  orderBy?: InputMaybe<BrokerFrontendRealEstateOrderByInput>
}

export type BrokerFrontendRealEstatePropertyFlowOutput = {
  __typename?: 'BrokerFrontendRealEstatePropertyFlowOutput'
  orderBy: BrokerFrontendRealEstateOrderByOutput
}

export type BrokerFrontendRealEstateProspectPdfInput = {
  nonBranded?: InputMaybe<Scalars['Boolean']['input']>
}

export type BrokerFrontendRealEstateProspectPdfOutput = {
  __typename?: 'BrokerFrontendRealEstateProspectPdfOutput'
  nonBranded: Scalars['Boolean']['output']
}

export type BrokerFrontendRealEstateSettingsOutput = {
  __typename?: 'BrokerFrontendRealEstateSettingsOutput'
  brokerId: Scalars['String']['output']
  propertyFlow: BrokerFrontendRealEstatePropertyFlowOutput
  prospectPdf: BrokerFrontendRealEstateProspectPdfOutput
  version: Scalars['Int']['output']
}

export type BrokerLeadContactMauticPreview = {
  __typename?: 'BrokerLeadContactMauticPreview'
  displayLabel?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  error?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  mauticContactId?: Maybe<Scalars['Int']['output']>
  ok: Scalars['Boolean']['output']
}

export type BrokerListRelationFilter = {
  every?: InputMaybe<BrokerWhereInput>
  none?: InputMaybe<BrokerWhereInput>
  some?: InputMaybe<BrokerWhereInput>
}

export type BrokerNullableRelationFilter = {
  is?: InputMaybe<BrokerWhereInput>
  isNot?: InputMaybe<BrokerWhereInput>
}

export type BrokerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type BrokerOrderByWithRelationInput = {
  agencyHistory?: InputMaybe<AgencyHistoryOrderByRelationAggregateInput>
  agencyId?: InputMaybe<SortOrder>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsOrderByWithRelationInput>
  applicationSettings?: InputMaybe<ApplicationSettingOrderByRelationAggregateInput>
  bannerUrl?: InputMaybe<SortOrder>
  brokerLeadContactMauticId?: InputMaybe<SortOrder>
  contactInfo?: InputMaybe<ContactInfoOrderByInput>
  createdAt?: InputMaybe<SortOrder>
  descriptions?: InputMaybe<DescriptionOrderByCompositeAggregateInput>
  email?: InputMaybe<SortOrder>
  featureIds?: InputMaybe<SortOrder>
  featureOptions?: InputMaybe<FeatureOrderByRelationAggregateInput>
  id?: InputMaybe<SortOrder>
  leadNotes?: InputMaybe<LeadNoteOrderByRelationAggregateInput>
  leads?: InputMaybe<LeadOrderByRelationAggregateInput>
  locationIds?: InputMaybe<SortOrder>
  locationOptions?: InputMaybe<LocationOrderByRelationAggregateInput>
  logoUrl?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  paidExtras?: InputMaybe<PaidExtraOrderByRelationAggregateInput>
  pictureUrl?: InputMaybe<SortOrder>
  products?: InputMaybe<ProductOrderByCompositeAggregateInput>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  propertyCardAds?: InputMaybe<PropertyCardAdOrderByRelationAggregateInput>
  propertyTypeIds?: InputMaybe<SortOrder>
  propertyTypeOptions?: InputMaybe<PropertyTypeOrderByRelationAggregateInput>
  services?: InputMaybe<SortOrder>
  settingsId?: InputMaybe<SortOrder>
  sharedProperties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  sharedPropertyIds?: InputMaybe<SortOrder>
  slugUrl?: InputMaybe<SortOrder>
  subscriptions?: InputMaybe<SubscriptionOrderByRelationAggregateInput>
  updatedAt?: InputMaybe<SortOrder>
  userIds?: InputMaybe<SortOrder>
}

export type BrokerRelationFilter = {
  is?: InputMaybe<BrokerWhereInput>
  isNot?: InputMaybe<BrokerWhereInput>
}

export enum BrokerScalarFieldEnum {
  AgencyId = 'agencyId',
  BannerUrl = 'bannerUrl',
  BrokerLeadContactMauticId = 'brokerLeadContactMauticId',
  CreatedAt = 'createdAt',
  Email = 'email',
  FeatureIds = 'featureIds',
  Id = 'id',
  LocationIds = 'locationIds',
  LogoUrl = 'logoUrl',
  Name = 'name',
  PictureUrl = 'pictureUrl',
  PropertyTypeIds = 'propertyTypeIds',
  Services = 'services',
  SettingsId = 'settingsId',
  SharedPropertyIds = 'sharedPropertyIds',
  SlugUrl = 'slugUrl',
  UpdatedAt = 'updatedAt',
  UserIds = 'userIds',
}

export type BrokerScalarWhereInput = {
  AND?: InputMaybe<Array<BrokerScalarWhereInput>>
  NOT?: InputMaybe<Array<BrokerScalarWhereInput>>
  OR?: InputMaybe<Array<BrokerScalarWhereInput>>
  agencyId?: InputMaybe<StringNullableFilter>
  bannerUrl?: InputMaybe<StringNullableFilter>
  brokerLeadContactMauticId?: InputMaybe<IntNullableFilter>
  createdAt?: InputMaybe<DateTimeNullableFilter>
  email?: InputMaybe<StringNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  id?: InputMaybe<StringFilter>
  locationIds?: InputMaybe<StringNullableListFilter>
  logoUrl?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  pictureUrl?: InputMaybe<StringNullableFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  services?: InputMaybe<StringNullableListFilter>
  settingsId?: InputMaybe<StringNullableFilter>
  sharedPropertyIds?: InputMaybe<StringNullableListFilter>
  slugUrl?: InputMaybe<StringNullableFilter>
  updatedAt?: InputMaybe<DateTimeNullableFilter>
  userIds?: InputMaybe<StringNullableListFilter>
}

export type BrokerSiteEndpointStatus = {
  __typename?: 'BrokerSiteEndpointStatus'
  reachability: BrokerSiteReachability
  statusCode?: Maybe<Scalars['Float']['output']>
  url: Scalars['String']['output']
}

export type BrokerSiteIndexEntry = {
  __typename?: 'BrokerSiteIndexEntry'
  brokerId: Scalars['String']['output']
  clickupListName: Scalars['String']['output']
  clickupListUrl?: Maybe<Scalars['String']['output']>
  clickupSpaceUrl: Scalars['String']['output']
  customerOwnedDomain?: Maybe<Scalars['String']['output']>
  displayName: Scalars['String']['output']
  githubRepoExists: Scalars['Boolean']['output']
  githubRepoUrl: Scalars['String']['output']
  locales: Array<Scalars['String']['output']>
  manifestPath: Scalars['String']['output']
  manifestUrl: Scalars['String']['output']
  mattermostChannelName: Scalars['String']['output']
  mattermostChannelUrl?: Maybe<Scalars['String']['output']>
  production?: Maybe<BrokerSiteEndpointStatus>
  productionUrl?: Maybe<Scalars['String']['output']>
  slug: Scalars['String']['output']
  sourceWebsiteUrl?: Maybe<Scalars['String']['output']>
  staging?: Maybe<BrokerSiteEndpointStatus>
  stagingUrl?: Maybe<Scalars['String']['output']>
  tagline?: Maybe<Scalars['String']['output']>
  workflowActionsUrl: Scalars['String']['output']
}

/** HTTP reachability probe result for a broker site URL */
export enum BrokerSiteReachability {
  Down = 'DOWN',
  Unknown = 'UNKNOWN',
  Up = 'UP',
}

export type BrokerUpdateManyMutationInput = {
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateManyWithWhereWithoutFeatureOptionsInput = {
  data: BrokerUpdateManyMutationInput
  where: BrokerScalarWhereInput
}

export type BrokerUpdateManyWithWhereWithoutLocationOptionsInput = {
  data: BrokerUpdateManyMutationInput
  where: BrokerScalarWhereInput
}

export type BrokerUpdateManyWithWhereWithoutPropertyTypeOptionsInput = {
  data: BrokerUpdateManyMutationInput
  where: BrokerScalarWhereInput
}

export type BrokerUpdateManyWithWhereWithoutSharedPropertiesInput = {
  data: BrokerUpdateManyMutationInput
  where: BrokerScalarWhereInput
}

export type BrokerUpdateManyWithoutFeatureOptionsNestedInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutFeatureOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutFeatureOptionsInput>>
  delete?: InputMaybe<Array<BrokerWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<BrokerScalarWhereInput>>
  disconnect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  set?: InputMaybe<Array<BrokerWhereUniqueInput>>
  update?: InputMaybe<Array<BrokerUpdateWithWhereUniqueWithoutFeatureOptionsInput>>
  updateMany?: InputMaybe<Array<BrokerUpdateManyWithWhereWithoutFeatureOptionsInput>>
  upsert?: InputMaybe<Array<BrokerUpsertWithWhereUniqueWithoutFeatureOptionsInput>>
}

export type BrokerUpdateManyWithoutLocationOptionsNestedInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutLocationOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutLocationOptionsInput>>
  delete?: InputMaybe<Array<BrokerWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<BrokerScalarWhereInput>>
  disconnect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  set?: InputMaybe<Array<BrokerWhereUniqueInput>>
  update?: InputMaybe<Array<BrokerUpdateWithWhereUniqueWithoutLocationOptionsInput>>
  updateMany?: InputMaybe<Array<BrokerUpdateManyWithWhereWithoutLocationOptionsInput>>
  upsert?: InputMaybe<Array<BrokerUpsertWithWhereUniqueWithoutLocationOptionsInput>>
}

export type BrokerUpdateManyWithoutPropertyTypeOptionsNestedInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutPropertyTypeOptionsInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutPropertyTypeOptionsInput>>
  delete?: InputMaybe<Array<BrokerWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<BrokerScalarWhereInput>>
  disconnect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  set?: InputMaybe<Array<BrokerWhereUniqueInput>>
  update?: InputMaybe<Array<BrokerUpdateWithWhereUniqueWithoutPropertyTypeOptionsInput>>
  updateMany?: InputMaybe<Array<BrokerUpdateManyWithWhereWithoutPropertyTypeOptionsInput>>
  upsert?: InputMaybe<Array<BrokerUpsertWithWhereUniqueWithoutPropertyTypeOptionsInput>>
}

export type BrokerUpdateManyWithoutSharedPropertiesNestedInput = {
  connect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<BrokerCreateOrConnectWithoutSharedPropertiesInput>>
  create?: InputMaybe<Array<BrokerCreateWithoutSharedPropertiesInput>>
  delete?: InputMaybe<Array<BrokerWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<BrokerScalarWhereInput>>
  disconnect?: InputMaybe<Array<BrokerWhereUniqueInput>>
  set?: InputMaybe<Array<BrokerWhereUniqueInput>>
  update?: InputMaybe<Array<BrokerUpdateWithWhereUniqueWithoutSharedPropertiesInput>>
  updateMany?: InputMaybe<Array<BrokerUpdateManyWithWhereWithoutSharedPropertiesInput>>
  upsert?: InputMaybe<Array<BrokerUpsertWithWhereUniqueWithoutSharedPropertiesInput>>
}

export type BrokerUpdateOneRequiredWithoutAgencyHistoryNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutAgencyHistoryInput>
  create?: InputMaybe<BrokerCreateWithoutAgencyHistoryInput>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutAgencyHistoryInput>
  upsert?: InputMaybe<BrokerUpsertWithoutAgencyHistoryInput>
}

export type BrokerUpdateOneRequiredWithoutAgencyPortalApplicationSettingsNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutAgencyPortalApplicationSettingsInput>
  create?: InputMaybe<BrokerCreateWithoutAgencyPortalApplicationSettingsInput>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutAgencyPortalApplicationSettingsInput>
  upsert?: InputMaybe<BrokerUpsertWithoutAgencyPortalApplicationSettingsInput>
}

export type BrokerUpdateOneRequiredWithoutPaidExtrasNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutPaidExtrasInput>
  create?: InputMaybe<BrokerCreateWithoutPaidExtrasInput>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutPaidExtrasInput>
  upsert?: InputMaybe<BrokerUpsertWithoutPaidExtrasInput>
}

export type BrokerUpdateOneRequiredWithoutSubscriptionsNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutSubscriptionsInput>
  create?: InputMaybe<BrokerCreateWithoutSubscriptionsInput>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutSubscriptionsInput>
  upsert?: InputMaybe<BrokerUpsertWithoutSubscriptionsInput>
}

export type BrokerUpdateOneWithoutLeadNotesNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutLeadNotesInput>
  create?: InputMaybe<BrokerCreateWithoutLeadNotesInput>
  delete?: InputMaybe<BrokerWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutLeadNotesInput>
  upsert?: InputMaybe<BrokerUpsertWithoutLeadNotesInput>
}

export type BrokerUpdateOneWithoutLeadsNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutLeadsInput>
  create?: InputMaybe<BrokerCreateWithoutLeadsInput>
  delete?: InputMaybe<BrokerWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutLeadsInput>
  upsert?: InputMaybe<BrokerUpsertWithoutLeadsInput>
}

export type BrokerUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<BrokerWhereUniqueInput>
  connectOrCreate?: InputMaybe<BrokerCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<BrokerCreateWithoutPropertiesInput>
  delete?: InputMaybe<BrokerWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<BrokerUpdateToOneWithWhereWithoutPropertiesInput>
  upsert?: InputMaybe<BrokerUpsertWithoutPropertiesInput>
}

export type BrokerUpdateToOneWithWhereWithoutAgencyHistoryInput = {
  data: BrokerUpdateWithoutAgencyHistoryInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutAgencyPortalApplicationSettingsInput = {
  data: BrokerUpdateWithoutAgencyPortalApplicationSettingsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutLeadNotesInput = {
  data: BrokerUpdateWithoutLeadNotesInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutLeadsInput = {
  data: BrokerUpdateWithoutLeadsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutPaidExtrasInput = {
  data: BrokerUpdateWithoutPaidExtrasInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutPropertiesInput = {
  data: BrokerUpdateWithoutPropertiesInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateToOneWithWhereWithoutSubscriptionsInput = {
  data: BrokerUpdateWithoutSubscriptionsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpdateWithWhereUniqueWithoutFeatureOptionsInput = {
  data: BrokerUpdateWithoutFeatureOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpdateWithWhereUniqueWithoutLocationOptionsInput = {
  data: BrokerUpdateWithoutLocationOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpdateWithWhereUniqueWithoutPropertyTypeOptionsInput = {
  data: BrokerUpdateWithoutPropertyTypeOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpdateWithWhereUniqueWithoutSharedPropertiesInput = {
  data: BrokerUpdateWithoutSharedPropertiesInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpdateWithoutAgencyHistoryInput = {
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutAgencyPortalApplicationSettingsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutFeatureOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutLeadNotesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutLeadsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutLocationOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutPaidExtrasInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutPropertiesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutPropertyTypeOptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutSharedPropertiesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subscriptions?: InputMaybe<SubscriptionUpdateManyWithoutBrokerNestedInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateWithoutSubscriptionsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutBrokerNestedInput>
  agencyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsUpdateOneWithoutBrokerNestedInput>
  applicationSettings?: InputMaybe<ApplicationSettingUpdateManyWithoutBrokerNestedInput>
  bannerUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  brokerLeadContactMauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  contactInfo?: InputMaybe<ContactInfoNullableUpdateEnvelopeInput>
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  featureOptions?: InputMaybe<FeatureUpdateManyWithoutBrokersNestedInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutAgencyNestedInput>
  leads?: InputMaybe<LeadUpdateManyWithoutBrokerNestedInput>
  locationOptions?: InputMaybe<LocationUpdateManyWithoutBrokersNestedInput>
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutBrokerNestedInput>
  pictureUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  products?: InputMaybe<Array<ProductCreateInput>>
  properties?: InputMaybe<PropertyUpdateManyWithoutBrokerNestedInput>
  propertyCardAds?: InputMaybe<PropertyCardAdUpdateManyWithoutBrokerNestedInput>
  propertyTypeOptions?: InputMaybe<PropertyTypeUpdateManyWithoutBrokersNestedInput>
  services?: InputMaybe<BrokerUpdateservicesInput>
  settingsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  sharedProperties?: InputMaybe<PropertyUpdateManyWithoutBrokersNestedInput>
  slugUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  userIds?: InputMaybe<BrokerUpdateuserIdsInput>
}

export type BrokerUpdateservicesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BrokerUpdateuserIdsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type BrokerUpsertWithWhereUniqueWithoutFeatureOptionsInput = {
  create: BrokerCreateWithoutFeatureOptionsInput
  update: BrokerUpdateWithoutFeatureOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpsertWithWhereUniqueWithoutLocationOptionsInput = {
  create: BrokerCreateWithoutLocationOptionsInput
  update: BrokerUpdateWithoutLocationOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpsertWithWhereUniqueWithoutPropertyTypeOptionsInput = {
  create: BrokerCreateWithoutPropertyTypeOptionsInput
  update: BrokerUpdateWithoutPropertyTypeOptionsInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpsertWithWhereUniqueWithoutSharedPropertiesInput = {
  create: BrokerCreateWithoutSharedPropertiesInput
  update: BrokerUpdateWithoutSharedPropertiesInput
  where: BrokerWhereUniqueInput
}

export type BrokerUpsertWithoutAgencyHistoryInput = {
  create: BrokerCreateWithoutAgencyHistoryInput
  update: BrokerUpdateWithoutAgencyHistoryInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutAgencyPortalApplicationSettingsInput = {
  create: BrokerCreateWithoutAgencyPortalApplicationSettingsInput
  update: BrokerUpdateWithoutAgencyPortalApplicationSettingsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutLeadNotesInput = {
  create: BrokerCreateWithoutLeadNotesInput
  update: BrokerUpdateWithoutLeadNotesInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutLeadsInput = {
  create: BrokerCreateWithoutLeadsInput
  update: BrokerUpdateWithoutLeadsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutPaidExtrasInput = {
  create: BrokerCreateWithoutPaidExtrasInput
  update: BrokerUpdateWithoutPaidExtrasInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutPropertiesInput = {
  create: BrokerCreateWithoutPropertiesInput
  update: BrokerUpdateWithoutPropertiesInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerUpsertWithoutSubscriptionsInput = {
  create: BrokerCreateWithoutSubscriptionsInput
  update: BrokerUpdateWithoutSubscriptionsInput
  where?: InputMaybe<BrokerWhereInput>
}

export type BrokerWhereInput = {
  AND?: InputMaybe<Array<BrokerWhereInput>>
  NOT?: InputMaybe<Array<BrokerWhereInput>>
  OR?: InputMaybe<Array<BrokerWhereInput>>
  agencyHistory?: InputMaybe<AgencyHistoryListRelationFilter>
  agencyId?: InputMaybe<StringNullableFilter>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsNullableRelationFilter>
  applicationSettings?: InputMaybe<ApplicationSettingListRelationFilter>
  bannerUrl?: InputMaybe<StringNullableFilter>
  brokerLeadContactMauticId?: InputMaybe<IntNullableFilter>
  contactInfo?: InputMaybe<ContactInfoNullableCompositeFilter>
  createdAt?: InputMaybe<DateTimeNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  email?: InputMaybe<StringNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  featureOptions?: InputMaybe<FeatureListRelationFilter>
  id?: InputMaybe<StringFilter>
  leadNotes?: InputMaybe<LeadNoteListRelationFilter>
  leads?: InputMaybe<LeadListRelationFilter>
  locationIds?: InputMaybe<StringNullableListFilter>
  locationOptions?: InputMaybe<LocationListRelationFilter>
  logoUrl?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  paidExtras?: InputMaybe<PaidExtraListRelationFilter>
  pictureUrl?: InputMaybe<StringNullableFilter>
  products?: InputMaybe<Array<ProductObjectEqualityInput>>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyCardAds?: InputMaybe<PropertyCardAdListRelationFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  propertyTypeOptions?: InputMaybe<PropertyTypeListRelationFilter>
  services?: InputMaybe<StringNullableListFilter>
  settingsId?: InputMaybe<StringNullableFilter>
  sharedProperties?: InputMaybe<PropertyListRelationFilter>
  sharedPropertyIds?: InputMaybe<StringNullableListFilter>
  slugUrl?: InputMaybe<StringNullableFilter>
  subscriptions?: InputMaybe<SubscriptionListRelationFilter>
  updatedAt?: InputMaybe<DateTimeNullableFilter>
  userIds?: InputMaybe<StringNullableListFilter>
}

export type BrokerWhereUniqueInput = {
  AND?: InputMaybe<Array<BrokerWhereInput>>
  NOT?: InputMaybe<Array<BrokerWhereInput>>
  OR?: InputMaybe<Array<BrokerWhereInput>>
  agencyHistory?: InputMaybe<AgencyHistoryListRelationFilter>
  agencyId?: InputMaybe<StringNullableFilter>
  agencyPortalApplicationSettings?: InputMaybe<AgencyPortalApplicationSettingsNullableRelationFilter>
  applicationSettings?: InputMaybe<ApplicationSettingListRelationFilter>
  bannerUrl?: InputMaybe<StringNullableFilter>
  brokerLeadContactMauticId?: InputMaybe<IntNullableFilter>
  contactInfo?: InputMaybe<ContactInfoNullableCompositeFilter>
  createdAt?: InputMaybe<DateTimeNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  email?: InputMaybe<StringNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  featureOptions?: InputMaybe<FeatureListRelationFilter>
  id?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteListRelationFilter>
  leads?: InputMaybe<LeadListRelationFilter>
  locationIds?: InputMaybe<StringNullableListFilter>
  locationOptions?: InputMaybe<LocationListRelationFilter>
  logoUrl?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  paidExtras?: InputMaybe<PaidExtraListRelationFilter>
  pictureUrl?: InputMaybe<StringNullableFilter>
  products?: InputMaybe<Array<ProductObjectEqualityInput>>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyCardAds?: InputMaybe<PropertyCardAdListRelationFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  propertyTypeOptions?: InputMaybe<PropertyTypeListRelationFilter>
  services?: InputMaybe<StringNullableListFilter>
  settingsId?: InputMaybe<StringNullableFilter>
  sharedProperties?: InputMaybe<PropertyListRelationFilter>
  sharedPropertyIds?: InputMaybe<StringNullableListFilter>
  slugUrl?: InputMaybe<StringNullableFilter>
  subscriptions?: InputMaybe<SubscriptionListRelationFilter>
  updatedAt?: InputMaybe<DateTimeNullableFilter>
  userIds?: InputMaybe<StringNullableListFilter>
}

export type BrokerWithPaidExtras = {
  __typename?: 'BrokerWithPaidExtras'
  broker: Broker
  extrasCount: Scalars['Int']['output']
}

export type BulkOperationResult = {
  __typename?: 'BulkOperationResult'
  failedIds?: Maybe<Array<Scalars['String']['output']>>
  message: Scalars['String']['output']
  processedIds?: Maybe<Array<Scalars['String']['output']>>
  success: Scalars['Boolean']['output']
}

export type ContactInfo = {
  __typename?: 'ContactInfo'
  address?: Maybe<Address>
  email: Scalars['String']['output']
  facebook?: Maybe<Scalars['String']['output']>
  fax?: Maybe<Scalars['String']['output']>
  instagram?: Maybe<Scalars['String']['output']>
  linkedin?: Maybe<Scalars['String']['output']>
  mobile?: Maybe<Scalars['String']['output']>
  phone: Scalars['String']['output']
  twitter?: Maybe<Scalars['String']['output']>
  website?: Maybe<Scalars['String']['output']>
  whatsapp?: Maybe<Scalars['String']['output']>
  x?: Maybe<Scalars['String']['output']>
}

export type ContactInfoCreateInput = {
  address?: InputMaybe<AddressCreateInput>
  email: Scalars['String']['input']
  facebook?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  whatsapp?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type ContactInfoInput = {
  address?: InputMaybe<AddressInput>
  email?: InputMaybe<Scalars['String']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  whatsapp?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type ContactInfoNullableCompositeFilter = {
  equals?: InputMaybe<ContactInfoObjectEqualityInput>
  is?: InputMaybe<ContactInfoWhereInput>
  isNot?: InputMaybe<ContactInfoWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type ContactInfoNullableCreateEnvelopeInput = {
  set?: InputMaybe<ContactInfoCreateInput>
}

export type ContactInfoNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ContactInfoCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<ContactInfoUpsertInput>
}

export type ContactInfoObjectEqualityInput = {
  address?: InputMaybe<AddressObjectEqualityInput>
  email: Scalars['String']['input']
  facebook?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  phone: Scalars['String']['input']
  twitter?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  whatsapp?: InputMaybe<Scalars['String']['input']>
  x?: InputMaybe<Scalars['String']['input']>
}

export type ContactInfoOrderByInput = {
  address?: InputMaybe<AddressOrderByInput>
  email?: InputMaybe<SortOrder>
  facebook?: InputMaybe<SortOrder>
  fax?: InputMaybe<SortOrder>
  instagram?: InputMaybe<SortOrder>
  linkedin?: InputMaybe<SortOrder>
  mobile?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  twitter?: InputMaybe<SortOrder>
  website?: InputMaybe<SortOrder>
  whatsapp?: InputMaybe<SortOrder>
  x?: InputMaybe<SortOrder>
}

export type ContactInfoUpdateInput = {
  address?: InputMaybe<AddressNullableUpdateEnvelopeInput>
  email?: InputMaybe<StringFieldUpdateOperationsInput>
  facebook?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  fax?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  instagram?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  linkedin?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mobile?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  phone?: InputMaybe<StringFieldUpdateOperationsInput>
  twitter?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  website?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  whatsapp?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  x?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type ContactInfoUpsertInput = {
  set: ContactInfoCreateInput
  update: ContactInfoUpdateInput
}

export type ContactInfoWhereInput = {
  AND?: InputMaybe<Array<ContactInfoWhereInput>>
  NOT?: InputMaybe<Array<ContactInfoWhereInput>>
  OR?: InputMaybe<Array<ContactInfoWhereInput>>
  address?: InputMaybe<AddressNullableCompositeFilter>
  email?: InputMaybe<StringFilter>
  facebook?: InputMaybe<StringNullableFilter>
  fax?: InputMaybe<StringNullableFilter>
  instagram?: InputMaybe<StringNullableFilter>
  linkedin?: InputMaybe<StringNullableFilter>
  mobile?: InputMaybe<StringNullableFilter>
  phone?: InputMaybe<StringFilter>
  twitter?: InputMaybe<StringNullableFilter>
  website?: InputMaybe<StringNullableFilter>
  whatsapp?: InputMaybe<StringNullableFilter>
  x?: InputMaybe<StringNullableFilter>
}

export type Context = {
  __typename?: 'Context'
  address?: Maybe<AddressContext>
  country: Country
  locality?: Maybe<Locality>
  place?: Maybe<Place>
  postcode?: Maybe<Postcode>
  region: GeoRegion
  street?: Maybe<StreetContext>
}

export type ContextCreateInput = {
  address?: InputMaybe<AddressContextCreateInput>
  country: CountryCreateInput
  locality?: InputMaybe<LocalityCreateInput>
  place?: InputMaybe<PlaceCreateInput>
  postcode?: InputMaybe<PostcodeCreateInput>
  region: GeoRegionCreateInput
  street?: InputMaybe<StreetContextCreateInput>
}

export type ContextNullableCompositeFilter = {
  equals?: InputMaybe<ContextObjectEqualityInput>
  is?: InputMaybe<ContextWhereInput>
  isNot?: InputMaybe<ContextWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type ContextNullableUpdateEnvelopeInput = {
  set?: InputMaybe<ContextCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<ContextUpsertInput>
}

export type ContextObjectEqualityInput = {
  address?: InputMaybe<AddressContextObjectEqualityInput>
  country: CountryObjectEqualityInput
  locality?: InputMaybe<LocalityObjectEqualityInput>
  place?: InputMaybe<PlaceObjectEqualityInput>
  postcode?: InputMaybe<PostcodeObjectEqualityInput>
  region: GeoRegionObjectEqualityInput
  street?: InputMaybe<StreetContextObjectEqualityInput>
}

export type ContextOrderByInput = {
  address?: InputMaybe<AddressContextOrderByInput>
  country?: InputMaybe<CountryOrderByInput>
  locality?: InputMaybe<LocalityOrderByInput>
  place?: InputMaybe<PlaceOrderByInput>
  postcode?: InputMaybe<PostcodeOrderByInput>
  region?: InputMaybe<GeoRegionOrderByInput>
  street?: InputMaybe<StreetContextOrderByInput>
}

export type ContextUpdateInput = {
  address?: InputMaybe<AddressContextNullableUpdateEnvelopeInput>
  country?: InputMaybe<CountryUpdateEnvelopeInput>
  locality?: InputMaybe<LocalityNullableUpdateEnvelopeInput>
  place?: InputMaybe<PlaceNullableUpdateEnvelopeInput>
  postcode?: InputMaybe<PostcodeNullableUpdateEnvelopeInput>
  region?: InputMaybe<GeoRegionUpdateEnvelopeInput>
  street?: InputMaybe<StreetContextNullableUpdateEnvelopeInput>
}

export type ContextUpsertInput = {
  set: ContextCreateInput
  update: ContextUpdateInput
}

export type ContextWhereInput = {
  AND?: InputMaybe<Array<ContextWhereInput>>
  NOT?: InputMaybe<Array<ContextWhereInput>>
  OR?: InputMaybe<Array<ContextWhereInput>>
  address?: InputMaybe<AddressContextNullableCompositeFilter>
  country?: InputMaybe<CountryCompositeFilter>
  locality?: InputMaybe<LocalityNullableCompositeFilter>
  place?: InputMaybe<PlaceNullableCompositeFilter>
  postcode?: InputMaybe<PostcodeNullableCompositeFilter>
  region?: InputMaybe<GeoRegionCompositeFilter>
  street?: InputMaybe<StreetContextNullableCompositeFilter>
}

export type Conversation = {
  __typename?: 'Conversation'
  _count?: Maybe<ConversationCount>
  createdAt: Scalars['DateTimeISO']['output']
  id: Scalars['String']['output']
  lastMessageAt: Scalars['DateTimeISO']['output']
  leadId: Scalars['String']['output']
  unreadCount: Scalars['Int']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type ConversationCount = {
  __typename?: 'ConversationCount'
  messages: Scalars['Int']['output']
}

export type ConversationCountMessagesArgs = {
  where?: InputMaybe<MessageWhereInput>
}

export type ConversationCreateManyLeadInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastMessageAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  unreadCount?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type ConversationCreateManyLeadInputEnvelope = {
  data: Array<ConversationCreateManyLeadInput>
}

export type ConversationCreateNestedManyWithoutLeadInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutLeadInput>>
  create?: InputMaybe<Array<ConversationCreateWithoutLeadInput>>
  createMany?: InputMaybe<ConversationCreateManyLeadInputEnvelope>
}

export type ConversationCreateOrConnectWithoutLeadInput = {
  create: ConversationCreateWithoutLeadInput
  where: ConversationWhereUniqueInput
}

export type ConversationCreateWithoutLeadInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastMessageAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  messages?: InputMaybe<MessageCreateNestedManyWithoutConversationInput>
  unreadCount?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type ConversationListRelationFilter = {
  every?: InputMaybe<ConversationWhereInput>
  none?: InputMaybe<ConversationWhereInput>
  some?: InputMaybe<ConversationWhereInput>
}

export type ConversationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type ConversationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastMessageAt?: InputMaybe<SortOrder>
  lead?: InputMaybe<LeadOrderByWithRelationInput>
  leadId?: InputMaybe<SortOrder>
  messages?: InputMaybe<MessageOrderByRelationAggregateInput>
  unreadCount?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type ConversationRelationFilter = {
  is?: InputMaybe<ConversationWhereInput>
  isNot?: InputMaybe<ConversationWhereInput>
}

export enum ConversationScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  LastMessageAt = 'lastMessageAt',
  LeadId = 'leadId',
  UnreadCount = 'unreadCount',
  UpdatedAt = 'updatedAt',
}

export type ConversationScalarWhereInput = {
  AND?: InputMaybe<Array<ConversationScalarWhereInput>>
  NOT?: InputMaybe<Array<ConversationScalarWhereInput>>
  OR?: InputMaybe<Array<ConversationScalarWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  lastMessageAt?: InputMaybe<DateTimeFilter>
  leadId?: InputMaybe<StringFilter>
  unreadCount?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type ConversationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  lastMessageAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  unreadCount?: InputMaybe<IntFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type ConversationUpdateManyWithWhereWithoutLeadInput = {
  data: ConversationUpdateManyMutationInput
  where: ConversationScalarWhereInput
}

export type ConversationUpdateManyWithoutLeadNestedInput = {
  connect?: InputMaybe<Array<ConversationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<ConversationCreateOrConnectWithoutLeadInput>>
  create?: InputMaybe<Array<ConversationCreateWithoutLeadInput>>
  createMany?: InputMaybe<ConversationCreateManyLeadInputEnvelope>
  delete?: InputMaybe<Array<ConversationWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<ConversationScalarWhereInput>>
  disconnect?: InputMaybe<Array<ConversationWhereUniqueInput>>
  set?: InputMaybe<Array<ConversationWhereUniqueInput>>
  update?: InputMaybe<Array<ConversationUpdateWithWhereUniqueWithoutLeadInput>>
  updateMany?: InputMaybe<Array<ConversationUpdateManyWithWhereWithoutLeadInput>>
  upsert?: InputMaybe<Array<ConversationUpsertWithWhereUniqueWithoutLeadInput>>
}

export type ConversationUpdateWithWhereUniqueWithoutLeadInput = {
  data: ConversationUpdateWithoutLeadInput
  where: ConversationWhereUniqueInput
}

export type ConversationUpdateWithoutLeadInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  lastMessageAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  messages?: InputMaybe<MessageUpdateManyWithoutConversationNestedInput>
  unreadCount?: InputMaybe<IntFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type ConversationUpsertWithWhereUniqueWithoutLeadInput = {
  create: ConversationCreateWithoutLeadInput
  update: ConversationUpdateWithoutLeadInput
  where: ConversationWhereUniqueInput
}

export type ConversationWhereInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>
  NOT?: InputMaybe<Array<ConversationWhereInput>>
  OR?: InputMaybe<Array<ConversationWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  lastMessageAt?: InputMaybe<DateTimeFilter>
  lead?: InputMaybe<LeadRelationFilter>
  leadId?: InputMaybe<StringFilter>
  messages?: InputMaybe<MessageListRelationFilter>
  unreadCount?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type ConversationWhereUniqueInput = {
  AND?: InputMaybe<Array<ConversationWhereInput>>
  NOT?: InputMaybe<Array<ConversationWhereInput>>
  OR?: InputMaybe<Array<ConversationWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  lastMessageAt?: InputMaybe<DateTimeFilter>
  lead?: InputMaybe<LeadRelationFilter>
  leadId?: InputMaybe<StringFilter>
  messages?: InputMaybe<MessageListRelationFilter>
  unreadCount?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type Coordinates = {
  __typename?: 'Coordinates'
  accuracy?: Maybe<Scalars['String']['output']>
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
  routable_points: Array<RoutablePoint>
}

export type CoordinatesCreateInput = {
  accuracy?: InputMaybe<Scalars['String']['input']>
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
  routable_points?: InputMaybe<Array<RoutablePointCreateInput>>
}

export type CoordinatesNullableCompositeFilter = {
  equals?: InputMaybe<CoordinatesObjectEqualityInput>
  is?: InputMaybe<CoordinatesWhereInput>
  isNot?: InputMaybe<CoordinatesWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type CoordinatesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<CoordinatesCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<CoordinatesUpsertInput>
}

export type CoordinatesObjectEqualityInput = {
  accuracy?: InputMaybe<Scalars['String']['input']>
  latitude: Scalars['Float']['input']
  longitude: Scalars['Float']['input']
  routable_points?: InputMaybe<Array<RoutablePointObjectEqualityInput>>
}

export type CoordinatesOrderByInput = {
  accuracy?: InputMaybe<SortOrder>
  latitude?: InputMaybe<SortOrder>
  longitude?: InputMaybe<SortOrder>
  routable_points?: InputMaybe<RoutablePointOrderByCompositeAggregateInput>
}

export type CoordinatesUpdateInput = {
  accuracy?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  latitude?: InputMaybe<FloatFieldUpdateOperationsInput>
  longitude?: InputMaybe<FloatFieldUpdateOperationsInput>
  routable_points?: InputMaybe<Array<RoutablePointCreateInput>>
}

export type CoordinatesUpsertInput = {
  set: CoordinatesCreateInput
  update: CoordinatesUpdateInput
}

export type CoordinatesWhereInput = {
  AND?: InputMaybe<Array<CoordinatesWhereInput>>
  NOT?: InputMaybe<Array<CoordinatesWhereInput>>
  OR?: InputMaybe<Array<CoordinatesWhereInput>>
  accuracy?: InputMaybe<StringNullableFilter>
  latitude?: InputMaybe<FloatFilter>
  longitude?: InputMaybe<FloatFilter>
  routable_points?: InputMaybe<Array<RoutablePointObjectEqualityInput>>
}

export type Country = {
  __typename?: 'Country'
  country_code: Scalars['String']['output']
  country_code_alpha_3: Scalars['String']['output']
  mapbox_id?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  wikidata_id?: Maybe<Scalars['String']['output']>
}

export type CountryCompositeFilter = {
  equals?: InputMaybe<CountryObjectEqualityInput>
  is?: InputMaybe<CountryWhereInput>
  isNot?: InputMaybe<CountryWhereInput>
}

export type CountryCreateInput = {
  country_code: Scalars['String']['input']
  country_code_alpha_3: Scalars['String']['input']
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type CountryObjectEqualityInput = {
  country_code: Scalars['String']['input']
  country_code_alpha_3: Scalars['String']['input']
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type CountryOrderByInput = {
  country_code?: InputMaybe<SortOrder>
  country_code_alpha_3?: InputMaybe<SortOrder>
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  wikidata_id?: InputMaybe<SortOrder>
}

export type CountryUpdateEnvelopeInput = {
  set?: InputMaybe<CountryCreateInput>
  update?: InputMaybe<CountryUpdateInput>
}

export type CountryUpdateInput = {
  country_code?: InputMaybe<StringFieldUpdateOperationsInput>
  country_code_alpha_3?: InputMaybe<StringFieldUpdateOperationsInput>
  mapbox_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  wikidata_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type CountryWhereInput = {
  AND?: InputMaybe<Array<CountryWhereInput>>
  NOT?: InputMaybe<Array<CountryWhereInput>>
  OR?: InputMaybe<Array<CountryWhereInput>>
  country_code?: InputMaybe<StringFilter>
  country_code_alpha_3?: InputMaybe<StringFilter>
  mapbox_id?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  wikidata_id?: InputMaybe<StringNullableFilter>
}

export type CreateAgencyInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  contactInfo?: InputMaybe<AgencyContactInfoUpdateInput>
  description?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<DescriptionInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  services?: InputMaybe<Array<Scalars['String']['input']>>
  slugUrl?: InputMaybe<Scalars['String']['input']>
}

export type CreateAvailablePaidExtrasInput = {
  category?: InputMaybe<Scalars['String']['input']>
  currency?: Scalars['String']['input']
  defaultPrice?: Scalars['Int']['input']
  description?: InputMaybe<Scalars['String']['input']>
  iconUrl?: InputMaybe<Scalars['String']['input']>
  isActive?: Scalars['Boolean']['input']
  label?: InputMaybe<Scalars['String']['input']>
  promoBannerUrl?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationInput>>
  type: Scalars['String']['input']
}

export type CreateBulkPaidExtrasInput = {
  brokerId: Scalars['String']['input']
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  propertyIds: Array<Scalars['String']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  type: Scalars['String']['input']
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type CreatePaidExtraInput = {
  brokerId: Scalars['String']['input']
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  type: Scalars['String']['input']
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type CreatePermissionInput = {
  category?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
}

export type CreatePropertyReportInput = {
  description?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  propertyId: Scalars['String']['input']
  reportReason: ReportReason
}

export type CreateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
}

export type CreateSubscriptionInput = {
  autoRenew?: Scalars['Boolean']['input']
  brokerId: Scalars['String']['input']
  currency?: Scalars['String']['input']
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price: Scalars['Float']['input']
  slotCount?: InputMaybe<Scalars['Int']['input']>
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
}

export type CreateUserInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  password?: InputMaybe<Scalars['String']['input']>
  role: Scalars['String']['input']
}

export type CronJobStatusItemModel = {
  __typename?: 'CronJobStatusItemModel'
  externalId: Scalars['String']['output']
  jobId?: Maybe<Scalars['String']['output']>
  jobType: Scalars['String']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['String']['output']
}

export type CustomerLeadResponse = {
  __typename?: 'CustomerLeadResponse'
  acceptMarketing: Scalars['Boolean']['output']
  country?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  firstName?: Maybe<Scalars['String']['output']>
  hasWhatsApp: Scalars['Boolean']['output']
  lastName?: Maybe<Scalars['String']['output']>
  leadBroker?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  phone?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  utm_campaign?: Maybe<Scalars['String']['output']>
  utm_content?: Maybe<Scalars['String']['output']>
  utm_medium?: Maybe<Scalars['String']['output']>
  utm_source?: Maybe<Scalars['String']['output']>
  utm_term?: Maybe<Scalars['String']['output']>
}

export type CustomerLoginResponse = {
  __typename?: 'CustomerLoginResponse'
  accessToken: Scalars['String']['output']
  customer: CustomerModel
}

export type CustomerModel = {
  __typename?: 'CustomerModel'
  acceptedMarketing?: Maybe<Scalars['Boolean']['output']>
  acceptedMarketingDate?: Maybe<Scalars['DateTimeISO']['output']>
  address?: Maybe<Scalars['String']['output']>
  address2?: Maybe<Scalars['String']['output']>
  agency?: Maybe<Broker>
  city?: Maybe<Scalars['String']['output']>
  company?: Maybe<Scalars['String']['output']>
  conversations: Scalars['String']['output']
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  currency?: Maybe<Scalars['String']['output']>
  deletedAt?: Maybe<Scalars['DateTimeISO']['output']>
  email: Scalars['String']['output']
  facebook?: Maybe<Scalars['String']['output']>
  favorites: Array<Scalars['String']['output']>
  fax?: Maybe<Scalars['String']['output']>
  firstName?: Maybe<Scalars['String']['output']>
  foursquare?: Maybe<Scalars['String']['output']>
  instagram?: Maybe<Scalars['String']['output']>
  lastLogin?: Maybe<Scalars['DateTimeISO']['output']>
  lastName?: Maybe<Scalars['String']['output']>
  leads: Array<CustomerLeadResponse>
  linkedin?: Maybe<Scalars['String']['output']>
  mobile?: Maybe<Scalars['String']['output']>
  phoneNumber?: Maybe<Scalars['String']['output']>
  picUrl?: Maybe<Scalars['String']['output']>
  position?: Maybe<Scalars['String']['output']>
  preferredLocale?: Maybe<Scalars['String']['output']>
  roles: Array<Scalars['String']['output']>
  skype?: Maybe<Scalars['String']['output']>
  state?: Maybe<Scalars['String']['output']>
  timezone?: Maybe<Scalars['String']['output']>
  twitter?: Maybe<Scalars['String']['output']>
  uiThemeName?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  userId: Scalars['ID']['output']
  website?: Maybe<Scalars['String']['output']>
  zipCode?: Maybe<Scalars['String']['output']>
}

export type CustomerSettingsResponse = {
  __typename?: 'CustomerSettingsResponse'
  customer?: Maybe<CustomerModel>
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type CustomerSignupResult = {
  __typename?: 'CustomerSignupResult'
  customer: CustomerModel
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type CustomerStats = {
  __typename?: 'CustomerStats'
  lastActivity?: Maybe<Scalars['DateTimeISO']['output']>
  totalConversations: Scalars['Float']['output']
  totalFavorites: Scalars['Float']['output']
  totalLeads: Scalars['Float']['output']
  totalPropertiesViewed: Scalars['Float']['output']
}

export type CustomerStatsData = {
  __typename?: 'CustomerStatsData'
  customerEmails: Array<Scalars['String']['output']>
  totalCustomers: Scalars['Float']['output']
}

export type DailyFetchStats = {
  __typename?: 'DailyFetchStats'
  count: Scalars['Int']['output']
  date: Scalars['String']['output']
}

export type DashboardStatsModel = {
  __typename?: 'DashboardStatsModel'
  activeUsers: Scalars['Float']['output']
  agenciesWithUsers: Scalars['Float']['output']
  agencyDistribution: Array<AgencyDistributionModel>
  customerCount: Scalars['Float']['output']
  recentActivities: Scalars['Float']['output']
  recentActivity: Array<RecentActivityModel>
  totalAgencies: Scalars['Float']['output']
  totalPermissions: Scalars['Float']['output']
  totalRoles: Scalars['Float']['output']
  totalUsers: Scalars['Float']['output']
  userGrowth: UserGrowthModel
}

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeNullableFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type DateTimeNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  has?: InputMaybe<Scalars['DateTimeISO']['input']>
  hasEvery?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  hasSome?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedDateTimeNullableFilter>
  _min?: InputMaybe<NestedDateTimeNullableFilter>
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedDateTimeFilter>
  _min?: InputMaybe<NestedDateTimeFilter>
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type Description = {
  __typename?: 'Description'
  imageLinks: Array<DescriptionImageLink>
  language: Scalars['String']['output']
  short?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type DescriptionCreateInput = {
  imageLinks?: InputMaybe<Array<DescriptionImageLinkCreateInput>>
  language: Scalars['String']['input']
  short?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type DescriptionImageLink = {
  __typename?: 'DescriptionImageLink'
  imageIndex: Scalars['Int']['output']
  phrase: Scalars['String']['output']
}

export type DescriptionImageLinkCreateInput = {
  imageIndex: Scalars['Int']['input']
  phrase: Scalars['String']['input']
}

export type DescriptionImageLinkObjectEqualityInput = {
  imageIndex: Scalars['Int']['input']
  phrase: Scalars['String']['input']
}

export type DescriptionInput = {
  language: Scalars['String']['input']
  short?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type DescriptionObjectEqualityInput = {
  imageLinks?: InputMaybe<Array<DescriptionImageLinkObjectEqualityInput>>
  language: Scalars['String']['input']
  short?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type DescriptionOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type DistrictPropertyCount = {
  __typename?: 'DistrictPropertyCount'
  count: Scalars['Int']['output']
  key: Scalars['String']['output']
}

export enum DraftStatus {
  Approved = 'approved',
  Draft = 'draft',
  Duplicate = 'duplicate',
  Error = 'error',
  Pending = 'pending',
  Published = 'published',
  Rejected = 'rejected',
}

export type DuplicateGroupModel = {
  __typename?: 'DuplicateGroupModel'
  count: Scalars['Float']['output']
  hash: Scalars['String']['output']
  items: Array<DuplicateItemModel>
}

export type DuplicateItemModel = {
  __typename?: 'DuplicateItemModel'
  checkedAt: Scalars['String']['output']
  collidedPropertyId?: Maybe<Scalars['String']['output']>
  exactHash: Scalars['String']['output']
  fileName: Scalars['String']['output']
  imageHash: Scalars['String']['output']
  propertyId: Scalars['String']['output']
}

export type DuplicatesResponseModel = {
  __typename?: 'DuplicatesResponseModel'
  actualDuplicateCount: Scalars['Float']['output']
  actualDuplicates: Array<DuplicateItemModel>
  count: Scalars['Float']['output']
  duplicateGroupCount: Scalars['Float']['output']
  duplicateGroups: Array<DuplicateGroupModel>
  duplicates: Array<DuplicateItemModel>
  hasMore: Scalars['Boolean']['output']
  lastEvaluatedKey?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  requestId: Scalars['String']['output']
}

export type EnergyRating = {
  __typename?: 'EnergyRating'
  classificationImageUrl?: Maybe<Scalars['String']['output']>
  co2Rated?: Maybe<Scalars['String']['output']>
  co2Value?: Maybe<Scalars['String']['output']>
  energyRated?: Maybe<Scalars['String']['output']>
  energyValue?: Maybe<Scalars['String']['output']>
}

export type EnergyRatingCreateInput = {
  classificationImageUrl?: InputMaybe<Scalars['String']['input']>
  co2Rated?: InputMaybe<Scalars['String']['input']>
  co2Value?: InputMaybe<Scalars['String']['input']>
  energyRated?: InputMaybe<Scalars['String']['input']>
  energyValue?: InputMaybe<Scalars['String']['input']>
}

export type EnergyRatingNullableCompositeFilter = {
  equals?: InputMaybe<EnergyRatingObjectEqualityInput>
  is?: InputMaybe<EnergyRatingWhereInput>
  isNot?: InputMaybe<EnergyRatingWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type EnergyRatingNullableCreateEnvelopeInput = {
  set?: InputMaybe<EnergyRatingCreateInput>
}

export type EnergyRatingNullableUpdateEnvelopeInput = {
  set?: InputMaybe<EnergyRatingCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<EnergyRatingUpsertInput>
}

export type EnergyRatingObjectEqualityInput = {
  classificationImageUrl?: InputMaybe<Scalars['String']['input']>
  co2Rated?: InputMaybe<Scalars['String']['input']>
  co2Value?: InputMaybe<Scalars['String']['input']>
  energyRated?: InputMaybe<Scalars['String']['input']>
  energyValue?: InputMaybe<Scalars['String']['input']>
}

export type EnergyRatingOrderByInput = {
  classificationImageUrl?: InputMaybe<SortOrder>
  co2Rated?: InputMaybe<SortOrder>
  co2Value?: InputMaybe<SortOrder>
  energyRated?: InputMaybe<SortOrder>
  energyValue?: InputMaybe<SortOrder>
}

export type EnergyRatingUpdateInput = {
  classificationImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  co2Rated?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  co2Value?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  energyRated?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  energyValue?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type EnergyRatingUpsertInput = {
  set: EnergyRatingCreateInput
  update: EnergyRatingUpdateInput
}

export type EnergyRatingWhereInput = {
  AND?: InputMaybe<Array<EnergyRatingWhereInput>>
  NOT?: InputMaybe<Array<EnergyRatingWhereInput>>
  OR?: InputMaybe<Array<EnergyRatingWhereInput>>
  classificationImageUrl?: InputMaybe<StringNullableFilter>
  co2Rated?: InputMaybe<StringNullableFilter>
  co2Value?: InputMaybe<StringNullableFilter>
  energyRated?: InputMaybe<StringNullableFilter>
  energyValue?: InputMaybe<StringNullableFilter>
}

export type EnumAiVisualsTierFieldUpdateOperationsInput = {
  set?: InputMaybe<AiVisualsTier>
}

export type EnumAiVisualsTierFilter = {
  equals?: InputMaybe<AiVisualsTier>
  in?: InputMaybe<Array<AiVisualsTier>>
  not?: InputMaybe<NestedEnumAiVisualsTierFilter>
  notIn?: InputMaybe<Array<AiVisualsTier>>
}

export type EnumAiVisualsTierWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedEnumAiVisualsTierFilter>
  _min?: InputMaybe<NestedEnumAiVisualsTierFilter>
  equals?: InputMaybe<AiVisualsTier>
  in?: InputMaybe<Array<AiVisualsTier>>
  not?: InputMaybe<NestedEnumAiVisualsTierWithAggregatesFilter>
  notIn?: InputMaybe<Array<AiVisualsTier>>
}

export type EnumBathroomQualityNullableFilter = {
  equals?: InputMaybe<BathroomQuality>
  in?: InputMaybe<Array<BathroomQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumBathroomQualityNullableFilter>
  notIn?: InputMaybe<Array<BathroomQuality>>
}

export type EnumDraftStatusNullableFilter = {
  equals?: InputMaybe<DraftStatus>
  in?: InputMaybe<Array<DraftStatus>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumDraftStatusNullableFilter>
  notIn?: InputMaybe<Array<DraftStatus>>
}

export type EnumFlooringTypeNullableListFilter = {
  equals?: InputMaybe<Array<FlooringType>>
  has?: InputMaybe<FlooringType>
  hasEvery?: InputMaybe<Array<FlooringType>>
  hasSome?: InputMaybe<Array<FlooringType>>
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type EnumKitchenQualityNullableFilter = {
  equals?: InputMaybe<KitchenQuality>
  in?: InputMaybe<Array<KitchenQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumKitchenQualityNullableFilter>
  notIn?: InputMaybe<Array<KitchenQuality>>
}

export type EnumMaintenanceHistoryNullableFilter = {
  equals?: InputMaybe<MaintenanceHistory>
  in?: InputMaybe<Array<MaintenanceHistory>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumMaintenanceHistoryNullableFilter>
  notIn?: InputMaybe<Array<MaintenanceHistory>>
}

export type EnumPaidExtraStatusNullableFilter = {
  equals?: InputMaybe<PaidExtraStatus>
  in?: InputMaybe<Array<PaidExtraStatus>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumPaidExtraStatusNullableFilter>
  notIn?: InputMaybe<Array<PaidExtraStatus>>
}

export type EnumPropertyConditionNullableFilter = {
  equals?: InputMaybe<PropertyCondition>
  in?: InputMaybe<Array<PropertyCondition>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumPropertyConditionNullableFilter>
  notIn?: InputMaybe<Array<PropertyCondition>>
}

export type EnumRenovationQualityNullableFilter = {
  equals?: InputMaybe<RenovationQuality>
  in?: InputMaybe<Array<RenovationQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumRenovationQualityNullableFilter>
  notIn?: InputMaybe<Array<RenovationQuality>>
}

export type EnumReportReasonFieldUpdateOperationsInput = {
  set?: InputMaybe<ReportReason>
}

export type EnumReportReasonFilter = {
  equals?: InputMaybe<ReportReason>
  in?: InputMaybe<Array<ReportReason>>
  not?: InputMaybe<NestedEnumReportReasonFilter>
  notIn?: InputMaybe<Array<ReportReason>>
}

export type FavoriteResponse = {
  __typename?: 'FavoriteResponse'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type Feature = {
  __typename?: 'Feature'
  Brokers: Array<Broker>
  _count?: Maybe<FeatureCount>
  brokerIds: Array<Scalars['String']['output']>
  category: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  icon?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  name: Scalars['String']['output']
  paramName: Scalars['String']['output']
  properties: Array<Property>
  propertyIds: Array<Scalars['String']['output']>
  translation?: Maybe<Scalars['String']['output']>
  translations: Array<FeatureTranslation>
}

export type FeatureBrokersArgs = {
  cursor?: InputMaybe<BrokerWhereUniqueInput>
  distinct?: InputMaybe<Array<BrokerScalarFieldEnum>>
  orderBy?: InputMaybe<Array<BrokerOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BrokerWhereInput>
}

export type FeaturePropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type FeatureCount = {
  __typename?: 'FeatureCount'
  Brokers: Scalars['Int']['output']
  properties: Scalars['Int']['output']
}

export type FeatureCountBrokersArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type FeatureCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type FeatureCreateNestedManyWithoutBrokersInput = {
  connect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<FeatureCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<FeatureCreateWithoutBrokersInput>>
}

export type FeatureCreateNestedManyWithoutPropertiesInput = {
  connect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<FeatureCreateOrConnectWithoutPropertiesInput>>
  create?: InputMaybe<Array<FeatureCreateWithoutPropertiesInput>>
}

export type FeatureCreateOrConnectWithoutBrokersInput = {
  create: FeatureCreateWithoutBrokersInput
  where: FeatureWhereUniqueInput
}

export type FeatureCreateOrConnectWithoutPropertiesInput = {
  create: FeatureCreateWithoutPropertiesInput
  where: FeatureWhereUniqueInput
}

export type FeatureCreateWithoutBrokersInput = {
  category: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paramName: Scalars['String']['input']
  properties?: InputMaybe<PropertyCreateNestedManyWithoutFeaturesInput>
  translation?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<FeatureTranslationCreateInput>>
}

export type FeatureCreateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutFeatureOptionsInput>
  category: Scalars['String']['input']
  description?: InputMaybe<Scalars['String']['input']>
  icon?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  paramName: Scalars['String']['input']
  translation?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<FeatureTranslationCreateInput>>
}

export type FeatureListRelationFilter = {
  every?: InputMaybe<FeatureWhereInput>
  none?: InputMaybe<FeatureWhereInput>
  some?: InputMaybe<FeatureWhereInput>
}

export type FeatureOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type FeatureOrderByWithRelationInput = {
  Brokers?: InputMaybe<BrokerOrderByRelationAggregateInput>
  brokerIds?: InputMaybe<SortOrder>
  category?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  icon?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  paramName?: InputMaybe<SortOrder>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  propertyIds?: InputMaybe<SortOrder>
  translation?: InputMaybe<SortOrder>
  translations?: InputMaybe<FeatureTranslationOrderByCompositeAggregateInput>
}

export enum FeatureScalarFieldEnum {
  BrokerIds = 'brokerIds',
  Category = 'category',
  Description = 'description',
  Icon = 'icon',
  Id = 'id',
  Name = 'name',
  ParamName = 'paramName',
  PropertyIds = 'propertyIds',
  Translation = 'translation',
}

export type FeatureScalarWhereInput = {
  AND?: InputMaybe<Array<FeatureScalarWhereInput>>
  NOT?: InputMaybe<Array<FeatureScalarWhereInput>>
  OR?: InputMaybe<Array<FeatureScalarWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  category?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  icon?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  paramName?: InputMaybe<StringFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  translation?: InputMaybe<StringNullableFilter>
}

export type FeatureTranslation = {
  __typename?: 'FeatureTranslation'
  category?: Maybe<Scalars['String']['output']>
  language: Scalars['String']['output']
  name?: Maybe<Scalars['String']['output']>
}

export type FeatureTranslationCreateInput = {
  category?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type FeatureTranslationObjectEqualityInput = {
  category?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type FeatureTranslationOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type FeatureUpdateManyMutationInput = {
  category?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paramName?: InputMaybe<StringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<FeatureTranslationCreateInput>>
}

export type FeatureUpdateManyWithWhereWithoutBrokersInput = {
  data: FeatureUpdateManyMutationInput
  where: FeatureScalarWhereInput
}

export type FeatureUpdateManyWithWhereWithoutPropertiesInput = {
  data: FeatureUpdateManyMutationInput
  where: FeatureScalarWhereInput
}

export type FeatureUpdateManyWithoutBrokersNestedInput = {
  connect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<FeatureCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<FeatureCreateWithoutBrokersInput>>
  delete?: InputMaybe<Array<FeatureWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<FeatureScalarWhereInput>>
  disconnect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  set?: InputMaybe<Array<FeatureWhereUniqueInput>>
  update?: InputMaybe<Array<FeatureUpdateWithWhereUniqueWithoutBrokersInput>>
  updateMany?: InputMaybe<Array<FeatureUpdateManyWithWhereWithoutBrokersInput>>
  upsert?: InputMaybe<Array<FeatureUpsertWithWhereUniqueWithoutBrokersInput>>
}

export type FeatureUpdateManyWithoutPropertiesNestedInput = {
  connect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<FeatureCreateOrConnectWithoutPropertiesInput>>
  create?: InputMaybe<Array<FeatureCreateWithoutPropertiesInput>>
  delete?: InputMaybe<Array<FeatureWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<FeatureScalarWhereInput>>
  disconnect?: InputMaybe<Array<FeatureWhereUniqueInput>>
  set?: InputMaybe<Array<FeatureWhereUniqueInput>>
  update?: InputMaybe<Array<FeatureUpdateWithWhereUniqueWithoutPropertiesInput>>
  updateMany?: InputMaybe<Array<FeatureUpdateManyWithWhereWithoutPropertiesInput>>
  upsert?: InputMaybe<Array<FeatureUpsertWithWhereUniqueWithoutPropertiesInput>>
}

export type FeatureUpdateWithWhereUniqueWithoutBrokersInput = {
  data: FeatureUpdateWithoutBrokersInput
  where: FeatureWhereUniqueInput
}

export type FeatureUpdateWithWhereUniqueWithoutPropertiesInput = {
  data: FeatureUpdateWithoutPropertiesInput
  where: FeatureWhereUniqueInput
}

export type FeatureUpdateWithoutBrokersInput = {
  category?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paramName?: InputMaybe<StringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutFeaturesNestedInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<FeatureTranslationCreateInput>>
}

export type FeatureUpdateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutFeatureOptionsNestedInput>
  category?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  icon?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  paramName?: InputMaybe<StringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<FeatureTranslationCreateInput>>
}

export type FeatureUpsertWithWhereUniqueWithoutBrokersInput = {
  create: FeatureCreateWithoutBrokersInput
  update: FeatureUpdateWithoutBrokersInput
  where: FeatureWhereUniqueInput
}

export type FeatureUpsertWithWhereUniqueWithoutPropertiesInput = {
  create: FeatureCreateWithoutPropertiesInput
  update: FeatureUpdateWithoutPropertiesInput
  where: FeatureWhereUniqueInput
}

export type FeatureWhereInput = {
  AND?: InputMaybe<Array<FeatureWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<FeatureWhereInput>>
  OR?: InputMaybe<Array<FeatureWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  category?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  icon?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  paramName?: InputMaybe<StringFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  translation?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<FeatureTranslationObjectEqualityInput>>
}

export type FeatureWhereUniqueInput = {
  AND?: InputMaybe<Array<FeatureWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<FeatureWhereInput>>
  OR?: InputMaybe<Array<FeatureWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  category?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  icon?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<StringFilter>
  paramName?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  translation?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<FeatureTranslationObjectEqualityInput>>
}

export type Fees = {
  __typename?: 'Fees'
  IBIFeesYear?: Maybe<Scalars['Float']['output']>
  communityFeesYear?: Maybe<Scalars['Float']['output']>
  garbageTax?: Maybe<Scalars['Float']['output']>
}

export type FeesCreateInput = {
  IBIFeesYear?: InputMaybe<Scalars['Float']['input']>
  communityFeesYear?: InputMaybe<Scalars['Float']['input']>
  garbageTax?: InputMaybe<Scalars['Float']['input']>
}

export type FeesNullableCompositeFilter = {
  equals?: InputMaybe<FeesObjectEqualityInput>
  is?: InputMaybe<FeesWhereInput>
  isNot?: InputMaybe<FeesWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type FeesNullableCreateEnvelopeInput = {
  set?: InputMaybe<FeesCreateInput>
}

export type FeesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<FeesCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<FeesUpsertInput>
}

export type FeesObjectEqualityInput = {
  IBIFeesYear?: InputMaybe<Scalars['Float']['input']>
  communityFeesYear?: InputMaybe<Scalars['Float']['input']>
  garbageTax?: InputMaybe<Scalars['Float']['input']>
}

export type FeesOrderByInput = {
  IBIFeesYear?: InputMaybe<SortOrder>
  communityFeesYear?: InputMaybe<SortOrder>
  garbageTax?: InputMaybe<SortOrder>
}

export type FeesUpdateInput = {
  IBIFeesYear?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  communityFeesYear?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  garbageTax?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
}

export type FeesUpsertInput = {
  set: FeesCreateInput
  update: FeesUpdateInput
}

export type FeesWhereInput = {
  AND?: InputMaybe<Array<FeesWhereInput>>
  IBIFeesYear?: InputMaybe<FloatNullableFilter>
  NOT?: InputMaybe<Array<FeesWhereInput>>
  OR?: InputMaybe<Array<FeesWhereInput>>
  communityFeesYear?: InputMaybe<FloatNullableFilter>
  garbageTax?: InputMaybe<FloatNullableFilter>
}

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>
  divide?: InputMaybe<Scalars['Float']['input']>
  increment?: InputMaybe<Scalars['Float']['input']>
  multiply?: InputMaybe<Scalars['Float']['input']>
  set?: InputMaybe<Scalars['Float']['input']>
}

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatNullableFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type FloatNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Float']['input']>>
  has?: InputMaybe<Scalars['Float']['input']>
  hasEvery?: InputMaybe<Array<Scalars['Float']['input']>>
  hasSome?: InputMaybe<Array<Scalars['Float']['input']>>
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedFloatFilter>
  _min?: InputMaybe<NestedFloatFilter>
  _sum?: InputMaybe<NestedFloatFilter>
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export enum FlooringType {
  Bamboo = 'bamboo',
  Carpet = 'carpet',
  Concrete = 'concrete',
  Cork = 'cork',
  Granite = 'granite',
  Hardwood = 'hardwood',
  Laminate = 'laminate',
  Marble = 'marble',
  Tile = 'tile',
  Vinyl = 'vinyl',
}

export type GeoProperties = {
  __typename?: 'GeoProperties'
  context?: Maybe<Context>
  coordinates?: Maybe<Coordinates>
  feature_type?: Maybe<Scalars['String']['output']>
  full_address?: Maybe<Scalars['String']['output']>
  mapbox_id?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  name_preferred?: Maybe<Scalars['String']['output']>
  place_formatted?: Maybe<Scalars['String']['output']>
}

export type GeoPropertiesCreateInput = {
  context?: InputMaybe<ContextCreateInput>
  coordinates?: InputMaybe<CoordinatesCreateInput>
  feature_type?: InputMaybe<Scalars['String']['input']>
  full_address?: InputMaybe<Scalars['String']['input']>
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  name_preferred?: InputMaybe<Scalars['String']['input']>
  place_formatted?: InputMaybe<Scalars['String']['input']>
}

export type GeoPropertiesNullableCompositeFilter = {
  equals?: InputMaybe<GeoPropertiesObjectEqualityInput>
  is?: InputMaybe<GeoPropertiesWhereInput>
  isNot?: InputMaybe<GeoPropertiesWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type GeoPropertiesNullableCreateEnvelopeInput = {
  set?: InputMaybe<GeoPropertiesCreateInput>
}

export type GeoPropertiesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<GeoPropertiesCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<GeoPropertiesUpsertInput>
}

export type GeoPropertiesObjectEqualityInput = {
  context?: InputMaybe<ContextObjectEqualityInput>
  coordinates?: InputMaybe<CoordinatesObjectEqualityInput>
  feature_type?: InputMaybe<Scalars['String']['input']>
  full_address?: InputMaybe<Scalars['String']['input']>
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  name_preferred?: InputMaybe<Scalars['String']['input']>
  place_formatted?: InputMaybe<Scalars['String']['input']>
}

export type GeoPropertiesOrderByInput = {
  context?: InputMaybe<ContextOrderByInput>
  coordinates?: InputMaybe<CoordinatesOrderByInput>
  feature_type?: InputMaybe<SortOrder>
  full_address?: InputMaybe<SortOrder>
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  name_preferred?: InputMaybe<SortOrder>
  place_formatted?: InputMaybe<SortOrder>
}

export type GeoPropertiesUpdateInput = {
  context?: InputMaybe<ContextNullableUpdateEnvelopeInput>
  coordinates?: InputMaybe<CoordinatesNullableUpdateEnvelopeInput>
  feature_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  full_address?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapbox_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name_preferred?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  place_formatted?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type GeoPropertiesUpsertInput = {
  set: GeoPropertiesCreateInput
  update: GeoPropertiesUpdateInput
}

export type GeoPropertiesWhereInput = {
  AND?: InputMaybe<Array<GeoPropertiesWhereInput>>
  NOT?: InputMaybe<Array<GeoPropertiesWhereInput>>
  OR?: InputMaybe<Array<GeoPropertiesWhereInput>>
  context?: InputMaybe<ContextNullableCompositeFilter>
  coordinates?: InputMaybe<CoordinatesNullableCompositeFilter>
  feature_type?: InputMaybe<StringNullableFilter>
  full_address?: InputMaybe<StringNullableFilter>
  mapbox_id?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringNullableFilter>
  name_preferred?: InputMaybe<StringNullableFilter>
  place_formatted?: InputMaybe<StringNullableFilter>
}

export type GeoRegion = {
  __typename?: 'GeoRegion'
  alternate?: Maybe<RegionAlternate>
  mapbox_id?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  region_code: Scalars['String']['output']
  region_code_full: Scalars['String']['output']
  wikidata_id?: Maybe<Scalars['String']['output']>
}

export type GeoRegionCompositeFilter = {
  equals?: InputMaybe<GeoRegionObjectEqualityInput>
  is?: InputMaybe<GeoRegionWhereInput>
  isNot?: InputMaybe<GeoRegionWhereInput>
}

export type GeoRegionCreateInput = {
  alternate?: InputMaybe<RegionAlternateCreateInput>
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  region_code: Scalars['String']['input']
  region_code_full: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type GeoRegionObjectEqualityInput = {
  alternate?: InputMaybe<RegionAlternateObjectEqualityInput>
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  region_code: Scalars['String']['input']
  region_code_full: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type GeoRegionOrderByInput = {
  alternate?: InputMaybe<RegionAlternateOrderByInput>
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  region_code?: InputMaybe<SortOrder>
  region_code_full?: InputMaybe<SortOrder>
  wikidata_id?: InputMaybe<SortOrder>
}

export type GeoRegionUpdateEnvelopeInput = {
  set?: InputMaybe<GeoRegionCreateInput>
  update?: InputMaybe<GeoRegionUpdateInput>
}

export type GeoRegionUpdateInput = {
  alternate?: InputMaybe<RegionAlternateNullableUpdateEnvelopeInput>
  mapbox_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  region_code?: InputMaybe<StringFieldUpdateOperationsInput>
  region_code_full?: InputMaybe<StringFieldUpdateOperationsInput>
  wikidata_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type GeoRegionWhereInput = {
  AND?: InputMaybe<Array<GeoRegionWhereInput>>
  NOT?: InputMaybe<Array<GeoRegionWhereInput>>
  OR?: InputMaybe<Array<GeoRegionWhereInput>>
  alternate?: InputMaybe<RegionAlternateNullableCompositeFilter>
  mapbox_id?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  region_code?: InputMaybe<StringFilter>
  region_code_full?: InputMaybe<StringFilter>
  wikidata_id?: InputMaybe<StringNullableFilter>
}

export type Geometry = {
  __typename?: 'Geometry'
  coordinates: Array<Scalars['Float']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type GeometryCreateInput = {
  coordinates?: InputMaybe<GeometryCreatecoordinatesInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type GeometryCreatecoordinatesInput = {
  set: Array<Scalars['Float']['input']>
}

export type GeometryNullableCompositeFilter = {
  equals?: InputMaybe<GeometryObjectEqualityInput>
  is?: InputMaybe<GeometryWhereInput>
  isNot?: InputMaybe<GeometryWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type GeometryNullableCreateEnvelopeInput = {
  set?: InputMaybe<GeometryCreateInput>
}

export type GeometryNullableUpdateEnvelopeInput = {
  set?: InputMaybe<GeometryCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<GeometryUpsertInput>
}

export type GeometryObjectEqualityInput = {
  coordinates?: InputMaybe<Array<Scalars['Float']['input']>>
  type?: InputMaybe<Scalars['String']['input']>
}

export type GeometryOrderByInput = {
  coordinates?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
}

export type GeometryUpdateInput = {
  coordinates?: InputMaybe<GeometryUpdatecoordinatesInput>
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type GeometryUpdatecoordinatesInput = {
  push?: InputMaybe<Array<Scalars['Float']['input']>>
  set?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type GeometryUpsertInput = {
  set: GeometryCreateInput
  update: GeometryUpdateInput
}

export type GeometryWhereInput = {
  AND?: InputMaybe<Array<GeometryWhereInput>>
  NOT?: InputMaybe<Array<GeometryWhereInput>>
  OR?: InputMaybe<Array<GeometryWhereInput>>
  coordinates?: InputMaybe<FloatNullableListFilter>
  type?: InputMaybe<StringNullableFilter>
}

export type HubMarketStats = {
  __typename?: 'HubMarketStats'
  averagePrice?: Maybe<Scalars['Float']['output']>
  averagePricePerSquareMeter?: Maybe<Scalars['Float']['output']>
  propertyCount: Scalars['Int']['output']
  propertyTypeDistribution: Array<HubStatsLabelCount>
  updatedAt: Scalars['DateTimeISO']['output']
}

export type HubStatsLabelCount = {
  __typename?: 'HubStatsLabelCount'
  label: Scalars['String']['output']
  value: Scalars['Int']['output']
}

export type Images = {
  __typename?: 'Images'
  id: Scalars['String']['output']
  large: Array<Scalars['String']['output']>
  medium: Array<Scalars['String']['output']>
  property: Property
  propertyId: Scalars['String']['output']
  /** Gallery rotation per index (0, 90, 180, 270) — parallel to `large` */
  rotations: Array<Scalars['Int']['output']>
  small: Array<Scalars['String']['output']>
  thumbnails: Array<Scalars['String']['output']>
}

export type ImagesAi = {
  __typename?: 'ImagesAI'
  /** Broker/admin approved — public site only shows imagesAI when true */
  approved: Scalars['Boolean']['output']
  approvedAt?: Maybe<Scalars['DateTimeISO']['output']>
  /** Auth service user id (SuperTokens UUID), not Mongo User _id */
  approvedBy?: Maybe<Scalars['String']['output']>
  /** processing | preview | approved */
  enrichmentStatus?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  images: Array<AiImage>
  propertyId: Scalars['String']['output']
}

export type ImagesAiCreateNestedOneWithoutPropertyInput = {
  connect?: InputMaybe<ImagesAiWhereUniqueInput>
  connectOrCreate?: InputMaybe<ImagesAiCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<ImagesAiCreateWithoutPropertyInput>
}

export type ImagesAiCreateOrConnectWithoutPropertyInput = {
  create: ImagesAiCreateWithoutPropertyInput
  where: ImagesAiWhereUniqueInput
}

export type ImagesAiCreateWithoutPropertyInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>
  approvedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  approvedBy?: InputMaybe<Scalars['String']['input']>
  enrichmentStatus?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<Array<AiImageCreateInput>>
}

export type ImagesAiNullableRelationFilter = {
  is?: InputMaybe<ImagesAiWhereInput>
  isNot?: InputMaybe<ImagesAiWhereInput>
}

export type ImagesAiOrderByWithRelationInput = {
  approved?: InputMaybe<SortOrder>
  approvedAt?: InputMaybe<SortOrder>
  approvedBy?: InputMaybe<SortOrder>
  enrichmentStatus?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  images?: InputMaybe<AiImageOrderByCompositeAggregateInput>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
}

export type ImagesAiUpdateOneWithoutPropertyNestedInput = {
  connect?: InputMaybe<ImagesAiWhereUniqueInput>
  connectOrCreate?: InputMaybe<ImagesAiCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<ImagesAiCreateWithoutPropertyInput>
  delete?: InputMaybe<ImagesAiWhereInput>
  disconnect?: InputMaybe<ImagesAiWhereInput>
  update?: InputMaybe<ImagesAiUpdateToOneWithWhereWithoutPropertyInput>
  upsert?: InputMaybe<ImagesAiUpsertWithoutPropertyInput>
}

export type ImagesAiUpdateToOneWithWhereWithoutPropertyInput = {
  data: ImagesAiUpdateWithoutPropertyInput
  where?: InputMaybe<ImagesAiWhereInput>
}

export type ImagesAiUpdateWithoutPropertyInput = {
  approved?: InputMaybe<BoolFieldUpdateOperationsInput>
  approvedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  approvedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  enrichmentStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  images?: InputMaybe<Array<AiImageCreateInput>>
}

export type ImagesAiUpsertWithoutPropertyInput = {
  create: ImagesAiCreateWithoutPropertyInput
  update: ImagesAiUpdateWithoutPropertyInput
  where?: InputMaybe<ImagesAiWhereInput>
}

export type ImagesAiWhereInput = {
  AND?: InputMaybe<Array<ImagesAiWhereInput>>
  NOT?: InputMaybe<Array<ImagesAiWhereInput>>
  OR?: InputMaybe<Array<ImagesAiWhereInput>>
  approved?: InputMaybe<BoolFilter>
  approvedAt?: InputMaybe<DateTimeNullableFilter>
  approvedBy?: InputMaybe<StringNullableFilter>
  enrichmentStatus?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  images?: InputMaybe<Array<AiImageObjectEqualityInput>>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
}

export type ImagesAiWhereUniqueInput = {
  AND?: InputMaybe<Array<ImagesAiWhereInput>>
  NOT?: InputMaybe<Array<ImagesAiWhereInput>>
  OR?: InputMaybe<Array<ImagesAiWhereInput>>
  approved?: InputMaybe<BoolFilter>
  approvedAt?: InputMaybe<DateTimeNullableFilter>
  approvedBy?: InputMaybe<StringNullableFilter>
  enrichmentStatus?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<Array<AiImageObjectEqualityInput>>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
}

export type ImagesCreateNestedOneWithoutPropertyInput = {
  connect?: InputMaybe<ImagesWhereUniqueInput>
  connectOrCreate?: InputMaybe<ImagesCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<ImagesCreateWithoutPropertyInput>
}

export type ImagesCreateOrConnectWithoutPropertyInput = {
  create: ImagesCreateWithoutPropertyInput
  where: ImagesWhereUniqueInput
}

export type ImagesCreateWithoutPropertyInput = {
  id?: InputMaybe<Scalars['String']['input']>
  large?: InputMaybe<ImagesCreatelargeInput>
  medium?: InputMaybe<ImagesCreatemediumInput>
  rotations?: InputMaybe<ImagesCreaterotationsInput>
  small?: InputMaybe<ImagesCreatesmallInput>
  thumbnails?: InputMaybe<ImagesCreatethumbnailsInput>
}

export type ImagesCreatelargeInput = {
  set: Array<Scalars['String']['input']>
}

export type ImagesCreatemediumInput = {
  set: Array<Scalars['String']['input']>
}

export type ImagesCreaterotationsInput = {
  set: Array<Scalars['Int']['input']>
}

export type ImagesCreatesmallInput = {
  set: Array<Scalars['String']['input']>
}

export type ImagesCreatethumbnailsInput = {
  set: Array<Scalars['String']['input']>
}

export type ImagesNullableRelationFilter = {
  is?: InputMaybe<ImagesWhereInput>
  isNot?: InputMaybe<ImagesWhereInput>
}

export type ImagesOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>
  large?: InputMaybe<SortOrder>
  medium?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  rotations?: InputMaybe<SortOrder>
  small?: InputMaybe<SortOrder>
  thumbnails?: InputMaybe<SortOrder>
}

export type ImagesUpdateOneWithoutPropertyNestedInput = {
  connect?: InputMaybe<ImagesWhereUniqueInput>
  connectOrCreate?: InputMaybe<ImagesCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<ImagesCreateWithoutPropertyInput>
  delete?: InputMaybe<ImagesWhereInput>
  disconnect?: InputMaybe<ImagesWhereInput>
  update?: InputMaybe<ImagesUpdateToOneWithWhereWithoutPropertyInput>
  upsert?: InputMaybe<ImagesUpsertWithoutPropertyInput>
}

export type ImagesUpdateToOneWithWhereWithoutPropertyInput = {
  data: ImagesUpdateWithoutPropertyInput
  where?: InputMaybe<ImagesWhereInput>
}

export type ImagesUpdateWithoutPropertyInput = {
  large?: InputMaybe<ImagesUpdatelargeInput>
  medium?: InputMaybe<ImagesUpdatemediumInput>
  rotations?: InputMaybe<ImagesUpdaterotationsInput>
  small?: InputMaybe<ImagesUpdatesmallInput>
  thumbnails?: InputMaybe<ImagesUpdatethumbnailsInput>
}

export type ImagesUpdatelargeInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ImagesUpdatemediumInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ImagesUpdaterotationsInput = {
  push?: InputMaybe<Array<Scalars['Int']['input']>>
  set?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type ImagesUpdatesmallInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ImagesUpdatethumbnailsInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type ImagesUpsertWithoutPropertyInput = {
  create: ImagesCreateWithoutPropertyInput
  update: ImagesUpdateWithoutPropertyInput
  where?: InputMaybe<ImagesWhereInput>
}

export type ImagesWhereInput = {
  AND?: InputMaybe<Array<ImagesWhereInput>>
  NOT?: InputMaybe<Array<ImagesWhereInput>>
  OR?: InputMaybe<Array<ImagesWhereInput>>
  id?: InputMaybe<StringFilter>
  large?: InputMaybe<StringNullableListFilter>
  medium?: InputMaybe<StringNullableListFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  rotations?: InputMaybe<IntNullableListFilter>
  small?: InputMaybe<StringNullableListFilter>
  thumbnails?: InputMaybe<StringNullableListFilter>
}

export type ImagesWhereUniqueInput = {
  AND?: InputMaybe<Array<ImagesWhereInput>>
  NOT?: InputMaybe<Array<ImagesWhereInput>>
  OR?: InputMaybe<Array<ImagesWhereInput>>
  id?: InputMaybe<Scalars['String']['input']>
  large?: InputMaybe<StringNullableListFilter>
  medium?: InputMaybe<StringNullableListFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
  rotations?: InputMaybe<IntNullableListFilter>
  small?: InputMaybe<StringNullableListFilter>
  thumbnails?: InputMaybe<StringNullableListFilter>
}

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>
  divide?: InputMaybe<Scalars['Int']['input']>
  increment?: InputMaybe<Scalars['Int']['input']>
  multiply?: InputMaybe<Scalars['Int']['input']>
  set?: InputMaybe<Scalars['Int']['input']>
}

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntNullableFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type IntNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['Int']['input']>>
  has?: InputMaybe<Scalars['Int']['input']>
  hasEvery?: InputMaybe<Array<Scalars['Int']['input']>>
  hasSome?: InputMaybe<Array<Scalars['Int']['input']>>
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedIntNullableFilter>
  _min?: InputMaybe<NestedIntNullableFilter>
  _sum?: InputMaybe<NestedIntNullableFilter>
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedIntFilter>
  _min?: InputMaybe<NestedIntFilter>
  _sum?: InputMaybe<NestedIntFilter>
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type IntegrationsModel = {
  __typename?: 'IntegrationsModel'
  kyero?: Maybe<Scalars['Boolean']['output']>
  resales?: Maybe<Scalars['String']['output']>
}

export type JsonNullableFilter = {
  equals?: InputMaybe<Scalars['JSON']['input']>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<Scalars['JSON']['input']>
}

export enum KitchenQuality {
  Luxury = 'luxury',
  Modern = 'modern',
  NeedsUpdate = 'needs_update',
  Original = 'original',
  Updated = 'updated',
}

export type KyeroDescription = {
  __typename?: 'KyeroDescription'
  language: Scalars['String']['output']
  short?: Maybe<Scalars['String']['output']>
  text?: Maybe<Scalars['String']['output']>
}

export type KyeroImagesPreview = {
  __typename?: 'KyeroImagesPreview'
  large?: Maybe<Array<Scalars['String']['output']>>
  small?: Maybe<Array<Scalars['String']['output']>>
}

export type KyeroLocationPreview = {
  __typename?: 'KyeroLocationPreview'
  country?: Maybe<Scalars['String']['output']>
  location?: Maybe<Scalars['String']['output']>
  province?: Maybe<Scalars['String']['output']>
  town?: Maybe<Scalars['String']['output']>
}

export type KyeroPropertyPreview = {
  __typename?: 'KyeroPropertyPreview'
  agencyRef?: Maybe<Scalars['String']['output']>
  baths?: Maybe<Scalars['Float']['output']>
  beds?: Maybe<Scalars['Float']['output']>
  currency?: Maybe<Scalars['String']['output']>
  descriptions?: Maybe<Array<KyeroDescription>>
  existingId?: Maybe<Scalars['String']['output']>
  exists: Scalars['Boolean']['output']
  externalId: Scalars['String']['output']
  featureIds?: Maybe<Array<Scalars['String']['output']>>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  images?: Maybe<KyeroImagesPreview>
  isNewDevelopment?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<KyeroLocationPreview>
  locationDetail?: Maybe<Scalars['String']['output']>
  ownProperty: Scalars['Boolean']['output']
  price?: Maybe<Scalars['Float']['output']>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  propertyTypeIds?: Maybe<Array<Scalars['String']['output']>>
  refId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  surfaceArea?: Maybe<KyeroSurfaceArea>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
  videoTour?: Maybe<Scalars['String']['output']>
}

export type KyeroSurfaceArea = {
  __typename?: 'KyeroSurfaceArea'
  built?: Maybe<Scalars['Float']['output']>
  plot?: Maybe<Scalars['Float']['output']>
  terrace?: Maybe<Scalars['Float']['output']>
}

export type LargeMunicipality = {
  __typename?: 'LargeMunicipality'
  CODIGOINE?: Maybe<Scalars['String']['output']>
  CODNUT1?: Maybe<Scalars['String']['output']>
  CODNUT2?: Maybe<Scalars['String']['output']>
  CODNUT3?: Maybe<Scalars['String']['output']>
  INSPIREID?: Maybe<Scalars['String']['output']>
  NAMEUNIT?: Maybe<Scalars['String']['output']>
  NATCODE?: Maybe<Scalars['String']['output']>
  OBJECTID?: Maybe<Scalars['Float']['output']>
  PROVINCE_CODE?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  mapboxId?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  normalizedName?: Maybe<Scalars['String']['output']>
}

export type Lead = {
  __typename?: 'Lead'
  _count?: Maybe<LeadCount>
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>
  acceptPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>
  adminStatus?: Maybe<Scalars['String']['output']>
  assignedTo?: Maybe<Scalars['String']['output']>
  broker?: Maybe<Broker>
  brokerId?: Maybe<Scalars['String']['output']>
  callAttemptsCount: Scalars['Int']['output']
  conversations: Array<Conversation>
  createdAt: Scalars['DateTimeISO']['output']
  email?: Maybe<Scalars['String']['output']>
  emailAttemptsCount: Scalars['Int']['output']
  id: Scalars['String']['output']
  lastCallAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastContactedAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastEmailAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  leadCrmInsights?: Maybe<LeadCrmInsights>
  leadId?: Maybe<Scalars['String']['output']>
  leadNotes: Array<LeadNote>
  leadScoring?: Maybe<LeadScoringReport>
  /** When the lead submitted the form (defaults to creation time; may be updated from integrations) */
  leadSubmittedAt?: Maybe<Scalars['DateTimeISO']['output']>
  listPosition?: Maybe<Scalars['Int']['output']>
  mauticFormData?: Maybe<Array<MauticFormDataEntry>>
  mauticFormId?: Maybe<Scalars['Int']['output']>
  mauticId?: Maybe<Scalars['Int']['output']>
  /** Most recent filled form from Mautic for this lead (by mauticId), as question-answer pairs */
  mauticMostRecentForm?: Maybe<MauticMostRecentForm>
  mauticStats?: Maybe<MauticStats>
  mauticSubmissionId?: Maybe<Scalars['Int']['output']>
  mauticUrl?: Maybe<Scalars['String']['output']>
  message?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes: Array<Scalars['String']['output']>
  personalData?: Maybe<PersonalData>
  phone?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['String']['output']>
  property?: Maybe<Property>
  propertyId?: Maybe<Scalars['String']['output']>
  propertyRef?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  utm_campaign?: Maybe<Scalars['String']['output']>
  utm_content?: Maybe<Scalars['String']['output']>
  utm_medium?: Maybe<Scalars['String']['output']>
  utm_source?: Maybe<Scalars['String']['output']>
  utm_term?: Maybe<Scalars['String']['output']>
}

export type LeadBrokerArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type LeadConversationsArgs = {
  cursor?: InputMaybe<ConversationWhereUniqueInput>
  distinct?: InputMaybe<Array<ConversationScalarFieldEnum>>
  orderBy?: InputMaybe<Array<ConversationOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<ConversationWhereInput>
}

export type LeadLeadNotesArgs = {
  cursor?: InputMaybe<LeadNoteWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadNoteScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadNoteOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadNoteWhereInput>
}

export type LeadPropertyArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type LeadAvgAggregate = {
  __typename?: 'LeadAvgAggregate'
  callAttemptsCount?: Maybe<Scalars['Float']['output']>
  emailAttemptsCount?: Maybe<Scalars['Float']['output']>
  listPosition?: Maybe<Scalars['Float']['output']>
  mauticFormId?: Maybe<Scalars['Float']['output']>
  mauticId?: Maybe<Scalars['Float']['output']>
  mauticSubmissionId?: Maybe<Scalars['Float']['output']>
}

export type LeadAvgOrderByAggregateInput = {
  callAttemptsCount?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
}

export type LeadCount = {
  __typename?: 'LeadCount'
  conversations: Scalars['Int']['output']
  leadNotes: Scalars['Int']['output']
}

export type LeadCountConversationsArgs = {
  where?: InputMaybe<ConversationWhereInput>
}

export type LeadCountLeadNotesArgs = {
  where?: InputMaybe<LeadNoteWhereInput>
}

export type LeadCountAggregate = {
  __typename?: 'LeadCountAggregate'
  _all: Scalars['Int']['output']
  acceptMarketing: Scalars['Int']['output']
  acceptPrivacyPolicy: Scalars['Int']['output']
  adminStatus: Scalars['Int']['output']
  assignedTo: Scalars['Int']['output']
  brokerId: Scalars['Int']['output']
  callAttemptsCount: Scalars['Int']['output']
  createdAt: Scalars['Int']['output']
  email: Scalars['Int']['output']
  emailAttemptsCount: Scalars['Int']['output']
  id: Scalars['Int']['output']
  lastCallAttemptAt: Scalars['Int']['output']
  lastContactedAt: Scalars['Int']['output']
  lastEmailAttemptAt: Scalars['Int']['output']
  leadId: Scalars['Int']['output']
  leadSubmittedAt: Scalars['Int']['output']
  listPosition: Scalars['Int']['output']
  mauticFormId: Scalars['Int']['output']
  mauticId: Scalars['Int']['output']
  mauticSubmissionId: Scalars['Int']['output']
  message: Scalars['Int']['output']
  name: Scalars['Int']['output']
  notes: Scalars['Int']['output']
  phone: Scalars['Int']['output']
  priority: Scalars['Int']['output']
  propertyId: Scalars['Int']['output']
  propertyRef: Scalars['Int']['output']
  source: Scalars['Int']['output']
  status: Scalars['Int']['output']
  updatedAt: Scalars['Int']['output']
  utm_campaign: Scalars['Int']['output']
  utm_content: Scalars['Int']['output']
  utm_medium: Scalars['Int']['output']
  utm_source: Scalars['Int']['output']
  utm_term: Scalars['Int']['output']
}

export type LeadCountOrderByAggregateInput = {
  acceptMarketing?: InputMaybe<SortOrder>
  acceptPrivacyPolicy?: InputMaybe<SortOrder>
  adminStatus?: InputMaybe<SortOrder>
  assignedTo?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  callAttemptsCount?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastCallAttemptAt?: InputMaybe<SortOrder>
  lastContactedAt?: InputMaybe<SortOrder>
  lastEmailAttemptAt?: InputMaybe<SortOrder>
  leadId?: InputMaybe<SortOrder>
  leadSubmittedAt?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
  message?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  notes?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  propertyId?: InputMaybe<SortOrder>
  propertyRef?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  utm_campaign?: InputMaybe<SortOrder>
  utm_content?: InputMaybe<SortOrder>
  utm_medium?: InputMaybe<SortOrder>
  utm_source?: InputMaybe<SortOrder>
  utm_term?: InputMaybe<SortOrder>
}

export type LeadCreateInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutLeadsInput>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  conversations?: InputMaybe<ConversationCreateNestedManyWithoutLeadInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutLeadInput>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  property?: InputMaybe<PropertyCreateNestedOneWithoutLeadsInput>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateManyBrokerInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateManyBrokerInputEnvelope = {
  data: Array<LeadCreateManyBrokerInput>
}

export type LeadCreateManyInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateManyPropertyInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateManyPropertyInputEnvelope = {
  data: Array<LeadCreateManyPropertyInput>
}

export type LeadCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<LeadWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<LeadCreateWithoutBrokerInput>>
  createMany?: InputMaybe<LeadCreateManyBrokerInputEnvelope>
}

export type LeadCreateNestedManyWithoutPropertyInput = {
  connect?: InputMaybe<Array<LeadWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<LeadCreateWithoutPropertyInput>>
  createMany?: InputMaybe<LeadCreateManyPropertyInputEnvelope>
}

export type LeadCreateNestedOneWithoutLeadNotesInput = {
  connect?: InputMaybe<LeadWhereUniqueInput>
  connectOrCreate?: InputMaybe<LeadCreateOrConnectWithoutLeadNotesInput>
  create?: InputMaybe<LeadCreateWithoutLeadNotesInput>
}

export type LeadCreateOrConnectWithoutBrokerInput = {
  create: LeadCreateWithoutBrokerInput
  where: LeadWhereUniqueInput
}

export type LeadCreateOrConnectWithoutLeadNotesInput = {
  create: LeadCreateWithoutLeadNotesInput
  where: LeadWhereUniqueInput
}

export type LeadCreateOrConnectWithoutPropertyInput = {
  create: LeadCreateWithoutPropertyInput
  where: LeadWhereUniqueInput
}

export type LeadCreateWithoutBrokerInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  conversations?: InputMaybe<ConversationCreateNestedManyWithoutLeadInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutLeadInput>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  property?: InputMaybe<PropertyCreateNestedOneWithoutLeadsInput>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateWithoutLeadNotesInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutLeadsInput>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  conversations?: InputMaybe<ConversationCreateNestedManyWithoutLeadInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  property?: InputMaybe<PropertyCreateNestedOneWithoutLeadsInput>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreateWithoutPropertyInput = {
  acceptMarketing?: InputMaybe<Scalars['Boolean']['input']>
  acceptPrivacyPolicy?: InputMaybe<Scalars['Boolean']['input']>
  adminStatus?: InputMaybe<Scalars['String']['input']>
  assignedTo?: InputMaybe<Scalars['String']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutLeadsInput>
  callAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  conversations?: InputMaybe<ConversationCreateNestedManyWithoutLeadInput>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  emailAttemptsCount?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastContactedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lastEmailAttemptAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leadId?: InputMaybe<Scalars['String']['input']>
  leadNotes?: InputMaybe<LeadNoteCreateNestedManyWithoutLeadInput>
  leadSubmittedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  listPosition?: InputMaybe<Scalars['Int']['input']>
  mauticFormId?: InputMaybe<Scalars['Int']['input']>
  mauticId?: InputMaybe<Scalars['Int']['input']>
  mauticSubmissionId?: InputMaybe<Scalars['Int']['input']>
  message?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  notes?: InputMaybe<LeadCreatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableCreateEnvelopeInput>
  phone?: InputMaybe<Scalars['String']['input']>
  priority?: InputMaybe<Scalars['String']['input']>
  propertyRef?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  utm_campaign?: InputMaybe<Scalars['String']['input']>
  utm_content?: InputMaybe<Scalars['String']['input']>
  utm_medium?: InputMaybe<Scalars['String']['input']>
  utm_source?: InputMaybe<Scalars['String']['input']>
  utm_term?: InputMaybe<Scalars['String']['input']>
}

export type LeadCreatenotesInput = {
  set: Array<Scalars['String']['input']>
}

/** Lead insights synced from Mautic contact fields and/or Twenty CRM opportunity */
export type LeadCrmInsights = {
  __typename?: 'LeadCrmInsights'
  /** cold | warm | hot | unclear */
  aiBuyerStage?: Maybe<Scalars['String']['output']>
  /** call_now | nurture | send_info_only | unclear */
  aiCallReadiness?: Maybe<Scalars['String']['output']>
  /** Short LLM summary for routing (Twenty bostAiIntentSummary / Mautic bost_ai_intent_summary) */
  aiIntentSummary?: Maybe<Scalars['String']['output']>
  /** sales | support | partnership | unclear */
  aiLeadType?: Maybe<Scalars['String']['output']>
  /** high | medium | low */
  aiPriority?: Maybe<Scalars['String']['output']>
  aiScoreNotes?: Maybe<Scalars['String']['output']>
  aiUnmappedKeys?: Maybe<Scalars['String']['output']>
  marketConsentDate?: Maybe<Scalars['String']['output']>
  marketConsentVersion?: Maybe<Scalars['String']['output']>
  marketingConsent?: Maybe<Scalars['Boolean']['output']>
}

export type LeadGroupBy = {
  __typename?: 'LeadGroupBy'
  _avg?: Maybe<LeadAvgAggregate>
  _count?: Maybe<LeadCountAggregate>
  _max?: Maybe<LeadMaxAggregate>
  _min?: Maybe<LeadMinAggregate>
  _sum?: Maybe<LeadSumAggregate>
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>
  acceptPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>
  adminStatus?: Maybe<Scalars['String']['output']>
  assignedTo?: Maybe<Scalars['String']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  callAttemptsCount: Scalars['Int']['output']
  createdAt: Scalars['DateTimeISO']['output']
  email?: Maybe<Scalars['String']['output']>
  emailAttemptsCount: Scalars['Int']['output']
  id: Scalars['String']['output']
  lastCallAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastContactedAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastEmailAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  leadId?: Maybe<Scalars['String']['output']>
  leadSubmittedAt?: Maybe<Scalars['DateTimeISO']['output']>
  listPosition?: Maybe<Scalars['Int']['output']>
  mauticFormId?: Maybe<Scalars['Int']['output']>
  mauticId?: Maybe<Scalars['Int']['output']>
  mauticSubmissionId?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  notes?: Maybe<Array<Scalars['String']['output']>>
  phone?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  propertyRef?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
  utm_campaign?: Maybe<Scalars['String']['output']>
  utm_content?: Maybe<Scalars['String']['output']>
  utm_medium?: Maybe<Scalars['String']['output']>
  utm_source?: Maybe<Scalars['String']['output']>
  utm_term?: Maybe<Scalars['String']['output']>
}

export type LeadListRelationFilter = {
  every?: InputMaybe<LeadWhereInput>
  none?: InputMaybe<LeadWhereInput>
  some?: InputMaybe<LeadWhereInput>
}

export type LeadMaxAggregate = {
  __typename?: 'LeadMaxAggregate'
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>
  acceptPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>
  adminStatus?: Maybe<Scalars['String']['output']>
  assignedTo?: Maybe<Scalars['String']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  callAttemptsCount?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  email?: Maybe<Scalars['String']['output']>
  emailAttemptsCount?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  lastCallAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastContactedAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastEmailAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  leadId?: Maybe<Scalars['String']['output']>
  leadSubmittedAt?: Maybe<Scalars['DateTimeISO']['output']>
  listPosition?: Maybe<Scalars['Int']['output']>
  mauticFormId?: Maybe<Scalars['Int']['output']>
  mauticId?: Maybe<Scalars['Int']['output']>
  mauticSubmissionId?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  propertyRef?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  utm_campaign?: Maybe<Scalars['String']['output']>
  utm_content?: Maybe<Scalars['String']['output']>
  utm_medium?: Maybe<Scalars['String']['output']>
  utm_source?: Maybe<Scalars['String']['output']>
  utm_term?: Maybe<Scalars['String']['output']>
}

export type LeadMaxOrderByAggregateInput = {
  acceptMarketing?: InputMaybe<SortOrder>
  acceptPrivacyPolicy?: InputMaybe<SortOrder>
  adminStatus?: InputMaybe<SortOrder>
  assignedTo?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  callAttemptsCount?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastCallAttemptAt?: InputMaybe<SortOrder>
  lastContactedAt?: InputMaybe<SortOrder>
  lastEmailAttemptAt?: InputMaybe<SortOrder>
  leadId?: InputMaybe<SortOrder>
  leadSubmittedAt?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
  message?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  propertyId?: InputMaybe<SortOrder>
  propertyRef?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  utm_campaign?: InputMaybe<SortOrder>
  utm_content?: InputMaybe<SortOrder>
  utm_medium?: InputMaybe<SortOrder>
  utm_source?: InputMaybe<SortOrder>
  utm_term?: InputMaybe<SortOrder>
}

export type LeadMinAggregate = {
  __typename?: 'LeadMinAggregate'
  acceptMarketing?: Maybe<Scalars['Boolean']['output']>
  acceptPrivacyPolicy?: Maybe<Scalars['Boolean']['output']>
  adminStatus?: Maybe<Scalars['String']['output']>
  assignedTo?: Maybe<Scalars['String']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  callAttemptsCount?: Maybe<Scalars['Int']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  email?: Maybe<Scalars['String']['output']>
  emailAttemptsCount?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  lastCallAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastContactedAt?: Maybe<Scalars['DateTimeISO']['output']>
  lastEmailAttemptAt?: Maybe<Scalars['DateTimeISO']['output']>
  leadId?: Maybe<Scalars['String']['output']>
  leadSubmittedAt?: Maybe<Scalars['DateTimeISO']['output']>
  listPosition?: Maybe<Scalars['Int']['output']>
  mauticFormId?: Maybe<Scalars['Int']['output']>
  mauticId?: Maybe<Scalars['Int']['output']>
  mauticSubmissionId?: Maybe<Scalars['Int']['output']>
  message?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  priority?: Maybe<Scalars['String']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  propertyRef?: Maybe<Scalars['String']['output']>
  source?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  utm_campaign?: Maybe<Scalars['String']['output']>
  utm_content?: Maybe<Scalars['String']['output']>
  utm_medium?: Maybe<Scalars['String']['output']>
  utm_source?: Maybe<Scalars['String']['output']>
  utm_term?: Maybe<Scalars['String']['output']>
}

export type LeadMinOrderByAggregateInput = {
  acceptMarketing?: InputMaybe<SortOrder>
  acceptPrivacyPolicy?: InputMaybe<SortOrder>
  adminStatus?: InputMaybe<SortOrder>
  assignedTo?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  callAttemptsCount?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastCallAttemptAt?: InputMaybe<SortOrder>
  lastContactedAt?: InputMaybe<SortOrder>
  lastEmailAttemptAt?: InputMaybe<SortOrder>
  leadId?: InputMaybe<SortOrder>
  leadSubmittedAt?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
  message?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  propertyId?: InputMaybe<SortOrder>
  propertyRef?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  utm_campaign?: InputMaybe<SortOrder>
  utm_content?: InputMaybe<SortOrder>
  utm_medium?: InputMaybe<SortOrder>
  utm_source?: InputMaybe<SortOrder>
  utm_term?: InputMaybe<SortOrder>
}

export type LeadNote = {
  __typename?: 'LeadNote'
  agencyId?: Maybe<Scalars['String']['output']>
  content: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  id: Scalars['String']['output']
  leadId: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  updatedBy?: Maybe<Scalars['String']['output']>
}

export type LeadNoteCreateManyAgencyInput = {
  content: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  leadId: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  updatedBy?: InputMaybe<Scalars['String']['input']>
}

export type LeadNoteCreateManyAgencyInputEnvelope = {
  data: Array<LeadNoteCreateManyAgencyInput>
}

export type LeadNoteCreateManyLeadInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>
  content: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  updatedBy?: InputMaybe<Scalars['String']['input']>
}

export type LeadNoteCreateManyLeadInputEnvelope = {
  data: Array<LeadNoteCreateManyLeadInput>
}

export type LeadNoteCreateNestedManyWithoutAgencyInput = {
  connect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadNoteCreateOrConnectWithoutAgencyInput>>
  create?: InputMaybe<Array<LeadNoteCreateWithoutAgencyInput>>
  createMany?: InputMaybe<LeadNoteCreateManyAgencyInputEnvelope>
}

export type LeadNoteCreateNestedManyWithoutLeadInput = {
  connect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadNoteCreateOrConnectWithoutLeadInput>>
  create?: InputMaybe<Array<LeadNoteCreateWithoutLeadInput>>
  createMany?: InputMaybe<LeadNoteCreateManyLeadInputEnvelope>
}

export type LeadNoteCreateOrConnectWithoutAgencyInput = {
  create: LeadNoteCreateWithoutAgencyInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteCreateOrConnectWithoutLeadInput = {
  create: LeadNoteCreateWithoutLeadInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteCreateWithoutAgencyInput = {
  content: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lead: LeadCreateNestedOneWithoutLeadNotesInput
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  updatedBy?: InputMaybe<Scalars['String']['input']>
}

export type LeadNoteCreateWithoutLeadInput = {
  agency?: InputMaybe<BrokerCreateNestedOneWithoutLeadNotesInput>
  content: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  updatedBy?: InputMaybe<Scalars['String']['input']>
}

export type LeadNoteListRelationFilter = {
  every?: InputMaybe<LeadNoteWhereInput>
  none?: InputMaybe<LeadNoteWhereInput>
  some?: InputMaybe<LeadNoteWhereInput>
}

export type LeadNoteOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type LeadNoteOrderByWithRelationInput = {
  agency?: InputMaybe<BrokerOrderByWithRelationInput>
  agencyId?: InputMaybe<SortOrder>
  content?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lead?: InputMaybe<LeadOrderByWithRelationInput>
  leadId?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  updatedBy?: InputMaybe<SortOrder>
}

export enum LeadNoteScalarFieldEnum {
  AgencyId = 'agencyId',
  Content = 'content',
  CreatedAt = 'createdAt',
  Id = 'id',
  LeadId = 'leadId',
  UpdatedAt = 'updatedAt',
  UpdatedBy = 'updatedBy',
}

export type LeadNoteScalarWhereInput = {
  AND?: InputMaybe<Array<LeadNoteScalarWhereInput>>
  NOT?: InputMaybe<Array<LeadNoteScalarWhereInput>>
  OR?: InputMaybe<Array<LeadNoteScalarWhereInput>>
  agencyId?: InputMaybe<StringNullableFilter>
  content?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  leadId?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  updatedBy?: InputMaybe<StringNullableFilter>
}

export type LeadNoteUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadNoteUpdateManyWithWhereWithoutAgencyInput = {
  data: LeadNoteUpdateManyMutationInput
  where: LeadNoteScalarWhereInput
}

export type LeadNoteUpdateManyWithWhereWithoutLeadInput = {
  data: LeadNoteUpdateManyMutationInput
  where: LeadNoteScalarWhereInput
}

export type LeadNoteUpdateManyWithoutAgencyNestedInput = {
  connect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadNoteCreateOrConnectWithoutAgencyInput>>
  create?: InputMaybe<Array<LeadNoteCreateWithoutAgencyInput>>
  createMany?: InputMaybe<LeadNoteCreateManyAgencyInputEnvelope>
  delete?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LeadNoteScalarWhereInput>>
  disconnect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  set?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  update?: InputMaybe<Array<LeadNoteUpdateWithWhereUniqueWithoutAgencyInput>>
  updateMany?: InputMaybe<Array<LeadNoteUpdateManyWithWhereWithoutAgencyInput>>
  upsert?: InputMaybe<Array<LeadNoteUpsertWithWhereUniqueWithoutAgencyInput>>
}

export type LeadNoteUpdateManyWithoutLeadNestedInput = {
  connect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadNoteCreateOrConnectWithoutLeadInput>>
  create?: InputMaybe<Array<LeadNoteCreateWithoutLeadInput>>
  createMany?: InputMaybe<LeadNoteCreateManyLeadInputEnvelope>
  delete?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LeadNoteScalarWhereInput>>
  disconnect?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  set?: InputMaybe<Array<LeadNoteWhereUniqueInput>>
  update?: InputMaybe<Array<LeadNoteUpdateWithWhereUniqueWithoutLeadInput>>
  updateMany?: InputMaybe<Array<LeadNoteUpdateManyWithWhereWithoutLeadInput>>
  upsert?: InputMaybe<Array<LeadNoteUpsertWithWhereUniqueWithoutLeadInput>>
}

export type LeadNoteUpdateWithWhereUniqueWithoutAgencyInput = {
  data: LeadNoteUpdateWithoutAgencyInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteUpdateWithWhereUniqueWithoutLeadInput = {
  data: LeadNoteUpdateWithoutLeadInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteUpdateWithoutAgencyInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  lead?: InputMaybe<LeadUpdateOneRequiredWithoutLeadNotesNestedInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadNoteUpdateWithoutLeadInput = {
  agency?: InputMaybe<BrokerUpdateOneWithoutLeadNotesNestedInput>
  content?: InputMaybe<StringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  updatedBy?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadNoteUpsertWithWhereUniqueWithoutAgencyInput = {
  create: LeadNoteCreateWithoutAgencyInput
  update: LeadNoteUpdateWithoutAgencyInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteUpsertWithWhereUniqueWithoutLeadInput = {
  create: LeadNoteCreateWithoutLeadInput
  update: LeadNoteUpdateWithoutLeadInput
  where: LeadNoteWhereUniqueInput
}

export type LeadNoteWhereInput = {
  AND?: InputMaybe<Array<LeadNoteWhereInput>>
  NOT?: InputMaybe<Array<LeadNoteWhereInput>>
  OR?: InputMaybe<Array<LeadNoteWhereInput>>
  agency?: InputMaybe<BrokerNullableRelationFilter>
  agencyId?: InputMaybe<StringNullableFilter>
  content?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<StringFilter>
  lead?: InputMaybe<LeadRelationFilter>
  leadId?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  updatedBy?: InputMaybe<StringNullableFilter>
}

export type LeadNoteWhereUniqueInput = {
  AND?: InputMaybe<Array<LeadNoteWhereInput>>
  NOT?: InputMaybe<Array<LeadNoteWhereInput>>
  OR?: InputMaybe<Array<LeadNoteWhereInput>>
  agency?: InputMaybe<BrokerNullableRelationFilter>
  agencyId?: InputMaybe<StringNullableFilter>
  content?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  lead?: InputMaybe<LeadRelationFilter>
  leadId?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  updatedBy?: InputMaybe<StringNullableFilter>
}

export type LeadOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type LeadOrderByWithAggregationInput = {
  _avg?: InputMaybe<LeadAvgOrderByAggregateInput>
  _count?: InputMaybe<LeadCountOrderByAggregateInput>
  _max?: InputMaybe<LeadMaxOrderByAggregateInput>
  _min?: InputMaybe<LeadMinOrderByAggregateInput>
  _sum?: InputMaybe<LeadSumOrderByAggregateInput>
  acceptMarketing?: InputMaybe<SortOrder>
  acceptPrivacyPolicy?: InputMaybe<SortOrder>
  adminStatus?: InputMaybe<SortOrder>
  assignedTo?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  callAttemptsCount?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastCallAttemptAt?: InputMaybe<SortOrder>
  lastContactedAt?: InputMaybe<SortOrder>
  lastEmailAttemptAt?: InputMaybe<SortOrder>
  leadId?: InputMaybe<SortOrder>
  leadSubmittedAt?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
  message?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  notes?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  propertyId?: InputMaybe<SortOrder>
  propertyRef?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  utm_campaign?: InputMaybe<SortOrder>
  utm_content?: InputMaybe<SortOrder>
  utm_medium?: InputMaybe<SortOrder>
  utm_source?: InputMaybe<SortOrder>
  utm_term?: InputMaybe<SortOrder>
}

export type LeadOrderByWithRelationInput = {
  acceptMarketing?: InputMaybe<SortOrder>
  acceptPrivacyPolicy?: InputMaybe<SortOrder>
  adminStatus?: InputMaybe<SortOrder>
  assignedTo?: InputMaybe<SortOrder>
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  callAttemptsCount?: InputMaybe<SortOrder>
  conversations?: InputMaybe<ConversationOrderByRelationAggregateInput>
  createdAt?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastCallAttemptAt?: InputMaybe<SortOrder>
  lastContactedAt?: InputMaybe<SortOrder>
  lastEmailAttemptAt?: InputMaybe<SortOrder>
  leadId?: InputMaybe<SortOrder>
  leadNotes?: InputMaybe<LeadNoteOrderByRelationAggregateInput>
  leadSubmittedAt?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
  message?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  notes?: InputMaybe<SortOrder>
  personalData?: InputMaybe<PersonalDataOrderByInput>
  phone?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  propertyRef?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  utm_campaign?: InputMaybe<SortOrder>
  utm_content?: InputMaybe<SortOrder>
  utm_medium?: InputMaybe<SortOrder>
  utm_source?: InputMaybe<SortOrder>
  utm_term?: InputMaybe<SortOrder>
}

export type LeadRelationFilter = {
  is?: InputMaybe<LeadWhereInput>
  isNot?: InputMaybe<LeadWhereInput>
}

export enum LeadScalarFieldEnum {
  AcceptMarketing = 'acceptMarketing',
  AcceptPrivacyPolicy = 'acceptPrivacyPolicy',
  AdminStatus = 'adminStatus',
  AssignedTo = 'assignedTo',
  BrokerId = 'brokerId',
  CallAttemptsCount = 'callAttemptsCount',
  CreatedAt = 'createdAt',
  Email = 'email',
  EmailAttemptsCount = 'emailAttemptsCount',
  Id = 'id',
  LastCallAttemptAt = 'lastCallAttemptAt',
  LastContactedAt = 'lastContactedAt',
  LastEmailAttemptAt = 'lastEmailAttemptAt',
  LeadId = 'leadId',
  LeadSubmittedAt = 'leadSubmittedAt',
  ListPosition = 'listPosition',
  MauticFormId = 'mauticFormId',
  MauticId = 'mauticId',
  MauticSubmissionId = 'mauticSubmissionId',
  Message = 'message',
  Name = 'name',
  Notes = 'notes',
  Phone = 'phone',
  Priority = 'priority',
  PropertyId = 'propertyId',
  PropertyRef = 'propertyRef',
  Source = 'source',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UtmCampaign = 'utm_campaign',
  UtmContent = 'utm_content',
  UtmMedium = 'utm_medium',
  UtmSource = 'utm_source',
  UtmTerm = 'utm_term',
}

export type LeadScalarWhereInput = {
  AND?: InputMaybe<Array<LeadScalarWhereInput>>
  NOT?: InputMaybe<Array<LeadScalarWhereInput>>
  OR?: InputMaybe<Array<LeadScalarWhereInput>>
  acceptMarketing?: InputMaybe<BoolNullableFilter>
  acceptPrivacyPolicy?: InputMaybe<BoolNullableFilter>
  adminStatus?: InputMaybe<StringNullableFilter>
  assignedTo?: InputMaybe<StringNullableFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callAttemptsCount?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  email?: InputMaybe<StringNullableFilter>
  emailAttemptsCount?: InputMaybe<IntFilter>
  id?: InputMaybe<StringFilter>
  lastCallAttemptAt?: InputMaybe<DateTimeNullableFilter>
  lastContactedAt?: InputMaybe<DateTimeNullableFilter>
  lastEmailAttemptAt?: InputMaybe<DateTimeNullableFilter>
  leadId?: InputMaybe<StringNullableFilter>
  leadSubmittedAt?: InputMaybe<DateTimeNullableFilter>
  listPosition?: InputMaybe<IntNullableFilter>
  mauticFormId?: InputMaybe<IntNullableFilter>
  mauticId?: InputMaybe<IntNullableFilter>
  mauticSubmissionId?: InputMaybe<IntNullableFilter>
  message?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringNullableFilter>
  notes?: InputMaybe<StringNullableListFilter>
  phone?: InputMaybe<StringNullableFilter>
  priority?: InputMaybe<StringNullableFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  propertyRef?: InputMaybe<StringNullableFilter>
  source?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  utm_campaign?: InputMaybe<StringNullableFilter>
  utm_content?: InputMaybe<StringNullableFilter>
  utm_medium?: InputMaybe<StringNullableFilter>
  utm_source?: InputMaybe<StringNullableFilter>
  utm_term?: InputMaybe<StringNullableFilter>
}

export type LeadScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LeadScalarWhereWithAggregatesInput>>
  NOT?: InputMaybe<Array<LeadScalarWhereWithAggregatesInput>>
  OR?: InputMaybe<Array<LeadScalarWhereWithAggregatesInput>>
  acceptMarketing?: InputMaybe<BoolNullableWithAggregatesFilter>
  acceptPrivacyPolicy?: InputMaybe<BoolNullableWithAggregatesFilter>
  adminStatus?: InputMaybe<StringNullableWithAggregatesFilter>
  assignedTo?: InputMaybe<StringNullableWithAggregatesFilter>
  brokerId?: InputMaybe<StringNullableWithAggregatesFilter>
  callAttemptsCount?: InputMaybe<IntWithAggregatesFilter>
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>
  email?: InputMaybe<StringNullableWithAggregatesFilter>
  emailAttemptsCount?: InputMaybe<IntWithAggregatesFilter>
  id?: InputMaybe<StringWithAggregatesFilter>
  lastCallAttemptAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  lastContactedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  lastEmailAttemptAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  leadId?: InputMaybe<StringNullableWithAggregatesFilter>
  leadSubmittedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  listPosition?: InputMaybe<IntNullableWithAggregatesFilter>
  mauticFormId?: InputMaybe<IntNullableWithAggregatesFilter>
  mauticId?: InputMaybe<IntNullableWithAggregatesFilter>
  mauticSubmissionId?: InputMaybe<IntNullableWithAggregatesFilter>
  message?: InputMaybe<StringNullableWithAggregatesFilter>
  name?: InputMaybe<StringNullableWithAggregatesFilter>
  notes?: InputMaybe<StringNullableListFilter>
  phone?: InputMaybe<StringNullableWithAggregatesFilter>
  priority?: InputMaybe<StringNullableWithAggregatesFilter>
  propertyId?: InputMaybe<StringNullableWithAggregatesFilter>
  propertyRef?: InputMaybe<StringNullableWithAggregatesFilter>
  source?: InputMaybe<StringNullableWithAggregatesFilter>
  status?: InputMaybe<StringNullableWithAggregatesFilter>
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>
  utm_campaign?: InputMaybe<StringNullableWithAggregatesFilter>
  utm_content?: InputMaybe<StringNullableWithAggregatesFilter>
  utm_medium?: InputMaybe<StringNullableWithAggregatesFilter>
  utm_source?: InputMaybe<StringNullableWithAggregatesFilter>
  utm_term?: InputMaybe<StringNullableWithAggregatesFilter>
}

/** OSINT and internal scoring from DynamoDB (no PII) */
export type LeadScoringReport = {
  __typename?: 'LeadScoringReport'
  osintEmailFound?: Maybe<Scalars['Boolean']['output']>
  osintEmailSites?: Maybe<Scalars['Int']['output']>
  osintGhuntFound?: Maybe<Scalars['Boolean']['output']>
  osintPhoneFound?: Maybe<Scalars['Boolean']['output']>
  osintScoreBonus?: Maybe<Scalars['Int']['output']>
  osintUsernameFound?: Maybe<Scalars['Boolean']['output']>
  osintUsernameSites?: Maybe<Scalars['Int']['output']>
  totalLeadScoreComputed?: Maybe<Scalars['Int']['output']>
  totalLeadScoreFinal?: Maybe<Scalars['Int']['output']>
  verifiedEmailStatus?: Maybe<Scalars['String']['output']>
  verifiedEmailValid?: Maybe<Scalars['Boolean']['output']>
}

export type LeadSumAggregate = {
  __typename?: 'LeadSumAggregate'
  callAttemptsCount?: Maybe<Scalars['Int']['output']>
  emailAttemptsCount?: Maybe<Scalars['Int']['output']>
  listPosition?: Maybe<Scalars['Int']['output']>
  mauticFormId?: Maybe<Scalars['Int']['output']>
  mauticId?: Maybe<Scalars['Int']['output']>
  mauticSubmissionId?: Maybe<Scalars['Int']['output']>
}

export type LeadSumOrderByAggregateInput = {
  callAttemptsCount?: InputMaybe<SortOrder>
  emailAttemptsCount?: InputMaybe<SortOrder>
  listPosition?: InputMaybe<SortOrder>
  mauticFormId?: InputMaybe<SortOrder>
  mauticId?: InputMaybe<SortOrder>
  mauticSubmissionId?: InputMaybe<SortOrder>
}

export type LeadUpdateInput = {
  acceptMarketing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  acceptPrivacyPolicy?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  adminStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  assignedTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutLeadsNestedInput>
  callAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  conversations?: InputMaybe<ConversationUpdateManyWithoutLeadNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  emailAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  lastCallAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastContactedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastEmailAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leadId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutLeadNestedInput>
  leadSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  listPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticFormId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticSubmissionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  notes?: InputMaybe<LeadUpdatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableUpdateEnvelopeInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  priority?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  property?: InputMaybe<PropertyUpdateOneWithoutLeadsNestedInput>
  propertyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  utm_campaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_content?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_term?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadUpdateManyMutationInput = {
  acceptMarketing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  acceptPrivacyPolicy?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  adminStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  assignedTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  callAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  emailAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  lastCallAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastContactedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastEmailAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leadId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  listPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticFormId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticSubmissionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  notes?: InputMaybe<LeadUpdatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableUpdateEnvelopeInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  priority?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  utm_campaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_content?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_term?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadUpdateManyWithWhereWithoutBrokerInput = {
  data: LeadUpdateManyMutationInput
  where: LeadScalarWhereInput
}

export type LeadUpdateManyWithWhereWithoutPropertyInput = {
  data: LeadUpdateManyMutationInput
  where: LeadScalarWhereInput
}

export type LeadUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<LeadWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<LeadCreateWithoutBrokerInput>>
  createMany?: InputMaybe<LeadCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<LeadWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LeadScalarWhereInput>>
  disconnect?: InputMaybe<Array<LeadWhereUniqueInput>>
  set?: InputMaybe<Array<LeadWhereUniqueInput>>
  update?: InputMaybe<Array<LeadUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<LeadUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<LeadUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type LeadUpdateManyWithoutPropertyNestedInput = {
  connect?: InputMaybe<Array<LeadWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LeadCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<LeadCreateWithoutPropertyInput>>
  createMany?: InputMaybe<LeadCreateManyPropertyInputEnvelope>
  delete?: InputMaybe<Array<LeadWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LeadScalarWhereInput>>
  disconnect?: InputMaybe<Array<LeadWhereUniqueInput>>
  set?: InputMaybe<Array<LeadWhereUniqueInput>>
  update?: InputMaybe<Array<LeadUpdateWithWhereUniqueWithoutPropertyInput>>
  updateMany?: InputMaybe<Array<LeadUpdateManyWithWhereWithoutPropertyInput>>
  upsert?: InputMaybe<Array<LeadUpsertWithWhereUniqueWithoutPropertyInput>>
}

export type LeadUpdateOneRequiredWithoutLeadNotesNestedInput = {
  connect?: InputMaybe<LeadWhereUniqueInput>
  connectOrCreate?: InputMaybe<LeadCreateOrConnectWithoutLeadNotesInput>
  create?: InputMaybe<LeadCreateWithoutLeadNotesInput>
  update?: InputMaybe<LeadUpdateToOneWithWhereWithoutLeadNotesInput>
  upsert?: InputMaybe<LeadUpsertWithoutLeadNotesInput>
}

export type LeadUpdateToOneWithWhereWithoutLeadNotesInput = {
  data: LeadUpdateWithoutLeadNotesInput
  where?: InputMaybe<LeadWhereInput>
}

export type LeadUpdateWithWhereUniqueWithoutBrokerInput = {
  data: LeadUpdateWithoutBrokerInput
  where: LeadWhereUniqueInput
}

export type LeadUpdateWithWhereUniqueWithoutPropertyInput = {
  data: LeadUpdateWithoutPropertyInput
  where: LeadWhereUniqueInput
}

export type LeadUpdateWithoutBrokerInput = {
  acceptMarketing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  acceptPrivacyPolicy?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  adminStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  assignedTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  callAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  conversations?: InputMaybe<ConversationUpdateManyWithoutLeadNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  emailAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  lastCallAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastContactedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastEmailAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leadId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutLeadNestedInput>
  leadSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  listPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticFormId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticSubmissionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  notes?: InputMaybe<LeadUpdatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableUpdateEnvelopeInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  priority?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  property?: InputMaybe<PropertyUpdateOneWithoutLeadsNestedInput>
  propertyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  utm_campaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_content?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_term?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadUpdateWithoutLeadNotesInput = {
  acceptMarketing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  acceptPrivacyPolicy?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  adminStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  assignedTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutLeadsNestedInput>
  callAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  conversations?: InputMaybe<ConversationUpdateManyWithoutLeadNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  emailAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  lastCallAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastContactedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastEmailAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leadId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  listPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticFormId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticSubmissionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  notes?: InputMaybe<LeadUpdatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableUpdateEnvelopeInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  priority?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  property?: InputMaybe<PropertyUpdateOneWithoutLeadsNestedInput>
  propertyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  utm_campaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_content?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_term?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadUpdateWithoutPropertyInput = {
  acceptMarketing?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  acceptPrivacyPolicy?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  adminStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  assignedTo?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutLeadsNestedInput>
  callAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  conversations?: InputMaybe<ConversationUpdateManyWithoutLeadNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  emailAttemptsCount?: InputMaybe<IntFieldUpdateOperationsInput>
  lastCallAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastContactedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  lastEmailAttemptAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leadId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leadNotes?: InputMaybe<LeadNoteUpdateManyWithoutLeadNestedInput>
  leadSubmittedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  listPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticFormId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mauticSubmissionId?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  message?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  notes?: InputMaybe<LeadUpdatenotesInput>
  personalData?: InputMaybe<PersonalDataNullableUpdateEnvelopeInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  priority?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  utm_campaign?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_content?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_medium?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_source?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utm_term?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LeadUpdatenotesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type LeadUpsertWithWhereUniqueWithoutBrokerInput = {
  create: LeadCreateWithoutBrokerInput
  update: LeadUpdateWithoutBrokerInput
  where: LeadWhereUniqueInput
}

export type LeadUpsertWithWhereUniqueWithoutPropertyInput = {
  create: LeadCreateWithoutPropertyInput
  update: LeadUpdateWithoutPropertyInput
  where: LeadWhereUniqueInput
}

export type LeadUpsertWithoutLeadNotesInput = {
  create: LeadCreateWithoutLeadNotesInput
  update: LeadUpdateWithoutLeadNotesInput
  where?: InputMaybe<LeadWhereInput>
}

export type LeadWhereInput = {
  AND?: InputMaybe<Array<LeadWhereInput>>
  NOT?: InputMaybe<Array<LeadWhereInput>>
  OR?: InputMaybe<Array<LeadWhereInput>>
  acceptMarketing?: InputMaybe<BoolNullableFilter>
  acceptPrivacyPolicy?: InputMaybe<BoolNullableFilter>
  adminStatus?: InputMaybe<StringNullableFilter>
  assignedTo?: InputMaybe<StringNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callAttemptsCount?: InputMaybe<IntFilter>
  conversations?: InputMaybe<ConversationListRelationFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  email?: InputMaybe<StringNullableFilter>
  emailAttemptsCount?: InputMaybe<IntFilter>
  id?: InputMaybe<StringFilter>
  lastCallAttemptAt?: InputMaybe<DateTimeNullableFilter>
  lastContactedAt?: InputMaybe<DateTimeNullableFilter>
  lastEmailAttemptAt?: InputMaybe<DateTimeNullableFilter>
  leadId?: InputMaybe<StringNullableFilter>
  leadNotes?: InputMaybe<LeadNoteListRelationFilter>
  leadSubmittedAt?: InputMaybe<DateTimeNullableFilter>
  listPosition?: InputMaybe<IntNullableFilter>
  mauticFormId?: InputMaybe<IntNullableFilter>
  mauticId?: InputMaybe<IntNullableFilter>
  mauticSubmissionId?: InputMaybe<IntNullableFilter>
  message?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringNullableFilter>
  notes?: InputMaybe<StringNullableListFilter>
  personalData?: InputMaybe<PersonalDataNullableCompositeFilter>
  phone?: InputMaybe<StringNullableFilter>
  priority?: InputMaybe<StringNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  propertyRef?: InputMaybe<StringNullableFilter>
  source?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  utm_campaign?: InputMaybe<StringNullableFilter>
  utm_content?: InputMaybe<StringNullableFilter>
  utm_medium?: InputMaybe<StringNullableFilter>
  utm_source?: InputMaybe<StringNullableFilter>
  utm_term?: InputMaybe<StringNullableFilter>
}

export type LeadWhereUniqueInput = {
  AND?: InputMaybe<Array<LeadWhereInput>>
  NOT?: InputMaybe<Array<LeadWhereInput>>
  OR?: InputMaybe<Array<LeadWhereInput>>
  acceptMarketing?: InputMaybe<BoolNullableFilter>
  acceptPrivacyPolicy?: InputMaybe<BoolNullableFilter>
  adminStatus?: InputMaybe<StringNullableFilter>
  assignedTo?: InputMaybe<StringNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callAttemptsCount?: InputMaybe<IntFilter>
  conversations?: InputMaybe<ConversationListRelationFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  email?: InputMaybe<StringNullableFilter>
  emailAttemptsCount?: InputMaybe<IntFilter>
  id?: InputMaybe<Scalars['String']['input']>
  lastCallAttemptAt?: InputMaybe<DateTimeNullableFilter>
  lastContactedAt?: InputMaybe<DateTimeNullableFilter>
  lastEmailAttemptAt?: InputMaybe<DateTimeNullableFilter>
  leadId?: InputMaybe<StringNullableFilter>
  leadNotes?: InputMaybe<LeadNoteListRelationFilter>
  leadSubmittedAt?: InputMaybe<DateTimeNullableFilter>
  listPosition?: InputMaybe<IntNullableFilter>
  mauticFormId?: InputMaybe<IntNullableFilter>
  mauticId?: InputMaybe<IntNullableFilter>
  mauticSubmissionId?: InputMaybe<IntNullableFilter>
  message?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringNullableFilter>
  notes?: InputMaybe<StringNullableListFilter>
  personalData?: InputMaybe<PersonalDataNullableCompositeFilter>
  phone?: InputMaybe<StringNullableFilter>
  priority?: InputMaybe<StringNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  propertyRef?: InputMaybe<StringNullableFilter>
  source?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  utm_campaign?: InputMaybe<StringNullableFilter>
  utm_content?: InputMaybe<StringNullableFilter>
  utm_medium?: InputMaybe<StringNullableFilter>
  utm_source?: InputMaybe<StringNullableFilter>
  utm_term?: InputMaybe<StringNullableFilter>
}

export type LeadsOverTimeEntry = {
  __typename?: 'LeadsOverTimeEntry'
  count: Scalars['Int']['output']
  date: Scalars['String']['output']
}

export type ListAssetsResponseModel = {
  __typename?: 'ListAssetsResponseModel'
  count: Scalars['Float']['output']
  items: Array<AssetItemModel>
  nextToken?: Maybe<Scalars['String']['output']>
}

export type ListingStatsSummary = {
  __typename?: 'ListingStatsSummary'
  bannerUrl?: Maybe<Scalars['String']['output']>
  brokerName?: Maybe<Scalars['String']['output']>
  logoUrl?: Maybe<Scalars['String']['output']>
  mostViewedProperty?: Maybe<ListingStatsTopProperty>
  totalProperties: Scalars['Int']['output']
  totalViews: Scalars['Int']['output']
}

export type ListingStatsTopProperty = {
  __typename?: 'ListingStatsTopProperty'
  externalId: Scalars['String']['output']
  fetchedTimes: Scalars['Int']['output']
  refId?: Maybe<Scalars['String']['output']>
  thumbnailUrl?: Maybe<Scalars['String']['output']>
}

export type Locality = {
  __typename?: 'Locality'
  mapbox_id: Scalars['String']['output']
  name: Scalars['String']['output']
  wikidata_id?: Maybe<Scalars['String']['output']>
}

export type LocalityCreateInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type LocalityNullableCompositeFilter = {
  equals?: InputMaybe<LocalityObjectEqualityInput>
  is?: InputMaybe<LocalityWhereInput>
  isNot?: InputMaybe<LocalityWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type LocalityNullableUpdateEnvelopeInput = {
  set?: InputMaybe<LocalityCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<LocalityUpsertInput>
}

export type LocalityObjectEqualityInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type LocalityOrderByInput = {
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  wikidata_id?: InputMaybe<SortOrder>
}

export type LocalityUpdateInput = {
  mapbox_id?: InputMaybe<StringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  wikidata_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocalityUpsertInput = {
  set: LocalityCreateInput
  update: LocalityUpdateInput
}

export type LocalityWhereInput = {
  AND?: InputMaybe<Array<LocalityWhereInput>>
  NOT?: InputMaybe<Array<LocalityWhereInput>>
  OR?: InputMaybe<Array<LocalityWhereInput>>
  mapbox_id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  wikidata_id?: InputMaybe<StringNullableFilter>
}

export type Location = {
  __typename?: 'Location'
  Brokers: Array<Broker>
  Province?: Maybe<Province>
  _count?: Maybe<LocationCount>
  area?: Maybe<Scalars['String']['output']>
  brokerIds: Array<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  isEstimated?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  location_detail?: Maybe<Scalars['String']['output']>
  mapLocation?: Maybe<MapLocation>
  municipality?: Maybe<Municipality>
  municipalityId?: Maybe<Scalars['String']['output']>
  municipalityName?: Maybe<Scalars['String']['output']>
  neighbourhood?: Maybe<Scalars['String']['output']>
  properties: Array<Property>
  province?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  town?: Maybe<Scalars['String']['output']>
}

export type LocationBrokersArgs = {
  cursor?: InputMaybe<BrokerWhereUniqueInput>
  distinct?: InputMaybe<Array<BrokerScalarFieldEnum>>
  orderBy?: InputMaybe<Array<BrokerOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BrokerWhereInput>
}

export type LocationProvinceArgs = {
  where?: InputMaybe<ProvinceWhereInput>
}

export type LocationMunicipalityArgs = {
  where?: InputMaybe<MunicipalityWhereInput>
}

export type LocationPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type LocationCount = {
  __typename?: 'LocationCount'
  Brokers: Scalars['Int']['output']
  properties: Scalars['Int']['output']
}

export type LocationCountBrokersArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type LocationCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type LocationCountAggregate = {
  __typename?: 'LocationCountAggregate'
  _all: Scalars['Int']['output']
  area: Scalars['Int']['output']
  brokerIds: Scalars['Int']['output']
  code: Scalars['Int']['output']
  country: Scalars['Int']['output']
  id: Scalars['Int']['output']
  isEstimated: Scalars['Int']['output']
  location: Scalars['Int']['output']
  location_detail: Scalars['Int']['output']
  municipalityId: Scalars['Int']['output']
  municipalityName: Scalars['Int']['output']
  neighbourhood: Scalars['Int']['output']
  province: Scalars['Int']['output']
  provinceId: Scalars['Int']['output']
  town: Scalars['Int']['output']
}

export type LocationCreateManyMunicipalityInput = {
  area?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<LocationCreatebrokerIdsInput>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  province?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreateManyMunicipalityInputEnvelope = {
  data: Array<LocationCreateManyMunicipalityInput>
}

export type LocationCreateManyProvinceInput = {
  area?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<LocationCreatebrokerIdsInput>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  province?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreateManyProvinceInputEnvelope = {
  data: Array<LocationCreateManyProvinceInput>
}

export type LocationCreateNestedManyWithoutBrokersInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<LocationCreateWithoutBrokersInput>>
}

export type LocationCreateNestedManyWithoutMunicipalityInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutMunicipalityInput>>
  create?: InputMaybe<Array<LocationCreateWithoutMunicipalityInput>>
  createMany?: InputMaybe<LocationCreateManyMunicipalityInputEnvelope>
}

export type LocationCreateNestedManyWithoutProvinceInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProvinceInput>>
  create?: InputMaybe<Array<LocationCreateWithoutProvinceInput>>
  createMany?: InputMaybe<LocationCreateManyProvinceInputEnvelope>
}

export type LocationCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<LocationCreateWithoutPropertiesInput>
}

export type LocationCreateOrConnectWithoutBrokersInput = {
  create: LocationCreateWithoutBrokersInput
  where: LocationWhereUniqueInput
}

export type LocationCreateOrConnectWithoutMunicipalityInput = {
  create: LocationCreateWithoutMunicipalityInput
  where: LocationWhereUniqueInput
}

export type LocationCreateOrConnectWithoutPropertiesInput = {
  create: LocationCreateWithoutPropertiesInput
  where: LocationWhereUniqueInput
}

export type LocationCreateOrConnectWithoutProvinceInput = {
  create: LocationCreateWithoutProvinceInput
  where: LocationWhereUniqueInput
}

export type LocationCreateWithoutBrokersInput = {
  Province?: InputMaybe<ProvinceCreateNestedOneWithoutLocationsInput>
  area?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityCreateNestedOneWithoutLocationsInput>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutLocationInput>
  province?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreateWithoutMunicipalityInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutLocationOptionsInput>
  Province?: InputMaybe<ProvinceCreateNestedOneWithoutLocationsInput>
  area?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutLocationInput>
  province?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutLocationOptionsInput>
  Province?: InputMaybe<ProvinceCreateNestedOneWithoutLocationsInput>
  area?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityCreateNestedOneWithoutLocationsInput>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  province?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreateWithoutProvinceInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutLocationOptionsInput>
  area?: InputMaybe<Scalars['String']['input']>
  code?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<Scalars['Boolean']['input']>
  location?: InputMaybe<Scalars['String']['input']>
  location_detail?: InputMaybe<Scalars['String']['input']>
  mapLocation?: InputMaybe<MapLocationNullableCreateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityCreateNestedOneWithoutLocationsInput>
  municipalityName?: InputMaybe<Scalars['String']['input']>
  neighbourhood?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutLocationInput>
  province?: InputMaybe<Scalars['String']['input']>
  town?: InputMaybe<Scalars['String']['input']>
}

export type LocationCreatebrokerIdsInput = {
  set: Array<Scalars['String']['input']>
}

export type LocationDataResponse = {
  __typename?: 'LocationDataResponse'
  districtTileName?: Maybe<Scalars['String']['output']>
  municipality?: Maybe<Scalars['String']['output']>
  neighbourhood?: Maybe<Scalars['String']['output']>
  place?: Maybe<Scalars['String']['output']>
  province?: Maybe<Scalars['String']['output']>
}

export type LocationGeoCode = {
  __typename?: 'LocationGeoCode'
  Property?: Maybe<Property>
  bbox: Array<Scalars['Float']['output']>
  geometry?: Maybe<Geometry>
  id: Scalars['String']['output']
  mapboxId?: Maybe<Scalars['String']['output']>
  properties?: Maybe<GeoProperties>
  propertyId?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type LocationGeoCodePropertyArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type LocationGeoCodeCreateNestedOneWithoutPropertyInput = {
  connect?: InputMaybe<LocationGeoCodeWhereUniqueInput>
  connectOrCreate?: InputMaybe<LocationGeoCodeCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<LocationGeoCodeCreateWithoutPropertyInput>
}

export type LocationGeoCodeCreateOrConnectWithoutPropertyInput = {
  create: LocationGeoCodeCreateWithoutPropertyInput
  where: LocationGeoCodeWhereUniqueInput
}

export type LocationGeoCodeCreateWithoutPropertyInput = {
  bbox?: InputMaybe<LocationGeoCodeCreatebboxInput>
  geometry?: InputMaybe<GeometryNullableCreateEnvelopeInput>
  id?: InputMaybe<Scalars['String']['input']>
  mapboxId?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<GeoPropertiesNullableCreateEnvelopeInput>
  type?: InputMaybe<Scalars['String']['input']>
}

export type LocationGeoCodeCreatebboxInput = {
  set: Array<Scalars['Float']['input']>
}

export type LocationGeoCodeNullableRelationFilter = {
  is?: InputMaybe<LocationGeoCodeWhereInput>
  isNot?: InputMaybe<LocationGeoCodeWhereInput>
}

export type LocationGeoCodeOrderByWithRelationInput = {
  Property?: InputMaybe<PropertyOrderByWithRelationInput>
  bbox?: InputMaybe<SortOrder>
  geometry?: InputMaybe<GeometryOrderByInput>
  id?: InputMaybe<SortOrder>
  mapboxId?: InputMaybe<SortOrder>
  properties?: InputMaybe<GeoPropertiesOrderByInput>
  propertyId?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
}

export type LocationGeoCodeUpdateOneWithoutPropertyNestedInput = {
  connect?: InputMaybe<LocationGeoCodeWhereUniqueInput>
  connectOrCreate?: InputMaybe<LocationGeoCodeCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<LocationGeoCodeCreateWithoutPropertyInput>
  delete?: InputMaybe<LocationGeoCodeWhereInput>
  disconnect?: InputMaybe<LocationGeoCodeWhereInput>
  update?: InputMaybe<LocationGeoCodeUpdateToOneWithWhereWithoutPropertyInput>
  upsert?: InputMaybe<LocationGeoCodeUpsertWithoutPropertyInput>
}

export type LocationGeoCodeUpdateToOneWithWhereWithoutPropertyInput = {
  data: LocationGeoCodeUpdateWithoutPropertyInput
  where?: InputMaybe<LocationGeoCodeWhereInput>
}

export type LocationGeoCodeUpdateWithoutPropertyInput = {
  bbox?: InputMaybe<LocationGeoCodeUpdatebboxInput>
  geometry?: InputMaybe<GeometryNullableUpdateEnvelopeInput>
  mapboxId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<GeoPropertiesNullableUpdateEnvelopeInput>
  type?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationGeoCodeUpdatebboxInput = {
  push?: InputMaybe<Array<Scalars['Float']['input']>>
  set?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type LocationGeoCodeUpsertWithoutPropertyInput = {
  create: LocationGeoCodeCreateWithoutPropertyInput
  update: LocationGeoCodeUpdateWithoutPropertyInput
  where?: InputMaybe<LocationGeoCodeWhereInput>
}

export type LocationGeoCodeWhereInput = {
  AND?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  NOT?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  OR?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  Property?: InputMaybe<PropertyNullableRelationFilter>
  bbox?: InputMaybe<FloatNullableListFilter>
  geometry?: InputMaybe<GeometryNullableCompositeFilter>
  id?: InputMaybe<StringFilter>
  mapboxId?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<GeoPropertiesNullableCompositeFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  type?: InputMaybe<StringNullableFilter>
}

export type LocationGeoCodeWhereUniqueInput = {
  AND?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  NOT?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  OR?: InputMaybe<Array<LocationGeoCodeWhereInput>>
  Property?: InputMaybe<PropertyNullableRelationFilter>
  bbox?: InputMaybe<FloatNullableListFilter>
  geometry?: InputMaybe<GeometryNullableCompositeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  mapboxId?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<GeoPropertiesNullableCompositeFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
  type?: InputMaybe<StringNullableFilter>
}

export type LocationListRelationFilter = {
  every?: InputMaybe<LocationWhereInput>
  none?: InputMaybe<LocationWhereInput>
  some?: InputMaybe<LocationWhereInput>
}

export type LocationLocationProvinceAreaCountryCompoundUniqueInput = {
  area: Scalars['String']['input']
  country: Scalars['String']['input']
  location: Scalars['String']['input']
  province: Scalars['String']['input']
}

export type LocationMaxAggregate = {
  __typename?: 'LocationMaxAggregate'
  area?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isEstimated?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  location_detail?: Maybe<Scalars['String']['output']>
  municipalityId?: Maybe<Scalars['String']['output']>
  municipalityName?: Maybe<Scalars['String']['output']>
  neighbourhood?: Maybe<Scalars['String']['output']>
  province?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  town?: Maybe<Scalars['String']['output']>
}

export type LocationMinAggregate = {
  __typename?: 'LocationMinAggregate'
  area?: Maybe<Scalars['String']['output']>
  code?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  isEstimated?: Maybe<Scalars['Boolean']['output']>
  location?: Maybe<Scalars['String']['output']>
  location_detail?: Maybe<Scalars['String']['output']>
  municipalityId?: Maybe<Scalars['String']['output']>
  municipalityName?: Maybe<Scalars['String']['output']>
  neighbourhood?: Maybe<Scalars['String']['output']>
  province?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  town?: Maybe<Scalars['String']['output']>
}

export type LocationNullableRelationFilter = {
  is?: InputMaybe<LocationWhereInput>
  isNot?: InputMaybe<LocationWhereInput>
}

export type LocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type LocationOrderByWithRelationInput = {
  Brokers?: InputMaybe<BrokerOrderByRelationAggregateInput>
  Province?: InputMaybe<ProvinceOrderByWithRelationInput>
  area?: InputMaybe<SortOrder>
  brokerIds?: InputMaybe<SortOrder>
  code?: InputMaybe<SortOrder>
  country?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  isEstimated?: InputMaybe<SortOrder>
  location?: InputMaybe<SortOrder>
  location_detail?: InputMaybe<SortOrder>
  mapLocation?: InputMaybe<MapLocationOrderByInput>
  municipality?: InputMaybe<MunicipalityOrderByWithRelationInput>
  municipalityId?: InputMaybe<SortOrder>
  municipalityName?: InputMaybe<SortOrder>
  neighbourhood?: InputMaybe<SortOrder>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  province?: InputMaybe<SortOrder>
  provinceId?: InputMaybe<SortOrder>
  town?: InputMaybe<SortOrder>
}

export enum LocationScalarFieldEnum {
  Area = 'area',
  BrokerIds = 'brokerIds',
  Code = 'code',
  Country = 'country',
  Id = 'id',
  IsEstimated = 'isEstimated',
  Location = 'location',
  LocationDetail = 'location_detail',
  MunicipalityId = 'municipalityId',
  MunicipalityName = 'municipalityName',
  Neighbourhood = 'neighbourhood',
  Province = 'province',
  ProvinceId = 'provinceId',
  Town = 'town',
}

export type LocationScalarWhereInput = {
  AND?: InputMaybe<Array<LocationScalarWhereInput>>
  NOT?: InputMaybe<Array<LocationScalarWhereInput>>
  OR?: InputMaybe<Array<LocationScalarWhereInput>>
  area?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  code?: InputMaybe<StringNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  isEstimated?: InputMaybe<BoolNullableFilter>
  location?: InputMaybe<StringNullableFilter>
  location_detail?: InputMaybe<StringNullableFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  municipalityName?: InputMaybe<StringNullableFilter>
  neighbourhood?: InputMaybe<StringNullableFilter>
  province?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  town?: InputMaybe<StringNullableFilter>
}

export type LocationSearchResponse = {
  __typename?: 'LocationSearchResponse'
  features: Array<SearchLocationFeature>
  type: Scalars['String']['output']
}

export type LocationSuggestion = {
  __typename?: 'LocationSuggestion'
  area?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  label: Scalars['String']['output']
  location?: Maybe<Scalars['String']['output']>
  province?: Maybe<Scalars['String']['output']>
}

export type LocationUpdateManyMutationInput = {
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isEstimated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  location_detail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapLocation?: InputMaybe<MapLocationNullableUpdateEnvelopeInput>
  municipalityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  neighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationUpdateManyWithWhereWithoutBrokersInput = {
  data: LocationUpdateManyMutationInput
  where: LocationScalarWhereInput
}

export type LocationUpdateManyWithWhereWithoutMunicipalityInput = {
  data: LocationUpdateManyMutationInput
  where: LocationScalarWhereInput
}

export type LocationUpdateManyWithWhereWithoutProvinceInput = {
  data: LocationUpdateManyMutationInput
  where: LocationScalarWhereInput
}

export type LocationUpdateManyWithoutBrokersNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<LocationCreateWithoutBrokersInput>>
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>
  set?: InputMaybe<Array<LocationWhereUniqueInput>>
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutBrokersInput>>
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutBrokersInput>>
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutBrokersInput>>
}

export type LocationUpdateManyWithoutMunicipalityNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutMunicipalityInput>>
  create?: InputMaybe<Array<LocationCreateWithoutMunicipalityInput>>
  createMany?: InputMaybe<LocationCreateManyMunicipalityInputEnvelope>
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>
  set?: InputMaybe<Array<LocationWhereUniqueInput>>
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutMunicipalityInput>>
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutMunicipalityInput>>
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutMunicipalityInput>>
}

export type LocationUpdateManyWithoutProvinceNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutProvinceInput>>
  create?: InputMaybe<Array<LocationCreateWithoutProvinceInput>>
  createMany?: InputMaybe<LocationCreateManyProvinceInputEnvelope>
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>
  set?: InputMaybe<Array<LocationWhereUniqueInput>>
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutProvinceInput>>
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutProvinceInput>>
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutProvinceInput>>
}

export type LocationUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<LocationCreateWithoutPropertiesInput>
  delete?: InputMaybe<LocationWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<LocationUpdateToOneWithWhereWithoutPropertiesInput>
  upsert?: InputMaybe<LocationUpsertWithoutPropertiesInput>
}

export type LocationUpdateToOneWithWhereWithoutPropertiesInput = {
  data: LocationUpdateWithoutPropertiesInput
  where?: InputMaybe<LocationWhereInput>
}

export type LocationUpdateWithWhereUniqueWithoutBrokersInput = {
  data: LocationUpdateWithoutBrokersInput
  where: LocationWhereUniqueInput
}

export type LocationUpdateWithWhereUniqueWithoutMunicipalityInput = {
  data: LocationUpdateWithoutMunicipalityInput
  where: LocationWhereUniqueInput
}

export type LocationUpdateWithWhereUniqueWithoutProvinceInput = {
  data: LocationUpdateWithoutProvinceInput
  where: LocationWhereUniqueInput
}

export type LocationUpdateWithoutBrokersInput = {
  Province?: InputMaybe<ProvinceUpdateOneWithoutLocationsNestedInput>
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isEstimated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  location_detail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapLocation?: InputMaybe<MapLocationNullableUpdateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityUpdateOneWithoutLocationsNestedInput>
  municipalityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  neighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutLocationNestedInput>
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationUpdateWithoutMunicipalityInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutLocationOptionsNestedInput>
  Province?: InputMaybe<ProvinceUpdateOneWithoutLocationsNestedInput>
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isEstimated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  location_detail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapLocation?: InputMaybe<MapLocationNullableUpdateEnvelopeInput>
  municipalityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  neighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutLocationNestedInput>
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationUpdateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutLocationOptionsNestedInput>
  Province?: InputMaybe<ProvinceUpdateOneWithoutLocationsNestedInput>
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isEstimated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  location_detail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapLocation?: InputMaybe<MapLocationNullableUpdateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityUpdateOneWithoutLocationsNestedInput>
  municipalityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  neighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationUpdateWithoutProvinceInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutLocationOptionsNestedInput>
  area?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isEstimated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  location?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  location_detail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapLocation?: InputMaybe<MapLocationNullableUpdateEnvelopeInput>
  municipality?: InputMaybe<MunicipalityUpdateOneWithoutLocationsNestedInput>
  municipalityName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  neighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutLocationNestedInput>
  province?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  town?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type LocationUpsertWithWhereUniqueWithoutBrokersInput = {
  create: LocationCreateWithoutBrokersInput
  update: LocationUpdateWithoutBrokersInput
  where: LocationWhereUniqueInput
}

export type LocationUpsertWithWhereUniqueWithoutMunicipalityInput = {
  create: LocationCreateWithoutMunicipalityInput
  update: LocationUpdateWithoutMunicipalityInput
  where: LocationWhereUniqueInput
}

export type LocationUpsertWithWhereUniqueWithoutProvinceInput = {
  create: LocationCreateWithoutProvinceInput
  update: LocationUpdateWithoutProvinceInput
  where: LocationWhereUniqueInput
}

export type LocationUpsertWithoutPropertiesInput = {
  create: LocationCreateWithoutPropertiesInput
  update: LocationUpdateWithoutPropertiesInput
  where?: InputMaybe<LocationWhereInput>
}

export type LocationWhereInput = {
  AND?: InputMaybe<Array<LocationWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<LocationWhereInput>>
  OR?: InputMaybe<Array<LocationWhereInput>>
  Province?: InputMaybe<ProvinceNullableRelationFilter>
  area?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  code?: InputMaybe<StringNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  isEstimated?: InputMaybe<BoolNullableFilter>
  location?: InputMaybe<StringNullableFilter>
  location_detail?: InputMaybe<StringNullableFilter>
  mapLocation?: InputMaybe<MapLocationNullableCompositeFilter>
  municipality?: InputMaybe<MunicipalityNullableRelationFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  municipalityName?: InputMaybe<StringNullableFilter>
  neighbourhood?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
  province?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  town?: InputMaybe<StringNullableFilter>
}

export type LocationWhereUniqueInput = {
  AND?: InputMaybe<Array<LocationWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<LocationWhereInput>>
  OR?: InputMaybe<Array<LocationWhereInput>>
  Province?: InputMaybe<ProvinceNullableRelationFilter>
  area?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  code?: InputMaybe<StringNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  isEstimated?: InputMaybe<BoolNullableFilter>
  location?: InputMaybe<StringNullableFilter>
  location_detail?: InputMaybe<StringNullableFilter>
  location_province_area_country?: InputMaybe<LocationLocationProvinceAreaCountryCompoundUniqueInput>
  mapLocation?: InputMaybe<MapLocationNullableCompositeFilter>
  municipality?: InputMaybe<MunicipalityNullableRelationFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  municipalityName?: InputMaybe<StringNullableFilter>
  neighbourhood?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
  province?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  town?: InputMaybe<StringNullableFilter>
}

export type LoginHistoryModel = {
  __typename?: 'LoginHistoryModel'
  createdAt: Scalars['DateTimeISO']['output']
  deviceInfo?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  ipAddress: Scalars['String']['output']
  successful: Scalars['Boolean']['output']
  userAgent?: Maybe<Scalars['String']['output']>
  userId: Scalars['String']['output']
}

export type LoginInput = {
  email: Scalars['String']['input']
  password: Scalars['String']['input']
}

export type LookupMunicipalityResponse = {
  __typename?: 'LookupMunicipalityResponse'
  municipality?: Maybe<Scalars['String']['output']>
}

export enum MaintenanceHistory {
  Average = 'average',
  Excellent = 'excellent',
  Good = 'good',
  Poor = 'poor',
}

export type MakeContactMetaInput = {
  brokerId?: InputMaybe<Scalars['String']['input']>
  hasWhatsApp?: InputMaybe<Scalars['Boolean']['input']>
  inboxUrl?: InputMaybe<Scalars['String']['input']>
  mauticCookieHeader?: InputMaybe<Scalars['String']['input']>
  priceRange?: InputMaybe<Scalars['String']['input']>
  purchaseTimeframe?: InputMaybe<Scalars['String']['input']>
  utmCampaign?: InputMaybe<Scalars['String']['input']>
  utmContent?: InputMaybe<Scalars['String']['input']>
  utmMedium?: InputMaybe<Scalars['String']['input']>
  utmSource?: InputMaybe<Scalars['String']['input']>
  utmTerm?: InputMaybe<Scalars['String']['input']>
}

export type MapData = {
  __typename?: 'MapData'
  city?: Maybe<Scalars['String']['output']>
  coordinates?: Maybe<Coordinates>
  id: Scalars['String']['output']
  locationsCount: Scalars['Int']['output']
  municipalityName?: Maybe<Scalars['String']['output']>
  propertiesCount: Scalars['Int']['output']
}

export type MapDataOrderByWithRelationInput = {
  city?: InputMaybe<SortOrder>
  coordinates?: InputMaybe<CoordinatesOrderByInput>
  id?: InputMaybe<SortOrder>
  locationsCount?: InputMaybe<SortOrder>
  municipalityName?: InputMaybe<SortOrder>
  propertiesCount?: InputMaybe<SortOrder>
}

export enum MapDataScalarFieldEnum {
  City = 'city',
  Id = 'id',
  LocationsCount = 'locationsCount',
  MunicipalityName = 'municipalityName',
  PropertiesCount = 'propertiesCount',
}

export type MapDataWhereInput = {
  AND?: InputMaybe<Array<MapDataWhereInput>>
  NOT?: InputMaybe<Array<MapDataWhereInput>>
  OR?: InputMaybe<Array<MapDataWhereInput>>
  city?: InputMaybe<StringNullableFilter>
  coordinates?: InputMaybe<CoordinatesNullableCompositeFilter>
  id?: InputMaybe<StringFilter>
  locationsCount?: InputMaybe<IntFilter>
  municipalityName?: InputMaybe<StringNullableFilter>
  propertiesCount?: InputMaybe<IntFilter>
}

export type MapDataWhereUniqueInput = {
  AND?: InputMaybe<Array<MapDataWhereInput>>
  NOT?: InputMaybe<Array<MapDataWhereInput>>
  OR?: InputMaybe<Array<MapDataWhereInput>>
  city?: InputMaybe<StringNullableFilter>
  coordinates?: InputMaybe<CoordinatesNullableCompositeFilter>
  id?: InputMaybe<Scalars['String']['input']>
  locationsCount?: InputMaybe<IntFilter>
  municipalityName?: InputMaybe<StringNullableFilter>
  propertiesCount?: InputMaybe<IntFilter>
}

export type MapLocation = {
  __typename?: 'MapLocation'
  address?: Maybe<Address>
  localityType?: Maybe<Scalars['String']['output']>
  mapView?: Maybe<MapView>
  position?: Maybe<Position>
  resultType?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
}

export type MapLocationCreateInput = {
  address?: InputMaybe<AddressCreateInput>
  localityType?: InputMaybe<Scalars['String']['input']>
  mapView?: InputMaybe<MapViewCreateInput>
  position?: InputMaybe<PositionCreateInput>
  resultType?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapLocationNullableCompositeFilter = {
  equals?: InputMaybe<MapLocationObjectEqualityInput>
  is?: InputMaybe<MapLocationWhereInput>
  isNot?: InputMaybe<MapLocationWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type MapLocationNullableCreateEnvelopeInput = {
  set?: InputMaybe<MapLocationCreateInput>
}

export type MapLocationNullableUpdateEnvelopeInput = {
  set?: InputMaybe<MapLocationCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<MapLocationUpsertInput>
}

export type MapLocationObjectEqualityInput = {
  address?: InputMaybe<AddressObjectEqualityInput>
  localityType?: InputMaybe<Scalars['String']['input']>
  mapView?: InputMaybe<MapViewObjectEqualityInput>
  position?: InputMaybe<PositionObjectEqualityInput>
  resultType?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
}

export type MapLocationOrderByInput = {
  address?: InputMaybe<AddressOrderByInput>
  localityType?: InputMaybe<SortOrder>
  mapView?: InputMaybe<MapViewOrderByInput>
  position?: InputMaybe<PositionOrderByInput>
  resultType?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type MapLocationUpdateInput = {
  address?: InputMaybe<AddressNullableUpdateEnvelopeInput>
  localityType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  mapView?: InputMaybe<MapViewNullableUpdateEnvelopeInput>
  position?: InputMaybe<PositionNullableUpdateEnvelopeInput>
  resultType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  title?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type MapLocationUpsertInput = {
  set: MapLocationCreateInput
  update: MapLocationUpdateInput
}

export type MapLocationWhereInput = {
  AND?: InputMaybe<Array<MapLocationWhereInput>>
  NOT?: InputMaybe<Array<MapLocationWhereInput>>
  OR?: InputMaybe<Array<MapLocationWhereInput>>
  address?: InputMaybe<AddressNullableCompositeFilter>
  localityType?: InputMaybe<StringNullableFilter>
  mapView?: InputMaybe<MapViewNullableCompositeFilter>
  position?: InputMaybe<PositionNullableCompositeFilter>
  resultType?: InputMaybe<StringNullableFilter>
  title?: InputMaybe<StringNullableFilter>
}

export type MapView = {
  __typename?: 'MapView'
  east?: Maybe<Scalars['Float']['output']>
  north?: Maybe<Scalars['Float']['output']>
  south?: Maybe<Scalars['Float']['output']>
  west?: Maybe<Scalars['Float']['output']>
}

export type MapViewCreateInput = {
  east?: InputMaybe<Scalars['Float']['input']>
  north?: InputMaybe<Scalars['Float']['input']>
  south?: InputMaybe<Scalars['Float']['input']>
  west?: InputMaybe<Scalars['Float']['input']>
}

export type MapViewNullableCompositeFilter = {
  equals?: InputMaybe<MapViewObjectEqualityInput>
  is?: InputMaybe<MapViewWhereInput>
  isNot?: InputMaybe<MapViewWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type MapViewNullableUpdateEnvelopeInput = {
  set?: InputMaybe<MapViewCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<MapViewUpsertInput>
}

export type MapViewObjectEqualityInput = {
  east?: InputMaybe<Scalars['Float']['input']>
  north?: InputMaybe<Scalars['Float']['input']>
  south?: InputMaybe<Scalars['Float']['input']>
  west?: InputMaybe<Scalars['Float']['input']>
}

export type MapViewOrderByInput = {
  east?: InputMaybe<SortOrder>
  north?: InputMaybe<SortOrder>
  south?: InputMaybe<SortOrder>
  west?: InputMaybe<SortOrder>
}

export type MapViewUpdateInput = {
  east?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  north?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  south?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  west?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
}

export type MapViewUpsertInput = {
  set: MapViewCreateInput
  update: MapViewUpdateInput
}

export type MapViewWhereInput = {
  AND?: InputMaybe<Array<MapViewWhereInput>>
  NOT?: InputMaybe<Array<MapViewWhereInput>>
  OR?: InputMaybe<Array<MapViewWhereInput>>
  east?: InputMaybe<FloatNullableFilter>
  north?: InputMaybe<FloatNullableFilter>
  south?: InputMaybe<FloatNullableFilter>
  west?: InputMaybe<FloatNullableFilter>
}

/** Single form field value from Mautic contact */
export type MauticFormDataEntry = {
  __typename?: 'MauticFormDataEntry'
  alias: Scalars['String']['output']
  label?: Maybe<Scalars['String']['output']>
  /** String representation of the value */
  value?: Maybe<Scalars['String']['output']>
}

/** Single question-answer pair from a Mautic form submission */
export type MauticFormQuestionAnswer = {
  __typename?: 'MauticFormQuestionAnswer'
  /** The submitted value (the answer) */
  answer?: Maybe<Scalars['String']['output']>
  /** The field label or alias (the question) */
  question: Scalars['String']['output']
}

/** A lead's most recent filled form from Mautic, in question-answer format */
export type MauticMostRecentForm = {
  __typename?: 'MauticMostRecentForm'
  /** Form fields as question-answer pairs */
  entries: Array<MauticFormQuestionAnswer>
  /** Name of the form that was submitted (from meta_original_form_name) */
  formName?: Maybe<Scalars['String']['output']>
  /** ISO datetime when the form was submitted (from lead_originally_submitted) */
  submittedAt?: Maybe<Scalars['String']['output']>
}

/** Mautic contact stats (points, tags, last activity, email/phone verified, source, form name) */
export type MauticStats = {
  __typename?: 'MauticStats'
  /** From Mautic contact field email_is_verified_ok */
  emailVerified?: Maybe<Scalars['Boolean']['output']>
  /** From Mautic contact field inbox_url (landing page URL, typically with UTM params) */
  inboxUrl?: Maybe<Scalars['String']['output']>
  lastActive?: Maybe<Scalars['String']['output']>
  /** From Mautic contact field lead_source */
  leadSource?: Maybe<Scalars['String']['output']>
  /** From Mautic contact field meta_original_form_name */
  originalFormName?: Maybe<Scalars['String']['output']>
  /** From Mautic contact field lead_originally_submitted (ISO datetime when lead was first submitted) */
  originallySubmittedAt?: Maybe<Scalars['String']['output']>
  /** From Mautic contact field phone_is_verified_ok */
  phoneVerified?: Maybe<Scalars['Boolean']['output']>
  points?: Maybe<Scalars['Int']['output']>
  tagNames?: Maybe<Array<Scalars['String']['output']>>
}

export type Message = {
  __typename?: 'Message'
  content: Scalars['String']['output']
  conversationId: Scalars['String']['output']
  from: Scalars['String']['output']
  id: Scalars['String']['output']
  read: Scalars['Boolean']['output']
  timestamp: Scalars['DateTimeISO']['output']
}

export type MessageCreateManyConversationInput = {
  content: Scalars['String']['input']
  from: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  read?: InputMaybe<Scalars['Boolean']['input']>
  timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type MessageCreateManyConversationInputEnvelope = {
  data: Array<MessageCreateManyConversationInput>
}

export type MessageCreateNestedManyWithoutConversationInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutConversationInput>>
  create?: InputMaybe<Array<MessageCreateWithoutConversationInput>>
  createMany?: InputMaybe<MessageCreateManyConversationInputEnvelope>
}

export type MessageCreateOrConnectWithoutConversationInput = {
  create: MessageCreateWithoutConversationInput
  where: MessageWhereUniqueInput
}

export type MessageCreateWithoutConversationInput = {
  content: Scalars['String']['input']
  from: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  read?: InputMaybe<Scalars['Boolean']['input']>
  timestamp?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type MessageListRelationFilter = {
  every?: InputMaybe<MessageWhereInput>
  none?: InputMaybe<MessageWhereInput>
  some?: InputMaybe<MessageWhereInput>
}

export type MessageOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type MessageScalarWhereInput = {
  AND?: InputMaybe<Array<MessageScalarWhereInput>>
  NOT?: InputMaybe<Array<MessageScalarWhereInput>>
  OR?: InputMaybe<Array<MessageScalarWhereInput>>
  content?: InputMaybe<StringFilter>
  conversationId?: InputMaybe<StringFilter>
  from?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  read?: InputMaybe<BoolFilter>
  timestamp?: InputMaybe<DateTimeFilter>
}

export type MessageUpdateManyMutationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>
  from?: InputMaybe<StringFieldUpdateOperationsInput>
  read?: InputMaybe<BoolFieldUpdateOperationsInput>
  timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type MessageUpdateManyWithWhereWithoutConversationInput = {
  data: MessageUpdateManyMutationInput
  where: MessageScalarWhereInput
}

export type MessageUpdateManyWithoutConversationNestedInput = {
  connect?: InputMaybe<Array<MessageWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<MessageCreateOrConnectWithoutConversationInput>>
  create?: InputMaybe<Array<MessageCreateWithoutConversationInput>>
  createMany?: InputMaybe<MessageCreateManyConversationInputEnvelope>
  delete?: InputMaybe<Array<MessageWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<MessageScalarWhereInput>>
  disconnect?: InputMaybe<Array<MessageWhereUniqueInput>>
  set?: InputMaybe<Array<MessageWhereUniqueInput>>
  update?: InputMaybe<Array<MessageUpdateWithWhereUniqueWithoutConversationInput>>
  updateMany?: InputMaybe<Array<MessageUpdateManyWithWhereWithoutConversationInput>>
  upsert?: InputMaybe<Array<MessageUpsertWithWhereUniqueWithoutConversationInput>>
}

export type MessageUpdateWithWhereUniqueWithoutConversationInput = {
  data: MessageUpdateWithoutConversationInput
  where: MessageWhereUniqueInput
}

export type MessageUpdateWithoutConversationInput = {
  content?: InputMaybe<StringFieldUpdateOperationsInput>
  from?: InputMaybe<StringFieldUpdateOperationsInput>
  read?: InputMaybe<BoolFieldUpdateOperationsInput>
  timestamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type MessageUpsertWithWhereUniqueWithoutConversationInput = {
  create: MessageCreateWithoutConversationInput
  update: MessageUpdateWithoutConversationInput
  where: MessageWhereUniqueInput
}

export type MessageWhereInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>
  NOT?: InputMaybe<Array<MessageWhereInput>>
  OR?: InputMaybe<Array<MessageWhereInput>>
  content?: InputMaybe<StringFilter>
  conversation?: InputMaybe<ConversationRelationFilter>
  conversationId?: InputMaybe<StringFilter>
  from?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  read?: InputMaybe<BoolFilter>
  timestamp?: InputMaybe<DateTimeFilter>
}

export type MessageWhereUniqueInput = {
  AND?: InputMaybe<Array<MessageWhereInput>>
  NOT?: InputMaybe<Array<MessageWhereInput>>
  OR?: InputMaybe<Array<MessageWhereInput>>
  content?: InputMaybe<StringFilter>
  conversation?: InputMaybe<ConversationRelationFilter>
  conversationId?: InputMaybe<StringFilter>
  from?: InputMaybe<StringFilter>
  id?: InputMaybe<Scalars['String']['input']>
  read?: InputMaybe<BoolFilter>
  timestamp?: InputMaybe<DateTimeFilter>
}

export type Municipality = {
  __typename?: 'Municipality'
  _count?: Maybe<MunicipalityCount>
  code?: Maybe<Scalars['Int']['output']>
  id: Scalars['String']['output']
  locations: Array<Location>
  mapboxId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  normalizedName?: Maybe<Scalars['String']['output']>
  properties: Array<Property>
}

export type MunicipalityLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LocationWhereInput>
}

export type MunicipalityPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type MunicipalityAvgAggregate = {
  __typename?: 'MunicipalityAvgAggregate'
  code?: Maybe<Scalars['Float']['output']>
}

export type MunicipalityCount = {
  __typename?: 'MunicipalityCount'
  locations: Scalars['Int']['output']
  properties: Scalars['Int']['output']
}

export type MunicipalityCountLocationsArgs = {
  where?: InputMaybe<LocationWhereInput>
}

export type MunicipalityCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type MunicipalityCountAggregate = {
  __typename?: 'MunicipalityCountAggregate'
  _all: Scalars['Int']['output']
  code: Scalars['Int']['output']
  id: Scalars['Int']['output']
  mapboxId: Scalars['Int']['output']
  name: Scalars['Int']['output']
  normalizedName: Scalars['Int']['output']
}

export type MunicipalityCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<MunicipalityWhereUniqueInput>
  connectOrCreate?: InputMaybe<MunicipalityCreateOrConnectWithoutLocationsInput>
  create?: InputMaybe<MunicipalityCreateWithoutLocationsInput>
}

export type MunicipalityCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<MunicipalityWhereUniqueInput>
  connectOrCreate?: InputMaybe<MunicipalityCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<MunicipalityCreateWithoutPropertiesInput>
}

export type MunicipalityCreateOrConnectWithoutLocationsInput = {
  create: MunicipalityCreateWithoutLocationsInput
  where: MunicipalityWhereUniqueInput
}

export type MunicipalityCreateOrConnectWithoutPropertiesInput = {
  create: MunicipalityCreateWithoutPropertiesInput
  where: MunicipalityWhereUniqueInput
}

export type MunicipalityCreateWithoutLocationsInput = {
  code?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  mapboxId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  normalizedName?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutLocationMunicipalityInput>
}

export type MunicipalityCreateWithoutPropertiesInput = {
  code?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<LocationCreateNestedManyWithoutMunicipalityInput>
  mapboxId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  normalizedName?: InputMaybe<Scalars['String']['input']>
}

export type MunicipalityMaxAggregate = {
  __typename?: 'MunicipalityMaxAggregate'
  code?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  mapboxId?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  normalizedName?: Maybe<Scalars['String']['output']>
}

export type MunicipalityMinAggregate = {
  __typename?: 'MunicipalityMinAggregate'
  code?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  mapboxId?: Maybe<Scalars['String']['output']>
  name?: Maybe<Scalars['String']['output']>
  normalizedName?: Maybe<Scalars['String']['output']>
}

export type MunicipalityNullableRelationFilter = {
  is?: InputMaybe<MunicipalityWhereInput>
  isNot?: InputMaybe<MunicipalityWhereInput>
}

export type MunicipalityOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>
  mapboxId?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  normalizedName?: InputMaybe<SortOrder>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
}

export enum MunicipalityScalarFieldEnum {
  Code = 'code',
  Id = 'id',
  MapboxId = 'mapboxId',
  Name = 'name',
  NormalizedName = 'normalizedName',
}

export type MunicipalitySumAggregate = {
  __typename?: 'MunicipalitySumAggregate'
  code?: Maybe<Scalars['Int']['output']>
}

export type MunicipalityUpdateOneWithoutLocationsNestedInput = {
  connect?: InputMaybe<MunicipalityWhereUniqueInput>
  connectOrCreate?: InputMaybe<MunicipalityCreateOrConnectWithoutLocationsInput>
  create?: InputMaybe<MunicipalityCreateWithoutLocationsInput>
  delete?: InputMaybe<MunicipalityWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<MunicipalityUpdateToOneWithWhereWithoutLocationsInput>
  upsert?: InputMaybe<MunicipalityUpsertWithoutLocationsInput>
}

export type MunicipalityUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<MunicipalityWhereUniqueInput>
  connectOrCreate?: InputMaybe<MunicipalityCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<MunicipalityCreateWithoutPropertiesInput>
  delete?: InputMaybe<MunicipalityWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<MunicipalityUpdateToOneWithWhereWithoutPropertiesInput>
  upsert?: InputMaybe<MunicipalityUpsertWithoutPropertiesInput>
}

export type MunicipalityUpdateToOneWithWhereWithoutLocationsInput = {
  data: MunicipalityUpdateWithoutLocationsInput
  where?: InputMaybe<MunicipalityWhereInput>
}

export type MunicipalityUpdateToOneWithWhereWithoutPropertiesInput = {
  data: MunicipalityUpdateWithoutPropertiesInput
  where?: InputMaybe<MunicipalityWhereInput>
}

export type MunicipalityUpdateWithoutLocationsInput = {
  code?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  mapboxId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  normalizedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutLocationMunicipalityNestedInput>
}

export type MunicipalityUpdateWithoutPropertiesInput = {
  code?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  locations?: InputMaybe<LocationUpdateManyWithoutMunicipalityNestedInput>
  mapboxId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  normalizedName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type MunicipalityUpsertWithoutLocationsInput = {
  create: MunicipalityCreateWithoutLocationsInput
  update: MunicipalityUpdateWithoutLocationsInput
  where?: InputMaybe<MunicipalityWhereInput>
}

export type MunicipalityUpsertWithoutPropertiesInput = {
  create: MunicipalityCreateWithoutPropertiesInput
  update: MunicipalityUpdateWithoutPropertiesInput
  where?: InputMaybe<MunicipalityWhereInput>
}

export type MunicipalityWhereInput = {
  AND?: InputMaybe<Array<MunicipalityWhereInput>>
  NOT?: InputMaybe<Array<MunicipalityWhereInput>>
  OR?: InputMaybe<Array<MunicipalityWhereInput>>
  code?: InputMaybe<IntNullableFilter>
  id?: InputMaybe<StringFilter>
  locations?: InputMaybe<LocationListRelationFilter>
  mapboxId?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  normalizedName?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
}

export type MunicipalityWhereUniqueInput = {
  AND?: InputMaybe<Array<MunicipalityWhereInput>>
  NOT?: InputMaybe<Array<MunicipalityWhereInput>>
  OR?: InputMaybe<Array<MunicipalityWhereInput>>
  code?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<LocationListRelationFilter>
  mapboxId?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  normalizedName?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyListRelationFilter>
}

export type Mutation = {
  __typename?: 'Mutation'
  addAgent: AgentSignupResult
  addLeadNote: Lead
  addMessage: Message
  addPropertiesToCustomSearchPriority: SearchOrderConfigOutput
  addPropertyToFavorites: FavoriteResponse
  adminLogin: AdminLoginResponse
  agentLogin: AgentLoginResponse
  agentSignup: AgentSignupResult
  approvePropertyImagesAI: Property
  assignAgencyRole: Scalars['Boolean']['output']
  assignLead: Lead
  assignLeadToBroker: Lead
  assignPermissionToRole: Scalars['Boolean']['output']
  assignUserToAgency: AgencyOperationResponse
  bulkDeleteUsers: BulkOperationResult
  cancelSubscription: Subscription
  confirmPayment: Subscription
  connectLocationsToBroker: Broker
  /** Create a new advertiser (SUPER_ADMIN only) */
  createAdvertiser: Advertiser
  createAgency: Broker
  createAgencyPortalApplicationSettings: AgencyPortalApplicationSettings
  createAvailablePaidExtra: AvailablePaidExtras
  createBulkPaidExtras: Array<PaidExtra>
  createLead: Lead
  createManyAvailablePaidExtras: AffectedRowsOutput
  createManyLead: AffectedRowsOutput
  createManyProperty: AffectedRowsOutput
  createManySubscription: AffectedRowsOutput
  createOneAvailablePaidExtras: AvailablePaidExtras
  createOneLead: Lead
  createOneSubscription: Subscription
  createPaidExtra: PaidExtra
  createPermission: PermissionModel
  createProperty: Property
  /** Create a new property card ad (SUPER_ADMIN only) */
  createPropertyCardAd: PropertyCardAd
  createPropertyReport: PropertyReport
  createRole: RoleModel
  createSubscription: Subscription
  createUser: AdminUserModel
  /** Delete an advertiser (SUPER_ADMIN only) */
  deleteAdvertiser: Scalars['Boolean']['output']
  deleteAgency: Scalars['Boolean']['output']
  deleteAgencyPortalApplicationSettings: AgencyPortalApplicationSettings
  deleteAvailablePaidExtra: Scalars['Boolean']['output']
  deleteLead: Lead
  deleteManyAvailablePaidExtras: AffectedRowsOutput
  deleteManyLead: AffectedRowsOutput
  deleteManySubscription: AffectedRowsOutput
  deleteMultipleProperties: Array<Property>
  deleteOneAvailablePaidExtras?: Maybe<AvailablePaidExtras>
  deleteOneLead: Lead
  deleteOneSubscription?: Maybe<Subscription>
  deletePaidExtra: Scalars['Boolean']['output']
  deletePermission: Scalars['Boolean']['output']
  deleteProperty: Property
  /** Delete a property card ad (SUPER_ADMIN only) */
  deletePropertyCardAd: Scalars['Boolean']['output']
  deleteRole: Scalars['Boolean']['output']
  deleteUser: Scalars['Boolean']['output']
  /** Import one or more properties from Resales by external IDs */
  importResalesProperties: Array<ResalesImportResult>
  /** Log a call or email contact attempt for a lead. Creates a note and AgencyHistory entry. */
  logLeadContact: Lead
  login: CustomerLoginResponse
  makeContact: Lead
  markConversationAsRead: Conversation
  mergePreviousSessionHandle: Scalars['Boolean']['output']
  /** Provision tenant Mongo DB, broker registry rows, auth agency + agency_manager user, Mautic, and subscription (SUPER_ADMIN only) */
  onboardBroker: OnboardBrokerResult
  passwordlessSignup: CustomerSignupResult
  /** Property detail valuation scenario from adjusted customer inputs */
  propertyValuationScenario: PropertyValuationResultGql
  publishMultipleProperties: Array<Property>
  publishProperty: Property
  /** Copy an agency property into the shared Bostello listings database */
  publishPropertyToBostello: Property
  /** Record a click for a property card ad */
  recordAdClick: Scalars['Boolean']['output']
  /** Record an impression for a property card ad */
  recordAdImpression: Scalars['Boolean']['output']
  /** Reject a lead with a required comment. Creates a note, updates status to rejected, and logs AgencyHistory. */
  rejectLead: Lead
  removeAgencyRole: Scalars['Boolean']['output']
  removeAgent: Scalars['Boolean']['output']
  removePermissionFromRole: Scalars['Boolean']['output']
  removePropertyFromCustomSearchPriority: SearchOrderConfigOutput
  removePropertyFromFavorites: FavoriteResponse
  removeUserFromAgency: AgencyOperationResponse
  resetUserPassword: PasswordResetResponse
  saveDraft?: Maybe<Property>
  scheduleCancelPaidExtra: PaidExtra
  /** Send Mautic template email to the broker lead contact (Broker.brokerLeadContactMauticId). Super admin only. */
  sendBrokerLeadNotificationEmail: SendBrokerLeadNotificationPayload
  signup: CustomerSignupResult
  /** Commit broker site seed manifest to bost-broker-site-pipeline and dispatch onboard CI (SUPER_ADMIN only) */
  startBrokerSiteOnboarding: StartBrokerSiteOnboardingResult
  trackSearchInterest: Scalars['Boolean']['output']
  /** Transfer multiple properties from one database to another (SUPER_ADMIN only) */
  transferMultipleProperties: Array<Property>
  /** Transfer a property from one database to another (SUPER_ADMIN only) */
  transferProperty: Property
  triggerLeadScoring: Scalars['Boolean']['output']
  triggerOpenAiDescriptionsRerun: OpenAiDescriptionsRerunResult
  triggerPropertyImageEnrichment: PropertyImageEnrichmentStatus
  unpublishProperty: Property
  /** Update an advertiser (SUPER_ADMIN only) */
  updateAdvertiser: Advertiser
  updateAgency: Broker
  updateAgencyPortalApplicationSettings: AgencyPortalApplicationSettings
  updateAgent: Scalars['Boolean']['output']
  updateAvailablePaidExtra: AvailablePaidExtras
  updateCustomerMarketingConsent: CustomerSettingsResponse
  updateCustomerSettings: CustomerSettingsResponse
  updateLead: Lead
  updateLeadAdminStatus: Lead
  updateLeadListPosition: Lead
  updateLeadStatus: Lead
  updateManyAvailablePaidExtras: AffectedRowsOutput
  updateManyLead: AffectedRowsOutput
  updateManySubscription: AffectedRowsOutput
  updateOneAvailablePaidExtras?: Maybe<AvailablePaidExtras>
  updateOneLead?: Maybe<Lead>
  updateOneSubscription?: Maybe<Subscription>
  updatePermission: PermissionModel
  updateProperty: Property
  /** Update a property card ad (SUPER_ADMIN only) */
  updatePropertyCardAd: PropertyCardAd
  updatePropertyImagesAIGallery: Property
  updatePropertyImagesAIRoomLabels: Property
  updatePropertyReportStatus: PropertyReport
  updateRole: RoleModel
  updateSearchOrderConfig: SearchOrderConfigOutput
  updateSubscription: Subscription
  updateUser: AdminUserModel
  upsertAgencyPortalApplicationSettings: AgencyPortalApplicationSettings
  upsertAgencySubscription: Scalars['Boolean']['output']
  upsertBrokerFrontendRealEstateSettings: BrokerFrontendRealEstateSettingsOutput
  upsertBrokerLeadContactMautic: Broker
  upsertManyProperty: AffectedRowsOutput
  upsertOneAvailablePaidExtras: AvailablePaidExtras
  upsertOneLead: Lead
  upsertOneSubscription: Subscription
  upsertProperty: Property
}

export type MutationAddAgentArgs = {
  input: SignupInput
}

export type MutationAddLeadNoteArgs = {
  id: Scalars['String']['input']
  note: Scalars['String']['input']
}

export type MutationAddMessageArgs = {
  content: Scalars['String']['input']
  conversationId: Scalars['String']['input']
  from: Scalars['String']['input']
}

export type MutationAddPropertiesToCustomSearchPriorityArgs = {
  refIds: Array<Scalars['String']['input']>
}

export type MutationAddPropertyToFavoritesArgs = {
  input: AddFavoriteInput
}

export type MutationAdminLoginArgs = {
  input: LoginInput
}

export type MutationAgentLoginArgs = {
  input: LoginInput
}

export type MutationAgentSignupArgs = {
  input: SignupInput
}

export type MutationApprovePropertyImagesAiArgs = {
  createPaidExtra?: InputMaybe<Scalars['Boolean']['input']>
  propertyId: Scalars['String']['input']
}

export type MutationAssignAgencyRoleArgs = {
  agencyId: Scalars['String']['input']
  role: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationAssignLeadArgs = {
  assignedTo: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type MutationAssignLeadToBrokerArgs = {
  brokerId: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type MutationAssignPermissionToRoleArgs = {
  permissionId: Scalars['String']['input']
  roleId: Scalars['String']['input']
}

export type MutationAssignUserToAgencyArgs = {
  input: AssignUserToAgencyInput
}

export type MutationBulkDeleteUsersArgs = {
  userIds: Array<Scalars['String']['input']>
}

export type MutationCancelSubscriptionArgs = {
  id: Scalars['String']['input']
}

export type MutationConfirmPaymentArgs = {
  id: Scalars['String']['input']
  paymentReference?: InputMaybe<Scalars['String']['input']>
}

export type MutationConnectLocationsToBrokerArgs = {
  brokerId: Scalars['String']['input']
  locationNames: Array<Scalars['String']['input']>
}

export type MutationCreateAdvertiserArgs = {
  data: AdvertiserInput
}

export type MutationCreateAgencyArgs = {
  input: CreateAgencyInput
}

export type MutationCreateAgencyPortalApplicationSettingsArgs = {
  data: AgencyPortalApplicationSettingsCreateInput
}

export type MutationCreateAvailablePaidExtraArgs = {
  data: CreateAvailablePaidExtrasInput
}

export type MutationCreateBulkPaidExtrasArgs = {
  input: CreateBulkPaidExtrasInput
}

export type MutationCreateLeadArgs = {
  data?: InputMaybe<LeadCreateInput>
}

export type MutationCreateManyAvailablePaidExtrasArgs = {
  data: Array<AvailablePaidExtrasCreateManyInput>
}

export type MutationCreateManyLeadArgs = {
  data: Array<LeadCreateManyInput>
}

export type MutationCreateManyPropertyArgs = {
  data: Array<PropertyCreateManyInput>
}

export type MutationCreateManySubscriptionArgs = {
  data: Array<SubscriptionCreateManyInput>
}

export type MutationCreateOneAvailablePaidExtrasArgs = {
  data: AvailablePaidExtrasCreateInput
}

export type MutationCreateOneLeadArgs = {
  data?: InputMaybe<LeadCreateInput>
}

export type MutationCreateOneSubscriptionArgs = {
  data: SubscriptionCreateInput
}

export type MutationCreatePaidExtraArgs = {
  input: CreatePaidExtraInput
}

export type MutationCreatePermissionArgs = {
  input: CreatePermissionInput
}

export type MutationCreatePropertyArgs = {
  data: PropertyCreateInput
}

export type MutationCreatePropertyCardAdArgs = {
  data: PropertyCardAdInput
}

export type MutationCreatePropertyReportArgs = {
  input: CreatePropertyReportInput
}

export type MutationCreateRoleArgs = {
  input: CreateRoleInput
}

export type MutationCreateSubscriptionArgs = {
  data: CreateSubscriptionInput
}

export type MutationCreateUserArgs = {
  input: CreateUserInput
}

export type MutationDeleteAdvertiserArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteAgencyArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteAgencyPortalApplicationSettingsArgs = {
  where: AgencyPortalApplicationSettingsWhereUniqueInput
}

export type MutationDeleteAvailablePaidExtraArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteLeadArgs = {
  where: LeadWhereUniqueInput
}

export type MutationDeleteManyAvailablePaidExtrasArgs = {
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type MutationDeleteManyLeadArgs = {
  where?: InputMaybe<LeadWhereInput>
}

export type MutationDeleteManySubscriptionArgs = {
  where?: InputMaybe<SubscriptionWhereInput>
}

export type MutationDeleteMultiplePropertiesArgs = {
  propertyIds: Array<Scalars['String']['input']>
}

export type MutationDeleteOneAvailablePaidExtrasArgs = {
  where: AvailablePaidExtrasWhereUniqueInput
}

export type MutationDeleteOneLeadArgs = {
  where: LeadWhereUniqueInput
}

export type MutationDeleteOneSubscriptionArgs = {
  where: SubscriptionWhereUniqueInput
}

export type MutationDeletePaidExtraArgs = {
  id: Scalars['String']['input']
}

export type MutationDeletePermissionArgs = {
  permissionId: Scalars['String']['input']
}

export type MutationDeletePropertyArgs = {
  id: Scalars['String']['input']
}

export type MutationDeletePropertyCardAdArgs = {
  id: Scalars['String']['input']
}

export type MutationDeleteRoleArgs = {
  roleId: Scalars['String']['input']
}

export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input']
}

export type MutationImportResalesPropertiesArgs = {
  externalIds: Array<Scalars['String']['input']>
}

export type MutationLogLeadContactArgs = {
  contactType: Scalars['String']['input']
  leadId: Scalars['String']['input']
}

export type MutationLoginArgs = {
  input: LoginInput
}

export type MutationMakeContactArgs = {
  data?: InputMaybe<LeadCreateInput>
  meta?: InputMaybe<MakeContactMetaInput>
}

export type MutationMarkConversationAsReadArgs = {
  conversationId: Scalars['String']['input']
}

export type MutationMergePreviousSessionHandleArgs = {
  previousSessionHandle: Scalars['String']['input']
}

export type MutationOnboardBrokerArgs = {
  input: OnboardBrokerInput
}

export type MutationPasswordlessSignupArgs = {
  input: PasswordlessSignupInput
}

export type MutationPropertyValuationScenarioArgs = {
  email: Scalars['String']['input']
  externalId?: InputMaybe<Scalars['String']['input']>
  featureParamNamesSelected?: InputMaybe<Array<Scalars['String']['input']>>
  inputs: Scalars['JSON']['input']
  kind?: InputMaybe<Scalars['String']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
}

export type MutationPublishMultiplePropertiesArgs = {
  propertyIds: Array<Scalars['String']['input']>
}

export type MutationPublishPropertyArgs = {
  id: Scalars['String']['input']
}

export type MutationPublishPropertyToBostelloArgs = {
  propertyId: Scalars['String']['input']
}

export type MutationRecordAdClickArgs = {
  adId: Scalars['String']['input']
}

export type MutationRecordAdImpressionArgs = {
  adId: Scalars['String']['input']
}

export type MutationRejectLeadArgs = {
  comment: Scalars['String']['input']
  leadId: Scalars['String']['input']
}

export type MutationRemoveAgencyRoleArgs = {
  role: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationRemoveAgentArgs = {
  agentId: Scalars['String']['input']
}

export type MutationRemovePermissionFromRoleArgs = {
  permissionId: Scalars['String']['input']
  roleId: Scalars['String']['input']
}

export type MutationRemovePropertyFromCustomSearchPriorityArgs = {
  refId: Scalars['String']['input']
}

export type MutationRemovePropertyFromFavoritesArgs = {
  input: RemoveFavoriteInput
}

export type MutationRemoveUserFromAgencyArgs = {
  agencyId: Scalars['String']['input']
  userId: Scalars['String']['input']
}

export type MutationResetUserPasswordArgs = {
  userId: Scalars['String']['input']
}

export type MutationSaveDraftArgs = {
  data: Scalars['JSON']['input']
  id: Scalars['String']['input']
}

export type MutationScheduleCancelPaidExtraArgs = {
  id: Scalars['String']['input']
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type MutationSendBrokerLeadNotificationEmailArgs = {
  leadId: Scalars['String']['input']
}

export type MutationSignupArgs = {
  input: SignupInput
}

export type MutationStartBrokerSiteOnboardingArgs = {
  input: StartBrokerSiteOnboardingInput
}

export type MutationTrackSearchInterestArgs = {
  filters?: InputMaybe<Scalars['JSON']['input']>
  query: Scalars['String']['input']
}

export type MutationTransferMultiplePropertiesArgs = {
  propertyIds: Array<Scalars['String']['input']>
  sourceAgencyId?: InputMaybe<Scalars['String']['input']>
  targetAgencyId: Scalars['String']['input']
}

export type MutationTransferPropertyArgs = {
  propertyId: Scalars['String']['input']
  sourceAgencyId?: InputMaybe<Scalars['String']['input']>
  targetAgencyId: Scalars['String']['input']
}

export type MutationTriggerLeadScoringArgs = {
  id: Scalars['String']['input']
}

export type MutationTriggerOpenAiDescriptionsRerunArgs = {
  propertyId: Scalars['String']['input']
}

export type MutationTriggerPropertyImageEnrichmentArgs = {
  propertyId: Scalars['String']['input']
}

export type MutationUnpublishPropertyArgs = {
  id: Scalars['String']['input']
}

export type MutationUpdateAdvertiserArgs = {
  data: AdvertiserUpdateInput
  id: Scalars['String']['input']
}

export type MutationUpdateAgencyArgs = {
  id: Scalars['String']['input']
  input: UpdateAgencyInput
}

export type MutationUpdateAgencyPortalApplicationSettingsArgs = {
  data: AgencyPortalApplicationSettingsUpdateInput
  where: AgencyPortalApplicationSettingsWhereUniqueInput
}

export type MutationUpdateAgentArgs = {
  agentId?: InputMaybe<Scalars['String']['input']>
  input: SignupInput
}

export type MutationUpdateAvailablePaidExtraArgs = {
  data: UpdateAvailablePaidExtrasInput
  id: Scalars['String']['input']
}

export type MutationUpdateCustomerMarketingConsentArgs = {
  input: UpdateCustomerSettingsInput
}

export type MutationUpdateCustomerSettingsArgs = {
  input: UpdateCustomerSettingsInput
}

export type MutationUpdateLeadArgs = {
  data: LeadUpdateInput
  where: LeadWhereUniqueInput
}

export type MutationUpdateLeadAdminStatusArgs = {
  adminStatus: Scalars['String']['input']
  id: Scalars['String']['input']
}

export type MutationUpdateLeadListPositionArgs = {
  id: Scalars['String']['input']
  listPosition: Scalars['Float']['input']
}

export type MutationUpdateLeadStatusArgs = {
  id: Scalars['String']['input']
  status: Scalars['String']['input']
}

export type MutationUpdateManyAvailablePaidExtrasArgs = {
  data: AvailablePaidExtrasUpdateManyMutationInput
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type MutationUpdateManyLeadArgs = {
  data: LeadUpdateManyMutationInput
  where?: InputMaybe<LeadWhereInput>
}

export type MutationUpdateManySubscriptionArgs = {
  data: SubscriptionUpdateManyMutationInput
  where?: InputMaybe<SubscriptionWhereInput>
}

export type MutationUpdateOneAvailablePaidExtrasArgs = {
  data: AvailablePaidExtrasUpdateInput
  where: AvailablePaidExtrasWhereUniqueInput
}

export type MutationUpdateOneLeadArgs = {
  data: LeadUpdateInput
  where: LeadWhereUniqueInput
}

export type MutationUpdateOneSubscriptionArgs = {
  data: SubscriptionUpdateInput
  where: SubscriptionWhereUniqueInput
}

export type MutationUpdatePermissionArgs = {
  input: UpdatePermissionInput
  permissionId: Scalars['String']['input']
}

export type MutationUpdatePropertyArgs = {
  data: PropertyUpdateInput
  where: PropertyWhereUniqueInput
}

export type MutationUpdatePropertyCardAdArgs = {
  data: PropertyCardAdUpdateInput
  id: Scalars['String']['input']
}

export type MutationUpdatePropertyImagesAiGalleryArgs = {
  images: Array<PropertyImagesAiGalleryItemInput>
  propertyId: Scalars['String']['input']
}

export type MutationUpdatePropertyImagesAiRoomLabelsArgs = {
  propertyId: Scalars['String']['input']
  updates: Array<PropertyImageRoomLabelUpdateInput>
}

export type MutationUpdatePropertyReportStatusArgs = {
  reportId: Scalars['String']['input']
  status: Scalars['String']['input']
}

export type MutationUpdateRoleArgs = {
  input: UpdateRoleInput
  roleId: Scalars['String']['input']
}

export type MutationUpdateSearchOrderConfigArgs = {
  input: SearchOrderConfigInput
}

export type MutationUpdateSubscriptionArgs = {
  data: UpdateSubscriptionInput
  id: Scalars['String']['input']
}

export type MutationUpdateUserArgs = {
  input: UpdateUserInput
  userId: Scalars['String']['input']
}

export type MutationUpsertAgencyPortalApplicationSettingsArgs = {
  create: AgencyPortalApplicationSettingsCreateInput
  update: AgencyPortalApplicationSettingsUpdateInput
  where: AgencyPortalApplicationSettingsWhereUniqueInput
}

export type MutationUpsertAgencySubscriptionArgs = {
  input: UpsertSubscriptionInput
}

export type MutationUpsertBrokerFrontendRealEstateSettingsArgs = {
  input: UpsertBrokerFrontendRealEstateSettingsInput
}

export type MutationUpsertBrokerLeadContactMauticArgs = {
  input: UpsertBrokerLeadContactMauticInput
}

export type MutationUpsertManyPropertyArgs = {
  data: Array<PropertyCreateManyInputExtended>
}

export type MutationUpsertOneAvailablePaidExtrasArgs = {
  create: AvailablePaidExtrasCreateInput
  update: AvailablePaidExtrasUpdateInput
  where: AvailablePaidExtrasWhereUniqueInput
}

export type MutationUpsertOneLeadArgs = {
  create: LeadCreateInput
  update: LeadUpdateInput
  where: LeadWhereUniqueInput
}

export type MutationUpsertOneSubscriptionArgs = {
  create: SubscriptionCreateInput
  update: SubscriptionUpdateInput
  where: SubscriptionWhereUniqueInput
}

export type MutationUpsertPropertyArgs = {
  create: PropertyCreateInput
  update: PropertyUpdateInput
  where: PropertyWhereUniqueInput
}

export type NearbyFeaturesResponse = {
  __typename?: 'NearbyFeaturesResponse'
  features: Array<SearchLocationFeature>
}

export type NearbyPropertiesResponse = {
  __typename?: 'NearbyPropertiesResponse'
  approximatedProperties: Array<NearbyProperty>
  approximatedTotalCount?: Maybe<Scalars['Int']['output']>
  didChangeArea: Scalars['Boolean']['output']
  municipality?: Maybe<Scalars['String']['output']>
  neighbourhood?: Maybe<Scalars['String']['output']>
  properties: Array<NearbyProperty>
  totalCount?: Maybe<Scalars['Int']['output']>
}

export type NearbyProperty = {
  __typename?: 'NearbyProperty'
  distance: Scalars['Float']['output']
  property: Property
}

export type NeighbourhoodLocationPropertyCount = {
  __typename?: 'NeighbourhoodLocationPropertyCount'
  count: Scalars['Int']['output']
  districtTileName?: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  locationNeighbourhood: Scalars['String']['output']
  locationTown?: Maybe<Scalars['String']['output']>
}

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolFilter>
}

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']['input']>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolNullableFilter>
}

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedBoolNullableFilter>
  _min?: InputMaybe<NestedBoolNullableFilter>
  equals?: InputMaybe<Scalars['Boolean']['input']>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>
}

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedBoolFilter>
  _min?: InputMaybe<NestedBoolFilter>
  equals?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedBoolWithAggregatesFilter>
}

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeNullableFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedDateTimeNullableFilter>
  _min?: InputMaybe<NestedDateTimeNullableFilter>
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedDateTimeFilter>
  _min?: InputMaybe<NestedDateTimeFilter>
  equals?: InputMaybe<Scalars['DateTimeISO']['input']>
  gt?: InputMaybe<Scalars['DateTimeISO']['input']>
  gte?: InputMaybe<Scalars['DateTimeISO']['input']>
  in?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  lt?: InputMaybe<Scalars['DateTimeISO']['input']>
  lte?: InputMaybe<Scalars['DateTimeISO']['input']>
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type NestedEnumAiVisualsTierFilter = {
  equals?: InputMaybe<AiVisualsTier>
  in?: InputMaybe<Array<AiVisualsTier>>
  not?: InputMaybe<NestedEnumAiVisualsTierFilter>
  notIn?: InputMaybe<Array<AiVisualsTier>>
}

export type NestedEnumAiVisualsTierWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedEnumAiVisualsTierFilter>
  _min?: InputMaybe<NestedEnumAiVisualsTierFilter>
  equals?: InputMaybe<AiVisualsTier>
  in?: InputMaybe<Array<AiVisualsTier>>
  not?: InputMaybe<NestedEnumAiVisualsTierWithAggregatesFilter>
  notIn?: InputMaybe<Array<AiVisualsTier>>
}

export type NestedEnumBathroomQualityNullableFilter = {
  equals?: InputMaybe<BathroomQuality>
  in?: InputMaybe<Array<BathroomQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumBathroomQualityNullableFilter>
  notIn?: InputMaybe<Array<BathroomQuality>>
}

export type NestedEnumDraftStatusNullableFilter = {
  equals?: InputMaybe<DraftStatus>
  in?: InputMaybe<Array<DraftStatus>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumDraftStatusNullableFilter>
  notIn?: InputMaybe<Array<DraftStatus>>
}

export type NestedEnumKitchenQualityNullableFilter = {
  equals?: InputMaybe<KitchenQuality>
  in?: InputMaybe<Array<KitchenQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumKitchenQualityNullableFilter>
  notIn?: InputMaybe<Array<KitchenQuality>>
}

export type NestedEnumMaintenanceHistoryNullableFilter = {
  equals?: InputMaybe<MaintenanceHistory>
  in?: InputMaybe<Array<MaintenanceHistory>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumMaintenanceHistoryNullableFilter>
  notIn?: InputMaybe<Array<MaintenanceHistory>>
}

export type NestedEnumPaidExtraStatusNullableFilter = {
  equals?: InputMaybe<PaidExtraStatus>
  in?: InputMaybe<Array<PaidExtraStatus>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumPaidExtraStatusNullableFilter>
  notIn?: InputMaybe<Array<PaidExtraStatus>>
}

export type NestedEnumPropertyConditionNullableFilter = {
  equals?: InputMaybe<PropertyCondition>
  in?: InputMaybe<Array<PropertyCondition>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumPropertyConditionNullableFilter>
  notIn?: InputMaybe<Array<PropertyCondition>>
}

export type NestedEnumRenovationQualityNullableFilter = {
  equals?: InputMaybe<RenovationQuality>
  in?: InputMaybe<Array<RenovationQuality>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  not?: InputMaybe<NestedEnumRenovationQualityNullableFilter>
  notIn?: InputMaybe<Array<RenovationQuality>>
}

export type NestedEnumReportReasonFilter = {
  equals?: InputMaybe<ReportReason>
  in?: InputMaybe<Array<ReportReason>>
  not?: InputMaybe<NestedEnumReportReasonFilter>
  notIn?: InputMaybe<Array<ReportReason>>
}

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatNullableFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedFloatFilter>
  _min?: InputMaybe<NestedFloatFilter>
  _sum?: InputMaybe<NestedFloatFilter>
  equals?: InputMaybe<Scalars['Float']['input']>
  gt?: InputMaybe<Scalars['Float']['input']>
  gte?: InputMaybe<Scalars['Float']['input']>
  in?: InputMaybe<Array<Scalars['Float']['input']>>
  lt?: InputMaybe<Scalars['Float']['input']>
  lte?: InputMaybe<Scalars['Float']['input']>
  not?: InputMaybe<NestedFloatWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Float']['input']>>
}

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntNullableFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedIntNullableFilter>
  _min?: InputMaybe<NestedIntNullableFilter>
  _sum?: InputMaybe<NestedIntNullableFilter>
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedIntFilter>
  _min?: InputMaybe<NestedIntFilter>
  _sum?: InputMaybe<NestedIntFilter>
  equals?: InputMaybe<Scalars['Int']['input']>
  gt?: InputMaybe<Scalars['Int']['input']>
  gte?: InputMaybe<Scalars['Int']['input']>
  in?: InputMaybe<Array<Scalars['Int']['input']>>
  lt?: InputMaybe<Scalars['Int']['input']>
  lte?: InputMaybe<Scalars['Int']['input']>
  not?: InputMaybe<NestedIntWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['Int']['input']>>
}

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<NestedStringFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<NestedStringNullableFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedStringNullableFilter>
  _min?: InputMaybe<NestedStringNullableFilter>
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedStringFilter>
  _min?: InputMaybe<NestedStringFilter>
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  not?: InputMaybe<NestedStringWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']['input']>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTimeISO']['input']>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumBathroomQualityFieldUpdateOperationsInput = {
  set?: InputMaybe<BathroomQuality>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumDraftStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<DraftStatus>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumKitchenQualityFieldUpdateOperationsInput = {
  set?: InputMaybe<KitchenQuality>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumMaintenanceHistoryFieldUpdateOperationsInput = {
  set?: InputMaybe<MaintenanceHistory>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumPaidExtraStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaidExtraStatus>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumPropertyConditionFieldUpdateOperationsInput = {
  set?: InputMaybe<PropertyCondition>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableEnumRenovationQualityFieldUpdateOperationsInput = {
  set?: InputMaybe<RenovationQuality>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']['input']>
  divide?: InputMaybe<Scalars['Float']['input']>
  increment?: InputMaybe<Scalars['Float']['input']>
  multiply?: InputMaybe<Scalars['Float']['input']>
  set?: InputMaybe<Scalars['Float']['input']>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']['input']>
  divide?: InputMaybe<Scalars['Int']['input']>
  increment?: InputMaybe<Scalars['Int']['input']>
  multiply?: InputMaybe<Scalars['Int']['input']>
  set?: InputMaybe<Scalars['Int']['input']>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>
  unset?: InputMaybe<Scalars['Boolean']['input']>
}

export type OnboardBrokerInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  /** BCP-47 locales for broker site manifest (default en, es) */
  brokerSiteLocales?: InputMaybe<Array<Scalars['String']['input']>>
  /** Optional tagline for broker site manifest */
  brokerSiteTagline?: InputMaybe<Scalars['String']['input']>
  contactInfo?: InputMaybe<AgencyContactInfoUpdateInput>
  description?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<DescriptionInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  /** Broker identifier; tenant database will be bostello_{name} */
  name: Scalars['String']['input']
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  /** Resales filter id (requires resalesP1Key and resalesP2Key) */
  resalesFilterId?: InputMaybe<Scalars['String']['input']>
  /** Resales API p1 partner key */
  resalesP1Key?: InputMaybe<Scalars['String']['input']>
  /** Resales API p2 partner key */
  resalesP2Key?: InputMaybe<Scalars['String']['input']>
  services?: InputMaybe<Array<Scalars['String']['input']>>
  /** After onboarding, commit site manifest and start bost-broker-site-pipeline */
  setupBrokerWebsite?: InputMaybe<Scalars['Boolean']['input']>
  skipSmokeTest?: InputMaybe<Scalars['Boolean']['input']>
  slugUrl?: InputMaybe<Scalars['String']['input']>
  /** Subscription plan and property slot limits; defaults from ONBOARD_DEFAULT_* env when omitted */
  subscription?: InputMaybe<OnboardBrokerSubscriptionInput>
  /** Existing broker website URL for pipeline seeding (required when setupBrokerWebsite is true) */
  websiteUrl?: InputMaybe<Scalars['String']['input']>
}

export type OnboardBrokerResult = {
  __typename?: 'OnboardBrokerResult'
  /** Same as brokerId; set from inserted broker _id */
  agencyId: Scalars['String']['output']
  authUserId: Scalars['String']['output']
  /** Mongo ObjectId of the inserted broker (same as agencyId) */
  brokerId: Scalars['String']['output']
  /** Set when setupBrokerWebsite was requested and pipeline started */
  brokerSite?: Maybe<StartBrokerSiteOnboardingResult>
  /** Tenant Mongo database name (bostello_{name}) */
  databaseName: Scalars['String']['output']
  /** Generated password for the agency manager user (shown once) */
  generatedPassword: Scalars['String']['output']
  smokeTest: OnboardBrokerSmokeTestResult
  stepsCompleted: Array<Scalars['String']['output']>
  subscriptionId: Scalars['String']['output']
}

export type OnboardBrokerSmokeTestResult = {
  __typename?: 'OnboardBrokerSmokeTestResult'
  error?: Maybe<Scalars['String']['output']>
  passed: Scalars['Boolean']['output']
  propertyCount: Scalars['Int']['output']
}

export type OnboardBrokerSubscriptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  /** Package id: core, bronze, silver, gold, custom, free, start, bas, pro */
  plan: Scalars['String']['input']
  /** Subscription price (EUR unless currency set). Defaults from plan. */
  price?: InputMaybe<Scalars['Float']['input']>
  /** Property slot limit on main Bostello catalog (bostello DB). Defaults from plan. */
  slotCount?: InputMaybe<Scalars['Int']['input']>
  /** Property slot limit on agency tenant DB (broker collection). Defaults from plan. */
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
}

export type OpenAiDescriptionsRerunResult = {
  __typename?: 'OpenAiDescriptionsRerunResult'
  cacheCleared: Scalars['Boolean']['output']
  cronStatusCleared: Scalars['Boolean']['output']
  descriptionsStoreCleared: Scalars['Boolean']['output']
  externalId: Scalars['String']['output']
  jobId?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  queuedImmediately: Scalars['Boolean']['output']
  resetAiMeta: Scalars['Boolean']['output']
}

export type PaginatedUsersResponse = {
  __typename?: 'PaginatedUsersResponse'
  currentPage: Scalars['Float']['output']
  hasNextPage: Scalars['Boolean']['output']
  hasPreviousPage: Scalars['Boolean']['output']
  totalPages: Scalars['Float']['output']
  totalUsers: Scalars['Float']['output']
  users: Array<AdminUserModel>
}

export type PaginationOptions = {
  limit: Scalars['Float']['input']
  page: Scalars['Float']['input']
}

/** Paid extras/promotions purchased by agencies and optionally tied to a specific property */
export type PaidExtra = {
  __typename?: 'PaidExtra'
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  price?: Maybe<Scalars['Float']['output']>
  propertyId?: Maybe<Scalars['String']['output']>
  searchPrio: Scalars['Int']['output']
  status?: Maybe<PaidExtraStatus>
  type: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  validFrom?: Maybe<Scalars['DateTimeISO']['output']>
  validTo?: Maybe<Scalars['DateTimeISO']['output']>
}

export type PaidExtraCreateManyBrokerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  propertyId?: InputMaybe<Scalars['String']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<PaidExtraStatus>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PaidExtraCreateManyBrokerInputEnvelope = {
  data: Array<PaidExtraCreateManyBrokerInput>
}

export type PaidExtraCreateManyPropertyInput = {
  brokerId: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<PaidExtraStatus>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PaidExtraCreateManyPropertyInputEnvelope = {
  data: Array<PaidExtraCreateManyPropertyInput>
}

export type PaidExtraCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PaidExtraCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PaidExtraCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PaidExtraCreateManyBrokerInputEnvelope>
}

export type PaidExtraCreateNestedManyWithoutPropertyInput = {
  connect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PaidExtraCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<PaidExtraCreateWithoutPropertyInput>>
  createMany?: InputMaybe<PaidExtraCreateManyPropertyInputEnvelope>
}

export type PaidExtraCreateOrConnectWithoutBrokerInput = {
  create: PaidExtraCreateWithoutBrokerInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraCreateOrConnectWithoutPropertyInput = {
  create: PaidExtraCreateWithoutPropertyInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraCreateWithoutBrokerInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  property?: InputMaybe<PropertyCreateNestedOneWithoutPaidExtrasInput>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<PaidExtraStatus>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PaidExtraCreateWithoutPropertyInput = {
  broker: BrokerCreateNestedOneWithoutPaidExtrasInput
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<Scalars['Float']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<PaidExtraStatus>
  type: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PaidExtraListRelationFilter = {
  every?: InputMaybe<PaidExtraWhereInput>
  none?: InputMaybe<PaidExtraWhereInput>
  some?: InputMaybe<PaidExtraWhereInput>
}

export type PaidExtraOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PaidExtraOrderByWithRelationInput = {
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  type?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  validFrom?: InputMaybe<SortOrder>
  validTo?: InputMaybe<SortOrder>
}

export enum PaidExtraScalarFieldEnum {
  BrokerId = 'brokerId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Description = 'description',
  Id = 'id',
  Price = 'price',
  PropertyId = 'propertyId',
  SearchPrio = 'searchPrio',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  ValidFrom = 'validFrom',
  ValidTo = 'validTo',
}

export type PaidExtraScalarWhereInput = {
  AND?: InputMaybe<Array<PaidExtraScalarWhereInput>>
  NOT?: InputMaybe<Array<PaidExtraScalarWhereInput>>
  OR?: InputMaybe<Array<PaidExtraScalarWhereInput>>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  price?: InputMaybe<FloatNullableFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  searchPrio?: InputMaybe<IntFilter>
  status?: InputMaybe<EnumPaidExtraStatusNullableFilter>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export enum PaidExtraStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING',
  PendingCancel = 'PENDING_CANCEL',
}

export type PaidExtraUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  status?: InputMaybe<NullableEnumPaidExtraStatusFieldUpdateOperationsInput>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PaidExtraUpdateManyWithWhereWithoutBrokerInput = {
  data: PaidExtraUpdateManyMutationInput
  where: PaidExtraScalarWhereInput
}

export type PaidExtraUpdateManyWithWhereWithoutPropertyInput = {
  data: PaidExtraUpdateManyMutationInput
  where: PaidExtraScalarWhereInput
}

export type PaidExtraUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PaidExtraCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PaidExtraCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PaidExtraCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PaidExtraScalarWhereInput>>
  disconnect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  set?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  update?: InputMaybe<Array<PaidExtraUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<PaidExtraUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<PaidExtraUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type PaidExtraUpdateManyWithoutPropertyNestedInput = {
  connect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PaidExtraCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<PaidExtraCreateWithoutPropertyInput>>
  createMany?: InputMaybe<PaidExtraCreateManyPropertyInputEnvelope>
  delete?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PaidExtraScalarWhereInput>>
  disconnect?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  set?: InputMaybe<Array<PaidExtraWhereUniqueInput>>
  update?: InputMaybe<Array<PaidExtraUpdateWithWhereUniqueWithoutPropertyInput>>
  updateMany?: InputMaybe<Array<PaidExtraUpdateManyWithWhereWithoutPropertyInput>>
  upsert?: InputMaybe<Array<PaidExtraUpsertWithWhereUniqueWithoutPropertyInput>>
}

export type PaidExtraUpdateWithWhereUniqueWithoutBrokerInput = {
  data: PaidExtraUpdateWithoutBrokerInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraUpdateWithWhereUniqueWithoutPropertyInput = {
  data: PaidExtraUpdateWithoutPropertyInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraUpdateWithoutBrokerInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  property?: InputMaybe<PropertyUpdateOneWithoutPaidExtrasNestedInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  status?: InputMaybe<NullableEnumPaidExtraStatusFieldUpdateOperationsInput>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PaidExtraUpdateWithoutPropertyInput = {
  broker?: InputMaybe<BrokerUpdateOneRequiredWithoutPaidExtrasNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  price?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  status?: InputMaybe<NullableEnumPaidExtraStatusFieldUpdateOperationsInput>
  type?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PaidExtraUpsertWithWhereUniqueWithoutBrokerInput = {
  create: PaidExtraCreateWithoutBrokerInput
  update: PaidExtraUpdateWithoutBrokerInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraUpsertWithWhereUniqueWithoutPropertyInput = {
  create: PaidExtraCreateWithoutPropertyInput
  update: PaidExtraUpdateWithoutPropertyInput
  where: PaidExtraWhereUniqueInput
}

export type PaidExtraWhereInput = {
  AND?: InputMaybe<Array<PaidExtraWhereInput>>
  NOT?: InputMaybe<Array<PaidExtraWhereInput>>
  OR?: InputMaybe<Array<PaidExtraWhereInput>>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  price?: InputMaybe<FloatNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  searchPrio?: InputMaybe<IntFilter>
  status?: InputMaybe<EnumPaidExtraStatusNullableFilter>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export type PaidExtraWhereUniqueInput = {
  AND?: InputMaybe<Array<PaidExtraWhereInput>>
  NOT?: InputMaybe<Array<PaidExtraWhereInput>>
  OR?: InputMaybe<Array<PaidExtraWhereInput>>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  description?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  price?: InputMaybe<FloatNullableFilter>
  property?: InputMaybe<PropertyNullableRelationFilter>
  propertyId?: InputMaybe<StringNullableFilter>
  searchPrio?: InputMaybe<IntFilter>
  status?: InputMaybe<EnumPaidExtraStatusNullableFilter>
  type?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export type PasswordResetResponse = {
  __typename?: 'PasswordResetResponse'
  email?: Maybe<Scalars['String']['output']>
  message: Scalars['String']['output']
  method?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type PasswordlessSignupInput = {
  email: Scalars['String']['input']
}

export type PermissionModel = {
  __typename?: 'PermissionModel'
  category?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPredefined: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type PersonalData = {
  __typename?: 'PersonalData'
  address?: Maybe<Scalars['String']['output']>
  city?: Maybe<Scalars['String']['output']>
  country?: Maybe<Scalars['String']['output']>
  email?: Maybe<Scalars['String']['output']>
  firstname?: Maybe<Scalars['String']['output']>
  lastname?: Maybe<Scalars['String']['output']>
  phone?: Maybe<Scalars['String']['output']>
  zip?: Maybe<Scalars['String']['output']>
}

export type PersonalDataCreateInput = {
  address?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type PersonalDataNullableCompositeFilter = {
  equals?: InputMaybe<PersonalDataObjectEqualityInput>
  is?: InputMaybe<PersonalDataWhereInput>
  isNot?: InputMaybe<PersonalDataWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type PersonalDataNullableCreateEnvelopeInput = {
  set?: InputMaybe<PersonalDataCreateInput>
}

export type PersonalDataNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PersonalDataCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<PersonalDataUpsertInput>
}

export type PersonalDataObjectEqualityInput = {
  address?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
  zip?: InputMaybe<Scalars['String']['input']>
}

export type PersonalDataOrderByInput = {
  address?: InputMaybe<SortOrder>
  city?: InputMaybe<SortOrder>
  country?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  firstname?: InputMaybe<SortOrder>
  lastname?: InputMaybe<SortOrder>
  phone?: InputMaybe<SortOrder>
  zip?: InputMaybe<SortOrder>
}

export type PersonalDataUpdateInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  city?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  firstname?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  lastname?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  phone?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  zip?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type PersonalDataUpsertInput = {
  set: PersonalDataCreateInput
  update: PersonalDataUpdateInput
}

export type PersonalDataWhereInput = {
  AND?: InputMaybe<Array<PersonalDataWhereInput>>
  NOT?: InputMaybe<Array<PersonalDataWhereInput>>
  OR?: InputMaybe<Array<PersonalDataWhereInput>>
  address?: InputMaybe<StringNullableFilter>
  city?: InputMaybe<StringNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  email?: InputMaybe<StringNullableFilter>
  firstname?: InputMaybe<StringNullableFilter>
  lastname?: InputMaybe<StringNullableFilter>
  phone?: InputMaybe<StringNullableFilter>
  zip?: InputMaybe<StringNullableFilter>
}

export type Place = {
  __typename?: 'Place'
  mapbox_id?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  wikidata_id?: Maybe<Scalars['String']['output']>
}

export type PlaceCreateInput = {
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type PlaceNullableCompositeFilter = {
  equals?: InputMaybe<PlaceObjectEqualityInput>
  is?: InputMaybe<PlaceWhereInput>
  isNot?: InputMaybe<PlaceWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type PlaceNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PlaceCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<PlaceUpsertInput>
}

export type PlaceObjectEqualityInput = {
  mapbox_id?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type PlaceOrderByInput = {
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  wikidata_id?: InputMaybe<SortOrder>
}

export type PlaceUpdateInput = {
  mapbox_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  wikidata_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type PlaceUpsertInput = {
  set: PlaceCreateInput
  update: PlaceUpdateInput
}

export type PlaceWhereInput = {
  AND?: InputMaybe<Array<PlaceWhereInput>>
  NOT?: InputMaybe<Array<PlaceWhereInput>>
  OR?: InputMaybe<Array<PlaceWhereInput>>
  mapbox_id?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  wikidata_id?: InputMaybe<StringNullableFilter>
}

export type Position = {
  __typename?: 'Position'
  lat?: Maybe<Scalars['Float']['output']>
  lng?: Maybe<Scalars['Float']['output']>
}

export type PositionCreateInput = {
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
}

export type PositionInput = {
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
  name?: InputMaybe<Scalars['String']['input']>
}

export type PositionNullableCompositeFilter = {
  equals?: InputMaybe<PositionObjectEqualityInput>
  is?: InputMaybe<PositionWhereInput>
  isNot?: InputMaybe<PositionWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type PositionNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PositionCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<PositionUpsertInput>
}

export type PositionObjectEqualityInput = {
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
}

export type PositionOrderByInput = {
  lat?: InputMaybe<SortOrder>
  lng?: InputMaybe<SortOrder>
}

export type PositionUpdateInput = {
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
}

export type PositionUpsertInput = {
  set: PositionCreateInput
  update: PositionUpdateInput
}

export type PositionWhereInput = {
  AND?: InputMaybe<Array<PositionWhereInput>>
  NOT?: InputMaybe<Array<PositionWhereInput>>
  OR?: InputMaybe<Array<PositionWhereInput>>
  lat?: InputMaybe<FloatNullableFilter>
  lng?: InputMaybe<FloatNullableFilter>
}

export type Postcode = {
  __typename?: 'Postcode'
  mapbox_id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type PostcodeCreateInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type PostcodeNullableCompositeFilter = {
  equals?: InputMaybe<PostcodeObjectEqualityInput>
  is?: InputMaybe<PostcodeWhereInput>
  isNot?: InputMaybe<PostcodeWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type PostcodeNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PostcodeCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<PostcodeUpsertInput>
}

export type PostcodeObjectEqualityInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type PostcodeOrderByInput = {
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export type PostcodeUpdateInput = {
  mapbox_id?: InputMaybe<StringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type PostcodeUpsertInput = {
  set: PostcodeCreateInput
  update: PostcodeUpdateInput
}

export type PostcodeWhereInput = {
  AND?: InputMaybe<Array<PostcodeWhereInput>>
  NOT?: InputMaybe<Array<PostcodeWhereInput>>
  OR?: InputMaybe<Array<PostcodeWhereInput>>
  mapbox_id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
}

export type PriceHistory = {
  __typename?: 'PriceHistory'
  date?: Maybe<Scalars['DateTimeISO']['output']>
  price?: Maybe<Scalars['Int']['output']>
  priceFrom?: Maybe<Scalars['Int']['output']>
  priceTo?: Maybe<Scalars['Int']['output']>
  value?: Maybe<Scalars['Int']['output']>
}

export type PriceHistoryCreateInput = {
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceFrom?: InputMaybe<Scalars['Int']['input']>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type PriceHistoryObjectEqualityInput = {
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceFrom?: InputMaybe<Scalars['Int']['input']>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  value?: InputMaybe<Scalars['Int']['input']>
}

export type PriceHistoryOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type Product = {
  __typename?: 'Product'
  name: Scalars['String']['output']
  type: Scalars['String']['output']
}

export type ProductCreateInput = {
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type ProductObjectEqualityInput = {
  name: Scalars['String']['input']
  type: Scalars['String']['input']
}

export type ProductOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type Property = {
  __typename?: 'Property'
  _count?: Maybe<PropertyCount>
  agencyHistory: Array<AgencyHistory>
  agencyRef?: Maybe<Scalars['String']['output']>
  /** Computed textual description of the property location */
  areaDescription?: Maybe<AreaDescription>
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  broker?: Maybe<Broker>
  brokerId?: Maybe<Scalars['String']['output']>
  brokerIds: Array<Scalars['String']['output']>
  brokerPropertyPriority?: Maybe<Scalars['Int']['output']>
  brokers: Array<Broker>
  builtYear?: Maybe<Scalars['String']['output']>
  cardTitle: Scalars['String']['output']
  category?: Maybe<Scalars['String']['output']>
  completionDate?: Maybe<Scalars['DateTimeISO']['output']>
  constructionYear?: Maybe<Scalars['DateTimeISO']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  cronMapbox?: Maybe<Scalars['String']['output']>
  cronOpenai?: Maybe<Scalars['String']['output']>
  currency?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['DateTimeISO']['output']>
  decree218?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Description>
  descriptions: Array<Description>
  displayTitle: Scalars['String']['output']
  districtTileEnrichedAt?: Maybe<Scalars['DateTimeISO']['output']>
  /** Normalized slug from district vector tile (`normalizedName`) at property GPS — stable filter key. */
  districtTileName?: Maybe<Scalars['String']['output']>
  draftComment?: Maybe<Scalars['String']['output']>
  draftStatus?: Maybe<DraftStatus>
  energyRating?: Maybe<EnergyRating>
  externalId: Scalars['String']['output']
  externalUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  featureIds: Array<Scalars['String']['output']>
  features: Array<Feature>
  fees?: Maybe<Fees>
  freeHold?: Maybe<Scalars['Boolean']['output']>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  hasGarden?: Maybe<Scalars['Boolean']['output']>
  hasParking?: Maybe<Scalars['Boolean']['output']>
  hasPool?: Maybe<Scalars['Boolean']['output']>
  id: Scalars['String']['output']
  images?: Maybe<Images>
  imagesAI?: Maybe<ImagesAi>
  importedAt?: Maybe<Scalars['DateTimeISO']['output']>
  importedFrom?: Maybe<Scalars['String']['output']>
  isNewDevelopment: Scalars['Boolean']['output']
  isPublished?: Maybe<Scalars['Boolean']['output']>
  lastCheckedAt?: Maybe<Scalars['DateTimeISO']['output']>
  leads: Array<Lead>
  leaseHold?: Maybe<Scalars['Boolean']['output']>
  levels?: Maybe<Scalars['Int']['output']>
  location?: Maybe<Location>
  locationArea?: Maybe<Scalars['String']['output']>
  locationDetail?: Maybe<Scalars['String']['output']>
  locationDistrict?: Maybe<Scalars['String']['output']>
  locationGeoCode?: Maybe<LocationGeoCode>
  locationId?: Maybe<Scalars['String']['output']>
  locationIsApproximated?: Maybe<Scalars['Boolean']['output']>
  locationMunicipality?: Maybe<Municipality>
  locationNeighbourhood?: Maybe<Scalars['String']['output']>
  locationProvince?: Maybe<Province>
  maxBaths?: Maybe<Scalars['Int']['output']>
  maxBeds?: Maybe<Scalars['Int']['output']>
  minBaths?: Maybe<Scalars['Int']['output']>
  minBeds?: Maybe<Scalars['Int']['output']>
  municipalityId?: Maybe<Scalars['String']['output']>
  newDevName?: Maybe<Scalars['String']['output']>
  originalPrice?: Maybe<Scalars['Int']['output']>
  ownProperty: Scalars['Boolean']['output']
  paidExtras: Array<PaidExtra>
  price?: Maybe<Scalars['Int']['output']>
  priceHistory: Array<PriceHistory>
  priceTo?: Maybe<Scalars['Int']['output']>
  propertyAlias?: Maybe<Scalars['String']['output']>
  propertyMeta?: Maybe<PropertyMeta>
  propertyQuality?: Maybe<PropertyQuality>
  propertyReports: Array<PropertyReport>
  propertyTitle: Array<PropertyTitle>
  propertyType?: Maybe<PropertyType>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  propertyTypeIds: Array<Scalars['String']['output']>
  propertyTypes: Array<PropertyType>
  prospectPdfAvailable: Scalars['Boolean']['output']
  prospectPdfError?: Maybe<Scalars['String']['output']>
  prospectPdfGeneratedAt?: Maybe<Scalars['DateTimeISO']['output']>
  prospectPdfStatus?: Maybe<Scalars['String']['output']>
  /** Pre-generated prospect PDF (async worker) */
  prospectPdfUrl?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  renovationDescription?: Maybe<Scalars['String']['output']>
  renovationYear?: Maybe<Scalars['DateTimeISO']['output']>
  rentalLicenseRef?: Maybe<Scalars['String']['output']>
  rentalProperties?: Maybe<RentalProperties>
  slug?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  statusHistory: Array<StatusHistory>
  surfaceArea?: Maybe<SurfaceArea>
  updatedAt: Scalars['DateTimeISO']['output']
  valuationEstimate?: Maybe<PropertyValuationEstimate>
  videoTour?: Maybe<Scalars['String']['output']>
  videos: Array<Video>
  virtualTour?: Maybe<Scalars['String']['output']>
  virtualTourUrl?: Maybe<Scalars['String']['output']>
  willFinishAtDate?: Maybe<Scalars['DateTimeISO']['output']>
}

export type PropertyAgencyHistoryArgs = {
  cursor?: InputMaybe<AgencyHistoryWhereUniqueInput>
  distinct?: InputMaybe<Array<AgencyHistoryScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AgencyHistoryOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AgencyHistoryWhereInput>
}

export type PropertyBrokerArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyBrokersArgs = {
  cursor?: InputMaybe<BrokerWhereUniqueInput>
  distinct?: InputMaybe<Array<BrokerScalarFieldEnum>>
  orderBy?: InputMaybe<Array<BrokerOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyFeaturesArgs = {
  cursor?: InputMaybe<FeatureWhereUniqueInput>
  distinct?: InputMaybe<Array<FeatureScalarFieldEnum>>
  orderBy?: InputMaybe<Array<FeatureOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FeatureWhereInput>
}

export type PropertyImagesArgs = {
  where?: InputMaybe<ImagesWhereInput>
}

export type PropertyImagesAiArgs = {
  where?: InputMaybe<ImagesAiWhereInput>
}

export type PropertyLeadsArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type PropertyLocationArgs = {
  where?: InputMaybe<LocationWhereInput>
}

export type PropertyLocationGeoCodeArgs = {
  where?: InputMaybe<LocationGeoCodeWhereInput>
}

export type PropertyLocationMunicipalityArgs = {
  where?: InputMaybe<MunicipalityWhereInput>
}

export type PropertyLocationProvinceArgs = {
  where?: InputMaybe<ProvinceWhereInput>
}

export type PropertyPaidExtrasArgs = {
  cursor?: InputMaybe<PaidExtraWhereUniqueInput>
  distinct?: InputMaybe<Array<PaidExtraScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PaidExtraOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PaidExtraWhereInput>
}

export type PropertyPropertyMetaArgs = {
  where?: InputMaybe<PropertyMetaWhereInput>
}

export type PropertyPropertyReportsArgs = {
  cursor?: InputMaybe<PropertyReportWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyReportScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyReportOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyReportWhereInput>
}

export type PropertyPropertyTypeArgs = {
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyPropertyTypesArgs = {
  cursor?: InputMaybe<PropertyTypeWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyTypeScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyTypeOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyValuationEstimateArgs = {
  where?: InputMaybe<PropertyValuationEstimateWhereInput>
}

export type PropertyVideosArgs = {
  cursor?: InputMaybe<VideoWhereUniqueInput>
  distinct?: InputMaybe<Array<VideoScalarFieldEnum>>
  orderBy?: InputMaybe<Array<VideoOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<VideoWhereInput>
}

export type PropertyAvgAggregate = {
  __typename?: 'PropertyAvgAggregate'
  baths?: Maybe<Scalars['Float']['output']>
  beds?: Maybe<Scalars['Float']['output']>
  brokerPropertyPriority?: Maybe<Scalars['Float']['output']>
  decree218?: Maybe<Scalars['Float']['output']>
  levels?: Maybe<Scalars['Float']['output']>
  maxBaths?: Maybe<Scalars['Float']['output']>
  maxBeds?: Maybe<Scalars['Float']['output']>
  minBaths?: Maybe<Scalars['Float']['output']>
  minBeds?: Maybe<Scalars['Float']['output']>
  originalPrice?: Maybe<Scalars['Float']['output']>
  price?: Maybe<Scalars['Float']['output']>
  priceTo?: Maybe<Scalars['Float']['output']>
}

export type PropertyCardAd = {
  __typename?: 'PropertyCardAd'
  adType?: Maybe<Scalars['String']['output']>
  advertiser?: Maybe<Advertiser>
  advertiserId?: Maybe<Scalars['String']['output']>
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  broker?: Maybe<Broker>
  brokerId?: Maybe<Scalars['String']['output']>
  callToAction?: Maybe<Scalars['String']['output']>
  clicks: Scalars['Int']['output']
  createdAt: Scalars['DateTimeISO']['output']
  currency?: Maybe<Scalars['String']['output']>
  descriptions: Array<Description>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  href?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  images?: Maybe<AdImages>
  impressions: Scalars['Int']['output']
  isActive: Scalars['Boolean']['output']
  language?: Maybe<Scalars['String']['output']>
  locationDisplay?: Maybe<Scalars['String']['output']>
  locationOnly: Scalars['Boolean']['output']
  maxDistance?: Maybe<Scalars['Int']['output']>
  presentAtPosition?: Maybe<Scalars['Int']['output']>
  price?: Maybe<Scalars['Int']['output']>
  priority: Scalars['Int']['output']
  propertyType?: Maybe<Scalars['String']['output']>
  subtitle?: Maybe<Scalars['String']['output']>
  surfaceArea?: Maybe<Scalars['Int']['output']>
  targetUrl?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  validFrom?: Maybe<Scalars['DateTimeISO']['output']>
  validTo?: Maybe<Scalars['DateTimeISO']['output']>
}

export type PropertyCardAdAdvertiserArgs = {
  where?: InputMaybe<AdvertiserWhereInput>
}

export type PropertyCardAdBrokerArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyCardAdCreateManyBrokerInput = {
  adType?: InputMaybe<Scalars['String']['input']>
  advertiserId?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  callToAction?: InputMaybe<Scalars['String']['input']>
  clicks?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  href?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<AdImagesNullableCreateEnvelopeInput>
  impressions?: InputMaybe<Scalars['Int']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  locationDisplay?: InputMaybe<Scalars['String']['input']>
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>
  maxDistance?: InputMaybe<Scalars['Int']['input']>
  presentAtPosition?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  surfaceArea?: InputMaybe<Scalars['Int']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCardAdCreateManyBrokerInputEnvelope = {
  data: Array<PropertyCardAdCreateManyBrokerInput>
}

export type PropertyCardAdCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<PropertyCardAdWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCardAdCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PropertyCardAdCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PropertyCardAdCreateManyBrokerInputEnvelope>
}

export type PropertyCardAdCreateOrConnectWithoutBrokerInput = {
  create: PropertyCardAdCreateWithoutBrokerInput
  where: PropertyCardAdWhereUniqueInput
}

export type PropertyCardAdCreateWithoutBrokerInput = {
  adType?: InputMaybe<Scalars['String']['input']>
  advertiser?: InputMaybe<AdvertiserCreateNestedOneWithoutPropertyCardAdsInput>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  callToAction?: InputMaybe<Scalars['String']['input']>
  clicks?: InputMaybe<Scalars['Int']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  href?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<AdImagesNullableCreateEnvelopeInput>
  impressions?: InputMaybe<Scalars['Int']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  locationDisplay?: InputMaybe<Scalars['String']['input']>
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>
  maxDistance?: InputMaybe<Scalars['Int']['input']>
  presentAtPosition?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  surfaceArea?: InputMaybe<Scalars['Int']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCardAdDescriptionInput = {
  language: Scalars['String']['input']
  short?: InputMaybe<Scalars['String']['input']>
  text?: InputMaybe<Scalars['String']['input']>
}

export type PropertyCardAdImagesInput = {
  large: Array<Scalars['String']['input']>
  small: Array<Scalars['String']['input']>
}

export type PropertyCardAdInput = {
  adType?: Scalars['String']['input']
  advertiserId?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  callToAction?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  descriptions: Array<PropertyCardAdDescriptionInput>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  href?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<PropertyCardAdImagesInput>
  isActive?: Scalars['Boolean']['input']
  language?: InputMaybe<Scalars['String']['input']>
  locationDisplay?: InputMaybe<Scalars['String']['input']>
  locationOnly?: Scalars['Boolean']['input']
  maxDistance?: InputMaybe<Scalars['Int']['input']>
  presentAtPosition?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priority?: Scalars['Int']['input']
  propertyType?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  surfaceArea?: InputMaybe<Scalars['Int']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title: Scalars['String']['input']
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCardAdListRelationFilter = {
  every?: InputMaybe<PropertyCardAdWhereInput>
  none?: InputMaybe<PropertyCardAdWhereInput>
  some?: InputMaybe<PropertyCardAdWhereInput>
}

export type PropertyCardAdOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyCardAdOrderByWithRelationInput = {
  adType?: InputMaybe<SortOrder>
  advertiser?: InputMaybe<AdvertiserOrderByWithRelationInput>
  advertiserId?: InputMaybe<SortOrder>
  baths?: InputMaybe<SortOrder>
  beds?: InputMaybe<SortOrder>
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  callToAction?: InputMaybe<SortOrder>
  clicks?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  descriptions?: InputMaybe<DescriptionOrderByCompositeAggregateInput>
  gpsX?: InputMaybe<SortOrder>
  gpsY?: InputMaybe<SortOrder>
  href?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  images?: InputMaybe<AdImagesOrderByInput>
  impressions?: InputMaybe<SortOrder>
  isActive?: InputMaybe<SortOrder>
  language?: InputMaybe<SortOrder>
  locationDisplay?: InputMaybe<SortOrder>
  locationOnly?: InputMaybe<SortOrder>
  maxDistance?: InputMaybe<SortOrder>
  presentAtPosition?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  priority?: InputMaybe<SortOrder>
  propertyType?: InputMaybe<SortOrder>
  subtitle?: InputMaybe<SortOrder>
  surfaceArea?: InputMaybe<SortOrder>
  targetUrl?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  validFrom?: InputMaybe<SortOrder>
  validTo?: InputMaybe<SortOrder>
}

export enum PropertyCardAdScalarFieldEnum {
  AdType = 'adType',
  AdvertiserId = 'advertiserId',
  Baths = 'baths',
  Beds = 'beds',
  BrokerId = 'brokerId',
  CallToAction = 'callToAction',
  Clicks = 'clicks',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  GpsX = 'gpsX',
  GpsY = 'gpsY',
  Href = 'href',
  Id = 'id',
  Impressions = 'impressions',
  IsActive = 'isActive',
  Language = 'language',
  LocationDisplay = 'locationDisplay',
  LocationOnly = 'locationOnly',
  MaxDistance = 'maxDistance',
  PresentAtPosition = 'presentAtPosition',
  Price = 'price',
  Priority = 'priority',
  PropertyType = 'propertyType',
  Subtitle = 'subtitle',
  SurfaceArea = 'surfaceArea',
  TargetUrl = 'targetUrl',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  ValidFrom = 'validFrom',
  ValidTo = 'validTo',
}

export type PropertyCardAdScalarWhereInput = {
  AND?: InputMaybe<Array<PropertyCardAdScalarWhereInput>>
  NOT?: InputMaybe<Array<PropertyCardAdScalarWhereInput>>
  OR?: InputMaybe<Array<PropertyCardAdScalarWhereInput>>
  adType?: InputMaybe<StringNullableFilter>
  advertiserId?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callToAction?: InputMaybe<StringNullableFilter>
  clicks?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  href?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  impressions?: InputMaybe<IntFilter>
  isActive?: InputMaybe<BoolFilter>
  language?: InputMaybe<StringNullableFilter>
  locationDisplay?: InputMaybe<StringNullableFilter>
  locationOnly?: InputMaybe<BoolFilter>
  maxDistance?: InputMaybe<IntNullableFilter>
  presentAtPosition?: InputMaybe<IntNullableFilter>
  price?: InputMaybe<IntNullableFilter>
  priority?: InputMaybe<IntFilter>
  propertyType?: InputMaybe<StringNullableFilter>
  subtitle?: InputMaybe<StringNullableFilter>
  surfaceArea?: InputMaybe<IntNullableFilter>
  targetUrl?: InputMaybe<StringNullableFilter>
  title?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export type PropertyCardAdUpdateInput = {
  adType?: InputMaybe<Scalars['String']['input']>
  advertiserId?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  callToAction?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<PropertyCardAdDescriptionInput>>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  href?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<PropertyCardAdImagesInput>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  locationDisplay?: InputMaybe<Scalars['String']['input']>
  locationOnly?: InputMaybe<Scalars['Boolean']['input']>
  maxDistance?: InputMaybe<Scalars['Int']['input']>
  presentAtPosition?: InputMaybe<Scalars['Int']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priority?: InputMaybe<Scalars['Int']['input']>
  propertyType?: InputMaybe<Scalars['String']['input']>
  subtitle?: InputMaybe<Scalars['String']['input']>
  surfaceArea?: InputMaybe<Scalars['Int']['input']>
  targetUrl?: InputMaybe<Scalars['String']['input']>
  title?: InputMaybe<Scalars['String']['input']>
  validFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  validTo?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCardAdUpdateManyMutationInput = {
  adType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  callToAction?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  clicks?: InputMaybe<IntFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  href?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  images?: InputMaybe<AdImagesNullableUpdateEnvelopeInput>
  impressions?: InputMaybe<IntFieldUpdateOperationsInput>
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDisplay?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationOnly?: InputMaybe<BoolFieldUpdateOperationsInput>
  maxDistance?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  presentAtPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priority?: InputMaybe<IntFieldUpdateOperationsInput>
  propertyType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  surfaceArea?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  title?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyCardAdUpdateManyWithWhereWithoutBrokerInput = {
  data: PropertyCardAdUpdateManyMutationInput
  where: PropertyCardAdScalarWhereInput
}

export type PropertyCardAdUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<PropertyCardAdWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCardAdCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PropertyCardAdCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PropertyCardAdCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<PropertyCardAdWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyCardAdScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyCardAdWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyCardAdWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyCardAdUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<PropertyCardAdUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<PropertyCardAdUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type PropertyCardAdUpdateWithWhereUniqueWithoutBrokerInput = {
  data: PropertyCardAdUpdateWithoutBrokerInput
  where: PropertyCardAdWhereUniqueInput
}

export type PropertyCardAdUpdateWithoutBrokerInput = {
  adType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  advertiser?: InputMaybe<AdvertiserUpdateOneWithoutPropertyCardAdsNestedInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  callToAction?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  clicks?: InputMaybe<IntFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  href?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  images?: InputMaybe<AdImagesNullableUpdateEnvelopeInput>
  impressions?: InputMaybe<IntFieldUpdateOperationsInput>
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  language?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDisplay?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationOnly?: InputMaybe<BoolFieldUpdateOperationsInput>
  maxDistance?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  presentAtPosition?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priority?: InputMaybe<IntFieldUpdateOperationsInput>
  propertyType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subtitle?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  surfaceArea?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  targetUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  title?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  validFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  validTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyCardAdUpsertWithWhereUniqueWithoutBrokerInput = {
  create: PropertyCardAdCreateWithoutBrokerInput
  update: PropertyCardAdUpdateWithoutBrokerInput
  where: PropertyCardAdWhereUniqueInput
}

export type PropertyCardAdWhereInput = {
  AND?: InputMaybe<Array<PropertyCardAdWhereInput>>
  NOT?: InputMaybe<Array<PropertyCardAdWhereInput>>
  OR?: InputMaybe<Array<PropertyCardAdWhereInput>>
  adType?: InputMaybe<StringNullableFilter>
  advertiser?: InputMaybe<AdvertiserNullableRelationFilter>
  advertiserId?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callToAction?: InputMaybe<StringNullableFilter>
  clicks?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  href?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<StringFilter>
  images?: InputMaybe<AdImagesNullableCompositeFilter>
  impressions?: InputMaybe<IntFilter>
  isActive?: InputMaybe<BoolFilter>
  language?: InputMaybe<StringNullableFilter>
  locationDisplay?: InputMaybe<StringNullableFilter>
  locationOnly?: InputMaybe<BoolFilter>
  maxDistance?: InputMaybe<IntNullableFilter>
  presentAtPosition?: InputMaybe<IntNullableFilter>
  price?: InputMaybe<IntNullableFilter>
  priority?: InputMaybe<IntFilter>
  propertyType?: InputMaybe<StringNullableFilter>
  subtitle?: InputMaybe<StringNullableFilter>
  surfaceArea?: InputMaybe<IntNullableFilter>
  targetUrl?: InputMaybe<StringNullableFilter>
  title?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export type PropertyCardAdWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyCardAdWhereInput>>
  NOT?: InputMaybe<Array<PropertyCardAdWhereInput>>
  OR?: InputMaybe<Array<PropertyCardAdWhereInput>>
  adType?: InputMaybe<StringNullableFilter>
  advertiser?: InputMaybe<AdvertiserNullableRelationFilter>
  advertiserId?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  callToAction?: InputMaybe<StringNullableFilter>
  clicks?: InputMaybe<IntFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  href?: InputMaybe<StringNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<AdImagesNullableCompositeFilter>
  impressions?: InputMaybe<IntFilter>
  isActive?: InputMaybe<BoolFilter>
  language?: InputMaybe<StringNullableFilter>
  locationDisplay?: InputMaybe<StringNullableFilter>
  locationOnly?: InputMaybe<BoolFilter>
  maxDistance?: InputMaybe<IntNullableFilter>
  presentAtPosition?: InputMaybe<IntNullableFilter>
  price?: InputMaybe<IntNullableFilter>
  priority?: InputMaybe<IntFilter>
  propertyType?: InputMaybe<StringNullableFilter>
  subtitle?: InputMaybe<StringNullableFilter>
  surfaceArea?: InputMaybe<IntNullableFilter>
  targetUrl?: InputMaybe<StringNullableFilter>
  title?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  validFrom?: InputMaybe<DateTimeNullableFilter>
  validTo?: InputMaybe<DateTimeNullableFilter>
}

export type PropertyCardAdWithDistance = {
  __typename?: 'PropertyCardAdWithDistance'
  ad: PropertyCardAd
  distance?: Maybe<Scalars['Float']['output']>
}

export enum PropertyCondition {
  Excellent = 'excellent',
  Fair = 'fair',
  Good = 'good',
  NeedsRenovation = 'needs_renovation',
  Poor = 'poor',
}

export type PropertyCount = {
  __typename?: 'PropertyCount'
  agencyHistory: Scalars['Int']['output']
  brokers: Scalars['Int']['output']
  features: Scalars['Int']['output']
  leads: Scalars['Int']['output']
  paidExtras: Scalars['Int']['output']
  propertyReports: Scalars['Int']['output']
  propertyTypes: Scalars['Int']['output']
  videos: Scalars['Int']['output']
}

export type PropertyCountAgencyHistoryArgs = {
  where?: InputMaybe<AgencyHistoryWhereInput>
}

export type PropertyCountBrokersArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyCountFeaturesArgs = {
  where?: InputMaybe<FeatureWhereInput>
}

export type PropertyCountLeadsArgs = {
  where?: InputMaybe<LeadWhereInput>
}

export type PropertyCountPaidExtrasArgs = {
  where?: InputMaybe<PaidExtraWhereInput>
}

export type PropertyCountPropertyReportsArgs = {
  where?: InputMaybe<PropertyReportWhereInput>
}

export type PropertyCountPropertyTypesArgs = {
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyCountVideosArgs = {
  where?: InputMaybe<VideoWhereInput>
}

export type PropertyCountAggregate = {
  __typename?: 'PropertyCountAggregate'
  _all: Scalars['Int']['output']
  agencyRef: Scalars['Int']['output']
  baths: Scalars['Int']['output']
  beds: Scalars['Int']['output']
  brokerId: Scalars['Int']['output']
  brokerIds: Scalars['Int']['output']
  brokerPropertyPriority: Scalars['Int']['output']
  builtYear: Scalars['Int']['output']
  category: Scalars['Int']['output']
  completionDate: Scalars['Int']['output']
  constructionYear: Scalars['Int']['output']
  country: Scalars['Int']['output']
  createdAt: Scalars['Int']['output']
  currency: Scalars['Int']['output']
  date: Scalars['Int']['output']
  decree218: Scalars['Int']['output']
  districtTileEnrichedAt: Scalars['Int']['output']
  districtTileName: Scalars['Int']['output']
  draftComment: Scalars['Int']['output']
  draftStatus: Scalars['Int']['output']
  externalId: Scalars['Int']['output']
  externalUpdatedAt: Scalars['Int']['output']
  featureIds: Scalars['Int']['output']
  freeHold: Scalars['Int']['output']
  gpsX: Scalars['Int']['output']
  gpsY: Scalars['Int']['output']
  hasGarden: Scalars['Int']['output']
  hasParking: Scalars['Int']['output']
  hasPool: Scalars['Int']['output']
  id: Scalars['Int']['output']
  importedAt: Scalars['Int']['output']
  importedFrom: Scalars['Int']['output']
  isNewDevelopment: Scalars['Int']['output']
  isPublished: Scalars['Int']['output']
  lastCheckedAt: Scalars['Int']['output']
  leaseHold: Scalars['Int']['output']
  levels: Scalars['Int']['output']
  locationArea: Scalars['Int']['output']
  locationDetail: Scalars['Int']['output']
  locationDistrict: Scalars['Int']['output']
  locationId: Scalars['Int']['output']
  locationIsApproximated: Scalars['Int']['output']
  locationNeighbourhood: Scalars['Int']['output']
  maxBaths: Scalars['Int']['output']
  maxBeds: Scalars['Int']['output']
  minBaths: Scalars['Int']['output']
  minBeds: Scalars['Int']['output']
  municipalityId: Scalars['Int']['output']
  newDevName: Scalars['Int']['output']
  originalPrice: Scalars['Int']['output']
  ownProperty: Scalars['Int']['output']
  price: Scalars['Int']['output']
  priceTo: Scalars['Int']['output']
  propertyAlias: Scalars['Int']['output']
  propertyTypeId: Scalars['Int']['output']
  propertyTypeIds: Scalars['Int']['output']
  prospectPdfError: Scalars['Int']['output']
  prospectPdfGeneratedAt: Scalars['Int']['output']
  prospectPdfStatus: Scalars['Int']['output']
  prospectPdfUrl: Scalars['Int']['output']
  provinceId: Scalars['Int']['output']
  refId: Scalars['Int']['output']
  renovationDescription: Scalars['Int']['output']
  renovationYear: Scalars['Int']['output']
  rentalLicenseRef: Scalars['Int']['output']
  slug: Scalars['Int']['output']
  status: Scalars['Int']['output']
  updatedAt: Scalars['Int']['output']
  videoTour: Scalars['Int']['output']
  virtualTour: Scalars['Int']['output']
  virtualTourUrl: Scalars['Int']['output']
  willFinishAtDate: Scalars['Int']['output']
}

export type PropertyCreateInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyBrokerInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyBrokerInputEnvelope = {
  data: Array<PropertyCreateManyBrokerInput>
}

export type PropertyCreateManyInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyInputExtended = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  /** Features nested relation - extends PropertyCreateManyInput to support features as nested relation (alternative to featureIds scalar) */
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  /** Images nested relation - extends PropertyCreateManyInput to support images */
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<Scalars['String']['input']>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyLocationInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyLocationInputEnvelope = {
  data: Array<PropertyCreateManyLocationInput>
}

export type PropertyCreateManyLocationMunicipalityInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyLocationMunicipalityInputEnvelope = {
  data: Array<PropertyCreateManyLocationMunicipalityInput>
}

export type PropertyCreateManyLocationProvinceInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeId?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyLocationProvinceInputEnvelope = {
  data: Array<PropertyCreateManyLocationProvinceInput>
}

export type PropertyCreateManyPropertyTypeInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerIds?: InputMaybe<PropertyCreatebrokerIdsInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  featureIds?: InputMaybe<PropertyCreatefeatureIdsInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationId?: InputMaybe<Scalars['String']['input']>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  municipalityId?: InputMaybe<Scalars['String']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypeIds?: InputMaybe<PropertyCreatepropertyTypeIdsInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  provinceId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  videoTour?: InputMaybe<Scalars['String']['input']>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateManyPropertyTypeInputEnvelope = {
  data: Array<PropertyCreateManyPropertyTypeInput>
}

export type PropertyCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PropertyCreateManyBrokerInputEnvelope>
}

export type PropertyCreateNestedManyWithoutBrokersInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutBrokersInput>>
}

export type PropertyCreateNestedManyWithoutFeaturesInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutFeaturesInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutFeaturesInput>>
}

export type PropertyCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationInputEnvelope>
}

export type PropertyCreateNestedManyWithoutLocationMunicipalityInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationMunicipalityInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationMunicipalityInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationMunicipalityInputEnvelope>
}

export type PropertyCreateNestedManyWithoutLocationProvinceInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationProvinceInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationProvinceInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationProvinceInputEnvelope>
}

export type PropertyCreateNestedManyWithoutPropertyTypeInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutPropertyTypeInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutPropertyTypeInput>>
  createMany?: InputMaybe<PropertyCreateManyPropertyTypeInputEnvelope>
}

export type PropertyCreateNestedManyWithoutPropertyTypesInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutPropertyTypesInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutPropertyTypesInput>>
}

export type PropertyCreateNestedOneWithoutAgencyHistoryInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutAgencyHistoryInput>
  create?: InputMaybe<PropertyCreateWithoutAgencyHistoryInput>
}

export type PropertyCreateNestedOneWithoutLeadsInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutLeadsInput>
  create?: InputMaybe<PropertyCreateWithoutLeadsInput>
}

export type PropertyCreateNestedOneWithoutPaidExtrasInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutPaidExtrasInput>
  create?: InputMaybe<PropertyCreateWithoutPaidExtrasInput>
}

export type PropertyCreateOrConnectWithoutAgencyHistoryInput = {
  create: PropertyCreateWithoutAgencyHistoryInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutBrokerInput = {
  create: PropertyCreateWithoutBrokerInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutBrokersInput = {
  create: PropertyCreateWithoutBrokersInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutFeaturesInput = {
  create: PropertyCreateWithoutFeaturesInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutLeadsInput = {
  create: PropertyCreateWithoutLeadsInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutLocationInput = {
  create: PropertyCreateWithoutLocationInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutLocationMunicipalityInput = {
  create: PropertyCreateWithoutLocationMunicipalityInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutLocationProvinceInput = {
  create: PropertyCreateWithoutLocationProvinceInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutPaidExtrasInput = {
  create: PropertyCreateWithoutPaidExtrasInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutPropertyTypeInput = {
  create: PropertyCreateWithoutPropertyTypeInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateOrConnectWithoutPropertyTypesInput = {
  create: PropertyCreateWithoutPropertyTypesInput
  where: PropertyWhereUniqueInput
}

export type PropertyCreateWithoutAgencyHistoryInput = {
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutBrokerInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutBrokersInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutFeaturesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutLeadsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutLocationInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutLocationMunicipalityInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutLocationProvinceInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutPaidExtrasInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutPropertyTypeInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypes?: InputMaybe<PropertyTypeCreateNestedManyWithoutPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreateWithoutPropertyTypesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryCreateNestedManyWithoutPropertyInput>
  agencyRef?: InputMaybe<Scalars['String']['input']>
  baths?: InputMaybe<Scalars['Int']['input']>
  beds?: InputMaybe<Scalars['Int']['input']>
  broker?: InputMaybe<BrokerCreateNestedOneWithoutPropertiesInput>
  brokerPropertyPriority?: InputMaybe<Scalars['Int']['input']>
  brokers?: InputMaybe<BrokerCreateNestedManyWithoutSharedPropertiesInput>
  builtYear?: InputMaybe<Scalars['String']['input']>
  category?: InputMaybe<Scalars['String']['input']>
  completionDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  constructionYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  decree218?: InputMaybe<Scalars['Int']['input']>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  districtTileName?: InputMaybe<Scalars['String']['input']>
  draftComment?: InputMaybe<Scalars['String']['input']>
  draftStatus?: InputMaybe<DraftStatus>
  energyRating?: InputMaybe<EnergyRatingNullableCreateEnvelopeInput>
  externalId: Scalars['String']['input']
  externalUpdatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  features?: InputMaybe<FeatureCreateNestedManyWithoutPropertiesInput>
  fees?: InputMaybe<FeesNullableCreateEnvelopeInput>
  freeHold?: InputMaybe<Scalars['Boolean']['input']>
  gpsX?: InputMaybe<Scalars['String']['input']>
  gpsY?: InputMaybe<Scalars['String']['input']>
  hasGarden?: InputMaybe<Scalars['Boolean']['input']>
  hasParking?: InputMaybe<Scalars['Boolean']['input']>
  hasPool?: InputMaybe<Scalars['Boolean']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesCreateNestedOneWithoutPropertyInput>
  imagesAI?: InputMaybe<ImagesAiCreateNestedOneWithoutPropertyInput>
  importedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  importedFrom?: InputMaybe<Scalars['String']['input']>
  isNewDevelopment?: InputMaybe<Scalars['Boolean']['input']>
  isPublished?: InputMaybe<Scalars['Boolean']['input']>
  lastCheckedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  leads?: InputMaybe<LeadCreateNestedManyWithoutPropertyInput>
  leaseHold?: InputMaybe<Scalars['Boolean']['input']>
  levels?: InputMaybe<Scalars['Int']['input']>
  location?: InputMaybe<LocationCreateNestedOneWithoutPropertiesInput>
  locationArea?: InputMaybe<Scalars['String']['input']>
  locationDetail?: InputMaybe<Scalars['String']['input']>
  locationDistrict?: InputMaybe<Scalars['String']['input']>
  locationGeoCode?: InputMaybe<LocationGeoCodeCreateNestedOneWithoutPropertyInput>
  locationIsApproximated?: InputMaybe<Scalars['Boolean']['input']>
  locationMunicipality?: InputMaybe<MunicipalityCreateNestedOneWithoutPropertiesInput>
  locationNeighbourhood?: InputMaybe<Scalars['String']['input']>
  locationProvince?: InputMaybe<ProvinceCreateNestedOneWithoutPropertiesInput>
  maxBaths?: InputMaybe<Scalars['Int']['input']>
  maxBeds?: InputMaybe<Scalars['Int']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  newDevName?: InputMaybe<Scalars['String']['input']>
  originalPrice?: InputMaybe<Scalars['Int']['input']>
  ownProperty?: InputMaybe<Scalars['Boolean']['input']>
  paidExtras?: InputMaybe<PaidExtraCreateNestedManyWithoutPropertyInput>
  price?: InputMaybe<Scalars['Int']['input']>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<Scalars['Int']['input']>
  propertyAlias?: InputMaybe<Scalars['String']['input']>
  propertyMeta?: InputMaybe<PropertyMetaCreateNestedOneWithoutPropertyInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableCreateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportCreateNestedManyWithoutPropertyInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeCreateNestedOneWithoutMainPropertiesInput>
  prospectPdfError?: InputMaybe<Scalars['String']['input']>
  prospectPdfGeneratedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  prospectPdfStatus?: InputMaybe<Scalars['String']['input']>
  prospectPdfUrl?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  renovationDescription?: InputMaybe<Scalars['String']['input']>
  renovationYear?: InputMaybe<Scalars['DateTimeISO']['input']>
  rentalLicenseRef?: InputMaybe<Scalars['String']['input']>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCreateEnvelopeInput>
  slug?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCreateEnvelopeInput>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateCreateNestedOneWithoutPropertyInput>
  videoTour?: InputMaybe<Scalars['String']['input']>
  videos?: InputMaybe<VideoCreateNestedManyWithoutPropertyInput>
  virtualTour?: InputMaybe<Scalars['String']['input']>
  virtualTourUrl?: InputMaybe<Scalars['String']['input']>
  willFinishAtDate?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyCreatebrokerIdsInput = {
  set: Array<Scalars['String']['input']>
}

export type PropertyCreatefeatureIdsInput = {
  set: Array<Scalars['String']['input']>
}

export type PropertyCreatepropertyTypeIdsInput = {
  set: Array<Scalars['String']['input']>
}

export type PropertyHistoryItem = {
  __typename?: 'PropertyHistoryItem'
  propertyShortRef: Scalars['String']['output']
  viewCount?: Maybe<Scalars['Float']['output']>
  viewedAt: Scalars['DateTimeISO']['output']
}

export type PropertyImageEnrichmentStatus = {
  __typename?: 'PropertyImageEnrichmentStatus'
  approved: Scalars['Boolean']['output']
  enrichmentStatus?: Maybe<Scalars['String']['output']>
  hasActivePaidExtra: Scalars['Boolean']['output']
  imageCount: Scalars['Int']['output']
  status: Scalars['String']['output']
}

export type PropertyImageRoomLabelUpdateInput = {
  index: Scalars['Int']['input']
  roomLabel: Scalars['String']['input']
}

export type PropertyImagesAiGalleryItemInput = {
  large: Scalars['String']['input']
  roomLabel?: InputMaybe<Scalars['String']['input']>
  rotation?: InputMaybe<Scalars['Int']['input']>
  small: Scalars['String']['input']
}

export type PropertyListRelationFilter = {
  every?: InputMaybe<PropertyWhereInput>
  none?: InputMaybe<PropertyWhereInput>
  some?: InputMaybe<PropertyWhereInput>
}

export type PropertyLocationCoverageRow = {
  __typename?: 'PropertyLocationCoverageRow'
  count: Scalars['Int']['output']
  districtTileName?: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  label: Scalars['String']['output']
  level: Scalars['String']['output']
  locationArea?: Maybe<Scalars['String']['output']>
  locationTown?: Maybe<Scalars['String']['output']>
}

export type PropertyMaxAggregate = {
  __typename?: 'PropertyMaxAggregate'
  agencyRef?: Maybe<Scalars['String']['output']>
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  brokerPropertyPriority?: Maybe<Scalars['Int']['output']>
  builtYear?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  completionDate?: Maybe<Scalars['DateTimeISO']['output']>
  constructionYear?: Maybe<Scalars['DateTimeISO']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['DateTimeISO']['output']>
  decree218?: Maybe<Scalars['Int']['output']>
  districtTileEnrichedAt?: Maybe<Scalars['DateTimeISO']['output']>
  districtTileName?: Maybe<Scalars['String']['output']>
  draftComment?: Maybe<Scalars['String']['output']>
  draftStatus?: Maybe<DraftStatus>
  externalId?: Maybe<Scalars['String']['output']>
  externalUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  freeHold?: Maybe<Scalars['Boolean']['output']>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  hasGarden?: Maybe<Scalars['Boolean']['output']>
  hasParking?: Maybe<Scalars['Boolean']['output']>
  hasPool?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  importedAt?: Maybe<Scalars['DateTimeISO']['output']>
  importedFrom?: Maybe<Scalars['String']['output']>
  isNewDevelopment?: Maybe<Scalars['Boolean']['output']>
  isPublished?: Maybe<Scalars['Boolean']['output']>
  lastCheckedAt?: Maybe<Scalars['DateTimeISO']['output']>
  leaseHold?: Maybe<Scalars['Boolean']['output']>
  levels?: Maybe<Scalars['Int']['output']>
  locationArea?: Maybe<Scalars['String']['output']>
  locationDetail?: Maybe<Scalars['String']['output']>
  locationDistrict?: Maybe<Scalars['String']['output']>
  locationId?: Maybe<Scalars['String']['output']>
  locationIsApproximated?: Maybe<Scalars['Boolean']['output']>
  locationNeighbourhood?: Maybe<Scalars['String']['output']>
  maxBaths?: Maybe<Scalars['Int']['output']>
  maxBeds?: Maybe<Scalars['Int']['output']>
  minBaths?: Maybe<Scalars['Int']['output']>
  minBeds?: Maybe<Scalars['Int']['output']>
  municipalityId?: Maybe<Scalars['String']['output']>
  newDevName?: Maybe<Scalars['String']['output']>
  originalPrice?: Maybe<Scalars['Int']['output']>
  ownProperty?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Int']['output']>
  priceTo?: Maybe<Scalars['Int']['output']>
  propertyAlias?: Maybe<Scalars['String']['output']>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  prospectPdfError?: Maybe<Scalars['String']['output']>
  prospectPdfGeneratedAt?: Maybe<Scalars['DateTimeISO']['output']>
  prospectPdfStatus?: Maybe<Scalars['String']['output']>
  prospectPdfUrl?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  renovationDescription?: Maybe<Scalars['String']['output']>
  renovationYear?: Maybe<Scalars['DateTimeISO']['output']>
  rentalLicenseRef?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  videoTour?: Maybe<Scalars['String']['output']>
  virtualTour?: Maybe<Scalars['String']['output']>
  virtualTourUrl?: Maybe<Scalars['String']['output']>
  willFinishAtDate?: Maybe<Scalars['DateTimeISO']['output']>
}

export type PropertyMeta = {
  __typename?: 'PropertyMeta'
  createdAt: Scalars['DateTimeISO']['output']
  fetchedAt: Array<Scalars['DateTimeISO']['output']>
  fetchedTimes: Scalars['Int']['output']
  id: Scalars['String']['output']
  lastFetchedAt?: Maybe<Scalars['DateTimeISO']['output']>
  propertyId: Scalars['String']['output']
  uniqueVisitors: Scalars['Int']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type PropertyMetaCreateNestedOneWithoutPropertyInput = {
  connect?: InputMaybe<PropertyMetaWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyMetaCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<PropertyMetaCreateWithoutPropertyInput>
}

export type PropertyMetaCreateOrConnectWithoutPropertyInput = {
  create: PropertyMetaCreateWithoutPropertyInput
  where: PropertyMetaWhereUniqueInput
}

export type PropertyMetaCreateWithoutPropertyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  fetchedAt?: InputMaybe<PropertyMetaCreatefetchedAtInput>
  fetchedTimes?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  lastFetchedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  uniqueVisitors?: InputMaybe<Scalars['Int']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyMetaCreatefetchedAtInput = {
  set: Array<Scalars['DateTimeISO']['input']>
}

export type PropertyMetaNullableRelationFilter = {
  is?: InputMaybe<PropertyMetaWhereInput>
  isNot?: InputMaybe<PropertyMetaWhereInput>
}

export type PropertyMetaOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>
  fetchedAt?: InputMaybe<SortOrder>
  fetchedTimes?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  lastFetchedAt?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  uniqueVisitors?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type PropertyMetaUpdateOneWithoutPropertyNestedInput = {
  connect?: InputMaybe<PropertyMetaWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyMetaCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<PropertyMetaCreateWithoutPropertyInput>
  delete?: InputMaybe<PropertyMetaWhereInput>
  disconnect?: InputMaybe<PropertyMetaWhereInput>
  update?: InputMaybe<PropertyMetaUpdateToOneWithWhereWithoutPropertyInput>
  upsert?: InputMaybe<PropertyMetaUpsertWithoutPropertyInput>
}

export type PropertyMetaUpdateToOneWithWhereWithoutPropertyInput = {
  data: PropertyMetaUpdateWithoutPropertyInput
  where?: InputMaybe<PropertyMetaWhereInput>
}

export type PropertyMetaUpdateWithoutPropertyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  fetchedAt?: InputMaybe<PropertyMetaUpdatefetchedAtInput>
  fetchedTimes?: InputMaybe<IntFieldUpdateOperationsInput>
  lastFetchedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  uniqueVisitors?: InputMaybe<IntFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type PropertyMetaUpdatefetchedAtInput = {
  push?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
  set?: InputMaybe<Array<Scalars['DateTimeISO']['input']>>
}

export type PropertyMetaUpsertWithoutPropertyInput = {
  create: PropertyMetaCreateWithoutPropertyInput
  update: PropertyMetaUpdateWithoutPropertyInput
  where?: InputMaybe<PropertyMetaWhereInput>
}

export type PropertyMetaWhereInput = {
  AND?: InputMaybe<Array<PropertyMetaWhereInput>>
  NOT?: InputMaybe<Array<PropertyMetaWhereInput>>
  OR?: InputMaybe<Array<PropertyMetaWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  fetchedAt?: InputMaybe<DateTimeNullableListFilter>
  fetchedTimes?: InputMaybe<IntFilter>
  id?: InputMaybe<StringFilter>
  lastFetchedAt?: InputMaybe<DateTimeNullableFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  uniqueVisitors?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyMetaWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyMetaWhereInput>>
  NOT?: InputMaybe<Array<PropertyMetaWhereInput>>
  OR?: InputMaybe<Array<PropertyMetaWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  fetchedAt?: InputMaybe<DateTimeNullableListFilter>
  fetchedTimes?: InputMaybe<IntFilter>
  id?: InputMaybe<Scalars['String']['input']>
  lastFetchedAt?: InputMaybe<DateTimeNullableFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
  uniqueVisitors?: InputMaybe<IntFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyMinAggregate = {
  __typename?: 'PropertyMinAggregate'
  agencyRef?: Maybe<Scalars['String']['output']>
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  brokerPropertyPriority?: Maybe<Scalars['Int']['output']>
  builtYear?: Maybe<Scalars['String']['output']>
  category?: Maybe<Scalars['String']['output']>
  completionDate?: Maybe<Scalars['DateTimeISO']['output']>
  constructionYear?: Maybe<Scalars['DateTimeISO']['output']>
  country?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  date?: Maybe<Scalars['DateTimeISO']['output']>
  decree218?: Maybe<Scalars['Int']['output']>
  districtTileEnrichedAt?: Maybe<Scalars['DateTimeISO']['output']>
  districtTileName?: Maybe<Scalars['String']['output']>
  draftComment?: Maybe<Scalars['String']['output']>
  draftStatus?: Maybe<DraftStatus>
  externalId?: Maybe<Scalars['String']['output']>
  externalUpdatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  freeHold?: Maybe<Scalars['Boolean']['output']>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  hasGarden?: Maybe<Scalars['Boolean']['output']>
  hasParking?: Maybe<Scalars['Boolean']['output']>
  hasPool?: Maybe<Scalars['Boolean']['output']>
  id?: Maybe<Scalars['String']['output']>
  importedAt?: Maybe<Scalars['DateTimeISO']['output']>
  importedFrom?: Maybe<Scalars['String']['output']>
  isNewDevelopment?: Maybe<Scalars['Boolean']['output']>
  isPublished?: Maybe<Scalars['Boolean']['output']>
  lastCheckedAt?: Maybe<Scalars['DateTimeISO']['output']>
  leaseHold?: Maybe<Scalars['Boolean']['output']>
  levels?: Maybe<Scalars['Int']['output']>
  locationArea?: Maybe<Scalars['String']['output']>
  locationDetail?: Maybe<Scalars['String']['output']>
  locationDistrict?: Maybe<Scalars['String']['output']>
  locationId?: Maybe<Scalars['String']['output']>
  locationIsApproximated?: Maybe<Scalars['Boolean']['output']>
  locationNeighbourhood?: Maybe<Scalars['String']['output']>
  maxBaths?: Maybe<Scalars['Int']['output']>
  maxBeds?: Maybe<Scalars['Int']['output']>
  minBaths?: Maybe<Scalars['Int']['output']>
  minBeds?: Maybe<Scalars['Int']['output']>
  municipalityId?: Maybe<Scalars['String']['output']>
  newDevName?: Maybe<Scalars['String']['output']>
  originalPrice?: Maybe<Scalars['Int']['output']>
  ownProperty?: Maybe<Scalars['Boolean']['output']>
  price?: Maybe<Scalars['Int']['output']>
  priceTo?: Maybe<Scalars['Int']['output']>
  propertyAlias?: Maybe<Scalars['String']['output']>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  prospectPdfError?: Maybe<Scalars['String']['output']>
  prospectPdfGeneratedAt?: Maybe<Scalars['DateTimeISO']['output']>
  prospectPdfStatus?: Maybe<Scalars['String']['output']>
  prospectPdfUrl?: Maybe<Scalars['String']['output']>
  provinceId?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  renovationDescription?: Maybe<Scalars['String']['output']>
  renovationYear?: Maybe<Scalars['DateTimeISO']['output']>
  rentalLicenseRef?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  videoTour?: Maybe<Scalars['String']['output']>
  virtualTour?: Maybe<Scalars['String']['output']>
  virtualTourUrl?: Maybe<Scalars['String']['output']>
  willFinishAtDate?: Maybe<Scalars['DateTimeISO']['output']>
}

export type PropertyNullableRelationFilter = {
  is?: InputMaybe<PropertyWhereInput>
  isNot?: InputMaybe<PropertyWhereInput>
}

export type PropertyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyOrderByWithRelationInput = {
  agencyHistory?: InputMaybe<AgencyHistoryOrderByRelationAggregateInput>
  agencyRef?: InputMaybe<SortOrder>
  baths?: InputMaybe<SortOrder>
  beds?: InputMaybe<SortOrder>
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  brokerIds?: InputMaybe<SortOrder>
  brokerPropertyPriority?: InputMaybe<SortOrder>
  brokers?: InputMaybe<BrokerOrderByRelationAggregateInput>
  builtYear?: InputMaybe<SortOrder>
  category?: InputMaybe<SortOrder>
  completionDate?: InputMaybe<SortOrder>
  constructionYear?: InputMaybe<SortOrder>
  country?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  date?: InputMaybe<SortOrder>
  decree218?: InputMaybe<SortOrder>
  descriptions?: InputMaybe<DescriptionOrderByCompositeAggregateInput>
  districtTileEnrichedAt?: InputMaybe<SortOrder>
  districtTileName?: InputMaybe<SortOrder>
  draftComment?: InputMaybe<SortOrder>
  draftStatus?: InputMaybe<SortOrder>
  energyRating?: InputMaybe<EnergyRatingOrderByInput>
  externalId?: InputMaybe<SortOrder>
  externalUpdatedAt?: InputMaybe<SortOrder>
  featureIds?: InputMaybe<SortOrder>
  features?: InputMaybe<FeatureOrderByRelationAggregateInput>
  fees?: InputMaybe<FeesOrderByInput>
  freeHold?: InputMaybe<SortOrder>
  gpsX?: InputMaybe<SortOrder>
  gpsY?: InputMaybe<SortOrder>
  hasGarden?: InputMaybe<SortOrder>
  hasParking?: InputMaybe<SortOrder>
  hasPool?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  images?: InputMaybe<ImagesOrderByWithRelationInput>
  imagesAI?: InputMaybe<ImagesAiOrderByWithRelationInput>
  importedAt?: InputMaybe<SortOrder>
  importedFrom?: InputMaybe<SortOrder>
  isNewDevelopment?: InputMaybe<SortOrder>
  isPublished?: InputMaybe<SortOrder>
  lastCheckedAt?: InputMaybe<SortOrder>
  leads?: InputMaybe<LeadOrderByRelationAggregateInput>
  leaseHold?: InputMaybe<SortOrder>
  levels?: InputMaybe<SortOrder>
  location?: InputMaybe<LocationOrderByWithRelationInput>
  locationArea?: InputMaybe<SortOrder>
  locationDetail?: InputMaybe<SortOrder>
  locationDistrict?: InputMaybe<SortOrder>
  locationGeoCode?: InputMaybe<LocationGeoCodeOrderByWithRelationInput>
  locationId?: InputMaybe<SortOrder>
  locationIsApproximated?: InputMaybe<SortOrder>
  locationMunicipality?: InputMaybe<MunicipalityOrderByWithRelationInput>
  locationNeighbourhood?: InputMaybe<SortOrder>
  locationProvince?: InputMaybe<ProvinceOrderByWithRelationInput>
  maxBaths?: InputMaybe<SortOrder>
  maxBeds?: InputMaybe<SortOrder>
  minBaths?: InputMaybe<SortOrder>
  minBeds?: InputMaybe<SortOrder>
  municipalityId?: InputMaybe<SortOrder>
  newDevName?: InputMaybe<SortOrder>
  originalPrice?: InputMaybe<SortOrder>
  ownProperty?: InputMaybe<SortOrder>
  paidExtras?: InputMaybe<PaidExtraOrderByRelationAggregateInput>
  price?: InputMaybe<SortOrder>
  priceHistory?: InputMaybe<PriceHistoryOrderByCompositeAggregateInput>
  priceTo?: InputMaybe<SortOrder>
  propertyAlias?: InputMaybe<SortOrder>
  propertyMeta?: InputMaybe<PropertyMetaOrderByWithRelationInput>
  propertyQuality?: InputMaybe<PropertyQualityOrderByInput>
  propertyReports?: InputMaybe<PropertyReportOrderByRelationAggregateInput>
  propertyTitle?: InputMaybe<PropertyTitleOrderByCompositeAggregateInput>
  propertyType?: InputMaybe<PropertyTypeOrderByWithRelationInput>
  propertyTypeId?: InputMaybe<SortOrder>
  propertyTypeIds?: InputMaybe<SortOrder>
  propertyTypes?: InputMaybe<PropertyTypeOrderByRelationAggregateInput>
  prospectPdfError?: InputMaybe<SortOrder>
  prospectPdfGeneratedAt?: InputMaybe<SortOrder>
  prospectPdfStatus?: InputMaybe<SortOrder>
  prospectPdfUrl?: InputMaybe<SortOrder>
  provinceId?: InputMaybe<SortOrder>
  refId?: InputMaybe<SortOrder>
  renovationDescription?: InputMaybe<SortOrder>
  renovationYear?: InputMaybe<SortOrder>
  rentalLicenseRef?: InputMaybe<SortOrder>
  rentalProperties?: InputMaybe<RentalPropertiesOrderByInput>
  slug?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  statusHistory?: InputMaybe<StatusHistoryOrderByCompositeAggregateInput>
  surfaceArea?: InputMaybe<SurfaceAreaOrderByInput>
  updatedAt?: InputMaybe<SortOrder>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateOrderByWithRelationInput>
  videoTour?: InputMaybe<SortOrder>
  videos?: InputMaybe<VideoOrderByRelationAggregateInput>
  virtualTour?: InputMaybe<SortOrder>
  virtualTourUrl?: InputMaybe<SortOrder>
  willFinishAtDate?: InputMaybe<SortOrder>
}

export type PropertyQuality = {
  __typename?: 'PropertyQuality'
  bathroomQuality?: Maybe<BathroomQuality>
  condition?: Maybe<PropertyCondition>
  flooringTypes: Array<FlooringType>
  hasBuiltInStorage?: Maybe<Scalars['Boolean']['output']>
  hasEnsuiteBathroom?: Maybe<Scalars['Boolean']['output']>
  hasWalkInCloset?: Maybe<Scalars['Boolean']['output']>
  kitchenQuality?: Maybe<KitchenQuality>
  lastRenovationYear?: Maybe<Scalars['Int']['output']>
  maintenanceHistory?: Maybe<MaintenanceHistory>
  renovationQuality?: Maybe<RenovationQuality>
  structuralIssues?: Maybe<Scalars['Boolean']['output']>
}

export type PropertyQualityCreateInput = {
  bathroomQuality?: InputMaybe<BathroomQuality>
  condition?: InputMaybe<PropertyCondition>
  flooringTypes?: InputMaybe<PropertyQualityCreateflooringTypesInput>
  hasBuiltInStorage?: InputMaybe<Scalars['Boolean']['input']>
  hasEnsuiteBathroom?: InputMaybe<Scalars['Boolean']['input']>
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']['input']>
  kitchenQuality?: InputMaybe<KitchenQuality>
  lastRenovationYear?: InputMaybe<Scalars['Int']['input']>
  maintenanceHistory?: InputMaybe<MaintenanceHistory>
  renovationQuality?: InputMaybe<RenovationQuality>
  structuralIssues?: InputMaybe<Scalars['Boolean']['input']>
}

export type PropertyQualityCreateflooringTypesInput = {
  set: Array<FlooringType>
}

export type PropertyQualityNullableCompositeFilter = {
  equals?: InputMaybe<PropertyQualityObjectEqualityInput>
  is?: InputMaybe<PropertyQualityWhereInput>
  isNot?: InputMaybe<PropertyQualityWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type PropertyQualityNullableCreateEnvelopeInput = {
  set?: InputMaybe<PropertyQualityCreateInput>
}

export type PropertyQualityNullableUpdateEnvelopeInput = {
  set?: InputMaybe<PropertyQualityCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<PropertyQualityUpsertInput>
}

export type PropertyQualityObjectEqualityInput = {
  bathroomQuality?: InputMaybe<BathroomQuality>
  condition?: InputMaybe<PropertyCondition>
  flooringTypes?: InputMaybe<Array<FlooringType>>
  hasBuiltInStorage?: InputMaybe<Scalars['Boolean']['input']>
  hasEnsuiteBathroom?: InputMaybe<Scalars['Boolean']['input']>
  hasWalkInCloset?: InputMaybe<Scalars['Boolean']['input']>
  kitchenQuality?: InputMaybe<KitchenQuality>
  lastRenovationYear?: InputMaybe<Scalars['Int']['input']>
  maintenanceHistory?: InputMaybe<MaintenanceHistory>
  renovationQuality?: InputMaybe<RenovationQuality>
  structuralIssues?: InputMaybe<Scalars['Boolean']['input']>
}

export type PropertyQualityOrderByInput = {
  bathroomQuality?: InputMaybe<SortOrder>
  condition?: InputMaybe<SortOrder>
  flooringTypes?: InputMaybe<SortOrder>
  hasBuiltInStorage?: InputMaybe<SortOrder>
  hasEnsuiteBathroom?: InputMaybe<SortOrder>
  hasWalkInCloset?: InputMaybe<SortOrder>
  kitchenQuality?: InputMaybe<SortOrder>
  lastRenovationYear?: InputMaybe<SortOrder>
  maintenanceHistory?: InputMaybe<SortOrder>
  renovationQuality?: InputMaybe<SortOrder>
  structuralIssues?: InputMaybe<SortOrder>
}

export type PropertyQualityUpdateInput = {
  bathroomQuality?: InputMaybe<NullableEnumBathroomQualityFieldUpdateOperationsInput>
  condition?: InputMaybe<NullableEnumPropertyConditionFieldUpdateOperationsInput>
  flooringTypes?: InputMaybe<PropertyQualityUpdateflooringTypesInput>
  hasBuiltInStorage?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasEnsuiteBathroom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasWalkInCloset?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  kitchenQuality?: InputMaybe<NullableEnumKitchenQualityFieldUpdateOperationsInput>
  lastRenovationYear?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maintenanceHistory?: InputMaybe<NullableEnumMaintenanceHistoryFieldUpdateOperationsInput>
  renovationQuality?: InputMaybe<NullableEnumRenovationQualityFieldUpdateOperationsInput>
  structuralIssues?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
}

export type PropertyQualityUpdateflooringTypesInput = {
  push?: InputMaybe<Array<FlooringType>>
  set?: InputMaybe<Array<FlooringType>>
}

export type PropertyQualityUpsertInput = {
  set: PropertyQualityCreateInput
  update: PropertyQualityUpdateInput
}

export type PropertyQualityWhereInput = {
  AND?: InputMaybe<Array<PropertyQualityWhereInput>>
  NOT?: InputMaybe<Array<PropertyQualityWhereInput>>
  OR?: InputMaybe<Array<PropertyQualityWhereInput>>
  bathroomQuality?: InputMaybe<EnumBathroomQualityNullableFilter>
  condition?: InputMaybe<EnumPropertyConditionNullableFilter>
  flooringTypes?: InputMaybe<EnumFlooringTypeNullableListFilter>
  hasBuiltInStorage?: InputMaybe<BoolNullableFilter>
  hasEnsuiteBathroom?: InputMaybe<BoolNullableFilter>
  hasWalkInCloset?: InputMaybe<BoolNullableFilter>
  kitchenQuality?: InputMaybe<EnumKitchenQualityNullableFilter>
  lastRenovationYear?: InputMaybe<IntNullableFilter>
  maintenanceHistory?: InputMaybe<EnumMaintenanceHistoryNullableFilter>
  renovationQuality?: InputMaybe<EnumRenovationQualityNullableFilter>
  structuralIssues?: InputMaybe<BoolNullableFilter>
}

export type PropertyRelationFilter = {
  is?: InputMaybe<PropertyWhereInput>
  isNot?: InputMaybe<PropertyWhereInput>
}

export type PropertyReport = {
  __typename?: 'PropertyReport'
  createdAt: Scalars['DateTimeISO']['output']
  description?: Maybe<Scalars['String']['output']>
  email: Scalars['String']['output']
  id: Scalars['String']['output']
  property: Property
  propertyId: Scalars['String']['output']
  reportReason: ReportReason
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type PropertyReportCreateManyPropertyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  reportReason: ReportReason
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyReportCreateManyPropertyInputEnvelope = {
  data: Array<PropertyReportCreateManyPropertyInput>
}

export type PropertyReportCreateNestedManyWithoutPropertyInput = {
  connect?: InputMaybe<Array<PropertyReportWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyReportCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<PropertyReportCreateWithoutPropertyInput>>
  createMany?: InputMaybe<PropertyReportCreateManyPropertyInputEnvelope>
}

export type PropertyReportCreateOrConnectWithoutPropertyInput = {
  create: PropertyReportCreateWithoutPropertyInput
  where: PropertyReportWhereUniqueInput
}

export type PropertyReportCreateWithoutPropertyInput = {
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  reportReason: ReportReason
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyReportListRelationFilter = {
  every?: InputMaybe<PropertyReportWhereInput>
  none?: InputMaybe<PropertyReportWhereInput>
  some?: InputMaybe<PropertyReportWhereInput>
}

export type PropertyReportOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyReportOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  email?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  reportReason?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export enum PropertyReportScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  Email = 'email',
  Id = 'id',
  PropertyId = 'propertyId',
  ReportReason = 'reportReason',
  Status = 'status',
  UpdatedAt = 'updatedAt',
}

export type PropertyReportScalarWhereInput = {
  AND?: InputMaybe<Array<PropertyReportScalarWhereInput>>
  NOT?: InputMaybe<Array<PropertyReportScalarWhereInput>>
  OR?: InputMaybe<Array<PropertyReportScalarWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  propertyId?: InputMaybe<StringFilter>
  reportReason?: InputMaybe<EnumReportReasonFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyReportUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  email?: InputMaybe<StringFieldUpdateOperationsInput>
  reportReason?: InputMaybe<EnumReportReasonFieldUpdateOperationsInput>
  status?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type PropertyReportUpdateManyWithWhereWithoutPropertyInput = {
  data: PropertyReportUpdateManyMutationInput
  where: PropertyReportScalarWhereInput
}

export type PropertyReportUpdateManyWithoutPropertyNestedInput = {
  connect?: InputMaybe<Array<PropertyReportWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyReportCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<PropertyReportCreateWithoutPropertyInput>>
  createMany?: InputMaybe<PropertyReportCreateManyPropertyInputEnvelope>
  delete?: InputMaybe<Array<PropertyReportWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyReportScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyReportWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyReportWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyReportUpdateWithWhereUniqueWithoutPropertyInput>>
  updateMany?: InputMaybe<Array<PropertyReportUpdateManyWithWhereWithoutPropertyInput>>
  upsert?: InputMaybe<Array<PropertyReportUpsertWithWhereUniqueWithoutPropertyInput>>
}

export type PropertyReportUpdateWithWhereUniqueWithoutPropertyInput = {
  data: PropertyReportUpdateWithoutPropertyInput
  where: PropertyReportWhereUniqueInput
}

export type PropertyReportUpdateWithoutPropertyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  email?: InputMaybe<StringFieldUpdateOperationsInput>
  reportReason?: InputMaybe<EnumReportReasonFieldUpdateOperationsInput>
  status?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type PropertyReportUpsertWithWhereUniqueWithoutPropertyInput = {
  create: PropertyReportCreateWithoutPropertyInput
  update: PropertyReportUpdateWithoutPropertyInput
  where: PropertyReportWhereUniqueInput
}

export type PropertyReportWhereInput = {
  AND?: InputMaybe<Array<PropertyReportWhereInput>>
  NOT?: InputMaybe<Array<PropertyReportWhereInput>>
  OR?: InputMaybe<Array<PropertyReportWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  reportReason?: InputMaybe<EnumReportReasonFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyReportWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyReportWhereInput>>
  NOT?: InputMaybe<Array<PropertyReportWhereInput>>
  OR?: InputMaybe<Array<PropertyReportWhereInput>>
  createdAt?: InputMaybe<DateTimeFilter>
  description?: InputMaybe<StringNullableFilter>
  email?: InputMaybe<StringFilter>
  id?: InputMaybe<Scalars['String']['input']>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  reportReason?: InputMaybe<EnumReportReasonFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export enum PropertyScalarFieldEnum {
  AgencyRef = 'agencyRef',
  Baths = 'baths',
  Beds = 'beds',
  BrokerId = 'brokerId',
  BrokerIds = 'brokerIds',
  BrokerPropertyPriority = 'brokerPropertyPriority',
  BuiltYear = 'builtYear',
  Category = 'category',
  CompletionDate = 'completionDate',
  ConstructionYear = 'constructionYear',
  Country = 'country',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  Date = 'date',
  Decree218 = 'decree218',
  DistrictTileEnrichedAt = 'districtTileEnrichedAt',
  DistrictTileName = 'districtTileName',
  DraftComment = 'draftComment',
  DraftStatus = 'draftStatus',
  ExternalId = 'externalId',
  ExternalUpdatedAt = 'externalUpdatedAt',
  FeatureIds = 'featureIds',
  FreeHold = 'freeHold',
  GpsX = 'gpsX',
  GpsY = 'gpsY',
  HasGarden = 'hasGarden',
  HasParking = 'hasParking',
  HasPool = 'hasPool',
  Id = 'id',
  ImportedAt = 'importedAt',
  ImportedFrom = 'importedFrom',
  IsNewDevelopment = 'isNewDevelopment',
  IsPublished = 'isPublished',
  LastCheckedAt = 'lastCheckedAt',
  LeaseHold = 'leaseHold',
  Levels = 'levels',
  LocationArea = 'locationArea',
  LocationDetail = 'locationDetail',
  LocationDistrict = 'locationDistrict',
  LocationId = 'locationId',
  LocationIsApproximated = 'locationIsApproximated',
  LocationNeighbourhood = 'locationNeighbourhood',
  MaxBaths = 'maxBaths',
  MaxBeds = 'maxBeds',
  MinBaths = 'minBaths',
  MinBeds = 'minBeds',
  MunicipalityId = 'municipalityId',
  NewDevName = 'newDevName',
  OriginalPrice = 'originalPrice',
  OwnProperty = 'ownProperty',
  Price = 'price',
  PriceTo = 'priceTo',
  PropertyAlias = 'propertyAlias',
  PropertyTypeId = 'propertyTypeId',
  PropertyTypeIds = 'propertyTypeIds',
  ProspectPdfError = 'prospectPdfError',
  ProspectPdfGeneratedAt = 'prospectPdfGeneratedAt',
  ProspectPdfStatus = 'prospectPdfStatus',
  ProspectPdfUrl = 'prospectPdfUrl',
  ProvinceId = 'provinceId',
  RefId = 'refId',
  RenovationDescription = 'renovationDescription',
  RenovationYear = 'renovationYear',
  RentalLicenseRef = 'rentalLicenseRef',
  Slug = 'slug',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  VideoTour = 'videoTour',
  VirtualTour = 'virtualTour',
  VirtualTourUrl = 'virtualTourUrl',
  WillFinishAtDate = 'willFinishAtDate',
}

export type PropertyScalarWhereInput = {
  AND?: InputMaybe<Array<PropertyScalarWhereInput>>
  NOT?: InputMaybe<Array<PropertyScalarWhereInput>>
  OR?: InputMaybe<Array<PropertyScalarWhereInput>>
  agencyRef?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  brokerPropertyPriority?: InputMaybe<IntNullableFilter>
  builtYear?: InputMaybe<StringNullableFilter>
  category?: InputMaybe<StringNullableFilter>
  completionDate?: InputMaybe<DateTimeNullableFilter>
  constructionYear?: InputMaybe<DateTimeNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  date?: InputMaybe<DateTimeNullableFilter>
  decree218?: InputMaybe<IntNullableFilter>
  districtTileEnrichedAt?: InputMaybe<DateTimeNullableFilter>
  districtTileName?: InputMaybe<StringNullableFilter>
  draftComment?: InputMaybe<StringNullableFilter>
  draftStatus?: InputMaybe<EnumDraftStatusNullableFilter>
  externalId?: InputMaybe<StringFilter>
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  freeHold?: InputMaybe<BoolNullableFilter>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  hasGarden?: InputMaybe<BoolNullableFilter>
  hasParking?: InputMaybe<BoolNullableFilter>
  hasPool?: InputMaybe<BoolNullableFilter>
  id?: InputMaybe<StringFilter>
  importedAt?: InputMaybe<DateTimeNullableFilter>
  importedFrom?: InputMaybe<StringNullableFilter>
  isNewDevelopment?: InputMaybe<BoolFilter>
  isPublished?: InputMaybe<BoolNullableFilter>
  lastCheckedAt?: InputMaybe<DateTimeNullableFilter>
  leaseHold?: InputMaybe<BoolNullableFilter>
  levels?: InputMaybe<IntNullableFilter>
  locationArea?: InputMaybe<StringNullableFilter>
  locationDetail?: InputMaybe<StringNullableFilter>
  locationDistrict?: InputMaybe<StringNullableFilter>
  locationId?: InputMaybe<StringNullableFilter>
  locationIsApproximated?: InputMaybe<BoolNullableFilter>
  locationNeighbourhood?: InputMaybe<StringNullableFilter>
  maxBaths?: InputMaybe<IntNullableFilter>
  maxBeds?: InputMaybe<IntNullableFilter>
  minBaths?: InputMaybe<IntNullableFilter>
  minBeds?: InputMaybe<IntNullableFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  newDevName?: InputMaybe<StringNullableFilter>
  originalPrice?: InputMaybe<IntNullableFilter>
  ownProperty?: InputMaybe<BoolFilter>
  price?: InputMaybe<IntNullableFilter>
  priceTo?: InputMaybe<IntNullableFilter>
  propertyAlias?: InputMaybe<StringNullableFilter>
  propertyTypeId?: InputMaybe<StringNullableFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  prospectPdfError?: InputMaybe<StringNullableFilter>
  prospectPdfGeneratedAt?: InputMaybe<DateTimeNullableFilter>
  prospectPdfStatus?: InputMaybe<StringNullableFilter>
  prospectPdfUrl?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  refId?: InputMaybe<StringNullableFilter>
  renovationDescription?: InputMaybe<StringNullableFilter>
  renovationYear?: InputMaybe<DateTimeNullableFilter>
  rentalLicenseRef?: InputMaybe<StringNullableFilter>
  slug?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  videoTour?: InputMaybe<StringNullableFilter>
  virtualTour?: InputMaybe<StringNullableFilter>
  virtualTourUrl?: InputMaybe<StringNullableFilter>
  willFinishAtDate?: InputMaybe<DateTimeNullableFilter>
}

export type PropertySearchCardGql = {
  __typename?: 'PropertySearchCardGql'
  area?: Maybe<Scalars['String']['output']>
  baths?: Maybe<Scalars['Float']['output']>
  beds?: Maybe<Scalars['Float']['output']>
  builtM2?: Maybe<Scalars['Float']['output']>
  currency?: Maybe<Scalars['String']['output']>
  externalId?: Maybe<Scalars['String']['output']>
  featureLabels: Array<Scalars['String']['output']>
  municipalityName?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  priceTo?: Maybe<Scalars['Float']['output']>
  propertyId: Scalars['String']['output']
  provinceName?: Maybe<Scalars['String']['output']>
  publicPath?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  semanticScore?: Maybe<Scalars['Float']['output']>
  shortDescription?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  thumbnailUrl?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type PropertySearchCardLiteGql = {
  __typename?: 'PropertySearchCardLiteGql'
  municipalityName?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  propertyId: Scalars['String']['output']
  publicPath?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  semanticScore?: Maybe<Scalars['Float']['output']>
  shortDescription?: Maybe<Scalars['String']['output']>
  slug?: Maybe<Scalars['String']['output']>
  title: Scalars['String']['output']
}

export type PropertySearchDebugInfoGql = {
  __typename?: 'PropertySearchDebugInfoGql'
  candidateIdsConsidered?: Maybe<Scalars['Float']['output']>
  cardsLoadedFromDb?: Maybe<Scalars['Float']['output']>
  embeddingDimensions?: Maybe<Scalars['Float']['output']>
  note?: Maybe<Scalars['String']['output']>
  path: Scalars['String']['output']
  pineconeMatchCount?: Maybe<Scalars['Float']['output']>
  pineconeTopPropertyIds?: Maybe<Array<Scalars['String']['output']>>
  vectorSearchConfigured?: Maybe<Scalars['Boolean']['output']>
}

export type PropertySearchFiltersInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  districtNames?: InputMaybe<Array<Scalars['String']['input']>>
  maxPrice?: InputMaybe<Scalars['Float']['input']>
  minBaths?: InputMaybe<Scalars['Float']['input']>
  minBeds?: InputMaybe<Scalars['Float']['input']>
  minPrice?: InputMaybe<Scalars['Float']['input']>
  municipalityNames?: InputMaybe<Array<Scalars['String']['input']>>
  mustHavePool?: InputMaybe<Scalars['Boolean']['input']>
  propertyTypes?: InputMaybe<Array<Scalars['String']['input']>>
}

export type PropertySearchResponseGql = {
  __typename?: 'PropertySearchResponseGql'
  debug?: Maybe<PropertySearchDebugInfoGql>
  results: Array<PropertySearchCardGql>
  usedSemanticSearch: Scalars['Boolean']['output']
}

export type PropertyStats = {
  __typename?: 'PropertyStats'
  avgFetchesPerProperty: Scalars['Int']['output']
  dailyStats: Array<DailyFetchStats>
  totalFetchedTimes: Scalars['Int']['output']
  totalProperties: Scalars['Int']['output']
  totalUniqueVisitors: Scalars['Int']['output']
}

export type PropertyStatsData = {
  __typename?: 'PropertyStatsData'
  averageVisitorsPerProperty?: Maybe<Scalars['Float']['output']>
  totalFetchedTimes: Scalars['Float']['output']
  totalProperties: Scalars['Float']['output']
  totalUniqueVisitors: Scalars['Float']['output']
}

export type PropertySumAggregate = {
  __typename?: 'PropertySumAggregate'
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  brokerPropertyPriority?: Maybe<Scalars['Int']['output']>
  decree218?: Maybe<Scalars['Int']['output']>
  levels?: Maybe<Scalars['Int']['output']>
  maxBaths?: Maybe<Scalars['Int']['output']>
  maxBeds?: Maybe<Scalars['Int']['output']>
  minBaths?: Maybe<Scalars['Int']['output']>
  minBeds?: Maybe<Scalars['Int']['output']>
  originalPrice?: Maybe<Scalars['Int']['output']>
  price?: Maybe<Scalars['Int']['output']>
  priceTo?: Maybe<Scalars['Int']['output']>
}

export type PropertyTitle = {
  __typename?: 'PropertyTitle'
  language: Scalars['String']['output']
  title?: Maybe<Scalars['String']['output']>
}

export type PropertyTitleCreateInput = {
  language: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export type PropertyTitleObjectEqualityInput = {
  language: Scalars['String']['input']
  title?: InputMaybe<Scalars['String']['input']>
}

export type PropertyTitleOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyType = {
  __typename?: 'PropertyType'
  Brokers: Array<Broker>
  _count?: Maybe<PropertyTypeCount>
  brokerIds: Array<Scalars['String']['output']>
  externalId: Scalars['String']['output']
  id: Scalars['String']['output']
  language: Scalars['String']['output']
  mainProperties: Array<Property>
  mainType?: Maybe<Scalars['String']['output']>
  properties: Array<Property>
  propertyIds: Array<Scalars['String']['output']>
  subType?: Maybe<Scalars['String']['output']>
  translation?: Maybe<Scalars['String']['output']>
  translations: Array<PropertyTypeTranslation>
}

export type PropertyTypeBrokersArgs = {
  cursor?: InputMaybe<BrokerWhereUniqueInput>
  distinct?: InputMaybe<Array<BrokerScalarFieldEnum>>
  orderBy?: InputMaybe<Array<BrokerOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyTypeMainPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyTypePropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyTypeCount = {
  __typename?: 'PropertyTypeCount'
  Brokers: Scalars['Int']['output']
  mainProperties: Scalars['Int']['output']
  properties: Scalars['Int']['output']
}

export type PropertyTypeCountBrokersArgs = {
  where?: InputMaybe<BrokerWhereInput>
}

export type PropertyTypeCountMainPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyTypeCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyTypeCreateNestedManyWithoutBrokersInput = {
  connect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyTypeCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<PropertyTypeCreateWithoutBrokersInput>>
}

export type PropertyTypeCreateNestedManyWithoutPropertiesInput = {
  connect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyTypeCreateOrConnectWithoutPropertiesInput>>
  create?: InputMaybe<Array<PropertyTypeCreateWithoutPropertiesInput>>
}

export type PropertyTypeCreateNestedOneWithoutMainPropertiesInput = {
  connect?: InputMaybe<PropertyTypeWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyTypeCreateOrConnectWithoutMainPropertiesInput>
  create?: InputMaybe<PropertyTypeCreateWithoutMainPropertiesInput>
}

export type PropertyTypeCreateOrConnectWithoutBrokersInput = {
  create: PropertyTypeCreateWithoutBrokersInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeCreateOrConnectWithoutMainPropertiesInput = {
  create: PropertyTypeCreateWithoutMainPropertiesInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeCreateOrConnectWithoutPropertiesInput = {
  create: PropertyTypeCreateWithoutPropertiesInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeCreateWithoutBrokersInput = {
  externalId: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
  mainProperties?: InputMaybe<PropertyCreateNestedManyWithoutPropertyTypeInput>
  mainType?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutPropertyTypesInput>
  subType?: InputMaybe<Scalars['String']['input']>
  translation?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeCreateWithoutMainPropertiesInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutPropertyTypeOptionsInput>
  externalId: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
  mainType?: InputMaybe<Scalars['String']['input']>
  properties?: InputMaybe<PropertyCreateNestedManyWithoutPropertyTypesInput>
  subType?: InputMaybe<Scalars['String']['input']>
  translation?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeCreateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerCreateNestedManyWithoutPropertyTypeOptionsInput>
  externalId: Scalars['String']['input']
  id?: InputMaybe<Scalars['String']['input']>
  language: Scalars['String']['input']
  mainProperties?: InputMaybe<PropertyCreateNestedManyWithoutPropertyTypeInput>
  mainType?: InputMaybe<Scalars['String']['input']>
  subType?: InputMaybe<Scalars['String']['input']>
  translation?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeListRelationFilter = {
  every?: InputMaybe<PropertyTypeWhereInput>
  none?: InputMaybe<PropertyTypeWhereInput>
  some?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyTypeMainTypeSubTypeLanguageExternalIdCompoundUniqueInput = {
  externalId: Scalars['String']['input']
  language: Scalars['String']['input']
  mainType: Scalars['String']['input']
  subType: Scalars['String']['input']
}

export type PropertyTypeNullableRelationFilter = {
  is?: InputMaybe<PropertyTypeWhereInput>
  isNot?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyTypeOrderByWithRelationInput = {
  Brokers?: InputMaybe<BrokerOrderByRelationAggregateInput>
  brokerIds?: InputMaybe<SortOrder>
  externalId?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  language?: InputMaybe<SortOrder>
  mainProperties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  mainType?: InputMaybe<SortOrder>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
  propertyIds?: InputMaybe<SortOrder>
  subType?: InputMaybe<SortOrder>
  translation?: InputMaybe<SortOrder>
  translations?: InputMaybe<PropertyTypeTranslationOrderByCompositeAggregateInput>
}

export enum PropertyTypeScalarFieldEnum {
  BrokerIds = 'brokerIds',
  ExternalId = 'externalId',
  Id = 'id',
  Language = 'language',
  MainType = 'mainType',
  PropertyIds = 'propertyIds',
  SubType = 'subType',
  Translation = 'translation',
}

export type PropertyTypeScalarWhereInput = {
  AND?: InputMaybe<Array<PropertyTypeScalarWhereInput>>
  NOT?: InputMaybe<Array<PropertyTypeScalarWhereInput>>
  OR?: InputMaybe<Array<PropertyTypeScalarWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  externalId?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  language?: InputMaybe<StringFilter>
  mainType?: InputMaybe<StringNullableFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  subType?: InputMaybe<StringNullableFilter>
  translation?: InputMaybe<StringNullableFilter>
}

export type PropertyTypeTranslation = {
  __typename?: 'PropertyTypeTranslation'
  language: Scalars['String']['output']
  mainType: Scalars['String']['output']
  subType?: Maybe<Scalars['String']['output']>
}

export type PropertyTypeTranslationCreateInput = {
  language: Scalars['String']['input']
  mainType: Scalars['String']['input']
  subType?: InputMaybe<Scalars['String']['input']>
}

export type PropertyTypeTranslationObjectEqualityInput = {
  language: Scalars['String']['input']
  mainType: Scalars['String']['input']
  subType?: InputMaybe<Scalars['String']['input']>
}

export type PropertyTypeTranslationOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type PropertyTypeUpdateManyMutationInput = {
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  mainType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeUpdateManyWithWhereWithoutBrokersInput = {
  data: PropertyTypeUpdateManyMutationInput
  where: PropertyTypeScalarWhereInput
}

export type PropertyTypeUpdateManyWithWhereWithoutPropertiesInput = {
  data: PropertyTypeUpdateManyMutationInput
  where: PropertyTypeScalarWhereInput
}

export type PropertyTypeUpdateManyWithoutBrokersNestedInput = {
  connect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyTypeCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<PropertyTypeCreateWithoutBrokersInput>>
  delete?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyTypeScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyTypeUpdateWithWhereUniqueWithoutBrokersInput>>
  updateMany?: InputMaybe<Array<PropertyTypeUpdateManyWithWhereWithoutBrokersInput>>
  upsert?: InputMaybe<Array<PropertyTypeUpsertWithWhereUniqueWithoutBrokersInput>>
}

export type PropertyTypeUpdateManyWithoutPropertiesNestedInput = {
  connect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyTypeCreateOrConnectWithoutPropertiesInput>>
  create?: InputMaybe<Array<PropertyTypeCreateWithoutPropertiesInput>>
  delete?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyTypeScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyTypeWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyTypeUpdateWithWhereUniqueWithoutPropertiesInput>>
  updateMany?: InputMaybe<Array<PropertyTypeUpdateManyWithWhereWithoutPropertiesInput>>
  upsert?: InputMaybe<Array<PropertyTypeUpsertWithWhereUniqueWithoutPropertiesInput>>
}

export type PropertyTypeUpdateOneWithoutMainPropertiesNestedInput = {
  connect?: InputMaybe<PropertyTypeWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyTypeCreateOrConnectWithoutMainPropertiesInput>
  create?: InputMaybe<PropertyTypeCreateWithoutMainPropertiesInput>
  delete?: InputMaybe<PropertyTypeWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<PropertyTypeUpdateToOneWithWhereWithoutMainPropertiesInput>
  upsert?: InputMaybe<PropertyTypeUpsertWithoutMainPropertiesInput>
}

export type PropertyTypeUpdateToOneWithWhereWithoutMainPropertiesInput = {
  data: PropertyTypeUpdateWithoutMainPropertiesInput
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyTypeUpdateWithWhereUniqueWithoutBrokersInput = {
  data: PropertyTypeUpdateWithoutBrokersInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeUpdateWithWhereUniqueWithoutPropertiesInput = {
  data: PropertyTypeUpdateWithoutPropertiesInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeUpdateWithoutBrokersInput = {
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  mainProperties?: InputMaybe<PropertyUpdateManyWithoutPropertyTypeNestedInput>
  mainType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutPropertyTypesNestedInput>
  subType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeUpdateWithoutMainPropertiesInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutPropertyTypeOptionsNestedInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  mainType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutPropertyTypesNestedInput>
  subType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeUpdateWithoutPropertiesInput = {
  Brokers?: InputMaybe<BrokerUpdateManyWithoutPropertyTypeOptionsNestedInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  language?: InputMaybe<StringFieldUpdateOperationsInput>
  mainProperties?: InputMaybe<PropertyUpdateManyWithoutPropertyTypeNestedInput>
  mainType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  subType?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translation?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  translations?: InputMaybe<Array<PropertyTypeTranslationCreateInput>>
}

export type PropertyTypeUpsertWithWhereUniqueWithoutBrokersInput = {
  create: PropertyTypeCreateWithoutBrokersInput
  update: PropertyTypeUpdateWithoutBrokersInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeUpsertWithWhereUniqueWithoutPropertiesInput = {
  create: PropertyTypeCreateWithoutPropertiesInput
  update: PropertyTypeUpdateWithoutPropertiesInput
  where: PropertyTypeWhereUniqueInput
}

export type PropertyTypeUpsertWithoutMainPropertiesInput = {
  create: PropertyTypeCreateWithoutMainPropertiesInput
  update: PropertyTypeUpdateWithoutMainPropertiesInput
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type PropertyTypeWhereInput = {
  AND?: InputMaybe<Array<PropertyTypeWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<PropertyTypeWhereInput>>
  OR?: InputMaybe<Array<PropertyTypeWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  externalId?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  language?: InputMaybe<StringFilter>
  mainProperties?: InputMaybe<PropertyListRelationFilter>
  mainType?: InputMaybe<StringNullableFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  subType?: InputMaybe<StringNullableFilter>
  translation?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<PropertyTypeTranslationObjectEqualityInput>>
}

export type PropertyTypeWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyTypeWhereInput>>
  Brokers?: InputMaybe<BrokerListRelationFilter>
  NOT?: InputMaybe<Array<PropertyTypeWhereInput>>
  OR?: InputMaybe<Array<PropertyTypeWhereInput>>
  brokerIds?: InputMaybe<StringNullableListFilter>
  externalId?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<StringFilter>
  mainProperties?: InputMaybe<PropertyListRelationFilter>
  mainType?: InputMaybe<StringNullableFilter>
  mainType_subType_language_externalId?: InputMaybe<PropertyTypeMainTypeSubTypeLanguageExternalIdCompoundUniqueInput>
  properties?: InputMaybe<PropertyListRelationFilter>
  propertyIds?: InputMaybe<StringNullableListFilter>
  subType?: InputMaybe<StringNullableFilter>
  translation?: InputMaybe<StringNullableFilter>
  translations?: InputMaybe<Array<PropertyTypeTranslationObjectEqualityInput>>
}

export type PropertyUpdateInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateManyMutationInput = {
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateManyWithWhereWithoutBrokerInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutBrokersInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutFeaturesInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutLocationInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutLocationMunicipalityInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutLocationProvinceInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutPropertyTypeInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithWhereWithoutPropertyTypesInput = {
  data: PropertyUpdateManyMutationInput
  where: PropertyScalarWhereInput
}

export type PropertyUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutBrokerInput>>
  createMany?: InputMaybe<PropertyCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type PropertyUpdateManyWithoutBrokersNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutBrokersInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutBrokersInput>>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutBrokersInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutBrokersInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutBrokersInput>>
}

export type PropertyUpdateManyWithoutFeaturesNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutFeaturesInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutFeaturesInput>>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutFeaturesInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutFeaturesInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutFeaturesInput>>
}

export type PropertyUpdateManyWithoutLocationMunicipalityNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationMunicipalityInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationMunicipalityInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationMunicipalityInputEnvelope>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutLocationMunicipalityInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutLocationMunicipalityInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutLocationMunicipalityInput>>
}

export type PropertyUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationInputEnvelope>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutLocationInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutLocationInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutLocationInput>>
}

export type PropertyUpdateManyWithoutLocationProvinceNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutLocationProvinceInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutLocationProvinceInput>>
  createMany?: InputMaybe<PropertyCreateManyLocationProvinceInputEnvelope>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutLocationProvinceInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutLocationProvinceInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutLocationProvinceInput>>
}

export type PropertyUpdateManyWithoutPropertyTypeNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutPropertyTypeInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutPropertyTypeInput>>
  createMany?: InputMaybe<PropertyCreateManyPropertyTypeInputEnvelope>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutPropertyTypeInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutPropertyTypeInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutPropertyTypeInput>>
}

export type PropertyUpdateManyWithoutPropertyTypesNestedInput = {
  connect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<PropertyCreateOrConnectWithoutPropertyTypesInput>>
  create?: InputMaybe<Array<PropertyCreateWithoutPropertyTypesInput>>
  delete?: InputMaybe<Array<PropertyWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<PropertyScalarWhereInput>>
  disconnect?: InputMaybe<Array<PropertyWhereUniqueInput>>
  set?: InputMaybe<Array<PropertyWhereUniqueInput>>
  update?: InputMaybe<Array<PropertyUpdateWithWhereUniqueWithoutPropertyTypesInput>>
  updateMany?: InputMaybe<Array<PropertyUpdateManyWithWhereWithoutPropertyTypesInput>>
  upsert?: InputMaybe<Array<PropertyUpsertWithWhereUniqueWithoutPropertyTypesInput>>
}

export type PropertyUpdateOneWithoutAgencyHistoryNestedInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutAgencyHistoryInput>
  create?: InputMaybe<PropertyCreateWithoutAgencyHistoryInput>
  delete?: InputMaybe<PropertyWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<PropertyUpdateToOneWithWhereWithoutAgencyHistoryInput>
  upsert?: InputMaybe<PropertyUpsertWithoutAgencyHistoryInput>
}

export type PropertyUpdateOneWithoutLeadsNestedInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutLeadsInput>
  create?: InputMaybe<PropertyCreateWithoutLeadsInput>
  delete?: InputMaybe<PropertyWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<PropertyUpdateToOneWithWhereWithoutLeadsInput>
  upsert?: InputMaybe<PropertyUpsertWithoutLeadsInput>
}

export type PropertyUpdateOneWithoutPaidExtrasNestedInput = {
  connect?: InputMaybe<PropertyWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyCreateOrConnectWithoutPaidExtrasInput>
  create?: InputMaybe<PropertyCreateWithoutPaidExtrasInput>
  delete?: InputMaybe<PropertyWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<PropertyUpdateToOneWithWhereWithoutPaidExtrasInput>
  upsert?: InputMaybe<PropertyUpsertWithoutPaidExtrasInput>
}

export type PropertyUpdateToOneWithWhereWithoutAgencyHistoryInput = {
  data: PropertyUpdateWithoutAgencyHistoryInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyUpdateToOneWithWhereWithoutLeadsInput = {
  data: PropertyUpdateWithoutLeadsInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyUpdateToOneWithWhereWithoutPaidExtrasInput = {
  data: PropertyUpdateWithoutPaidExtrasInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyUpdateWithWhereUniqueWithoutBrokerInput = {
  data: PropertyUpdateWithoutBrokerInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutBrokersInput = {
  data: PropertyUpdateWithoutBrokersInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutFeaturesInput = {
  data: PropertyUpdateWithoutFeaturesInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutLocationInput = {
  data: PropertyUpdateWithoutLocationInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutLocationMunicipalityInput = {
  data: PropertyUpdateWithoutLocationMunicipalityInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutLocationProvinceInput = {
  data: PropertyUpdateWithoutLocationProvinceInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutPropertyTypeInput = {
  data: PropertyUpdateWithoutPropertyTypeInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithWhereUniqueWithoutPropertyTypesInput = {
  data: PropertyUpdateWithoutPropertyTypesInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpdateWithoutAgencyHistoryInput = {
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutBrokerInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutBrokersInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutFeaturesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutLeadsInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutLocationInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutLocationMunicipalityInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutLocationProvinceInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutPaidExtrasInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutPropertyTypeInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyTypes?: InputMaybe<PropertyTypeUpdateManyWithoutPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpdateWithoutPropertyTypesInput = {
  agencyHistory?: InputMaybe<AgencyHistoryUpdateManyWithoutPropertyNestedInput>
  agencyRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  baths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  beds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneWithoutPropertiesNestedInput>
  brokerPropertyPriority?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  brokers?: InputMaybe<BrokerUpdateManyWithoutSharedPropertiesNestedInput>
  builtYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  category?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  completionDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  constructionYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  date?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  decree218?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  descriptions?: InputMaybe<Array<DescriptionCreateInput>>
  districtTileEnrichedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  districtTileName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftComment?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  draftStatus?: InputMaybe<NullableEnumDraftStatusFieldUpdateOperationsInput>
  energyRating?: InputMaybe<EnergyRatingNullableUpdateEnvelopeInput>
  externalId?: InputMaybe<StringFieldUpdateOperationsInput>
  externalUpdatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  features?: InputMaybe<FeatureUpdateManyWithoutPropertiesNestedInput>
  fees?: InputMaybe<FeesNullableUpdateEnvelopeInput>
  freeHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  gpsX?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  gpsY?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  hasGarden?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasParking?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  hasPool?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  images?: InputMaybe<ImagesUpdateOneWithoutPropertyNestedInput>
  imagesAI?: InputMaybe<ImagesAiUpdateOneWithoutPropertyNestedInput>
  importedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  importedFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isNewDevelopment?: InputMaybe<BoolFieldUpdateOperationsInput>
  isPublished?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastCheckedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leads?: InputMaybe<LeadUpdateManyWithoutPropertyNestedInput>
  leaseHold?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  levels?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  location?: InputMaybe<LocationUpdateOneWithoutPropertiesNestedInput>
  locationArea?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDetail?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationDistrict?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationGeoCode?: InputMaybe<LocationGeoCodeUpdateOneWithoutPropertyNestedInput>
  locationIsApproximated?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  locationMunicipality?: InputMaybe<MunicipalityUpdateOneWithoutPropertiesNestedInput>
  locationNeighbourhood?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  locationProvince?: InputMaybe<ProvinceUpdateOneWithoutPropertiesNestedInput>
  maxBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBaths?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minBeds?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  newDevName?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  originalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  ownProperty?: InputMaybe<BoolFieldUpdateOperationsInput>
  paidExtras?: InputMaybe<PaidExtraUpdateManyWithoutPropertyNestedInput>
  price?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  priceHistory?: InputMaybe<Array<PriceHistoryCreateInput>>
  priceTo?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  propertyAlias?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  propertyMeta?: InputMaybe<PropertyMetaUpdateOneWithoutPropertyNestedInput>
  propertyQuality?: InputMaybe<PropertyQualityNullableUpdateEnvelopeInput>
  propertyReports?: InputMaybe<PropertyReportUpdateManyWithoutPropertyNestedInput>
  propertyTitle?: InputMaybe<Array<PropertyTitleCreateInput>>
  propertyType?: InputMaybe<PropertyTypeUpdateOneWithoutMainPropertiesNestedInput>
  prospectPdfError?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfGeneratedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  prospectPdfStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  prospectPdfUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  refId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  renovationYear?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  rentalLicenseRef?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rentalProperties?: InputMaybe<RentalPropertiesNullableUpdateEnvelopeInput>
  slug?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  status?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  statusHistory?: InputMaybe<Array<StatusHistoryCreateInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableUpdateEnvelopeInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput>
  videoTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  videos?: InputMaybe<VideoUpdateManyWithoutPropertyNestedInput>
  virtualTour?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  virtualTourUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  willFinishAtDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
}

export type PropertyUpsertWithWhereUniqueWithoutBrokerInput = {
  create: PropertyCreateWithoutBrokerInput
  update: PropertyUpdateWithoutBrokerInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutBrokersInput = {
  create: PropertyCreateWithoutBrokersInput
  update: PropertyUpdateWithoutBrokersInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutFeaturesInput = {
  create: PropertyCreateWithoutFeaturesInput
  update: PropertyUpdateWithoutFeaturesInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutLocationInput = {
  create: PropertyCreateWithoutLocationInput
  update: PropertyUpdateWithoutLocationInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutLocationMunicipalityInput = {
  create: PropertyCreateWithoutLocationMunicipalityInput
  update: PropertyUpdateWithoutLocationMunicipalityInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutLocationProvinceInput = {
  create: PropertyCreateWithoutLocationProvinceInput
  update: PropertyUpdateWithoutLocationProvinceInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutPropertyTypeInput = {
  create: PropertyCreateWithoutPropertyTypeInput
  update: PropertyUpdateWithoutPropertyTypeInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithWhereUniqueWithoutPropertyTypesInput = {
  create: PropertyCreateWithoutPropertyTypesInput
  update: PropertyUpdateWithoutPropertyTypesInput
  where: PropertyWhereUniqueInput
}

export type PropertyUpsertWithoutAgencyHistoryInput = {
  create: PropertyCreateWithoutAgencyHistoryInput
  update: PropertyUpdateWithoutAgencyHistoryInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyUpsertWithoutLeadsInput = {
  create: PropertyCreateWithoutLeadsInput
  update: PropertyUpdateWithoutLeadsInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyUpsertWithoutPaidExtrasInput = {
  create: PropertyCreateWithoutPaidExtrasInput
  update: PropertyUpdateWithoutPaidExtrasInput
  where?: InputMaybe<PropertyWhereInput>
}

export type PropertyValuationEstimate = {
  __typename?: 'PropertyValuationEstimate'
  confidenceScore?: Maybe<Scalars['Float']['output']>
  contributions?: Maybe<Scalars['JSON']['output']>
  createdAt: Scalars['DateTimeISO']['output']
  error?: Maybe<Scalars['String']['output']>
  evaluatedAt: Scalars['DateTimeISO']['output']
  factors?: Maybe<Scalars['JSON']['output']>
  id: Scalars['String']['output']
  inputs?: Maybe<Scalars['JSON']['output']>
  modelVersion?: Maybe<Scalars['String']['output']>
  predictedPrice: Scalars['Float']['output']
  priceRangeHigh?: Maybe<Scalars['Float']['output']>
  priceRangeLow?: Maybe<Scalars['Float']['output']>
  propertyId: Scalars['String']['output']
  rangeMethod?: Maybe<Scalars['String']['output']>
  rawResult?: Maybe<Scalars['JSON']['output']>
  reliability?: Maybe<Scalars['String']['output']>
  reliabilityReason?: Maybe<Scalars['String']['output']>
  source: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
}

export type PropertyValuationEstimateCreateNestedOneWithoutPropertyInput = {
  connect?: InputMaybe<PropertyValuationEstimateWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyValuationEstimateCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<PropertyValuationEstimateCreateWithoutPropertyInput>
}

export type PropertyValuationEstimateCreateOrConnectWithoutPropertyInput = {
  create: PropertyValuationEstimateCreateWithoutPropertyInput
  where: PropertyValuationEstimateWhereUniqueInput
}

export type PropertyValuationEstimateCreateWithoutPropertyInput = {
  confidenceScore?: InputMaybe<Scalars['Float']['input']>
  contributions?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  error?: InputMaybe<Scalars['String']['input']>
  evaluatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  factors?: InputMaybe<Scalars['JSON']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  inputs?: InputMaybe<Scalars['JSON']['input']>
  modelVersion?: InputMaybe<Scalars['String']['input']>
  predictedPrice: Scalars['Float']['input']
  priceRangeHigh?: InputMaybe<Scalars['Float']['input']>
  priceRangeLow?: InputMaybe<Scalars['Float']['input']>
  rangeMethod?: InputMaybe<Scalars['String']['input']>
  rawResult?: InputMaybe<Scalars['JSON']['input']>
  reliability?: InputMaybe<Scalars['String']['input']>
  reliabilityReason?: InputMaybe<Scalars['String']['input']>
  source?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
}

export type PropertyValuationEstimateNullableRelationFilter = {
  is?: InputMaybe<PropertyValuationEstimateWhereInput>
  isNot?: InputMaybe<PropertyValuationEstimateWhereInput>
}

export type PropertyValuationEstimateOrderByWithRelationInput = {
  confidenceScore?: InputMaybe<SortOrder>
  contributions?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  error?: InputMaybe<SortOrder>
  evaluatedAt?: InputMaybe<SortOrder>
  factors?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  inputs?: InputMaybe<SortOrder>
  modelVersion?: InputMaybe<SortOrder>
  predictedPrice?: InputMaybe<SortOrder>
  priceRangeHigh?: InputMaybe<SortOrder>
  priceRangeLow?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  rangeMethod?: InputMaybe<SortOrder>
  rawResult?: InputMaybe<SortOrder>
  reliability?: InputMaybe<SortOrder>
  reliabilityReason?: InputMaybe<SortOrder>
  source?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
}

export type PropertyValuationEstimateUpdateOneWithoutPropertyNestedInput = {
  connect?: InputMaybe<PropertyValuationEstimateWhereUniqueInput>
  connectOrCreate?: InputMaybe<PropertyValuationEstimateCreateOrConnectWithoutPropertyInput>
  create?: InputMaybe<PropertyValuationEstimateCreateWithoutPropertyInput>
  delete?: InputMaybe<PropertyValuationEstimateWhereInput>
  disconnect?: InputMaybe<PropertyValuationEstimateWhereInput>
  update?: InputMaybe<PropertyValuationEstimateUpdateToOneWithWhereWithoutPropertyInput>
  upsert?: InputMaybe<PropertyValuationEstimateUpsertWithoutPropertyInput>
}

export type PropertyValuationEstimateUpdateToOneWithWhereWithoutPropertyInput = {
  data: PropertyValuationEstimateUpdateWithoutPropertyInput
  where?: InputMaybe<PropertyValuationEstimateWhereInput>
}

export type PropertyValuationEstimateUpdateWithoutPropertyInput = {
  confidenceScore?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  contributions?: InputMaybe<Scalars['JSON']['input']>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  error?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  evaluatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  factors?: InputMaybe<Scalars['JSON']['input']>
  inputs?: InputMaybe<Scalars['JSON']['input']>
  modelVersion?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  predictedPrice?: InputMaybe<FloatFieldUpdateOperationsInput>
  priceRangeHigh?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  priceRangeLow?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  rangeMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  rawResult?: InputMaybe<Scalars['JSON']['input']>
  reliability?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  reliabilityReason?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  source?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
}

export type PropertyValuationEstimateUpsertWithoutPropertyInput = {
  create: PropertyValuationEstimateCreateWithoutPropertyInput
  update: PropertyValuationEstimateUpdateWithoutPropertyInput
  where?: InputMaybe<PropertyValuationEstimateWhereInput>
}

export type PropertyValuationEstimateWhereInput = {
  AND?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  NOT?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  OR?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  confidenceScore?: InputMaybe<FloatNullableFilter>
  contributions?: InputMaybe<JsonNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  error?: InputMaybe<StringNullableFilter>
  evaluatedAt?: InputMaybe<DateTimeFilter>
  factors?: InputMaybe<JsonNullableFilter>
  id?: InputMaybe<StringFilter>
  inputs?: InputMaybe<JsonNullableFilter>
  modelVersion?: InputMaybe<StringNullableFilter>
  predictedPrice?: InputMaybe<FloatFilter>
  priceRangeHigh?: InputMaybe<FloatNullableFilter>
  priceRangeLow?: InputMaybe<FloatNullableFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  rangeMethod?: InputMaybe<StringNullableFilter>
  rawResult?: InputMaybe<JsonNullableFilter>
  reliability?: InputMaybe<StringNullableFilter>
  reliabilityReason?: InputMaybe<StringNullableFilter>
  source?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyValuationEstimateWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  NOT?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  OR?: InputMaybe<Array<PropertyValuationEstimateWhereInput>>
  confidenceScore?: InputMaybe<FloatNullableFilter>
  contributions?: InputMaybe<JsonNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  error?: InputMaybe<StringNullableFilter>
  evaluatedAt?: InputMaybe<DateTimeFilter>
  factors?: InputMaybe<JsonNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  inputs?: InputMaybe<JsonNullableFilter>
  modelVersion?: InputMaybe<StringNullableFilter>
  predictedPrice?: InputMaybe<FloatFilter>
  priceRangeHigh?: InputMaybe<FloatNullableFilter>
  priceRangeLow?: InputMaybe<FloatNullableFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
  rangeMethod?: InputMaybe<StringNullableFilter>
  rawResult?: InputMaybe<JsonNullableFilter>
  reliability?: InputMaybe<StringNullableFilter>
  reliabilityReason?: InputMaybe<StringNullableFilter>
  source?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
}

export type PropertyValuationResultGql = {
  __typename?: 'PropertyValuationResultGql'
  baselinePrice: Scalars['Float']['output']
  calibrationVersion?: Maybe<Scalars['String']['output']>
  confidenceScore?: Maybe<Scalars['Float']['output']>
  contributions: Array<ValuationContributionGql>
  logPredictionClipped: Scalars['Boolean']['output']
  modelScopeSummary?: Maybe<Scalars['String']['output']>
  predictedPrice: Scalars['Float']['output']
  predictedPriceRaw?: Maybe<Scalars['Float']['output']>
  priceRangeHigh?: Maybe<Scalars['Float']['output']>
  priceRangeLow?: Maybe<Scalars['Float']['output']>
  priceUncalibratedClippedExp?: Maybe<Scalars['Float']['output']>
  rangeMethod?: Maybe<Scalars['String']['output']>
  reliability: Scalars['String']['output']
  reliabilityReason?: Maybe<Scalars['String']['output']>
  shapNote?: Maybe<Scalars['String']['output']>
  similarProperties: Array<Scalars['JSON']['output']>
}

export type PropertyWhereInput = {
  AND?: InputMaybe<Array<PropertyWhereInput>>
  NOT?: InputMaybe<Array<PropertyWhereInput>>
  OR?: InputMaybe<Array<PropertyWhereInput>>
  agencyHistory?: InputMaybe<AgencyHistoryListRelationFilter>
  agencyRef?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  brokerPropertyPriority?: InputMaybe<IntNullableFilter>
  brokers?: InputMaybe<BrokerListRelationFilter>
  builtYear?: InputMaybe<StringNullableFilter>
  category?: InputMaybe<StringNullableFilter>
  completionDate?: InputMaybe<DateTimeNullableFilter>
  constructionYear?: InputMaybe<DateTimeNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  date?: InputMaybe<DateTimeNullableFilter>
  decree218?: InputMaybe<IntNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  districtTileEnrichedAt?: InputMaybe<DateTimeNullableFilter>
  districtTileName?: InputMaybe<StringNullableFilter>
  draftComment?: InputMaybe<StringNullableFilter>
  draftStatus?: InputMaybe<EnumDraftStatusNullableFilter>
  energyRating?: InputMaybe<EnergyRatingNullableCompositeFilter>
  externalId?: InputMaybe<StringFilter>
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  features?: InputMaybe<FeatureListRelationFilter>
  fees?: InputMaybe<FeesNullableCompositeFilter>
  freeHold?: InputMaybe<BoolNullableFilter>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  hasGarden?: InputMaybe<BoolNullableFilter>
  hasParking?: InputMaybe<BoolNullableFilter>
  hasPool?: InputMaybe<BoolNullableFilter>
  id?: InputMaybe<StringFilter>
  images?: InputMaybe<ImagesNullableRelationFilter>
  imagesAI?: InputMaybe<ImagesAiNullableRelationFilter>
  importedAt?: InputMaybe<DateTimeNullableFilter>
  importedFrom?: InputMaybe<StringNullableFilter>
  isNewDevelopment?: InputMaybe<BoolFilter>
  isPublished?: InputMaybe<BoolNullableFilter>
  lastCheckedAt?: InputMaybe<DateTimeNullableFilter>
  leads?: InputMaybe<LeadListRelationFilter>
  leaseHold?: InputMaybe<BoolNullableFilter>
  levels?: InputMaybe<IntNullableFilter>
  location?: InputMaybe<LocationNullableRelationFilter>
  locationArea?: InputMaybe<StringNullableFilter>
  locationDetail?: InputMaybe<StringNullableFilter>
  locationDistrict?: InputMaybe<StringNullableFilter>
  locationGeoCode?: InputMaybe<LocationGeoCodeNullableRelationFilter>
  locationId?: InputMaybe<StringNullableFilter>
  locationIsApproximated?: InputMaybe<BoolNullableFilter>
  locationMunicipality?: InputMaybe<MunicipalityNullableRelationFilter>
  locationNeighbourhood?: InputMaybe<StringNullableFilter>
  locationProvince?: InputMaybe<ProvinceNullableRelationFilter>
  maxBaths?: InputMaybe<IntNullableFilter>
  maxBeds?: InputMaybe<IntNullableFilter>
  minBaths?: InputMaybe<IntNullableFilter>
  minBeds?: InputMaybe<IntNullableFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  newDevName?: InputMaybe<StringNullableFilter>
  originalPrice?: InputMaybe<IntNullableFilter>
  ownProperty?: InputMaybe<BoolFilter>
  paidExtras?: InputMaybe<PaidExtraListRelationFilter>
  price?: InputMaybe<IntNullableFilter>
  priceHistory?: InputMaybe<Array<PriceHistoryObjectEqualityInput>>
  priceTo?: InputMaybe<IntNullableFilter>
  propertyAlias?: InputMaybe<StringNullableFilter>
  propertyMeta?: InputMaybe<PropertyMetaNullableRelationFilter>
  propertyQuality?: InputMaybe<PropertyQualityNullableCompositeFilter>
  propertyReports?: InputMaybe<PropertyReportListRelationFilter>
  propertyTitle?: InputMaybe<Array<PropertyTitleObjectEqualityInput>>
  propertyType?: InputMaybe<PropertyTypeNullableRelationFilter>
  propertyTypeId?: InputMaybe<StringNullableFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  propertyTypes?: InputMaybe<PropertyTypeListRelationFilter>
  prospectPdfError?: InputMaybe<StringNullableFilter>
  prospectPdfGeneratedAt?: InputMaybe<DateTimeNullableFilter>
  prospectPdfStatus?: InputMaybe<StringNullableFilter>
  prospectPdfUrl?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  refId?: InputMaybe<StringNullableFilter>
  renovationDescription?: InputMaybe<StringNullableFilter>
  renovationYear?: InputMaybe<DateTimeNullableFilter>
  rentalLicenseRef?: InputMaybe<StringNullableFilter>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCompositeFilter>
  slug?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  statusHistory?: InputMaybe<Array<StatusHistoryObjectEqualityInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCompositeFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateNullableRelationFilter>
  videoTour?: InputMaybe<StringNullableFilter>
  videos?: InputMaybe<VideoListRelationFilter>
  virtualTour?: InputMaybe<StringNullableFilter>
  virtualTourUrl?: InputMaybe<StringNullableFilter>
  willFinishAtDate?: InputMaybe<DateTimeNullableFilter>
}

export type PropertyWhereUniqueInput = {
  AND?: InputMaybe<Array<PropertyWhereInput>>
  NOT?: InputMaybe<Array<PropertyWhereInput>>
  OR?: InputMaybe<Array<PropertyWhereInput>>
  agencyHistory?: InputMaybe<AgencyHistoryListRelationFilter>
  agencyRef?: InputMaybe<StringNullableFilter>
  baths?: InputMaybe<IntNullableFilter>
  beds?: InputMaybe<IntNullableFilter>
  broker?: InputMaybe<BrokerNullableRelationFilter>
  brokerId?: InputMaybe<StringNullableFilter>
  brokerIds?: InputMaybe<StringNullableListFilter>
  brokerPropertyPriority?: InputMaybe<IntNullableFilter>
  brokers?: InputMaybe<BrokerListRelationFilter>
  builtYear?: InputMaybe<StringNullableFilter>
  category?: InputMaybe<StringNullableFilter>
  completionDate?: InputMaybe<DateTimeNullableFilter>
  constructionYear?: InputMaybe<DateTimeNullableFilter>
  country?: InputMaybe<StringNullableFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringNullableFilter>
  date?: InputMaybe<DateTimeNullableFilter>
  decree218?: InputMaybe<IntNullableFilter>
  descriptions?: InputMaybe<Array<DescriptionObjectEqualityInput>>
  districtTileEnrichedAt?: InputMaybe<DateTimeNullableFilter>
  districtTileName?: InputMaybe<StringNullableFilter>
  draftComment?: InputMaybe<StringNullableFilter>
  draftStatus?: InputMaybe<EnumDraftStatusNullableFilter>
  energyRating?: InputMaybe<EnergyRatingNullableCompositeFilter>
  externalId?: InputMaybe<Scalars['String']['input']>
  externalUpdatedAt?: InputMaybe<DateTimeNullableFilter>
  featureIds?: InputMaybe<StringNullableListFilter>
  features?: InputMaybe<FeatureListRelationFilter>
  fees?: InputMaybe<FeesNullableCompositeFilter>
  freeHold?: InputMaybe<BoolNullableFilter>
  gpsX?: InputMaybe<StringNullableFilter>
  gpsY?: InputMaybe<StringNullableFilter>
  hasGarden?: InputMaybe<BoolNullableFilter>
  hasParking?: InputMaybe<BoolNullableFilter>
  hasPool?: InputMaybe<BoolNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  images?: InputMaybe<ImagesNullableRelationFilter>
  imagesAI?: InputMaybe<ImagesAiNullableRelationFilter>
  importedAt?: InputMaybe<DateTimeNullableFilter>
  importedFrom?: InputMaybe<StringNullableFilter>
  isNewDevelopment?: InputMaybe<BoolFilter>
  isPublished?: InputMaybe<BoolNullableFilter>
  lastCheckedAt?: InputMaybe<DateTimeNullableFilter>
  leads?: InputMaybe<LeadListRelationFilter>
  leaseHold?: InputMaybe<BoolNullableFilter>
  levels?: InputMaybe<IntNullableFilter>
  location?: InputMaybe<LocationNullableRelationFilter>
  locationArea?: InputMaybe<StringNullableFilter>
  locationDetail?: InputMaybe<StringNullableFilter>
  locationDistrict?: InputMaybe<StringNullableFilter>
  locationGeoCode?: InputMaybe<LocationGeoCodeNullableRelationFilter>
  locationId?: InputMaybe<StringNullableFilter>
  locationIsApproximated?: InputMaybe<BoolNullableFilter>
  locationMunicipality?: InputMaybe<MunicipalityNullableRelationFilter>
  locationNeighbourhood?: InputMaybe<StringNullableFilter>
  locationProvince?: InputMaybe<ProvinceNullableRelationFilter>
  maxBaths?: InputMaybe<IntNullableFilter>
  maxBeds?: InputMaybe<IntNullableFilter>
  minBaths?: InputMaybe<IntNullableFilter>
  minBeds?: InputMaybe<IntNullableFilter>
  municipalityId?: InputMaybe<StringNullableFilter>
  newDevName?: InputMaybe<StringNullableFilter>
  originalPrice?: InputMaybe<IntNullableFilter>
  ownProperty?: InputMaybe<BoolFilter>
  paidExtras?: InputMaybe<PaidExtraListRelationFilter>
  price?: InputMaybe<IntNullableFilter>
  priceHistory?: InputMaybe<Array<PriceHistoryObjectEqualityInput>>
  priceTo?: InputMaybe<IntNullableFilter>
  propertyAlias?: InputMaybe<StringNullableFilter>
  propertyMeta?: InputMaybe<PropertyMetaNullableRelationFilter>
  propertyQuality?: InputMaybe<PropertyQualityNullableCompositeFilter>
  propertyReports?: InputMaybe<PropertyReportListRelationFilter>
  propertyTitle?: InputMaybe<Array<PropertyTitleObjectEqualityInput>>
  propertyType?: InputMaybe<PropertyTypeNullableRelationFilter>
  propertyTypeId?: InputMaybe<StringNullableFilter>
  propertyTypeIds?: InputMaybe<StringNullableListFilter>
  propertyTypes?: InputMaybe<PropertyTypeListRelationFilter>
  prospectPdfError?: InputMaybe<StringNullableFilter>
  prospectPdfGeneratedAt?: InputMaybe<DateTimeNullableFilter>
  prospectPdfStatus?: InputMaybe<StringNullableFilter>
  prospectPdfUrl?: InputMaybe<StringNullableFilter>
  provinceId?: InputMaybe<StringNullableFilter>
  refId?: InputMaybe<StringNullableFilter>
  renovationDescription?: InputMaybe<StringNullableFilter>
  renovationYear?: InputMaybe<DateTimeNullableFilter>
  rentalLicenseRef?: InputMaybe<StringNullableFilter>
  rentalProperties?: InputMaybe<RentalPropertiesNullableCompositeFilter>
  slug?: InputMaybe<StringNullableFilter>
  status?: InputMaybe<StringNullableFilter>
  statusHistory?: InputMaybe<Array<StatusHistoryObjectEqualityInput>>
  surfaceArea?: InputMaybe<SurfaceAreaNullableCompositeFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  valuationEstimate?: InputMaybe<PropertyValuationEstimateNullableRelationFilter>
  videoTour?: InputMaybe<StringNullableFilter>
  videos?: InputMaybe<VideoListRelationFilter>
  virtualTour?: InputMaybe<StringNullableFilter>
  virtualTourUrl?: InputMaybe<StringNullableFilter>
  willFinishAtDate?: InputMaybe<DateTimeNullableFilter>
}

export type Province = {
  __typename?: 'Province'
  _count?: Maybe<ProvinceCount>
  code: Scalars['Int']['output']
  id: Scalars['String']['output']
  mapboxId?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  normalizedName: Scalars['String']['output']
}

export type ProvinceBboxResponse = {
  __typename?: 'ProvinceBboxResponse'
  maxLat: Scalars['Float']['output']
  maxLng: Scalars['Float']['output']
  minLat: Scalars['Float']['output']
  minLng: Scalars['Float']['output']
  provinceName: Scalars['String']['output']
}

export type ProvinceCount = {
  __typename?: 'ProvinceCount'
  locations: Scalars['Int']['output']
  properties: Scalars['Int']['output']
}

export type ProvinceCountLocationsArgs = {
  where?: InputMaybe<LocationWhereInput>
}

export type ProvinceCountPropertiesArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type ProvinceCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<ProvinceWhereUniqueInput>
  connectOrCreate?: InputMaybe<ProvinceCreateOrConnectWithoutLocationsInput>
  create?: InputMaybe<ProvinceCreateWithoutLocationsInput>
}

export type ProvinceCreateNestedOneWithoutPropertiesInput = {
  connect?: InputMaybe<ProvinceWhereUniqueInput>
  connectOrCreate?: InputMaybe<ProvinceCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<ProvinceCreateWithoutPropertiesInput>
}

export type ProvinceCreateOrConnectWithoutLocationsInput = {
  create: ProvinceCreateWithoutLocationsInput
  where: ProvinceWhereUniqueInput
}

export type ProvinceCreateOrConnectWithoutPropertiesInput = {
  create: ProvinceCreateWithoutPropertiesInput
  where: ProvinceWhereUniqueInput
}

export type ProvinceCreateWithoutLocationsInput = {
  code: Scalars['Int']['input']
  id?: InputMaybe<Scalars['String']['input']>
  mapboxId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  normalizedName: Scalars['String']['input']
  properties?: InputMaybe<PropertyCreateNestedManyWithoutLocationProvinceInput>
}

export type ProvinceCreateWithoutPropertiesInput = {
  code: Scalars['Int']['input']
  id?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<LocationCreateNestedManyWithoutProvinceInput>
  mapboxId?: InputMaybe<Scalars['String']['input']>
  name: Scalars['String']['input']
  normalizedName: Scalars['String']['input']
}

export type ProvinceNullableRelationFilter = {
  is?: InputMaybe<ProvinceWhereInput>
  isNot?: InputMaybe<ProvinceWhereInput>
}

export type ProvinceOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>
  mapboxId?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  normalizedName?: InputMaybe<SortOrder>
  properties?: InputMaybe<PropertyOrderByRelationAggregateInput>
}

export type ProvinceUpdateOneWithoutLocationsNestedInput = {
  connect?: InputMaybe<ProvinceWhereUniqueInput>
  connectOrCreate?: InputMaybe<ProvinceCreateOrConnectWithoutLocationsInput>
  create?: InputMaybe<ProvinceCreateWithoutLocationsInput>
  delete?: InputMaybe<ProvinceWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<ProvinceUpdateToOneWithWhereWithoutLocationsInput>
  upsert?: InputMaybe<ProvinceUpsertWithoutLocationsInput>
}

export type ProvinceUpdateOneWithoutPropertiesNestedInput = {
  connect?: InputMaybe<ProvinceWhereUniqueInput>
  connectOrCreate?: InputMaybe<ProvinceCreateOrConnectWithoutPropertiesInput>
  create?: InputMaybe<ProvinceCreateWithoutPropertiesInput>
  delete?: InputMaybe<ProvinceWhereInput>
  disconnect?: InputMaybe<Scalars['Boolean']['input']>
  update?: InputMaybe<ProvinceUpdateToOneWithWhereWithoutPropertiesInput>
  upsert?: InputMaybe<ProvinceUpsertWithoutPropertiesInput>
}

export type ProvinceUpdateToOneWithWhereWithoutLocationsInput = {
  data: ProvinceUpdateWithoutLocationsInput
  where?: InputMaybe<ProvinceWhereInput>
}

export type ProvinceUpdateToOneWithWhereWithoutPropertiesInput = {
  data: ProvinceUpdateWithoutPropertiesInput
  where?: InputMaybe<ProvinceWhereInput>
}

export type ProvinceUpdateWithoutLocationsInput = {
  code?: InputMaybe<IntFieldUpdateOperationsInput>
  mapboxId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  normalizedName?: InputMaybe<StringFieldUpdateOperationsInput>
  properties?: InputMaybe<PropertyUpdateManyWithoutLocationProvinceNestedInput>
}

export type ProvinceUpdateWithoutPropertiesInput = {
  code?: InputMaybe<IntFieldUpdateOperationsInput>
  locations?: InputMaybe<LocationUpdateManyWithoutProvinceNestedInput>
  mapboxId?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  normalizedName?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type ProvinceUpsertWithoutLocationsInput = {
  create: ProvinceCreateWithoutLocationsInput
  update: ProvinceUpdateWithoutLocationsInput
  where?: InputMaybe<ProvinceWhereInput>
}

export type ProvinceUpsertWithoutPropertiesInput = {
  create: ProvinceCreateWithoutPropertiesInput
  update: ProvinceUpdateWithoutPropertiesInput
  where?: InputMaybe<ProvinceWhereInput>
}

export type ProvinceWhereInput = {
  AND?: InputMaybe<Array<ProvinceWhereInput>>
  NOT?: InputMaybe<Array<ProvinceWhereInput>>
  OR?: InputMaybe<Array<ProvinceWhereInput>>
  code?: InputMaybe<IntFilter>
  id?: InputMaybe<StringFilter>
  locations?: InputMaybe<LocationListRelationFilter>
  mapboxId?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  normalizedName?: InputMaybe<StringFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
}

export type ProvinceWhereUniqueInput = {
  AND?: InputMaybe<Array<ProvinceWhereInput>>
  NOT?: InputMaybe<Array<ProvinceWhereInput>>
  OR?: InputMaybe<Array<ProvinceWhereInput>>
  code?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  locations?: InputMaybe<LocationListRelationFilter>
  mapboxId?: InputMaybe<StringNullableFilter>
  name?: InputMaybe<StringFilter>
  normalizedName?: InputMaybe<StringFilter>
  properties?: InputMaybe<PropertyListRelationFilter>
}

export type Query = {
  __typename?: 'Query'
  activeSubscriptions: Array<Subscription>
  adminMe?: Maybe<AdminUserModel>
  /** Get a single advertiser by ID */
  advertiser?: Maybe<Advertiser>
  agency?: Maybe<Broker>
  agencyHistoryFeed: Array<AgencyHistoryFeedEntry>
  agencyListingStatsDual: AgencyListingStatsDual
  agencyPortalApplicationSettings?: Maybe<AgencyPortalApplicationSettings>
  agencyPortalApplicationSettingsList: Array<AgencyPortalApplicationSettings>
  agencyStats: AgencyStatsModel
  agencyUsers: Array<AgencyUserModel>
  agentByEmail?: Maybe<AgentModel>
  agentMe?: Maybe<AgentModel>
  aggregateAvailablePaidExtras: AggregateAvailablePaidExtras
  aggregateLead: AggregateLead
  aggregateLocation: AggregateLocation
  aggregateMunicipality: AggregateMunicipality
  aggregateProperty: AggregateProperty
  aggregateSubscription: AggregateSubscription
  /** Get all advertisers for admin management */
  allAdvertisers: Array<Advertiser>
  /** Get all property card ads for admin management */
  allPropertyCardAds: Array<PropertyCardAd>
  availablePaidExtra?: Maybe<AvailablePaidExtras>
  availablePaidExtras: Array<AvailablePaidExtras>
  availablePaidExtrasWithUsage: Array<AvailablePaidExtrasWithUsage>
  brokerFrontendRealEstateSettings: BrokerFrontendRealEstateSettingsOutput
  /** Load broker lead contact from Mautic (by agency brokerLeadContactMauticId) for admin UI confirmation. */
  brokerLeadContactMauticPreview: BrokerLeadContactMauticPreview
  /** Index broker site manifests from bost-broker-site-pipeline with optional live URL probes (SUPER_ADMIN only) */
  brokerSitesIndex: Array<BrokerSiteIndexEntry>
  brokersWithPaidExtras: Array<BrokerWithPaidExtras>
  cronJobStatusByProperty: Array<CronJobStatusItemModel>
  cronJobStatusList: Array<CronJobStatusItemModel>
  currentSessionHandle?: Maybe<Scalars['String']['output']>
  customerByEmail?: Maybe<CustomerModel>
  customerMe?: Maybe<CustomerModel>
  dashboardStats: DashboardStatsModel
  features: Array<Feature>
  fetchDuplicates: DuplicatesResponseModel
  findFirstAvailablePaidExtras?: Maybe<AvailablePaidExtras>
  findFirstAvailablePaidExtrasOrThrow?: Maybe<AvailablePaidExtras>
  findFirstBrokerOrThrow?: Maybe<Broker>
  findFirstLead?: Maybe<Lead>
  findFirstLeadOrThrow?: Maybe<Lead>
  findFirstMunicipality?: Maybe<Municipality>
  findFirstMunicipalityOrThrow?: Maybe<Municipality>
  findFirstPropertyOrThrow?: Maybe<Property>
  findFirstSubscription?: Maybe<Subscription>
  findFirstSubscriptionOrThrow?: Maybe<Subscription>
  findManyAvailablePaidExtras: Array<AvailablePaidExtras>
  findManyMapData: Array<MapData>
  findUniqueAvailablePaidExtras?: Maybe<AvailablePaidExtras>
  findUniqueAvailablePaidExtrasOrThrow?: Maybe<AvailablePaidExtras>
  geocodeSearch: ValidatedLocationResponse
  getAgencies?: Maybe<Array<Broker>>
  getAgency?: Maybe<Broker>
  getCustomerConversations: Scalars['String']['output']
  getCustomerHistory: Array<PropertyHistoryItem>
  getCustomerLeads: Array<CustomerLeadResponse>
  getCustomerProfile?: Maybe<CustomerModel>
  getCustomerStatistics: CustomerStats
  getLead?: Maybe<Lead>
  getNearbyFeatures: NearbyFeaturesResponse
  getNearbyProperties: NearbyPropertiesResponse
  getPermission?: Maybe<PermissionModel>
  getProvinceBboxByRegion?: Maybe<ProvinceBboxResponse>
  getRole?: Maybe<RoleModel>
  getRolePermissions: Array<PermissionModel>
  getSearchOrderConfig: SearchOrderConfigOutput
  getSubscription?: Maybe<Subscription>
  getUser?: Maybe<AdminUserModel>
  getUserFavorites: Array<Scalars['String']['output']>
  getUserStats?: Maybe<UserStatsModel>
  groupByAvailablePaidExtras: Array<AvailablePaidExtrasGroupBy>
  groupByLead: Array<LeadGroupBy>
  groupBySubscription: Array<SubscriptionGroupBy>
  hubMarketStats: HubMarketStats
  /** Fetch properties from Kyero feed for frontend property creation */
  kyeroProperties: Array<KyeroPropertyPreview>
  lead?: Maybe<Lead>
  /** Fetch a lead's most recent filled form from Mautic by contact (Mautic) ID. Returns form data as question-answer pairs. */
  leadMostRecentForm?: Maybe<MauticMostRecentForm>
  leads: Array<Lead>
  leadsOverTime: Array<LeadsOverTimeEntry>
  listAgents: Array<AgentModel>
  listAllAgents: Array<AgentModel>
  listAssets: ListAssetsResponseModel
  listBrokerFrontendRealEstateApplicationSettings: Array<BrokerFrontendRealEstateApplicationSettingRow>
  listPermissions: Array<PermissionModel>
  listRoles: Array<RoleModel>
  listUsers: PaginatedUsersResponse
  locations: Array<Location>
  lookupLocationDataByPosition: LocationDataResponse
  lookupMunicipalityByPosition: LookupMunicipalityResponse
  municipalities: Array<Municipality>
  paidExtrasByAgency: Array<PaidExtra>
  properties: Array<Property>
  /** Get a single property card ad by ID */
  propertyCardAd?: Maybe<PropertyCardAd>
  /** Get a page-ad by referer (href). If acceptLanguage is not "en", prefers matching language. */
  propertyCardAdByHref?: Maybe<PropertyCardAd>
  /** Fetch active property card ads, optionally filtered by location */
  propertyCardAds: Array<PropertyCardAdWithDistance>
  propertyCountByDistrictTileName: Array<DistrictPropertyCount>
  propertyCountByLocationArea: Array<DistrictPropertyCount>
  propertyCountByLocationNeighbourhood: Array<DistrictPropertyCount>
  propertyCountByNeighbourhoodLocation: Array<NeighbourhoodLocationPropertyCount>
  propertyImageEnrichmentStatus: PropertyImageEnrichmentStatus
  propertyImageRoomLabelOptions: Array<Scalars['String']['output']>
  propertyLocationCoverage: Array<PropertyLocationCoverageRow>
  propertyReports: Array<PropertyReport>
  propertyReportsCount: Scalars['Int']['output']
  propertyTypes: Array<PropertyType>
  /** Property sale price estimate (ML) with driver contributions and similar broker listings */
  propertyValuation: PropertyValuationResultGql
  publicPropertySearch: PropertySearchResponseGql
  /** Semantic search over properties and Strapi articles (Pinecone). */
  publicUnifiedContentSearch: UnifiedContentSearchResponseGql
  /** Live PropertyDetails proxy for broker sites (Redis-cached) by Resales reference id */
  resalesLiveProperty?: Maybe<ResalesLivePropertyPayloadGql>
  /** Live SearchProperties proxy for broker sites (Redis-cached). Provide native OR mapped filters. */
  resalesLiveSearch: ResalesLiveSearchPageGql
  /** Resales SearchLocations — dropdown options; `value` is sent as `resalesProperties.resalesLocation` (SearchProperties P_Location). */
  resalesLocationOptions: Array<ResalesLocationOption>
  /** Fetch properties from Resales API (one SearchProperties request per call; paginated). When onlyOwnProperties is true, uses Own_Listings search to avoid scanning all pages. */
  resalesProperties: ResalesPropertiesPage
  /** Fetch a single property from Resales PropertyDetails API (full feed data for preview modal). */
  resalesPropertyDetails?: Maybe<ResalesPropertyDetails>
  /** Resales SearchPropertyTypes — dropdown options; `value` is sent as `resalesProperties.resalesPropertyTypes` (SearchProperties P_PropertyTypes, comma-separated for multiple). */
  resalesPropertyTypeOptions: Array<ResalesPropertyTypeOption>
  /** Search large municipalities dataset by name/normalizedName/NAMEUNIT */
  searchLargeMunicipalities: Array<LargeMunicipality>
  /** Search leads via Mautic (name, email, etc.). Super admin only. Returns leads that exist in DB and match Mautic search. */
  searchLeads: Array<Lead>
  searchLocationsByQuery: ValidatedLocationResponse
  searchUsers: Array<AdminUserModel>
  stats: AgencyStats
  subscription?: Maybe<Subscription>
  /** Available subscription packages with default slot limits and pricing (SUPER_ADMIN) */
  subscriptionPackageOptions: Array<SubscriptionPackageOption>
  subscriptionSlotUsage?: Maybe<SubscriptionSlotUsage>
  subscriptions: Array<Subscription>
  translation: Array<Feature>
  unreadConversations: Array<Conversation>
  /** Valuation wizard blueprint (ML service /wizard-blueprint) */
  valuationWizardBlueprint: Scalars['JSON']['output']
}

export type QueryActiveSubscriptionsArgs = {
  agencyId?: InputMaybe<Scalars['String']['input']>
}

export type QueryAdvertiserArgs = {
  id: Scalars['String']['input']
}

export type QueryAgencyArgs = {
  id: Scalars['String']['input']
}

export type QueryAgencyHistoryFeedArgs = {
  agencyId?: InputMaybe<Scalars['String']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}

export type QueryAgencyListingStatsDualArgs = {
  agencyId?: InputMaybe<Scalars['String']['input']>
}

export type QueryAgencyPortalApplicationSettingsArgs = {
  where: AgencyPortalApplicationSettingsWhereUniqueInput
}

export type QueryAgencyPortalApplicationSettingsListArgs = {
  cursor?: InputMaybe<AgencyPortalApplicationSettingsWhereUniqueInput>
  distinct?: InputMaybe<Array<AgencyPortalApplicationSettingsScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AgencyPortalApplicationSettingsOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AgencyPortalApplicationSettingsWhereInput>
}

export type QueryAgencyStatsArgs = {
  agencyId: Scalars['String']['input']
}

export type QueryAgencyUsersArgs = {
  agencyId?: InputMaybe<Scalars['String']['input']>
}

export type QueryAgentByEmailArgs = {
  email: Scalars['String']['input']
}

export type QueryAggregateAvailablePaidExtrasArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryAggregateLeadArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type QueryAggregateLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LocationWhereInput>
}

export type QueryAggregateMunicipalityArgs = {
  cursor?: InputMaybe<MunicipalityWhereUniqueInput>
  orderBy?: InputMaybe<Array<MunicipalityOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MunicipalityWhereInput>
}

export type QueryAggregatePropertyArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryAggregateSubscriptionArgs = {
  cursor?: InputMaybe<SubscriptionWhereUniqueInput>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type QueryAvailablePaidExtraArgs = {
  where: AvailablePaidExtrasWhereUniqueInput
}

export type QueryAvailablePaidExtrasArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  distinct?: InputMaybe<Array<AvailablePaidExtrasScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryAvailablePaidExtrasWithUsageArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  distinct?: InputMaybe<Array<AvailablePaidExtrasScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryBrokerFrontendRealEstateSettingsArgs = {
  brokerId?: InputMaybe<Scalars['String']['input']>
}

export type QueryBrokerLeadContactMauticPreviewArgs = {
  brokerId: Scalars['String']['input']
}

export type QueryBrokerSitesIndexArgs = {
  checkReachability?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryCronJobStatusByPropertyArgs = {
  externalId: Scalars['String']['input']
}

export type QueryCronJobStatusListArgs = {
  jobType: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryCustomerByEmailArgs = {
  email: Scalars['String']['input']
}

export type QueryFeaturesArgs = {
  cursor?: InputMaybe<FeatureWhereUniqueInput>
  distinct?: InputMaybe<Array<FeatureScalarFieldEnum>>
  orderBy?: InputMaybe<Array<FeatureOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<FeatureWhereInput>
}

export type QueryFetchDuplicatesArgs = {
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>
  limit?: Scalars['Float']['input']
}

export type QueryFindFirstAvailablePaidExtrasArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  distinct?: InputMaybe<Array<AvailablePaidExtrasScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryFindFirstAvailablePaidExtrasOrThrowArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  distinct?: InputMaybe<Array<AvailablePaidExtrasScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryFindFirstBrokerOrThrowArgs = {
  cursor?: InputMaybe<BrokerWhereUniqueInput>
  distinct?: InputMaybe<Array<BrokerScalarFieldEnum>>
  orderBy?: InputMaybe<Array<BrokerOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<BrokerWhereInput>
}

export type QueryFindFirstLeadArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type QueryFindFirstLeadOrThrowArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type QueryFindFirstMunicipalityArgs = {
  cursor?: InputMaybe<MunicipalityWhereUniqueInput>
  distinct?: InputMaybe<Array<MunicipalityScalarFieldEnum>>
  orderBy?: InputMaybe<Array<MunicipalityOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MunicipalityWhereInput>
}

export type QueryFindFirstMunicipalityOrThrowArgs = {
  cursor?: InputMaybe<MunicipalityWhereUniqueInput>
  distinct?: InputMaybe<Array<MunicipalityScalarFieldEnum>>
  orderBy?: InputMaybe<Array<MunicipalityOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MunicipalityWhereInput>
}

export type QueryFindFirstPropertyOrThrowArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryFindFirstSubscriptionArgs = {
  cursor?: InputMaybe<SubscriptionWhereUniqueInput>
  distinct?: InputMaybe<Array<SubscriptionScalarFieldEnum>>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type QueryFindFirstSubscriptionOrThrowArgs = {
  cursor?: InputMaybe<SubscriptionWhereUniqueInput>
  distinct?: InputMaybe<Array<SubscriptionScalarFieldEnum>>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type QueryFindManyAvailablePaidExtrasArgs = {
  cursor?: InputMaybe<AvailablePaidExtrasWhereUniqueInput>
  distinct?: InputMaybe<Array<AvailablePaidExtrasScalarFieldEnum>>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryFindManyMapDataArgs = {
  cursor?: InputMaybe<MapDataWhereUniqueInput>
  distinct?: InputMaybe<Array<MapDataScalarFieldEnum>>
  orderBy?: InputMaybe<Array<MapDataOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MapDataWhereInput>
}

export type QueryFindUniqueAvailablePaidExtrasArgs = {
  where: AvailablePaidExtrasWhereUniqueInput
}

export type QueryFindUniqueAvailablePaidExtrasOrThrowArgs = {
  where: AvailablePaidExtrasWhereUniqueInput
}

export type QueryGeocodeSearchArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
  types?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetAgencyArgs = {
  id: Scalars['String']['input']
}

export type QueryGetCustomerConversationsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetCustomerHistoryArgs = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetCustomerLeadsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetCustomerProfileArgs = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetCustomerStatisticsArgs = {
  userId?: InputMaybe<Scalars['String']['input']>
}

export type QueryGetLeadArgs = {
  where: LeadWhereUniqueInput
}

export type QueryGetNearbyFeaturesArgs = {
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
  radius?: InputMaybe<Scalars['Float']['input']>
}

export type QueryGetNearbyPropertiesArgs = {
  area?: InputMaybe<Scalars['String']['input']>
  bbox?: InputMaybe<BoundingBoxInput>
  lat?: InputMaybe<Scalars['Float']['input']>
  lng?: InputMaybe<Scalars['Float']['input']>
  maxResults?: InputMaybe<Scalars['Int']['input']>
  municipality?: InputMaybe<Scalars['String']['input']>
  province?: InputMaybe<Scalars['String']['input']>
  radius?: InputMaybe<Scalars['Float']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryGetPermissionArgs = {
  permissionId: Scalars['String']['input']
}

export type QueryGetProvinceBboxByRegionArgs = {
  region: Scalars['String']['input']
}

export type QueryGetRoleArgs = {
  roleId: Scalars['String']['input']
}

export type QueryGetRolePermissionsArgs = {
  roleId: Scalars['String']['input']
}

export type QueryGetSubscriptionArgs = {
  where: SubscriptionWhereUniqueInput
}

export type QueryGetUserArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserFavoritesArgs = {
  userId: Scalars['String']['input']
}

export type QueryGetUserStatsArgs = {
  userId: Scalars['String']['input']
}

export type QueryGroupByAvailablePaidExtrasArgs = {
  by: Array<AvailablePaidExtrasScalarFieldEnum>
  having?: InputMaybe<AvailablePaidExtrasScalarWhereWithAggregatesInput>
  orderBy?: InputMaybe<Array<AvailablePaidExtrasOrderByWithAggregationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<AvailablePaidExtrasWhereInput>
}

export type QueryGroupByLeadArgs = {
  by: Array<LeadScalarFieldEnum>
  having?: InputMaybe<LeadScalarWhereWithAggregatesInput>
  orderBy?: InputMaybe<Array<LeadOrderByWithAggregationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type QueryGroupBySubscriptionArgs = {
  by: Array<SubscriptionScalarFieldEnum>
  having?: InputMaybe<SubscriptionScalarWhereWithAggregatesInput>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithAggregationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type QueryHubMarketStatsArgs = {
  where: PropertyWhereInput
}

export type QueryKyeroPropertiesArgs = {
  brokerId?: InputMaybe<Scalars['String']['input']>
  brokerName?: InputMaybe<Scalars['String']['input']>
  feedUrl?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  rentalsOnly?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryLeadArgs = {
  where: LeadWhereUniqueInput
}

export type QueryLeadMostRecentFormArgs = {
  contactId: Scalars['Int']['input']
}

export type QueryLeadsArgs = {
  cursor?: InputMaybe<LeadWhereUniqueInput>
  distinct?: InputMaybe<Array<LeadScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LeadWhereInput>
}

export type QueryLeadsOverTimeArgs = {
  days?: InputMaybe<Scalars['Int']['input']>
  from?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  to?: InputMaybe<Scalars['String']['input']>
}

export type QueryListAssetsArgs = {
  limit?: Scalars['Int']['input']
  token?: InputMaybe<Scalars['String']['input']>
  type?: AssetListType
}

export type QueryListUsersArgs = {
  filters?: InputMaybe<UserFilters>
  pagination?: InputMaybe<PaginationOptions>
  sort?: InputMaybe<SortOptions>
}

export type QueryLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<LocationWhereInput>
}

export type QueryLookupLocationDataByPositionArgs = {
  position: PositionInput
}

export type QueryLookupMunicipalityByPositionArgs = {
  position: PositionInput
}

export type QueryMunicipalitiesArgs = {
  cursor?: InputMaybe<MunicipalityWhereUniqueInput>
  distinct?: InputMaybe<Array<MunicipalityScalarFieldEnum>>
  orderBy?: InputMaybe<Array<MunicipalityOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<MunicipalityWhereInput>
}

export type QueryPaidExtrasByAgencyArgs = {
  brokerId: Scalars['String']['input']
}

export type QueryPropertiesArgs = {
  cursor?: InputMaybe<PropertyWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  useDiverseBrokersOrdering?: InputMaybe<Scalars['Boolean']['input']>
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyCardAdArgs = {
  id: Scalars['String']['input']
}

export type QueryPropertyCardAdByHrefArgs = {
  acceptLanguage?: InputMaybe<Scalars['String']['input']>
  href: Scalars['String']['input']
}

export type QueryPropertyCardAdsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  searchCoordinates?: InputMaybe<SearchCoordinatesInput>
}

export type QueryPropertyCountByDistrictTileNameArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyCountByLocationAreaArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyCountByLocationNeighbourhoodArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyCountByNeighbourhoodLocationArgs = {
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyImageEnrichmentStatusArgs = {
  propertyId: Scalars['String']['input']
}

export type QueryPropertyLocationCoverageArgs = {
  minCount?: Scalars['Int']['input']
  where?: InputMaybe<PropertyWhereInput>
}

export type QueryPropertyReportsArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>
  skip?: InputMaybe<Scalars['Float']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryPropertyReportsCountArgs = {
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryPropertyTypesArgs = {
  cursor?: InputMaybe<PropertyTypeWhereUniqueInput>
  distinct?: InputMaybe<Array<PropertyTypeScalarFieldEnum>>
  orderBy?: InputMaybe<Array<PropertyTypeOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<PropertyTypeWhereInput>
}

export type QueryPropertyValuationArgs = {
  featureParamNamesSelected?: InputMaybe<Array<Scalars['String']['input']>>
  inputs: Scalars['JSON']['input']
  kind?: InputMaybe<Scalars['String']['input']>
  similarTake?: InputMaybe<Scalars['Int']['input']>
}

export type QueryPublicPropertySearchArgs = {
  brokerId?: InputMaybe<Scalars['String']['input']>
  debug?: InputMaybe<Scalars['Boolean']['input']>
  filters?: InputMaybe<PropertySearchFiltersInput>
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  query?: InputMaybe<Scalars['String']['input']>
}

export type QueryPublicUnifiedContentSearchArgs = {
  brokerId?: InputMaybe<Scalars['String']['input']>
  language?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QueryResalesLivePropertyArgs = {
  lang?: InputMaybe<Scalars['Int']['input']>
  nativeParams?: InputMaybe<Array<ResalesQueryParamInput>>
  refId: Scalars['String']['input']
  skipCache?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryResalesLiveSearchArgs = {
  mapped?: InputMaybe<ResalesMappedSearchInput>
  native?: InputMaybe<ResalesSearchNativeInput>
  skipCache?: InputMaybe<Scalars['Boolean']['input']>
}

export type QueryResalesLocationOptionsArgs = {
  lang?: InputMaybe<Scalars['Float']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QueryResalesPropertiesArgs = {
  externalId?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  onlyOwnProperties?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Float']['input']>
  resalesLocation?: InputMaybe<Scalars['String']['input']>
  resalesPropertyTypes?: InputMaybe<Scalars['String']['input']>
  status?: InputMaybe<Scalars['String']['input']>
}

export type QueryResalesPropertyDetailsArgs = {
  externalId: Scalars['String']['input']
}

export type QueryResalesPropertyTypeOptionsArgs = {
  lang?: InputMaybe<Scalars['Float']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  search?: InputMaybe<Scalars['String']['input']>
}

export type QuerySearchLargeMunicipalitiesArgs = {
  limit?: InputMaybe<Scalars['Float']['input']>
  provinceCode?: InputMaybe<Scalars['String']['input']>
  query: Scalars['String']['input']
}

export type QuerySearchLeadsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  search: Scalars['String']['input']
}

export type QuerySearchLocationsByQueryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>
  query: Scalars['String']['input']
}

export type QuerySearchUsersArgs = {
  query: Scalars['String']['input']
}

export type QueryStatsArgs = {
  agencyId: Scalars['String']['input']
}

export type QuerySubscriptionArgs = {
  where: SubscriptionWhereUniqueInput
}

export type QuerySubscriptionSlotUsageArgs = {
  agencyId?: InputMaybe<Scalars['String']['input']>
}

export type QuerySubscriptionsArgs = {
  cursor?: InputMaybe<SubscriptionWhereUniqueInput>
  distinct?: InputMaybe<Array<SubscriptionScalarFieldEnum>>
  orderBy?: InputMaybe<Array<SubscriptionOrderByWithRelationInput>>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
  where?: InputMaybe<SubscriptionWhereInput>
}

export type QueryUnreadConversationsArgs = {
  brokerId?: InputMaybe<Scalars['String']['input']>
}

export type QueryValuationWizardBlueprintArgs = {
  kind?: InputMaybe<Scalars['String']['input']>
}

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive',
}

export type RecentActivityModel = {
  __typename?: 'RecentActivityModel'
  agencyId?: Maybe<Scalars['String']['output']>
  createdAt: Scalars['String']['output']
  description: Scalars['String']['output']
  id: Scalars['String']['output']
  type: Scalars['String']['output']
  userId?: Maybe<Scalars['String']['output']>
}

export type RegionAlternate = {
  __typename?: 'RegionAlternate'
  mapbox_id: Scalars['String']['output']
  name: Scalars['String']['output']
  region_code: Scalars['String']['output']
  region_code_full: Scalars['String']['output']
  wikidata_id?: Maybe<Scalars['String']['output']>
}

export type RegionAlternateCreateInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
  region_code: Scalars['String']['input']
  region_code_full: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type RegionAlternateNullableCompositeFilter = {
  equals?: InputMaybe<RegionAlternateObjectEqualityInput>
  is?: InputMaybe<RegionAlternateWhereInput>
  isNot?: InputMaybe<RegionAlternateWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type RegionAlternateNullableUpdateEnvelopeInput = {
  set?: InputMaybe<RegionAlternateCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<RegionAlternateUpsertInput>
}

export type RegionAlternateObjectEqualityInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
  region_code: Scalars['String']['input']
  region_code_full: Scalars['String']['input']
  wikidata_id?: InputMaybe<Scalars['String']['input']>
}

export type RegionAlternateOrderByInput = {
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  region_code?: InputMaybe<SortOrder>
  region_code_full?: InputMaybe<SortOrder>
  wikidata_id?: InputMaybe<SortOrder>
}

export type RegionAlternateUpdateInput = {
  mapbox_id?: InputMaybe<StringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
  region_code?: InputMaybe<StringFieldUpdateOperationsInput>
  region_code_full?: InputMaybe<StringFieldUpdateOperationsInput>
  wikidata_id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type RegionAlternateUpsertInput = {
  set: RegionAlternateCreateInput
  update: RegionAlternateUpdateInput
}

export type RegionAlternateWhereInput = {
  AND?: InputMaybe<Array<RegionAlternateWhereInput>>
  NOT?: InputMaybe<Array<RegionAlternateWhereInput>>
  OR?: InputMaybe<Array<RegionAlternateWhereInput>>
  mapbox_id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  region_code?: InputMaybe<StringFilter>
  region_code_full?: InputMaybe<StringFilter>
  wikidata_id?: InputMaybe<StringNullableFilter>
}

export type RemoveFavoriteInput = {
  propertyShortRef?: Scalars['String']['input']
}

export enum RenovationQuality {
  Basic = 'basic',
  HighEnd = 'high_end',
  Luxury = 'luxury',
  Standard = 'standard',
}

export type RentalPeriod = {
  __typename?: 'RentalPeriod'
  description?: Maybe<Scalars['String']['output']>
  duration?: Maybe<Scalars['Int']['output']>
  id?: Maybe<Scalars['String']['output']>
  multiplier?: Maybe<Scalars['Float']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type RentalPeriodCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  multiplier?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type RentalPeriodNullableCompositeFilter = {
  equals?: InputMaybe<RentalPeriodObjectEqualityInput>
  is?: InputMaybe<RentalPeriodWhereInput>
  isNot?: InputMaybe<RentalPeriodWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type RentalPeriodNullableUpdateEnvelopeInput = {
  set?: InputMaybe<RentalPeriodCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<RentalPeriodUpsertInput>
}

export type RentalPeriodObjectEqualityInput = {
  description?: InputMaybe<Scalars['String']['input']>
  duration?: InputMaybe<Scalars['Int']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  multiplier?: InputMaybe<Scalars['Float']['input']>
  name?: InputMaybe<Scalars['String']['input']>
}

export type RentalPeriodOrderByInput = {
  description?: InputMaybe<SortOrder>
  duration?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  multiplier?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export type RentalPeriodUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  id?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  multiplier?: InputMaybe<NullableFloatFieldUpdateOperationsInput>
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>
}

export type RentalPeriodUpsertInput = {
  set: RentalPeriodCreateInput
  update: RentalPeriodUpdateInput
}

export type RentalPeriodWhereInput = {
  AND?: InputMaybe<Array<RentalPeriodWhereInput>>
  NOT?: InputMaybe<Array<RentalPeriodWhereInput>>
  OR?: InputMaybe<Array<RentalPeriodWhereInput>>
  description?: InputMaybe<StringNullableFilter>
  duration?: InputMaybe<IntNullableFilter>
  id?: InputMaybe<StringNullableFilter>
  multiplier?: InputMaybe<FloatNullableFilter>
  name?: InputMaybe<StringNullableFilter>
}

export type RentalProperties = {
  __typename?: 'RentalProperties'
  availableFrom?: Maybe<Scalars['DateTimeISO']['output']>
  availableTo?: Maybe<Scalars['DateTimeISO']['output']>
  cleaningFee?: Maybe<Scalars['Int']['output']>
  communityFeesIncluded?: Maybe<Scalars['Boolean']['output']>
  currency?: Maybe<Scalars['String']['output']>
  furnished?: Maybe<Scalars['String']['output']>
  isRent?: Maybe<Scalars['Boolean']['output']>
  isRentLongterm?: Maybe<Scalars['Boolean']['output']>
  isRentShortterm?: Maybe<Scalars['Boolean']['output']>
  isRented?: Maybe<Scalars['Boolean']['output']>
  lastRentedDate?: Maybe<Scalars['DateTimeISO']['output']>
  leasePeriod?: Maybe<Scalars['String']['output']>
  leaseTypes: Array<Scalars['String']['output']>
  maxOccupancy?: Maybe<Scalars['Int']['output']>
  maximumLeaseDuration?: Maybe<Scalars['Int']['output']>
  minimumLeaseDuration?: Maybe<Scalars['Int']['output']>
  parkingIncluded?: Maybe<Scalars['Boolean']['output']>
  pax?: Maybe<Scalars['Int']['output']>
  petDeposit?: Maybe<Scalars['Int']['output']>
  petsAllowed?: Maybe<Scalars['Boolean']['output']>
  rentalPrice?: Maybe<Scalars['Int']['output']>
  rentalPriceLong?: Maybe<Scalars['Int']['output']>
  rentalPriceLongShow?: Maybe<Scalars['Boolean']['output']>
  rentalPricePeriod?: Maybe<RentalPeriod>
  rentalPriceShow?: Maybe<Scalars['Boolean']['output']>
  securityDeposit?: Maybe<Scalars['Int']['output']>
  smokingAllowed?: Maybe<Scalars['Boolean']['output']>
  storageIncluded?: Maybe<Scalars['Boolean']['output']>
  touristicCode?: Maybe<Scalars['String']['output']>
  utilitiesIncluded: Array<Scalars['String']['output']>
  utilityDeposit?: Maybe<Scalars['Int']['output']>
  vacationRental?: Maybe<Scalars['Boolean']['output']>
}

export type RentalPropertiesCreateInput = {
  availableFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  availableTo?: InputMaybe<Scalars['DateTimeISO']['input']>
  cleaningFee?: InputMaybe<Scalars['Int']['input']>
  communityFeesIncluded?: InputMaybe<Scalars['Boolean']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  furnished?: InputMaybe<Scalars['String']['input']>
  isRent?: InputMaybe<Scalars['Boolean']['input']>
  isRentLongterm?: InputMaybe<Scalars['Boolean']['input']>
  isRentShortterm?: InputMaybe<Scalars['Boolean']['input']>
  isRented?: InputMaybe<Scalars['Boolean']['input']>
  lastRentedDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  leasePeriod?: InputMaybe<Scalars['String']['input']>
  leaseTypes?: InputMaybe<RentalPropertiesCreateleaseTypesInput>
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>
  maximumLeaseDuration?: InputMaybe<Scalars['Int']['input']>
  minimumLeaseDuration?: InputMaybe<Scalars['Int']['input']>
  parkingIncluded?: InputMaybe<Scalars['Boolean']['input']>
  pax?: InputMaybe<Scalars['Int']['input']>
  petDeposit?: InputMaybe<Scalars['Int']['input']>
  petsAllowed?: InputMaybe<Scalars['Boolean']['input']>
  rentalPrice?: InputMaybe<Scalars['Int']['input']>
  rentalPriceLong?: InputMaybe<Scalars['Int']['input']>
  rentalPriceLongShow?: InputMaybe<Scalars['Boolean']['input']>
  rentalPricePeriod?: InputMaybe<RentalPeriodCreateInput>
  rentalPriceShow?: InputMaybe<Scalars['Boolean']['input']>
  securityDeposit?: InputMaybe<Scalars['Int']['input']>
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>
  storageIncluded?: InputMaybe<Scalars['Boolean']['input']>
  touristicCode?: InputMaybe<Scalars['String']['input']>
  utilitiesIncluded?: InputMaybe<RentalPropertiesCreateutilitiesIncludedInput>
  utilityDeposit?: InputMaybe<Scalars['Int']['input']>
  vacationRental?: InputMaybe<Scalars['Boolean']['input']>
}

export type RentalPropertiesCreateleaseTypesInput = {
  set: Array<Scalars['String']['input']>
}

export type RentalPropertiesCreateutilitiesIncludedInput = {
  set: Array<Scalars['String']['input']>
}

export type RentalPropertiesNullableCompositeFilter = {
  equals?: InputMaybe<RentalPropertiesObjectEqualityInput>
  is?: InputMaybe<RentalPropertiesWhereInput>
  isNot?: InputMaybe<RentalPropertiesWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type RentalPropertiesNullableCreateEnvelopeInput = {
  set?: InputMaybe<RentalPropertiesCreateInput>
}

export type RentalPropertiesNullableUpdateEnvelopeInput = {
  set?: InputMaybe<RentalPropertiesCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<RentalPropertiesUpsertInput>
}

export type RentalPropertiesObjectEqualityInput = {
  availableFrom?: InputMaybe<Scalars['DateTimeISO']['input']>
  availableTo?: InputMaybe<Scalars['DateTimeISO']['input']>
  cleaningFee?: InputMaybe<Scalars['Int']['input']>
  communityFeesIncluded?: InputMaybe<Scalars['Boolean']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  furnished?: InputMaybe<Scalars['String']['input']>
  isRent?: InputMaybe<Scalars['Boolean']['input']>
  isRentLongterm?: InputMaybe<Scalars['Boolean']['input']>
  isRentShortterm?: InputMaybe<Scalars['Boolean']['input']>
  isRented?: InputMaybe<Scalars['Boolean']['input']>
  lastRentedDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  leasePeriod?: InputMaybe<Scalars['String']['input']>
  leaseTypes?: InputMaybe<Array<Scalars['String']['input']>>
  maxOccupancy?: InputMaybe<Scalars['Int']['input']>
  maximumLeaseDuration?: InputMaybe<Scalars['Int']['input']>
  minimumLeaseDuration?: InputMaybe<Scalars['Int']['input']>
  parkingIncluded?: InputMaybe<Scalars['Boolean']['input']>
  pax?: InputMaybe<Scalars['Int']['input']>
  petDeposit?: InputMaybe<Scalars['Int']['input']>
  petsAllowed?: InputMaybe<Scalars['Boolean']['input']>
  rentalPrice?: InputMaybe<Scalars['Int']['input']>
  rentalPriceLong?: InputMaybe<Scalars['Int']['input']>
  rentalPriceLongShow?: InputMaybe<Scalars['Boolean']['input']>
  rentalPricePeriod?: InputMaybe<RentalPeriodObjectEqualityInput>
  rentalPriceShow?: InputMaybe<Scalars['Boolean']['input']>
  securityDeposit?: InputMaybe<Scalars['Int']['input']>
  smokingAllowed?: InputMaybe<Scalars['Boolean']['input']>
  storageIncluded?: InputMaybe<Scalars['Boolean']['input']>
  touristicCode?: InputMaybe<Scalars['String']['input']>
  utilitiesIncluded?: InputMaybe<Array<Scalars['String']['input']>>
  utilityDeposit?: InputMaybe<Scalars['Int']['input']>
  vacationRental?: InputMaybe<Scalars['Boolean']['input']>
}

export type RentalPropertiesOrderByInput = {
  availableFrom?: InputMaybe<SortOrder>
  availableTo?: InputMaybe<SortOrder>
  cleaningFee?: InputMaybe<SortOrder>
  communityFeesIncluded?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  furnished?: InputMaybe<SortOrder>
  isRent?: InputMaybe<SortOrder>
  isRentLongterm?: InputMaybe<SortOrder>
  isRentShortterm?: InputMaybe<SortOrder>
  isRented?: InputMaybe<SortOrder>
  lastRentedDate?: InputMaybe<SortOrder>
  leasePeriod?: InputMaybe<SortOrder>
  leaseTypes?: InputMaybe<SortOrder>
  maxOccupancy?: InputMaybe<SortOrder>
  maximumLeaseDuration?: InputMaybe<SortOrder>
  minimumLeaseDuration?: InputMaybe<SortOrder>
  parkingIncluded?: InputMaybe<SortOrder>
  pax?: InputMaybe<SortOrder>
  petDeposit?: InputMaybe<SortOrder>
  petsAllowed?: InputMaybe<SortOrder>
  rentalPrice?: InputMaybe<SortOrder>
  rentalPriceLong?: InputMaybe<SortOrder>
  rentalPriceLongShow?: InputMaybe<SortOrder>
  rentalPricePeriod?: InputMaybe<RentalPeriodOrderByInput>
  rentalPriceShow?: InputMaybe<SortOrder>
  securityDeposit?: InputMaybe<SortOrder>
  smokingAllowed?: InputMaybe<SortOrder>
  storageIncluded?: InputMaybe<SortOrder>
  touristicCode?: InputMaybe<SortOrder>
  utilitiesIncluded?: InputMaybe<SortOrder>
  utilityDeposit?: InputMaybe<SortOrder>
  vacationRental?: InputMaybe<SortOrder>
}

export type RentalPropertiesUpdateInput = {
  availableFrom?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  availableTo?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  cleaningFee?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  communityFeesIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  currency?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  furnished?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  isRent?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  isRentLongterm?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  isRentShortterm?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  isRented?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  lastRentedDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  leasePeriod?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  leaseTypes?: InputMaybe<RentalPropertiesUpdateleaseTypesInput>
  maxOccupancy?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maximumLeaseDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  minimumLeaseDuration?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  parkingIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  pax?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  petDeposit?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  petsAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  rentalPrice?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  rentalPriceLong?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  rentalPriceLongShow?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  rentalPricePeriod?: InputMaybe<RentalPeriodNullableUpdateEnvelopeInput>
  rentalPriceShow?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  securityDeposit?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  smokingAllowed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  storageIncluded?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
  touristicCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  utilitiesIncluded?: InputMaybe<RentalPropertiesUpdateutilitiesIncludedInput>
  utilityDeposit?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  vacationRental?: InputMaybe<NullableBoolFieldUpdateOperationsInput>
}

export type RentalPropertiesUpdateleaseTypesInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RentalPropertiesUpdateutilitiesIncludedInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type RentalPropertiesUpsertInput = {
  set: RentalPropertiesCreateInput
  update: RentalPropertiesUpdateInput
}

export type RentalPropertiesWhereInput = {
  AND?: InputMaybe<Array<RentalPropertiesWhereInput>>
  NOT?: InputMaybe<Array<RentalPropertiesWhereInput>>
  OR?: InputMaybe<Array<RentalPropertiesWhereInput>>
  availableFrom?: InputMaybe<DateTimeNullableFilter>
  availableTo?: InputMaybe<DateTimeNullableFilter>
  cleaningFee?: InputMaybe<IntNullableFilter>
  communityFeesIncluded?: InputMaybe<BoolNullableFilter>
  currency?: InputMaybe<StringNullableFilter>
  furnished?: InputMaybe<StringNullableFilter>
  isRent?: InputMaybe<BoolNullableFilter>
  isRentLongterm?: InputMaybe<BoolNullableFilter>
  isRentShortterm?: InputMaybe<BoolNullableFilter>
  isRented?: InputMaybe<BoolNullableFilter>
  lastRentedDate?: InputMaybe<DateTimeNullableFilter>
  leasePeriod?: InputMaybe<StringNullableFilter>
  leaseTypes?: InputMaybe<StringNullableListFilter>
  maxOccupancy?: InputMaybe<IntNullableFilter>
  maximumLeaseDuration?: InputMaybe<IntNullableFilter>
  minimumLeaseDuration?: InputMaybe<IntNullableFilter>
  parkingIncluded?: InputMaybe<BoolNullableFilter>
  pax?: InputMaybe<IntNullableFilter>
  petDeposit?: InputMaybe<IntNullableFilter>
  petsAllowed?: InputMaybe<BoolNullableFilter>
  rentalPrice?: InputMaybe<IntNullableFilter>
  rentalPriceLong?: InputMaybe<IntNullableFilter>
  rentalPriceLongShow?: InputMaybe<BoolNullableFilter>
  rentalPricePeriod?: InputMaybe<RentalPeriodNullableCompositeFilter>
  rentalPriceShow?: InputMaybe<BoolNullableFilter>
  securityDeposit?: InputMaybe<IntNullableFilter>
  smokingAllowed?: InputMaybe<BoolNullableFilter>
  storageIncluded?: InputMaybe<BoolNullableFilter>
  touristicCode?: InputMaybe<StringNullableFilter>
  utilitiesIncluded?: InputMaybe<StringNullableListFilter>
  utilityDeposit?: InputMaybe<IntNullableFilter>
  vacationRental?: InputMaybe<BoolNullableFilter>
}

export enum ReportReason {
  CopyrightInfringement = 'COPYRIGHT_INFRINGEMENT',
  IncorrectData = 'INCORRECT_DATA',
  NonExistingProperty = 'NON_EXISTING_PROPERTY',
  Other = 'OTHER',
  ProvokingContent = 'PROVOKING_CONTENT',
}

export type ResalesDescriptionEntry = {
  __typename?: 'ResalesDescriptionEntry'
  /** BCP-47-ish language code from the feed (e.g. en, es, se). */
  language: Scalars['String']['output']
  /** Short/teaser text when the feed provides it. */
  short?: Maybe<Scalars['String']['output']>
  /** Plain text (HTML stripped) for this language. */
  text: Scalars['String']['output']
}

export type ResalesFeatureParamInput = {
  key: Scalars['String']['input']
  value?: InputMaybe<Scalars['String']['input']>
}

export type ResalesImportResult = {
  __typename?: 'ResalesImportResult'
  error?: Maybe<Scalars['String']['output']>
  externalId: Scalars['String']['output']
  propertyId?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type ResalesLiveDescriptionEntryGql = {
  __typename?: 'ResalesLiveDescriptionEntryGql'
  language: Scalars['String']['output']
  short?: Maybe<Scalars['String']['output']>
  text: Scalars['String']['output']
}

export type ResalesLivePropertyCardGql = {
  __typename?: 'ResalesLivePropertyCardGql'
  baths?: Maybe<Scalars['Int']['output']>
  beds?: Maybe<Scalars['Int']['output']>
  builtArea?: Maybe<Scalars['Float']['output']>
  currency?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  externalId: Scalars['String']['output']
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  images?: Maybe<Array<Scalars['String']['output']>>
  isNewDevelopment?: Maybe<Scalars['Boolean']['output']>
  locationDetail?: Maybe<Scalars['String']['output']>
  maxBaths: Scalars['Int']['output']
  maxBeds: Scalars['Int']['output']
  minBaths: Scalars['Int']['output']
  minBeds: Scalars['Int']['output']
  ownProperty: Scalars['Boolean']['output']
  plotArea?: Maybe<Scalars['Float']['output']>
  price?: Maybe<Scalars['Float']['output']>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  refId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type ResalesLivePropertyGql = {
  __typename?: 'ResalesLivePropertyGql'
  brokerName?: Maybe<Scalars['String']['output']>
  card: ResalesLivePropertyCardGql
  descriptionsByLanguage: Array<ResalesLiveDescriptionEntryGql>
  featureNames: Array<Scalars['String']['output']>
  locationArea?: Maybe<Scalars['String']['output']>
  locationCountry?: Maybe<Scalars['String']['output']>
  locationProvince?: Maybe<Scalars['String']['output']>
  locationTown?: Maybe<Scalars['String']['output']>
}

export type ResalesLivePropertyPayloadGql = {
  __typename?: 'ResalesLivePropertyPayloadGql'
  fromCache: Scalars['Boolean']['output']
  property: ResalesLivePropertyGql
  queryInfo?: Maybe<ResalesLiveQueryInfoGql>
}

export type ResalesLiveQueryInfoGql = {
  __typename?: 'ResalesLiveQueryInfoGql'
  currentPage: Scalars['Int']['output']
  propertiesPerPage: Scalars['Int']['output']
  propertyCount: Scalars['Int']['output']
  queryId?: Maybe<Scalars['String']['output']>
  searchType?: Maybe<Scalars['String']['output']>
}

export type ResalesLiveSearchPageGql = {
  __typename?: 'ResalesLiveSearchPageGql'
  fromCache: Scalars['Boolean']['output']
  hasNextPage: Scalars['Boolean']['output']
  items: Array<ResalesLivePropertyCardGql>
  page: Scalars['Int']['output']
  pageSize: Scalars['Int']['output']
  queryInfo: ResalesLiveQueryInfoGql
  totalCount: Scalars['Int']['output']
  totalPages: Scalars['Int']['output']
}

/** Resales SearchProperties feed scope */
export enum ResalesLiveSearchScope {
  All = 'ALL',
  NewDevelopments = 'NEW_DEVELOPMENTS',
  NoDevelopments = 'NO_DEVELOPMENTS',
  OwnListings = 'OWN_LISTINGS',
}

export type ResalesLocationOption = {
  __typename?: 'ResalesLocationOption'
  label: Scalars['String']['output']
  province?: Maybe<Scalars['String']['output']>
  value: Scalars['String']['output']
}

export type ResalesMappedSearchInput = {
  currency?: InputMaybe<Scalars['String']['input']>
  featureParams?: InputMaybe<Array<ResalesFeatureParamInput>>
  location?: InputMaybe<Scalars['String']['input']>
  maxPrice?: InputMaybe<Scalars['Float']['input']>
  minBaths?: InputMaybe<Scalars['Int']['input']>
  /** When true, minBaths is exact count; otherwise uses Nx (at least) */
  minBathsExact?: InputMaybe<Scalars['Boolean']['input']>
  minBeds?: InputMaybe<Scalars['Int']['input']>
  /** When true, minBeds is exact count; otherwise uses Nx (at least) */
  minBedsExact?: InputMaybe<Scalars['Boolean']['input']>
  minPrice?: InputMaybe<Scalars['Float']['input']>
  mustHavePool?: InputMaybe<Scalars['Boolean']['input']>
  page?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** Resales P_PropertyTypes tokens, comma-separated */
  propertyTypes?: InputMaybe<Scalars['String']['input']>
  province?: InputMaybe<Scalars['String']['input']>
  queryId?: InputMaybe<Scalars['String']['input']>
  refId?: InputMaybe<Scalars['String']['input']>
  scope?: InputMaybe<ResalesLiveSearchScope>
  sortType?: InputMaybe<Scalars['String']['input']>
}

export type ResalesPropertiesPage = {
  __typename?: 'ResalesPropertiesPage'
  hasNextPage: Scalars['Boolean']['output']
  items: Array<ResalesPropertyPreview>
  page: Scalars['Float']['output']
  pageSize: Scalars['Float']['output']
  totalCount: Scalars['Float']['output']
  totalPages: Scalars['Float']['output']
}

export type ResalesPropertyDetails = {
  __typename?: 'ResalesPropertyDetails'
  brokerName?: Maybe<Scalars['String']['output']>
  descriptionsByLanguage: Array<ResalesDescriptionEntry>
  featureNames: Array<Scalars['String']['output']>
  locationArea?: Maybe<Scalars['String']['output']>
  locationCountry?: Maybe<Scalars['String']['output']>
  locationProvince?: Maybe<Scalars['String']['output']>
  locationTown?: Maybe<Scalars['String']['output']>
  preview: ResalesPropertyPreview
}

export type ResalesPropertyPreview = {
  __typename?: 'ResalesPropertyPreview'
  baths?: Maybe<Scalars['Float']['output']>
  beds?: Maybe<Scalars['Float']['output']>
  builtArea?: Maybe<Scalars['Float']['output']>
  currency?: Maybe<Scalars['String']['output']>
  description?: Maybe<Scalars['String']['output']>
  existingId?: Maybe<Scalars['String']['output']>
  exists: Scalars['Boolean']['output']
  externalId: Scalars['String']['output']
  featureIds?: Maybe<Array<Scalars['String']['output']>>
  gpsX?: Maybe<Scalars['String']['output']>
  gpsY?: Maybe<Scalars['String']['output']>
  id?: Maybe<Scalars['String']['output']>
  images?: Maybe<Array<Scalars['String']['output']>>
  isNewDevelopment?: Maybe<Scalars['Boolean']['output']>
  locationDetail?: Maybe<Scalars['String']['output']>
  maxBaths: Scalars['Float']['output']
  maxBeds: Scalars['Float']['output']
  minBaths: Scalars['Float']['output']
  minBeds: Scalars['Float']['output']
  ownProperty: Scalars['Boolean']['output']
  plotArea?: Maybe<Scalars['Float']['output']>
  price?: Maybe<Scalars['Float']['output']>
  propertyTypeId?: Maybe<Scalars['String']['output']>
  propertyTypeIds?: Maybe<Array<Scalars['String']['output']>>
  refId?: Maybe<Scalars['String']['output']>
  status?: Maybe<Scalars['String']['output']>
  title?: Maybe<Scalars['String']['output']>
  type?: Maybe<Scalars['String']['output']>
}

export type ResalesPropertyTypeOption = {
  __typename?: 'ResalesPropertyTypeOption'
  groupLabel?: Maybe<Scalars['String']['output']>
  label: Scalars['String']['output']
  value: Scalars['String']['output']
}

export type ResalesQueryParamInput = {
  key: Scalars['String']['input']
  value: Scalars['String']['input']
}

export type ResalesSearchNativeInput = {
  pageNo?: InputMaybe<Scalars['Int']['input']>
  pageSize?: InputMaybe<Scalars['Int']['input']>
  /** Passthrough Resales SearchProperties params (p1/p2/P_Apiid blocked) */
  params?: InputMaybe<Array<ResalesQueryParamInput>>
  queryId?: InputMaybe<Scalars['String']['input']>
}

export type RoleModel = {
  __typename?: 'RoleModel'
  createdAt: Scalars['DateTimeISO']['output']
  description?: Maybe<Scalars['String']['output']>
  id: Scalars['ID']['output']
  isPredefined: Scalars['Boolean']['output']
  name: Scalars['String']['output']
  permissions: Array<Scalars['String']['output']>
  updatedAt: Scalars['DateTimeISO']['output']
}

export type RoutablePoint = {
  __typename?: 'RoutablePoint'
  location: Array<Scalars['Float']['output']>
  name?: Maybe<Scalars['String']['output']>
}

export type RoutablePointCreateInput = {
  location?: InputMaybe<RoutablePointCreatelocationInput>
  name?: InputMaybe<Scalars['String']['input']>
}

export type RoutablePointCreatelocationInput = {
  set: Array<Scalars['Float']['input']>
}

export type RoutablePointObjectEqualityInput = {
  location?: InputMaybe<Array<Scalars['Float']['input']>>
  name?: InputMaybe<Scalars['String']['input']>
}

export type RoutablePointOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type SearchCoordinates = {
  __typename?: 'SearchCoordinates'
  latitude: Scalars['Float']['output']
  longitude: Scalars['Float']['output']
}

export type SearchCoordinatesInput = {
  lat: Scalars['Float']['input']
  lng: Scalars['Float']['input']
}

export type SearchLocationFeature = {
  __typename?: 'SearchLocationFeature'
  distance?: Maybe<Scalars['Float']['output']>
  geometry: SearchLocationGeometry
  properties: SearchLocationProperties
  type: Scalars['String']['output']
}

export type SearchLocationGeometry = {
  __typename?: 'SearchLocationGeometry'
  coordinates: Array<Scalars['Float']['output']>
  type: Scalars['String']['output']
}

export type SearchLocationProperties = {
  __typename?: 'SearchLocationProperties'
  bbox?: Maybe<Array<Scalars['Float']['output']>>
  coordinates: SearchCoordinates
  distance?: Maybe<Scalars['Float']['output']>
  districtTileName?: Maybe<Scalars['String']['output']>
  name: Scalars['String']['output']
  place_formatted: Scalars['String']['output']
  place_type: Scalars['String']['output']
  refId?: Maybe<Scalars['String']['output']>
}

export type SearchOrderConfigInput = {
  cacheTtlSeconds?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  key?: InputMaybe<Scalars['String']['input']>
  rotationWindowSeconds?: InputMaybe<Scalars['Int']['input']>
  segment1Enabled?: InputMaybe<Scalars['Boolean']['input']>
  segment1MaxItems?: InputMaybe<Scalars['Int']['input']>
  segment1Type?: InputMaybe<Scalars['String']['input']>
  segment1Weight?: InputMaybe<Scalars['Int']['input']>
  segment2TopMvaCount?: InputMaybe<Scalars['Int']['input']>
  segment2Weight?: InputMaybe<Scalars['Int']['input']>
  segment3Enabled?: InputMaybe<Scalars['Boolean']['input']>
  segment3MaxItems?: InputMaybe<Scalars['Int']['input']>
  segment3Weight?: InputMaybe<Scalars['Int']['input']>
  segmentCustomEnabled?: InputMaybe<Scalars['Boolean']['input']>
  segmentCustomMaxItems?: InputMaybe<Scalars['Int']['input']>
  segmentCustomRefIds?: InputMaybe<Array<Scalars['String']['input']>>
  segmentCustomWeight?: InputMaybe<Scalars['Int']['input']>
}

export type SearchOrderConfigOutput = {
  __typename?: 'SearchOrderConfigOutput'
  cacheTtlSeconds?: Maybe<Scalars['Int']['output']>
  description?: Maybe<Scalars['String']['output']>
  key: Scalars['String']['output']
  rotationWindowSeconds?: Maybe<Scalars['Int']['output']>
  segment1Enabled: Scalars['Boolean']['output']
  segment1MaxItems?: Maybe<Scalars['Int']['output']>
  segment1Type: Scalars['String']['output']
  segment1Weight?: Maybe<Scalars['Int']['output']>
  segment2TopMvaCount: Scalars['Int']['output']
  segment2Weight?: Maybe<Scalars['Int']['output']>
  segment3Enabled: Scalars['Boolean']['output']
  segment3MaxItems?: Maybe<Scalars['Int']['output']>
  segment3Weight?: Maybe<Scalars['Int']['output']>
  segmentCustomEnabled: Scalars['Boolean']['output']
  segmentCustomMaxItems?: Maybe<Scalars['Int']['output']>
  segmentCustomRefIds?: Maybe<Array<Scalars['String']['output']>>
  segmentCustomWeight?: Maybe<Scalars['Int']['output']>
}

/** Result of sending the broker lead notification email via Mautic (super admin only). */
export type SendBrokerLeadNotificationPayload = {
  __typename?: 'SendBrokerLeadNotificationPayload'
  message?: Maybe<Scalars['String']['output']>
  success: Scalars['Boolean']['output']
}

export type SignupInput = {
  address?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email: Scalars['String']['input']
  fax?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  picUrl?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type SortOptions = {
  direction: Scalars['String']['input']
  field: Scalars['String']['input']
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
}

export type StartBrokerSiteOnboardingInput = {
  brokerId: Scalars['String']['input']
  displayName: Scalars['String']['input']
  locales?: InputMaybe<Array<Scalars['String']['input']>>
  slug?: InputMaybe<Scalars['String']['input']>
  sourceWebsiteUrl: Scalars['String']['input']
  tagline?: InputMaybe<Scalars['String']['input']>
}

export type StartBrokerSiteOnboardingResult = {
  __typename?: 'StartBrokerSiteOnboardingResult'
  commitSha?: Maybe<Scalars['String']['output']>
  commitUrl?: Maybe<Scalars['String']['output']>
  manifestPath: Scalars['String']['output']
  message?: Maybe<Scalars['String']['output']>
  ok: Scalars['Boolean']['output']
  slug: Scalars['String']['output']
  workflowActionsUrl: Scalars['String']['output']
}

export type StatusHistory = {
  __typename?: 'StatusHistory'
  date?: Maybe<Scalars['DateTimeISO']['output']>
  status?: Maybe<Scalars['String']['output']>
  value?: Maybe<Scalars['String']['output']>
}

export type StatusHistoryCreateInput = {
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type StatusHistoryObjectEqualityInput = {
  date?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  value?: InputMaybe<Scalars['String']['input']>
}

export type StatusHistoryOrderByCompositeAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type StreetContext = {
  __typename?: 'StreetContext'
  mapbox_id: Scalars['String']['output']
  name: Scalars['String']['output']
}

export type StreetContextCreateInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type StreetContextNullableCompositeFilter = {
  equals?: InputMaybe<StreetContextObjectEqualityInput>
  is?: InputMaybe<StreetContextWhereInput>
  isNot?: InputMaybe<StreetContextWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type StreetContextNullableUpdateEnvelopeInput = {
  set?: InputMaybe<StreetContextCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<StreetContextUpsertInput>
}

export type StreetContextObjectEqualityInput = {
  mapbox_id: Scalars['String']['input']
  name: Scalars['String']['input']
}

export type StreetContextOrderByInput = {
  mapbox_id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
}

export type StreetContextUpdateInput = {
  mapbox_id?: InputMaybe<StringFieldUpdateOperationsInput>
  name?: InputMaybe<StringFieldUpdateOperationsInput>
}

export type StreetContextUpsertInput = {
  set: StreetContextCreateInput
  update: StreetContextUpdateInput
}

export type StreetContextWhereInput = {
  AND?: InputMaybe<Array<StreetContextWhereInput>>
  NOT?: InputMaybe<Array<StreetContextWhereInput>>
  OR?: InputMaybe<Array<StreetContextWhereInput>>
  mapbox_id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
}

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']['input']>
}

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<QueryMode>
  not?: InputMaybe<NestedStringFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<QueryMode>
  not?: InputMaybe<NestedStringNullableFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type StringNullableListFilter = {
  equals?: InputMaybe<Array<Scalars['String']['input']>>
  has?: InputMaybe<Scalars['String']['input']>
  hasEvery?: InputMaybe<Array<Scalars['String']['input']>>
  hasSome?: InputMaybe<Array<Scalars['String']['input']>>
  isEmpty?: InputMaybe<Scalars['Boolean']['input']>
}

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>
  _max?: InputMaybe<NestedStringNullableFilter>
  _min?: InputMaybe<NestedStringNullableFilter>
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<QueryMode>
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>
  _max?: InputMaybe<NestedStringFilter>
  _min?: InputMaybe<NestedStringFilter>
  contains?: InputMaybe<Scalars['String']['input']>
  endsWith?: InputMaybe<Scalars['String']['input']>
  equals?: InputMaybe<Scalars['String']['input']>
  gt?: InputMaybe<Scalars['String']['input']>
  gte?: InputMaybe<Scalars['String']['input']>
  in?: InputMaybe<Array<Scalars['String']['input']>>
  lt?: InputMaybe<Scalars['String']['input']>
  lte?: InputMaybe<Scalars['String']['input']>
  mode?: InputMaybe<QueryMode>
  not?: InputMaybe<NestedStringWithAggregatesFilter>
  notIn?: InputMaybe<Array<Scalars['String']['input']>>
  startsWith?: InputMaybe<Scalars['String']['input']>
}

export type Subscription = {
  __typename?: 'Subscription'
  aiVisualsTier: AiVisualsTier
  autoRenew: Scalars['Boolean']['output']
  broker: Broker
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  discountEndDate?: Maybe<Scalars['DateTimeISO']['output']>
  discountPercentage: Scalars['Int']['output']
  endDate?: Maybe<Scalars['DateTimeISO']['output']>
  id: Scalars['String']['output']
  paymentDate?: Maybe<Scalars['DateTimeISO']['output']>
  paymentMethod?: Maybe<Scalars['String']['output']>
  paymentReference?: Maybe<Scalars['String']['output']>
  paymentStatus: Scalars['String']['output']
  plan: Scalars['String']['output']
  price: Scalars['Float']['output']
  searchPrio: Scalars['Int']['output']
  slotCount: Scalars['Int']['output']
  slotCountAgency: Scalars['Int']['output']
  slotsActive: Scalars['Boolean']['output']
  slotsActiveAgency: Scalars['Boolean']['output']
  startDate: Scalars['DateTimeISO']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  usedSlots: Scalars['Int']['output']
  usedSlotsAgency: Scalars['Int']['output']
}

export type SubscriptionAvgAggregate = {
  __typename?: 'SubscriptionAvgAggregate'
  discountPercentage?: Maybe<Scalars['Float']['output']>
  price?: Maybe<Scalars['Float']['output']>
  searchPrio?: Maybe<Scalars['Float']['output']>
  slotCount?: Maybe<Scalars['Float']['output']>
  slotCountAgency?: Maybe<Scalars['Float']['output']>
  usedSlots?: Maybe<Scalars['Float']['output']>
  usedSlotsAgency?: Maybe<Scalars['Float']['output']>
}

export type SubscriptionAvgOrderByAggregateInput = {
  discountPercentage?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionCountAggregate = {
  __typename?: 'SubscriptionCountAggregate'
  _all: Scalars['Int']['output']
  aiVisualsTier: Scalars['Int']['output']
  autoRenew: Scalars['Int']['output']
  brokerId: Scalars['Int']['output']
  createdAt: Scalars['Int']['output']
  currency: Scalars['Int']['output']
  discountEndDate: Scalars['Int']['output']
  discountPercentage: Scalars['Int']['output']
  endDate: Scalars['Int']['output']
  id: Scalars['Int']['output']
  paymentDate: Scalars['Int']['output']
  paymentMethod: Scalars['Int']['output']
  paymentReference: Scalars['Int']['output']
  paymentStatus: Scalars['Int']['output']
  plan: Scalars['Int']['output']
  price: Scalars['Int']['output']
  searchPrio: Scalars['Int']['output']
  slotCount: Scalars['Int']['output']
  slotCountAgency: Scalars['Int']['output']
  slotsActive: Scalars['Int']['output']
  slotsActiveAgency: Scalars['Int']['output']
  startDate: Scalars['Int']['output']
  status: Scalars['Int']['output']
  updatedAt: Scalars['Int']['output']
  usedSlots: Scalars['Int']['output']
  usedSlotsAgency: Scalars['Int']['output']
}

export type SubscriptionCountOrderByAggregateInput = {
  aiVisualsTier?: InputMaybe<SortOrder>
  autoRenew?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  discountEndDate?: InputMaybe<SortOrder>
  discountPercentage?: InputMaybe<SortOrder>
  endDate?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  paymentDate?: InputMaybe<SortOrder>
  paymentMethod?: InputMaybe<SortOrder>
  paymentReference?: InputMaybe<SortOrder>
  paymentStatus?: InputMaybe<SortOrder>
  plan?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  slotsActive?: InputMaybe<SortOrder>
  slotsActiveAgency?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionCreateInput = {
  aiVisualsTier?: InputMaybe<AiVisualsTier>
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  broker: BrokerCreateNestedOneWithoutSubscriptionsInput
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price: Scalars['Float']['input']
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  slotCount: Scalars['Int']['input']
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type SubscriptionCreateManyBrokerInput = {
  aiVisualsTier?: InputMaybe<AiVisualsTier>
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price: Scalars['Float']['input']
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  slotCount: Scalars['Int']['input']
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type SubscriptionCreateManyBrokerInputEnvelope = {
  data: Array<SubscriptionCreateManyBrokerInput>
}

export type SubscriptionCreateManyInput = {
  aiVisualsTier?: InputMaybe<AiVisualsTier>
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  brokerId: Scalars['String']['input']
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price: Scalars['Float']['input']
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  slotCount: Scalars['Int']['input']
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type SubscriptionCreateNestedManyWithoutBrokerInput = {
  connect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<SubscriptionCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<SubscriptionCreateWithoutBrokerInput>>
  createMany?: InputMaybe<SubscriptionCreateManyBrokerInputEnvelope>
}

export type SubscriptionCreateOrConnectWithoutBrokerInput = {
  create: SubscriptionCreateWithoutBrokerInput
  where: SubscriptionWhereUniqueInput
}

export type SubscriptionCreateWithoutBrokerInput = {
  aiVisualsTier?: InputMaybe<AiVisualsTier>
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  createdAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  discountEndDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price: Scalars['Float']['input']
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  slotCount: Scalars['Int']['input']
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  updatedAt?: InputMaybe<Scalars['DateTimeISO']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type SubscriptionGroupBy = {
  __typename?: 'SubscriptionGroupBy'
  _avg?: Maybe<SubscriptionAvgAggregate>
  _count?: Maybe<SubscriptionCountAggregate>
  _max?: Maybe<SubscriptionMaxAggregate>
  _min?: Maybe<SubscriptionMinAggregate>
  _sum?: Maybe<SubscriptionSumAggregate>
  aiVisualsTier: AiVisualsTier
  autoRenew: Scalars['Boolean']['output']
  brokerId: Scalars['String']['output']
  createdAt: Scalars['DateTimeISO']['output']
  currency: Scalars['String']['output']
  discountEndDate?: Maybe<Scalars['DateTimeISO']['output']>
  discountPercentage: Scalars['Int']['output']
  endDate?: Maybe<Scalars['DateTimeISO']['output']>
  id: Scalars['String']['output']
  paymentDate?: Maybe<Scalars['DateTimeISO']['output']>
  paymentMethod?: Maybe<Scalars['String']['output']>
  paymentReference?: Maybe<Scalars['String']['output']>
  paymentStatus: Scalars['String']['output']
  plan: Scalars['String']['output']
  price: Scalars['Float']['output']
  searchPrio: Scalars['Int']['output']
  slotCount: Scalars['Int']['output']
  slotCountAgency: Scalars['Int']['output']
  slotsActive: Scalars['Boolean']['output']
  slotsActiveAgency: Scalars['Boolean']['output']
  startDate: Scalars['DateTimeISO']['output']
  status: Scalars['String']['output']
  updatedAt: Scalars['DateTimeISO']['output']
  usedSlots: Scalars['Int']['output']
  usedSlotsAgency: Scalars['Int']['output']
}

export type SubscriptionListRelationFilter = {
  every?: InputMaybe<SubscriptionWhereInput>
  none?: InputMaybe<SubscriptionWhereInput>
  some?: InputMaybe<SubscriptionWhereInput>
}

export type SubscriptionMaxAggregate = {
  __typename?: 'SubscriptionMaxAggregate'
  aiVisualsTier?: Maybe<AiVisualsTier>
  autoRenew?: Maybe<Scalars['Boolean']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  discountEndDate?: Maybe<Scalars['DateTimeISO']['output']>
  discountPercentage?: Maybe<Scalars['Int']['output']>
  endDate?: Maybe<Scalars['DateTimeISO']['output']>
  id?: Maybe<Scalars['String']['output']>
  paymentDate?: Maybe<Scalars['DateTimeISO']['output']>
  paymentMethod?: Maybe<Scalars['String']['output']>
  paymentReference?: Maybe<Scalars['String']['output']>
  paymentStatus?: Maybe<Scalars['String']['output']>
  plan?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  searchPrio?: Maybe<Scalars['Int']['output']>
  slotCount?: Maybe<Scalars['Int']['output']>
  slotCountAgency?: Maybe<Scalars['Int']['output']>
  slotsActive?: Maybe<Scalars['Boolean']['output']>
  slotsActiveAgency?: Maybe<Scalars['Boolean']['output']>
  startDate?: Maybe<Scalars['DateTimeISO']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  usedSlots?: Maybe<Scalars['Int']['output']>
  usedSlotsAgency?: Maybe<Scalars['Int']['output']>
}

export type SubscriptionMaxOrderByAggregateInput = {
  aiVisualsTier?: InputMaybe<SortOrder>
  autoRenew?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  discountEndDate?: InputMaybe<SortOrder>
  discountPercentage?: InputMaybe<SortOrder>
  endDate?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  paymentDate?: InputMaybe<SortOrder>
  paymentMethod?: InputMaybe<SortOrder>
  paymentReference?: InputMaybe<SortOrder>
  paymentStatus?: InputMaybe<SortOrder>
  plan?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  slotsActive?: InputMaybe<SortOrder>
  slotsActiveAgency?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionMinAggregate = {
  __typename?: 'SubscriptionMinAggregate'
  aiVisualsTier?: Maybe<AiVisualsTier>
  autoRenew?: Maybe<Scalars['Boolean']['output']>
  brokerId?: Maybe<Scalars['String']['output']>
  createdAt?: Maybe<Scalars['DateTimeISO']['output']>
  currency?: Maybe<Scalars['String']['output']>
  discountEndDate?: Maybe<Scalars['DateTimeISO']['output']>
  discountPercentage?: Maybe<Scalars['Int']['output']>
  endDate?: Maybe<Scalars['DateTimeISO']['output']>
  id?: Maybe<Scalars['String']['output']>
  paymentDate?: Maybe<Scalars['DateTimeISO']['output']>
  paymentMethod?: Maybe<Scalars['String']['output']>
  paymentReference?: Maybe<Scalars['String']['output']>
  paymentStatus?: Maybe<Scalars['String']['output']>
  plan?: Maybe<Scalars['String']['output']>
  price?: Maybe<Scalars['Float']['output']>
  searchPrio?: Maybe<Scalars['Int']['output']>
  slotCount?: Maybe<Scalars['Int']['output']>
  slotCountAgency?: Maybe<Scalars['Int']['output']>
  slotsActive?: Maybe<Scalars['Boolean']['output']>
  slotsActiveAgency?: Maybe<Scalars['Boolean']['output']>
  startDate?: Maybe<Scalars['DateTimeISO']['output']>
  status?: Maybe<Scalars['String']['output']>
  updatedAt?: Maybe<Scalars['DateTimeISO']['output']>
  usedSlots?: Maybe<Scalars['Int']['output']>
  usedSlotsAgency?: Maybe<Scalars['Int']['output']>
}

export type SubscriptionMinOrderByAggregateInput = {
  aiVisualsTier?: InputMaybe<SortOrder>
  autoRenew?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  discountEndDate?: InputMaybe<SortOrder>
  discountPercentage?: InputMaybe<SortOrder>
  endDate?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  paymentDate?: InputMaybe<SortOrder>
  paymentMethod?: InputMaybe<SortOrder>
  paymentReference?: InputMaybe<SortOrder>
  paymentStatus?: InputMaybe<SortOrder>
  plan?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  slotsActive?: InputMaybe<SortOrder>
  slotsActiveAgency?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type SubscriptionOrderByWithAggregationInput = {
  _avg?: InputMaybe<SubscriptionAvgOrderByAggregateInput>
  _count?: InputMaybe<SubscriptionCountOrderByAggregateInput>
  _max?: InputMaybe<SubscriptionMaxOrderByAggregateInput>
  _min?: InputMaybe<SubscriptionMinOrderByAggregateInput>
  _sum?: InputMaybe<SubscriptionSumOrderByAggregateInput>
  aiVisualsTier?: InputMaybe<SortOrder>
  autoRenew?: InputMaybe<SortOrder>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  discountEndDate?: InputMaybe<SortOrder>
  discountPercentage?: InputMaybe<SortOrder>
  endDate?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  paymentDate?: InputMaybe<SortOrder>
  paymentMethod?: InputMaybe<SortOrder>
  paymentReference?: InputMaybe<SortOrder>
  paymentStatus?: InputMaybe<SortOrder>
  plan?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  slotsActive?: InputMaybe<SortOrder>
  slotsActiveAgency?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionOrderByWithRelationInput = {
  aiVisualsTier?: InputMaybe<SortOrder>
  autoRenew?: InputMaybe<SortOrder>
  broker?: InputMaybe<BrokerOrderByWithRelationInput>
  brokerId?: InputMaybe<SortOrder>
  createdAt?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
  discountEndDate?: InputMaybe<SortOrder>
  discountPercentage?: InputMaybe<SortOrder>
  endDate?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  paymentDate?: InputMaybe<SortOrder>
  paymentMethod?: InputMaybe<SortOrder>
  paymentReference?: InputMaybe<SortOrder>
  paymentStatus?: InputMaybe<SortOrder>
  plan?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  slotsActive?: InputMaybe<SortOrder>
  slotsActiveAgency?: InputMaybe<SortOrder>
  startDate?: InputMaybe<SortOrder>
  status?: InputMaybe<SortOrder>
  updatedAt?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionPackageOption = {
  __typename?: 'SubscriptionPackageOption'
  customPricing: Scalars['Boolean']['output']
  defaultPriceEur: Scalars['Float']['output']
  defaultSlotCount: Scalars['Int']['output']
  defaultSlotCountAgency: Scalars['Int']['output']
  name: Scalars['String']['output']
  plan: Scalars['String']['output']
}

export enum SubscriptionScalarFieldEnum {
  AiVisualsTier = 'aiVisualsTier',
  AutoRenew = 'autoRenew',
  BrokerId = 'brokerId',
  CreatedAt = 'createdAt',
  Currency = 'currency',
  DiscountEndDate = 'discountEndDate',
  DiscountPercentage = 'discountPercentage',
  EndDate = 'endDate',
  Id = 'id',
  PaymentDate = 'paymentDate',
  PaymentMethod = 'paymentMethod',
  PaymentReference = 'paymentReference',
  PaymentStatus = 'paymentStatus',
  Plan = 'plan',
  Price = 'price',
  SearchPrio = 'searchPrio',
  SlotCount = 'slotCount',
  SlotCountAgency = 'slotCountAgency',
  SlotsActive = 'slotsActive',
  SlotsActiveAgency = 'slotsActiveAgency',
  StartDate = 'startDate',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UsedSlots = 'usedSlots',
  UsedSlotsAgency = 'usedSlotsAgency',
}

export type SubscriptionScalarWhereInput = {
  AND?: InputMaybe<Array<SubscriptionScalarWhereInput>>
  NOT?: InputMaybe<Array<SubscriptionScalarWhereInput>>
  OR?: InputMaybe<Array<SubscriptionScalarWhereInput>>
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFilter>
  autoRenew?: InputMaybe<BoolFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  discountEndDate?: InputMaybe<DateTimeNullableFilter>
  discountPercentage?: InputMaybe<IntFilter>
  endDate?: InputMaybe<DateTimeNullableFilter>
  id?: InputMaybe<StringFilter>
  paymentDate?: InputMaybe<DateTimeNullableFilter>
  paymentMethod?: InputMaybe<StringNullableFilter>
  paymentReference?: InputMaybe<StringNullableFilter>
  paymentStatus?: InputMaybe<StringFilter>
  plan?: InputMaybe<StringFilter>
  price?: InputMaybe<FloatFilter>
  searchPrio?: InputMaybe<IntFilter>
  slotCount?: InputMaybe<IntFilter>
  slotCountAgency?: InputMaybe<IntFilter>
  slotsActive?: InputMaybe<BoolFilter>
  slotsActiveAgency?: InputMaybe<BoolFilter>
  startDate?: InputMaybe<DateTimeFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  usedSlots?: InputMaybe<IntFilter>
  usedSlotsAgency?: InputMaybe<IntFilter>
}

export type SubscriptionScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<SubscriptionScalarWhereWithAggregatesInput>>
  NOT?: InputMaybe<Array<SubscriptionScalarWhereWithAggregatesInput>>
  OR?: InputMaybe<Array<SubscriptionScalarWhereWithAggregatesInput>>
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierWithAggregatesFilter>
  autoRenew?: InputMaybe<BoolWithAggregatesFilter>
  brokerId?: InputMaybe<StringWithAggregatesFilter>
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>
  currency?: InputMaybe<StringWithAggregatesFilter>
  discountEndDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  discountPercentage?: InputMaybe<IntWithAggregatesFilter>
  endDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  id?: InputMaybe<StringWithAggregatesFilter>
  paymentDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>
  paymentMethod?: InputMaybe<StringNullableWithAggregatesFilter>
  paymentReference?: InputMaybe<StringNullableWithAggregatesFilter>
  paymentStatus?: InputMaybe<StringWithAggregatesFilter>
  plan?: InputMaybe<StringWithAggregatesFilter>
  price?: InputMaybe<FloatWithAggregatesFilter>
  searchPrio?: InputMaybe<IntWithAggregatesFilter>
  slotCount?: InputMaybe<IntWithAggregatesFilter>
  slotCountAgency?: InputMaybe<IntWithAggregatesFilter>
  slotsActive?: InputMaybe<BoolWithAggregatesFilter>
  slotsActiveAgency?: InputMaybe<BoolWithAggregatesFilter>
  startDate?: InputMaybe<DateTimeWithAggregatesFilter>
  status?: InputMaybe<StringWithAggregatesFilter>
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>
  usedSlots?: InputMaybe<IntWithAggregatesFilter>
  usedSlotsAgency?: InputMaybe<IntWithAggregatesFilter>
}

export type SubscriptionSlotUsage = {
  __typename?: 'SubscriptionSlotUsage'
  brokerId: Scalars['String']['output']
  remainingSlots: Scalars['Int']['output']
  remainingSlotsAgency: Scalars['Int']['output']
  slotCount: Scalars['Int']['output']
  slotCountAgency: Scalars['Int']['output']
  slotsActive: Scalars['Boolean']['output']
  slotsActiveAgency: Scalars['Boolean']['output']
  usedSlots: Scalars['Int']['output']
  usedSlotsAgency: Scalars['Int']['output']
}

export type SubscriptionSumAggregate = {
  __typename?: 'SubscriptionSumAggregate'
  discountPercentage?: Maybe<Scalars['Int']['output']>
  price?: Maybe<Scalars['Float']['output']>
  searchPrio?: Maybe<Scalars['Int']['output']>
  slotCount?: Maybe<Scalars['Int']['output']>
  slotCountAgency?: Maybe<Scalars['Int']['output']>
  usedSlots?: Maybe<Scalars['Int']['output']>
  usedSlotsAgency?: Maybe<Scalars['Int']['output']>
}

export type SubscriptionSumOrderByAggregateInput = {
  discountPercentage?: InputMaybe<SortOrder>
  price?: InputMaybe<SortOrder>
  searchPrio?: InputMaybe<SortOrder>
  slotCount?: InputMaybe<SortOrder>
  slotCountAgency?: InputMaybe<SortOrder>
  usedSlots?: InputMaybe<SortOrder>
  usedSlotsAgency?: InputMaybe<SortOrder>
}

export type SubscriptionUpdateInput = {
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFieldUpdateOperationsInput>
  autoRenew?: InputMaybe<BoolFieldUpdateOperationsInput>
  broker?: InputMaybe<BrokerUpdateOneRequiredWithoutSubscriptionsNestedInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  discountPercentage?: InputMaybe<IntFieldUpdateOperationsInput>
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentStatus?: InputMaybe<StringFieldUpdateOperationsInput>
  plan?: InputMaybe<StringFieldUpdateOperationsInput>
  price?: InputMaybe<FloatFieldUpdateOperationsInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCount?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCountAgency?: InputMaybe<IntFieldUpdateOperationsInput>
  slotsActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  slotsActiveAgency?: InputMaybe<BoolFieldUpdateOperationsInput>
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  status?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  usedSlots?: InputMaybe<IntFieldUpdateOperationsInput>
  usedSlotsAgency?: InputMaybe<IntFieldUpdateOperationsInput>
}

export type SubscriptionUpdateManyMutationInput = {
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFieldUpdateOperationsInput>
  autoRenew?: InputMaybe<BoolFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  discountPercentage?: InputMaybe<IntFieldUpdateOperationsInput>
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentStatus?: InputMaybe<StringFieldUpdateOperationsInput>
  plan?: InputMaybe<StringFieldUpdateOperationsInput>
  price?: InputMaybe<FloatFieldUpdateOperationsInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCount?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCountAgency?: InputMaybe<IntFieldUpdateOperationsInput>
  slotsActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  slotsActiveAgency?: InputMaybe<BoolFieldUpdateOperationsInput>
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  status?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  usedSlots?: InputMaybe<IntFieldUpdateOperationsInput>
  usedSlotsAgency?: InputMaybe<IntFieldUpdateOperationsInput>
}

export type SubscriptionUpdateManyWithWhereWithoutBrokerInput = {
  data: SubscriptionUpdateManyMutationInput
  where: SubscriptionScalarWhereInput
}

export type SubscriptionUpdateManyWithoutBrokerNestedInput = {
  connect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<SubscriptionCreateOrConnectWithoutBrokerInput>>
  create?: InputMaybe<Array<SubscriptionCreateWithoutBrokerInput>>
  createMany?: InputMaybe<SubscriptionCreateManyBrokerInputEnvelope>
  delete?: InputMaybe<Array<SubscriptionWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<SubscriptionScalarWhereInput>>
  disconnect?: InputMaybe<Array<SubscriptionWhereUniqueInput>>
  set?: InputMaybe<Array<SubscriptionWhereUniqueInput>>
  update?: InputMaybe<Array<SubscriptionUpdateWithWhereUniqueWithoutBrokerInput>>
  updateMany?: InputMaybe<Array<SubscriptionUpdateManyWithWhereWithoutBrokerInput>>
  upsert?: InputMaybe<Array<SubscriptionUpsertWithWhereUniqueWithoutBrokerInput>>
}

export type SubscriptionUpdateWithWhereUniqueWithoutBrokerInput = {
  data: SubscriptionUpdateWithoutBrokerInput
  where: SubscriptionWhereUniqueInput
}

export type SubscriptionUpdateWithoutBrokerInput = {
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFieldUpdateOperationsInput>
  autoRenew?: InputMaybe<BoolFieldUpdateOperationsInput>
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  currency?: InputMaybe<StringFieldUpdateOperationsInput>
  discountEndDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  discountPercentage?: InputMaybe<IntFieldUpdateOperationsInput>
  endDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>
  paymentMethod?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentReference?: InputMaybe<NullableStringFieldUpdateOperationsInput>
  paymentStatus?: InputMaybe<StringFieldUpdateOperationsInput>
  plan?: InputMaybe<StringFieldUpdateOperationsInput>
  price?: InputMaybe<FloatFieldUpdateOperationsInput>
  searchPrio?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCount?: InputMaybe<IntFieldUpdateOperationsInput>
  slotCountAgency?: InputMaybe<IntFieldUpdateOperationsInput>
  slotsActive?: InputMaybe<BoolFieldUpdateOperationsInput>
  slotsActiveAgency?: InputMaybe<BoolFieldUpdateOperationsInput>
  startDate?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  status?: InputMaybe<StringFieldUpdateOperationsInput>
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>
  usedSlots?: InputMaybe<IntFieldUpdateOperationsInput>
  usedSlotsAgency?: InputMaybe<IntFieldUpdateOperationsInput>
}

export type SubscriptionUpsertWithWhereUniqueWithoutBrokerInput = {
  create: SubscriptionCreateWithoutBrokerInput
  update: SubscriptionUpdateWithoutBrokerInput
  where: SubscriptionWhereUniqueInput
}

export type SubscriptionWhereInput = {
  AND?: InputMaybe<Array<SubscriptionWhereInput>>
  NOT?: InputMaybe<Array<SubscriptionWhereInput>>
  OR?: InputMaybe<Array<SubscriptionWhereInput>>
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFilter>
  autoRenew?: InputMaybe<BoolFilter>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  discountEndDate?: InputMaybe<DateTimeNullableFilter>
  discountPercentage?: InputMaybe<IntFilter>
  endDate?: InputMaybe<DateTimeNullableFilter>
  id?: InputMaybe<StringFilter>
  paymentDate?: InputMaybe<DateTimeNullableFilter>
  paymentMethod?: InputMaybe<StringNullableFilter>
  paymentReference?: InputMaybe<StringNullableFilter>
  paymentStatus?: InputMaybe<StringFilter>
  plan?: InputMaybe<StringFilter>
  price?: InputMaybe<FloatFilter>
  searchPrio?: InputMaybe<IntFilter>
  slotCount?: InputMaybe<IntFilter>
  slotCountAgency?: InputMaybe<IntFilter>
  slotsActive?: InputMaybe<BoolFilter>
  slotsActiveAgency?: InputMaybe<BoolFilter>
  startDate?: InputMaybe<DateTimeFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  usedSlots?: InputMaybe<IntFilter>
  usedSlotsAgency?: InputMaybe<IntFilter>
}

export type SubscriptionWhereUniqueInput = {
  AND?: InputMaybe<Array<SubscriptionWhereInput>>
  NOT?: InputMaybe<Array<SubscriptionWhereInput>>
  OR?: InputMaybe<Array<SubscriptionWhereInput>>
  aiVisualsTier?: InputMaybe<EnumAiVisualsTierFilter>
  autoRenew?: InputMaybe<BoolFilter>
  broker?: InputMaybe<BrokerRelationFilter>
  brokerId?: InputMaybe<StringFilter>
  createdAt?: InputMaybe<DateTimeFilter>
  currency?: InputMaybe<StringFilter>
  discountEndDate?: InputMaybe<DateTimeNullableFilter>
  discountPercentage?: InputMaybe<IntFilter>
  endDate?: InputMaybe<DateTimeNullableFilter>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<DateTimeNullableFilter>
  paymentMethod?: InputMaybe<StringNullableFilter>
  paymentReference?: InputMaybe<StringNullableFilter>
  paymentStatus?: InputMaybe<StringFilter>
  plan?: InputMaybe<StringFilter>
  price?: InputMaybe<FloatFilter>
  searchPrio?: InputMaybe<IntFilter>
  slotCount?: InputMaybe<IntFilter>
  slotCountAgency?: InputMaybe<IntFilter>
  slotsActive?: InputMaybe<BoolFilter>
  slotsActiveAgency?: InputMaybe<BoolFilter>
  startDate?: InputMaybe<DateTimeFilter>
  status?: InputMaybe<StringFilter>
  updatedAt?: InputMaybe<DateTimeFilter>
  usedSlots?: InputMaybe<IntFilter>
  usedSlotsAgency?: InputMaybe<IntFilter>
}

export type SurfaceArea = {
  __typename?: 'SurfaceArea'
  built?: Maybe<Scalars['Int']['output']>
  gardenPlot?: Maybe<Scalars['Int']['output']>
  intFloorSpace?: Maybe<Scalars['Int']['output']>
  maxBuilt?: Maybe<Scalars['Int']['output']>
  maxGardenPlot?: Maybe<Scalars['Int']['output']>
  maxPlot?: Maybe<Scalars['Int']['output']>
  maxTerrace?: Maybe<Scalars['Int']['output']>
  plot?: Maybe<Scalars['Int']['output']>
  terrace?: Maybe<Scalars['Int']['output']>
}

export type SurfaceAreaCreateInput = {
  built?: InputMaybe<Scalars['Int']['input']>
  gardenPlot?: InputMaybe<Scalars['Int']['input']>
  intFloorSpace?: InputMaybe<Scalars['Int']['input']>
  maxBuilt?: InputMaybe<Scalars['Int']['input']>
  maxGardenPlot?: InputMaybe<Scalars['Int']['input']>
  maxPlot?: InputMaybe<Scalars['Int']['input']>
  maxTerrace?: InputMaybe<Scalars['Int']['input']>
  plot?: InputMaybe<Scalars['Int']['input']>
  terrace?: InputMaybe<Scalars['Int']['input']>
}

export type SurfaceAreaNullableCompositeFilter = {
  equals?: InputMaybe<SurfaceAreaObjectEqualityInput>
  is?: InputMaybe<SurfaceAreaWhereInput>
  isNot?: InputMaybe<SurfaceAreaWhereInput>
  isSet?: InputMaybe<Scalars['Boolean']['input']>
}

export type SurfaceAreaNullableCreateEnvelopeInput = {
  set?: InputMaybe<SurfaceAreaCreateInput>
}

export type SurfaceAreaNullableUpdateEnvelopeInput = {
  set?: InputMaybe<SurfaceAreaCreateInput>
  unset?: InputMaybe<Scalars['Boolean']['input']>
  upsert?: InputMaybe<SurfaceAreaUpsertInput>
}

export type SurfaceAreaObjectEqualityInput = {
  built?: InputMaybe<Scalars['Int']['input']>
  gardenPlot?: InputMaybe<Scalars['Int']['input']>
  intFloorSpace?: InputMaybe<Scalars['Int']['input']>
  maxBuilt?: InputMaybe<Scalars['Int']['input']>
  maxGardenPlot?: InputMaybe<Scalars['Int']['input']>
  maxPlot?: InputMaybe<Scalars['Int']['input']>
  maxTerrace?: InputMaybe<Scalars['Int']['input']>
  plot?: InputMaybe<Scalars['Int']['input']>
  terrace?: InputMaybe<Scalars['Int']['input']>
}

export type SurfaceAreaOrderByInput = {
  built?: InputMaybe<SortOrder>
  gardenPlot?: InputMaybe<SortOrder>
  intFloorSpace?: InputMaybe<SortOrder>
  maxBuilt?: InputMaybe<SortOrder>
  maxGardenPlot?: InputMaybe<SortOrder>
  maxPlot?: InputMaybe<SortOrder>
  maxTerrace?: InputMaybe<SortOrder>
  plot?: InputMaybe<SortOrder>
  terrace?: InputMaybe<SortOrder>
}

export type SurfaceAreaUpdateInput = {
  built?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  gardenPlot?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  intFloorSpace?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxBuilt?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxGardenPlot?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxPlot?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  maxTerrace?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  plot?: InputMaybe<NullableIntFieldUpdateOperationsInput>
  terrace?: InputMaybe<NullableIntFieldUpdateOperationsInput>
}

export type SurfaceAreaUpsertInput = {
  set: SurfaceAreaCreateInput
  update: SurfaceAreaUpdateInput
}

export type SurfaceAreaWhereInput = {
  AND?: InputMaybe<Array<SurfaceAreaWhereInput>>
  NOT?: InputMaybe<Array<SurfaceAreaWhereInput>>
  OR?: InputMaybe<Array<SurfaceAreaWhereInput>>
  built?: InputMaybe<IntNullableFilter>
  gardenPlot?: InputMaybe<IntNullableFilter>
  intFloorSpace?: InputMaybe<IntNullableFilter>
  maxBuilt?: InputMaybe<IntNullableFilter>
  maxGardenPlot?: InputMaybe<IntNullableFilter>
  maxPlot?: InputMaybe<IntNullableFilter>
  maxTerrace?: InputMaybe<IntNullableFilter>
  plot?: InputMaybe<IntNullableFilter>
  terrace?: InputMaybe<IntNullableFilter>
}

export type TranslationOutput = {
  __typename?: 'TranslationOutput'
  description?: Maybe<Scalars['String']['output']>
  language: Scalars['String']['output']
}

export type UnifiedContentHitGql = {
  __typename?: 'UnifiedContentHitGql'
  article?: Maybe<ArticleSearchCardGql>
  kind: Scalars['String']['output']
  property?: Maybe<PropertySearchCardLiteGql>
}

export type UnifiedContentSearchResponseGql = {
  __typename?: 'UnifiedContentSearchResponseGql'
  message?: Maybe<Scalars['String']['output']>
  results: Array<UnifiedContentHitGql>
  usedArticleSearch: Scalars['Boolean']['output']
  usedPropertySearch: Scalars['Boolean']['output']
  usedSemanticSearch: Scalars['Boolean']['output']
}

export type UpdateAgencyInput = {
  bannerUrl?: InputMaybe<Scalars['String']['input']>
  contactInfo?: InputMaybe<ContactInfoInput>
  description?: InputMaybe<Scalars['String']['input']>
  descriptions?: InputMaybe<Array<DescriptionInput>>
  email?: InputMaybe<Scalars['String']['input']>
  featureIds?: InputMaybe<Array<Scalars['String']['input']>>
  locationIds?: InputMaybe<Array<Scalars['String']['input']>>
  logoUrl?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  pictureUrl?: InputMaybe<Scalars['String']['input']>
  propertyTypeIds?: InputMaybe<Array<Scalars['String']['input']>>
  services?: InputMaybe<Array<Scalars['String']['input']>>
  slugUrl?: InputMaybe<Scalars['String']['input']>
}

export type UpdateAvailablePaidExtrasInput = {
  category?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  defaultPrice?: InputMaybe<Scalars['Int']['input']>
  description?: InputMaybe<Scalars['String']['input']>
  iconUrl?: InputMaybe<Scalars['String']['input']>
  isActive?: InputMaybe<Scalars['Boolean']['input']>
  label?: InputMaybe<Scalars['String']['input']>
  promoBannerUrl?: InputMaybe<Scalars['String']['input']>
  translations?: InputMaybe<Array<AvailablePaidExtrasTranslationInput>>
  type?: InputMaybe<Scalars['String']['input']>
}

export type UpdateCustomerSettingsInput = {
  acceptDigitalMarketing?: InputMaybe<Scalars['Boolean']['input']>
  address?: InputMaybe<Scalars['String']['input']>
  address2?: InputMaybe<Scalars['String']['input']>
  city?: InputMaybe<Scalars['String']['input']>
  company?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  currency?: InputMaybe<Scalars['String']['input']>
  facebook?: InputMaybe<Scalars['String']['input']>
  fax?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  foursquare?: InputMaybe<Scalars['String']['input']>
  instagram?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  linkedin?: InputMaybe<Scalars['String']['input']>
  mobile?: InputMaybe<Scalars['String']['input']>
  phoneNumber?: InputMaybe<Scalars['String']['input']>
  picUrl?: InputMaybe<Scalars['String']['input']>
  position?: InputMaybe<Scalars['String']['input']>
  preferred_locale?: InputMaybe<Scalars['String']['input']>
  skype?: InputMaybe<Scalars['String']['input']>
  state?: InputMaybe<Scalars['String']['input']>
  timezone?: InputMaybe<Scalars['String']['input']>
  twitter?: InputMaybe<Scalars['String']['input']>
  uiThemeName?: InputMaybe<Scalars['String']['input']>
  website?: InputMaybe<Scalars['String']['input']>
  zipCode?: InputMaybe<Scalars['String']['input']>
}

export type UpdatePermissionInput = {
  category?: InputMaybe<Scalars['String']['input']>
  description?: InputMaybe<Scalars['String']['input']>
}

export type UpdateRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>
  name?: InputMaybe<Scalars['String']['input']>
  permissions?: InputMaybe<Array<Scalars['String']['input']>>
}

export type UpdateSubscriptionInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  slotCount?: InputMaybe<Scalars['Int']['input']>
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type UpdateUserInput = {
  agencyId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstName?: InputMaybe<Scalars['String']['input']>
  lastName?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export type UpsertBrokerFrontendRealEstateSettingsInput = {
  brokerId?: InputMaybe<Scalars['String']['input']>
  propertyFlow?: InputMaybe<BrokerFrontendRealEstatePropertyFlowInput>
  prospectPdf?: InputMaybe<BrokerFrontendRealEstateProspectPdfInput>
}

export type UpsertBrokerLeadContactMauticInput = {
  address1?: InputMaybe<Scalars['String']['input']>
  brokerId: Scalars['String']['input']
  city?: InputMaybe<Scalars['String']['input']>
  country?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  firstname?: InputMaybe<Scalars['String']['input']>
  lastname?: InputMaybe<Scalars['String']['input']>
  mauticContactId?: InputMaybe<Scalars['Int']['input']>
  phone?: InputMaybe<Scalars['String']['input']>
}

export type UpsertSubscriptionInput = {
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>
  brokerId: Scalars['String']['input']
  currency?: InputMaybe<Scalars['String']['input']>
  discountPercentage?: InputMaybe<Scalars['Int']['input']>
  endDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  paymentDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  paymentMethod?: InputMaybe<Scalars['String']['input']>
  paymentReference?: InputMaybe<Scalars['String']['input']>
  paymentStatus?: InputMaybe<Scalars['String']['input']>
  plan: Scalars['String']['input']
  price?: InputMaybe<Scalars['Float']['input']>
  searchPrio?: InputMaybe<Scalars['Int']['input']>
  slotCount?: InputMaybe<Scalars['Int']['input']>
  slotCountAgency?: InputMaybe<Scalars['Int']['input']>
  slotsActive?: InputMaybe<Scalars['Boolean']['input']>
  slotsActiveAgency?: InputMaybe<Scalars['Boolean']['input']>
  startDate?: InputMaybe<Scalars['DateTimeISO']['input']>
  status?: InputMaybe<Scalars['String']['input']>
  usedSlots?: InputMaybe<Scalars['Int']['input']>
  usedSlotsAgency?: InputMaybe<Scalars['Int']['input']>
}

export type UserActivityModel = {
  __typename?: 'UserActivityModel'
  createdAt: Scalars['String']['output']
  description: Scalars['String']['output']
  deviceInfo?: Maybe<Scalars['String']['output']>
  id: Scalars['String']['output']
  ipAddress?: Maybe<Scalars['String']['output']>
  type: Scalars['String']['output']
}

export type UserAgencyAssociationModel = {
  __typename?: 'UserAgencyAssociationModel'
  agencyId: Scalars['String']['output']
  agencyName: Scalars['String']['output']
  associatedAt: Scalars['String']['output']
  userType: Scalars['String']['output']
}

export type UserFilters = {
  active?: InputMaybe<Scalars['Boolean']['input']>
  agencyId?: InputMaybe<Scalars['String']['input']>
  email?: InputMaybe<Scalars['String']['input']>
  role?: InputMaybe<Scalars['String']['input']>
}

export type UserGrowthModel = {
  __typename?: 'UserGrowthModel'
  last7Days: Scalars['Float']['output']
  last30Days: Scalars['Float']['output']
  last90Days: Scalars['Float']['output']
}

export type UserLoginActivityModel = {
  __typename?: 'UserLoginActivityModel'
  last7Days: Scalars['Float']['output']
  last30Days: Scalars['Float']['output']
  last90Days: Scalars['Float']['output']
}

export type UserPermissionModel = {
  __typename?: 'UserPermissionModel'
  expiresAt?: Maybe<Scalars['DateTimeISO']['output']>
  grantedAt: Scalars['DateTimeISO']['output']
  grantedBy: Scalars['String']['output']
  id: Scalars['ID']['output']
  permission: PermissionModel
  permissionId: Scalars['String']['output']
  userId: Scalars['String']['output']
}

export type UserStatsModel = {
  __typename?: 'UserStatsModel'
  accountCreatedAt: Scalars['String']['output']
  agencyAssociations: Array<UserAgencyAssociationModel>
  email: Scalars['String']['output']
  failedLogins: Scalars['Float']['output']
  lastActivity: Scalars['String']['output']
  lastLogin?: Maybe<Scalars['String']['output']>
  loginActivity: UserLoginActivityModel
  recentActivity: Array<UserActivityModel>
  recentLogins: Scalars['Float']['output']
  totalLogins: Scalars['Float']['output']
  userId: Scalars['String']['output']
}

export type ValidatedLocationResponse = {
  __typename?: 'ValidatedLocationResponse'
  locations?: Maybe<Array<LocationSuggestion>>
  municipality?: Maybe<Scalars['String']['output']>
  searchResults: LocationSearchResponse
}

export type ValuationContributionGql = {
  __typename?: 'ValuationContributionGql'
  label: Scalars['String']['output']
  name: Scalars['String']['output']
  shapLog?: Maybe<Scalars['Float']['output']>
  valueFloat: Scalars['Float']['output']
}

export type Video = {
  __typename?: 'Video'
  format: Scalars['String']['output']
  id: Scalars['String']['output']
  propertyId: Scalars['String']['output']
  provider: Scalars['String']['output']
  video: Array<Scalars['String']['output']>
}

export type VideoCreateManyPropertyInput = {
  format?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  video?: InputMaybe<VideoCreatevideoInput>
}

export type VideoCreateManyPropertyInputEnvelope = {
  data: Array<VideoCreateManyPropertyInput>
}

export type VideoCreateNestedManyWithoutPropertyInput = {
  connect?: InputMaybe<Array<VideoWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<VideoCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<VideoCreateWithoutPropertyInput>>
  createMany?: InputMaybe<VideoCreateManyPropertyInputEnvelope>
}

export type VideoCreateOrConnectWithoutPropertyInput = {
  create: VideoCreateWithoutPropertyInput
  where: VideoWhereUniqueInput
}

export type VideoCreateWithoutPropertyInput = {
  format?: InputMaybe<Scalars['String']['input']>
  id?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<Scalars['String']['input']>
  video?: InputMaybe<VideoCreatevideoInput>
}

export type VideoCreatevideoInput = {
  set: Array<Scalars['String']['input']>
}

export type VideoListRelationFilter = {
  every?: InputMaybe<VideoWhereInput>
  none?: InputMaybe<VideoWhereInput>
  some?: InputMaybe<VideoWhereInput>
}

export type VideoOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>
}

export type VideoOrderByWithRelationInput = {
  format?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  property?: InputMaybe<PropertyOrderByWithRelationInput>
  propertyId?: InputMaybe<SortOrder>
  provider?: InputMaybe<SortOrder>
  video?: InputMaybe<SortOrder>
}

export enum VideoScalarFieldEnum {
  Format = 'format',
  Id = 'id',
  PropertyId = 'propertyId',
  Provider = 'provider',
  Video = 'video',
}

export type VideoScalarWhereInput = {
  AND?: InputMaybe<Array<VideoScalarWhereInput>>
  NOT?: InputMaybe<Array<VideoScalarWhereInput>>
  OR?: InputMaybe<Array<VideoScalarWhereInput>>
  format?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  propertyId?: InputMaybe<StringFilter>
  provider?: InputMaybe<StringFilter>
  video?: InputMaybe<StringNullableListFilter>
}

export type VideoUpdateManyMutationInput = {
  format?: InputMaybe<StringFieldUpdateOperationsInput>
  provider?: InputMaybe<StringFieldUpdateOperationsInput>
  video?: InputMaybe<VideoUpdatevideoInput>
}

export type VideoUpdateManyWithWhereWithoutPropertyInput = {
  data: VideoUpdateManyMutationInput
  where: VideoScalarWhereInput
}

export type VideoUpdateManyWithoutPropertyNestedInput = {
  connect?: InputMaybe<Array<VideoWhereUniqueInput>>
  connectOrCreate?: InputMaybe<Array<VideoCreateOrConnectWithoutPropertyInput>>
  create?: InputMaybe<Array<VideoCreateWithoutPropertyInput>>
  createMany?: InputMaybe<VideoCreateManyPropertyInputEnvelope>
  delete?: InputMaybe<Array<VideoWhereUniqueInput>>
  deleteMany?: InputMaybe<Array<VideoScalarWhereInput>>
  disconnect?: InputMaybe<Array<VideoWhereUniqueInput>>
  set?: InputMaybe<Array<VideoWhereUniqueInput>>
  update?: InputMaybe<Array<VideoUpdateWithWhereUniqueWithoutPropertyInput>>
  updateMany?: InputMaybe<Array<VideoUpdateManyWithWhereWithoutPropertyInput>>
  upsert?: InputMaybe<Array<VideoUpsertWithWhereUniqueWithoutPropertyInput>>
}

export type VideoUpdateWithWhereUniqueWithoutPropertyInput = {
  data: VideoUpdateWithoutPropertyInput
  where: VideoWhereUniqueInput
}

export type VideoUpdateWithoutPropertyInput = {
  format?: InputMaybe<StringFieldUpdateOperationsInput>
  provider?: InputMaybe<StringFieldUpdateOperationsInput>
  video?: InputMaybe<VideoUpdatevideoInput>
}

export type VideoUpdatevideoInput = {
  push?: InputMaybe<Array<Scalars['String']['input']>>
  set?: InputMaybe<Array<Scalars['String']['input']>>
}

export type VideoUpsertWithWhereUniqueWithoutPropertyInput = {
  create: VideoCreateWithoutPropertyInput
  update: VideoUpdateWithoutPropertyInput
  where: VideoWhereUniqueInput
}

export type VideoWhereInput = {
  AND?: InputMaybe<Array<VideoWhereInput>>
  NOT?: InputMaybe<Array<VideoWhereInput>>
  OR?: InputMaybe<Array<VideoWhereInput>>
  format?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<StringFilter>
  provider?: InputMaybe<StringFilter>
  video?: InputMaybe<StringNullableListFilter>
}

export type VideoWhereUniqueInput = {
  AND?: InputMaybe<Array<VideoWhereInput>>
  NOT?: InputMaybe<Array<VideoWhereInput>>
  OR?: InputMaybe<Array<VideoWhereInput>>
  format?: InputMaybe<StringFilter>
  id?: InputMaybe<Scalars['String']['input']>
  property?: InputMaybe<PropertyRelationFilter>
  propertyId?: InputMaybe<Scalars['String']['input']>
  provider?: InputMaybe<StringFilter>
  video?: InputMaybe<StringNullableListFilter>
}

export type GetAgenciesQueryVariables = Exact<{ [key: string]: never }>

export type GetAgenciesQuery = {
  __typename?: 'Query'
  getAgencies?: Array<{
    __typename?: 'Broker'
    id: string
    name: string
    email?: string | null
    agencyId?: string | null
    pictureUrl?: string | null
    bannerUrl?: string | null
    logoUrl?: string | null
    slugUrl?: string | null
    userIds: Array<string>
    services: Array<string>
    locationIds: Array<string>
    propertyTypeIds: Array<string>
    featureIds: Array<string>
    brokerLeadContactMauticId?: number | null
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    contactInfo?: {
      __typename?: 'ContactInfo'
      email: string
      phone: string
      mobile?: string | null
      fax?: string | null
      website?: string | null
      facebook?: string | null
      twitter?: string | null
      linkedin?: string | null
      instagram?: string | null
      whatsapp?: string | null
      x?: string | null
      address?: {
        __typename?: 'Address'
        label?: string | null
        countryCode?: string | null
        countryName?: string | null
        stateCode?: string | null
        state?: string | null
        county?: string | null
        city?: string | null
        district?: string | null
        postalCode?: string | null
        street?: string | null
      } | null
    } | null
    products: Array<{ __typename?: 'Product'; name: string; type: string }>
    users?: Array<{
      __typename?: 'AgentModel'
      userId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      roles: Array<string>
      picUrl?: string | null
      createdAt: any
      updatedAt: any
      lastLogin?: any | null
      deletedAt?: any | null
    }> | null
  }> | null
}

export type UpsertBrokerLeadContactMauticMutationVariables = Exact<{
  input: UpsertBrokerLeadContactMauticInput
}>

export type UpsertBrokerLeadContactMauticMutation = {
  __typename?: 'Mutation'
  upsertBrokerLeadContactMautic: {
    __typename?: 'Broker'
    id: string
    name: string
    brokerLeadContactMauticId?: number | null
  }
}

export type BrokerLeadContactMauticPreviewQueryVariables = Exact<{
  brokerId: Scalars['String']['input']
}>

export type BrokerLeadContactMauticPreviewQuery = {
  __typename?: 'Query'
  brokerLeadContactMauticPreview: {
    __typename?: 'BrokerLeadContactMauticPreview'
    ok: boolean
    mauticContactId?: number | null
    email?: string | null
    firstName?: string | null
    lastName?: string | null
    displayLabel?: string | null
    error?: string | null
  }
}

export type GetAgencyQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type GetAgencyQuery = {
  __typename?: 'Query'
  getAgency?: {
    __typename?: 'Broker'
    id: string
    agencyId?: string | null
    name: string
    email?: string | null
    pictureUrl?: string | null
    bannerUrl?: string | null
    logoUrl?: string | null
    slugUrl?: string | null
    userIds: Array<string>
    services: Array<string>
    locationIds: Array<string>
    propertyTypeIds: Array<string>
    featureIds: Array<string>
    brokerLeadContactMauticId?: number | null
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    contactInfo?: {
      __typename?: 'ContactInfo'
      email: string
      phone: string
      mobile?: string | null
      fax?: string | null
      website?: string | null
      facebook?: string | null
      twitter?: string | null
      linkedin?: string | null
      instagram?: string | null
      whatsapp?: string | null
      x?: string | null
      address?: {
        __typename?: 'Address'
        label?: string | null
        countryCode?: string | null
        countryName?: string | null
        stateCode?: string | null
        state?: string | null
        county?: string | null
        city?: string | null
        district?: string | null
        postalCode?: string | null
        street?: string | null
      } | null
    } | null
    products: Array<{ __typename?: 'Product'; name: string; type: string }>
    users?: Array<{
      __typename?: 'AgentModel'
      userId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      roles: Array<string>
      picUrl?: string | null
      createdAt: any
      updatedAt: any
      lastLogin?: any | null
      deletedAt?: any | null
    }> | null
  } | null
}

export type ListAllAgenciesAgentsQueryVariables = Exact<{ [key: string]: never }>

export type ListAllAgenciesAgentsQuery = {
  __typename?: 'Query'
  listAllAgents: Array<{
    __typename?: 'AgentModel'
    userId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    picUrl?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    agency?: {
      __typename?: 'Broker'
      id: string
      name: string
      email?: string | null
      agencyId?: string | null
      bannerUrl?: string | null
      logoUrl?: string | null
      pictureUrl?: string | null
      slugUrl?: string | null
      userIds: Array<string>
      contactInfo?: {
        __typename?: 'ContactInfo'
        phone: string
        email: string
        website?: string | null
      } | null
    } | null
  }>
}

export type CreateAgencyMutationVariables = Exact<{
  input: CreateAgencyInput
}>

export type CreateAgencyMutation = {
  __typename?: 'Mutation'
  createAgency: {
    __typename?: 'Broker'
    id: string
    name: string
    email?: string | null
    pictureUrl?: string | null
    agencyId?: string | null
    bannerUrl?: string | null
    logoUrl?: string | null
    slugUrl?: string | null
    services: Array<string>
    locationIds: Array<string>
    propertyTypeIds: Array<string>
    featureIds: Array<string>
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    contactInfo?: {
      __typename?: 'ContactInfo'
      email: string
      phone: string
      mobile?: string | null
      fax?: string | null
      website?: string | null
      facebook?: string | null
      twitter?: string | null
      linkedin?: string | null
      instagram?: string | null
      whatsapp?: string | null
      x?: string | null
      address?: {
        __typename?: 'Address'
        label?: string | null
        countryCode?: string | null
        countryName?: string | null
        stateCode?: string | null
        state?: string | null
        county?: string | null
        city?: string | null
        district?: string | null
        postalCode?: string | null
        street?: string | null
      } | null
    } | null
  }
}

export type UpdateAgencyMutationVariables = Exact<{
  id: Scalars['String']['input']
  input: UpdateAgencyInput
}>

export type UpdateAgencyMutation = {
  __typename?: 'Mutation'
  updateAgency: {
    __typename?: 'Broker'
    id: string
    name: string
    email?: string | null
    pictureUrl?: string | null
    agencyId?: string | null
    bannerUrl?: string | null
    logoUrl?: string | null
    slugUrl?: string | null
    services: Array<string>
    locationIds: Array<string>
    propertyTypeIds: Array<string>
    featureIds: Array<string>
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    contactInfo?: {
      __typename?: 'ContactInfo'
      email: string
      phone: string
      mobile?: string | null
      fax?: string | null
      website?: string | null
      facebook?: string | null
      twitter?: string | null
      linkedin?: string | null
      instagram?: string | null
      whatsapp?: string | null
      x?: string | null
      address?: {
        __typename?: 'Address'
        label?: string | null
        countryCode?: string | null
        countryName?: string | null
        stateCode?: string | null
        state?: string | null
        county?: string | null
        city?: string | null
        district?: string | null
        postalCode?: string | null
        street?: string | null
      } | null
    } | null
  }
}

export type DeleteAgencyMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeleteAgencyMutation = { __typename?: 'Mutation'; deleteAgency: boolean }

export type AssignUserToAgencyMutationVariables = Exact<{
  input: AssignUserToAgencyInput
}>

export type AssignUserToAgencyMutation = {
  __typename?: 'Mutation'
  assignUserToAgency: {
    __typename?: 'AgencyOperationResponse'
    success: boolean
    message?: string | null
  }
}

export type RemoveUserFromAgencyMutationVariables = Exact<{
  userId: Scalars['String']['input']
  agencyId: Scalars['String']['input']
}>

export type RemoveUserFromAgencyMutation = {
  __typename?: 'Mutation'
  removeUserFromAgency: {
    __typename?: 'AgencyOperationResponse'
    success: boolean
    message?: string | null
  }
}

export type StartBrokerSiteOnboardingMutationVariables = Exact<{
  input: StartBrokerSiteOnboardingInput
}>

export type StartBrokerSiteOnboardingMutation = {
  __typename?: 'Mutation'
  startBrokerSiteOnboarding: {
    __typename?: 'StartBrokerSiteOnboardingResult'
    ok: boolean
    slug: string
    manifestPath: string
    commitSha?: string | null
    commitUrl?: string | null
    workflowActionsUrl: string
    message?: string | null
  }
}

export type BrokerSitesIndexQueryVariables = Exact<{
  checkReachability?: InputMaybe<Scalars['Boolean']['input']>
}>

export type BrokerSitesIndexQuery = {
  __typename?: 'Query'
  brokerSitesIndex: Array<{
    __typename?: 'BrokerSiteIndexEntry'
    slug: string
    displayName: string
    brokerId: string
    tagline?: string | null
    sourceWebsiteUrl?: string | null
    stagingUrl?: string | null
    productionUrl?: string | null
    customerOwnedDomain?: string | null
    locales: Array<string>
    manifestPath: string
    manifestUrl: string
    githubRepoUrl: string
    githubRepoExists: boolean
    workflowActionsUrl: string
    clickupListName: string
    clickupSpaceUrl: string
    clickupListUrl?: string | null
    mattermostChannelName: string
    mattermostChannelUrl?: string | null
    staging?: {
      __typename?: 'BrokerSiteEndpointStatus'
      url: string
      reachability: BrokerSiteReachability
      statusCode?: number | null
    } | null
    production?: {
      __typename?: 'BrokerSiteEndpointStatus'
      url: string
      reachability: BrokerSiteReachability
      statusCode?: number | null
    } | null
  }>
}

export type DashboardStatsQueryVariables = Exact<{ [key: string]: never }>

export type DashboardStatsQuery = {
  __typename?: 'Query'
  dashboardStats: {
    __typename?: 'DashboardStatsModel'
    totalUsers: number
    activeUsers: number
    customerCount: number
    totalAgencies: number
    agenciesWithUsers: number
    totalRoles: number
    totalPermissions: number
    recentActivities: number
    userGrowth: {
      __typename?: 'UserGrowthModel'
      last7Days: number
      last30Days: number
      last90Days: number
    }
    agencyDistribution: Array<{
      __typename?: 'AgencyDistributionModel'
      agencyId: string
      agencyName: string
      userCount: number
      managerCount: number
      regularUserCount: number
    }>
    recentActivity: Array<{
      __typename?: 'RecentActivityModel'
      id: string
      type: string
      description: string
      createdAt: string
      userId?: string | null
      agencyId?: string | null
    }>
  }
}

export type AgencyStatsQueryVariables = Exact<{
  agencyId: Scalars['String']['input']
}>

export type AgencyStatsQuery = {
  __typename?: 'Query'
  agencyStats: {
    __typename?: 'AgencyStatsModel'
    agencyId: string
    agencyName: string
    totalUsers: number
    managerCount: number
    userCount: number
    recentLogins: number
    lastActivity: string
    userGrowth: {
      __typename?: 'UserGrowthModel'
      last7Days: number
      last30Days: number
      last90Days: number
    }
    recentActivity: Array<{
      __typename?: 'RecentActivityModel'
      id: string
      type: string
      description: string
      createdAt: string
      userId?: string | null
    }>
  }
}

export type LegacyDashboardStatsQueryVariables = Exact<{ [key: string]: never }>

export type LegacyDashboardStatsQuery = {
  __typename?: 'Query'
  listAllAgents: Array<{
    __typename?: 'AgentModel'
    userId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    deletedAt?: any | null
    createdAt: any
    updatedAt: any
    agency?: { __typename?: 'Broker'; id: string; name: string } | null
  }>
}

export type UserActivityQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type UserActivityQuery = { __typename: 'Query' }

export type FetchDuplicatesQueryVariables = Exact<{
  limit: Scalars['Float']['input']
  lastEvaluatedKey?: InputMaybe<Scalars['String']['input']>
}>

export type FetchDuplicatesQuery = {
  __typename?: 'Query'
  fetchDuplicates: {
    __typename?: 'DuplicatesResponseModel'
    message: string
    count: number
    actualDuplicateCount: number
    duplicateGroupCount: number
    lastEvaluatedKey?: string | null
    hasMore: boolean
    requestId: string
    duplicates: Array<{
      __typename?: 'DuplicateItemModel'
      propertyId: string
      fileName: string
      imageHash: string
      exactHash: string
      collidedPropertyId?: string | null
      checkedAt: string
    }>
    duplicateGroups: Array<{
      __typename?: 'DuplicateGroupModel'
      hash: string
      count: number
      items: Array<{
        __typename?: 'DuplicateItemModel'
        propertyId: string
        fileName: string
        imageHash: string
        exactHash: string
        collidedPropertyId?: string | null
        checkedAt: string
      }>
    }>
    actualDuplicates: Array<{
      __typename?: 'DuplicateItemModel'
      propertyId: string
      fileName: string
      imageHash: string
      exactHash: string
      collidedPropertyId?: string | null
      checkedAt: string
    }>
  }
}

export type LeadsListQueryVariables = Exact<{
  where?: InputMaybe<LeadWhereInput>
  orderBy?: InputMaybe<Array<LeadOrderByWithRelationInput> | LeadOrderByWithRelationInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type LeadsListQuery = {
  __typename?: 'Query'
  leadsCount: {
    __typename?: 'AggregateLead'
    _count?: { __typename?: 'LeadCountAggregate'; _all: number } | null
  }
  leads: Array<{
    __typename?: 'Lead'
    id: string
    name?: string | null
    email?: string | null
    phone?: string | null
    message?: string | null
    source?: string | null
    utm_source?: string | null
    utm_medium?: string | null
    utm_campaign?: string | null
    utm_content?: string | null
    utm_term?: string | null
    status?: string | null
    adminStatus?: string | null
    priority?: string | null
    assignedTo?: string | null
    brokerId?: string | null
    propertyId?: string | null
    propertyRef?: string | null
    mauticId?: number | null
    listPosition?: number | null
    createdAt: any
    leadSubmittedAt?: any | null
    updatedAt: any
    personalData?: { __typename?: 'PersonalData'; country?: string | null } | null
    broker?: { __typename?: 'Broker'; bannerUrl?: string | null } | null
    property?: {
      __typename?: 'Property'
      externalId: string
      agencyRef?: string | null
      images?: { __typename?: 'Images'; small: Array<string> } | null
    } | null
    mauticStats?: {
      __typename?: 'MauticStats'
      points?: number | null
      emailVerified?: boolean | null
      phoneVerified?: boolean | null
      originallySubmittedAt?: string | null
      leadSource?: string | null
      originalFormName?: string | null
      inboxUrl?: string | null
    } | null
    leadScoring?: {
      __typename?: 'LeadScoringReport'
      osintPhoneFound?: boolean | null
      verifiedEmailValid?: boolean | null
    } | null
    leadNotes: Array<{
      __typename?: 'LeadNote'
      id: string
      content: string
      updatedBy?: string | null
      updatedAt: any
    }>
  }>
}

export type SearchLeadsQueryVariables = Exact<{
  search: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchLeadsQuery = {
  __typename?: 'Query'
  searchLeads: Array<{
    __typename?: 'Lead'
    id: string
    name?: string | null
    email?: string | null
    phone?: string | null
    message?: string | null
    source?: string | null
    utm_source?: string | null
    utm_medium?: string | null
    utm_campaign?: string | null
    utm_content?: string | null
    utm_term?: string | null
    status?: string | null
    adminStatus?: string | null
    priority?: string | null
    assignedTo?: string | null
    brokerId?: string | null
    propertyId?: string | null
    propertyRef?: string | null
    mauticId?: number | null
    listPosition?: number | null
    createdAt: any
    updatedAt: any
    personalData?: { __typename?: 'PersonalData'; country?: string | null } | null
    broker?: { __typename?: 'Broker'; bannerUrl?: string | null } | null
    property?: {
      __typename?: 'Property'
      externalId: string
      agencyRef?: string | null
      images?: { __typename?: 'Images'; small: Array<string> } | null
    } | null
    mauticStats?: {
      __typename?: 'MauticStats'
      points?: number | null
      emailVerified?: boolean | null
      phoneVerified?: boolean | null
      originallySubmittedAt?: string | null
      leadSource?: string | null
      originalFormName?: string | null
      inboxUrl?: string | null
    } | null
    leadScoring?: {
      __typename?: 'LeadScoringReport'
      osintPhoneFound?: boolean | null
      verifiedEmailValid?: boolean | null
    } | null
    leadNotes: Array<{
      __typename?: 'LeadNote'
      id: string
      content: string
      updatedBy?: string | null
      updatedAt: any
    }>
  }>
}

export type LeadScoringQueryVariables = Exact<{
  where: LeadWhereUniqueInput
}>

export type LeadScoringQuery = {
  __typename?: 'Query'
  getLead?: {
    __typename?: 'Lead'
    id: string
    leadScoring?: {
      __typename?: 'LeadScoringReport'
      osintEmailFound?: boolean | null
      osintEmailSites?: number | null
      osintGhuntFound?: boolean | null
      osintPhoneFound?: boolean | null
      osintUsernameFound?: boolean | null
      osintUsernameSites?: number | null
      verifiedEmailValid?: boolean | null
      verifiedEmailStatus?: string | null
      totalLeadScoreComputed?: number | null
      osintScoreBonus?: number | null
      totalLeadScoreFinal?: number | null
    } | null
  } | null
}

export type LeadDetailQueryVariables = Exact<{
  where: LeadWhereUniqueInput
}>

export type LeadDetailQuery = {
  __typename?: 'Query'
  getLead?: {
    __typename?: 'Lead'
    id: string
    name?: string | null
    email?: string | null
    phone?: string | null
    message?: string | null
    status?: string | null
    adminStatus?: string | null
    priority?: string | null
    assignedTo?: string | null
    brokerId?: string | null
    propertyId?: string | null
    propertyRef?: string | null
    mauticId?: number | null
    listPosition?: number | null
    createdAt: any
    updatedAt: any
    mauticUrl?: string | null
    broker?: {
      __typename?: 'Broker'
      id: string
      name: string
      brokerLeadContactMauticId?: number | null
    } | null
    leadScoring?: {
      __typename?: 'LeadScoringReport'
      osintEmailFound?: boolean | null
      osintEmailSites?: number | null
      osintGhuntFound?: boolean | null
      osintPhoneFound?: boolean | null
      osintUsernameFound?: boolean | null
      osintUsernameSites?: number | null
      verifiedEmailValid?: boolean | null
      verifiedEmailStatus?: string | null
      totalLeadScoreComputed?: number | null
      osintScoreBonus?: number | null
      totalLeadScoreFinal?: number | null
    } | null
    mauticFormData?: Array<{
      __typename?: 'MauticFormDataEntry'
      alias: string
      label?: string | null
      value?: string | null
    }> | null
    mauticMostRecentForm?: {
      __typename?: 'MauticMostRecentForm'
      formName?: string | null
      submittedAt?: string | null
      entries: Array<{
        __typename?: 'MauticFormQuestionAnswer'
        question: string
        answer?: string | null
      }>
    } | null
    mauticStats?: {
      __typename?: 'MauticStats'
      points?: number | null
      tagNames?: Array<string> | null
      lastActive?: string | null
      emailVerified?: boolean | null
      phoneVerified?: boolean | null
      originallySubmittedAt?: string | null
      leadSource?: string | null
      originalFormName?: string | null
    } | null
    leadCrmInsights?: {
      __typename?: 'LeadCrmInsights'
      marketingConsent?: boolean | null
      marketConsentDate?: string | null
      marketConsentVersion?: string | null
      aiIntentSummary?: string | null
      aiBuyerStage?: string | null
      aiCallReadiness?: string | null
      aiPriority?: string | null
      aiLeadType?: string | null
      aiScoreNotes?: string | null
      aiUnmappedKeys?: string | null
    } | null
    leadNotes: Array<{
      __typename?: 'LeadNote'
      id: string
      content: string
      updatedBy?: string | null
      updatedAt: any
    }>
  } | null
}

export type LeadsGroupByAdminStatusQueryVariables = Exact<{
  where?: InputMaybe<LeadWhereInput>
}>

export type LeadsGroupByAdminStatusQuery = {
  __typename?: 'Query'
  groupByLead: Array<{
    __typename?: 'LeadGroupBy'
    adminStatus?: string | null
    _count?: { __typename?: 'LeadCountAggregate'; _all: number } | null
  }>
}

export type LeadsByAgencyQueryVariables = Exact<{
  where?: InputMaybe<LeadWhereInput>
}>

export type LeadsByAgencyQuery = {
  __typename?: 'Query'
  groupByLead: Array<{
    __typename?: 'LeadGroupBy'
    brokerId?: string | null
    _count?: { __typename?: 'LeadCountAggregate'; _all: number } | null
  }>
}

export type LeadsByPropertyQueryVariables = Exact<{
  where?: InputMaybe<LeadWhereInput>
}>

export type LeadsByPropertyQuery = {
  __typename?: 'Query'
  groupByLead: Array<{
    __typename?: 'LeadGroupBy'
    propertyId?: string | null
    _count?: { __typename?: 'LeadCountAggregate'; _all: number } | null
  }>
}

export type UpdateLeadMutationVariables = Exact<{
  where: LeadWhereUniqueInput
  data: LeadUpdateInput
}>

export type UpdateLeadMutation = {
  __typename?: 'Mutation'
  updateLead: {
    __typename?: 'Lead'
    id: string
    name?: string | null
    email?: string | null
    phone?: string | null
    message?: string | null
    status?: string | null
    adminStatus?: string | null
    priority?: string | null
    assignedTo?: string | null
    brokerId?: string | null
    propertyId?: string | null
    propertyRef?: string | null
    updatedAt: any
  }
}

export type DeleteLeadMutationVariables = Exact<{
  where: LeadWhereUniqueInput
}>

export type DeleteLeadMutation = {
  __typename?: 'Mutation'
  deleteLead: { __typename?: 'Lead'; id: string }
}

export type AddLeadNoteMutationVariables = Exact<{
  id: Scalars['String']['input']
  note: Scalars['String']['input']
}>

export type AddLeadNoteMutation = {
  __typename?: 'Mutation'
  addLeadNote: {
    __typename?: 'Lead'
    id: string
    leadNotes: Array<{
      __typename?: 'LeadNote'
      id: string
      content: string
      updatedBy?: string | null
      updatedAt: any
    }>
  }
}

export type UpdateLeadListPositionMutationVariables = Exact<{
  id: Scalars['String']['input']
  listPosition: Scalars['Float']['input']
}>

export type UpdateLeadListPositionMutation = {
  __typename?: 'Mutation'
  updateLeadListPosition: { __typename?: 'Lead'; id: string; listPosition?: number | null }
}

export type AssignLeadToBrokerMutationVariables = Exact<{
  id: Scalars['String']['input']
  brokerId: Scalars['String']['input']
}>

export type AssignLeadToBrokerMutation = {
  __typename?: 'Mutation'
  assignLeadToBroker: { __typename?: 'Lead'; id: string; brokerId?: string | null }
}

export type UpdateLeadStatusMutationVariables = Exact<{
  id: Scalars['String']['input']
  status: Scalars['String']['input']
}>

export type UpdateLeadStatusMutation = {
  __typename?: 'Mutation'
  updateLeadStatus: { __typename?: 'Lead'; id: string; status?: string | null }
}

export type UpdateLeadAdminStatusMutationVariables = Exact<{
  id: Scalars['String']['input']
  adminStatus: Scalars['String']['input']
}>

export type UpdateLeadAdminStatusMutation = {
  __typename?: 'Mutation'
  updateLeadAdminStatus: { __typename?: 'Lead'; id: string; adminStatus?: string | null }
}

export type TriggerLeadScoringMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type TriggerLeadScoringMutation = { __typename?: 'Mutation'; triggerLeadScoring: boolean }

export type SendBrokerLeadNotificationEmailMutationVariables = Exact<{
  leadId: Scalars['String']['input']
}>

export type SendBrokerLeadNotificationEmailMutation = {
  __typename?: 'Mutation'
  sendBrokerLeadNotificationEmail: {
    __typename?: 'SendBrokerLeadNotificationPayload'
    success: boolean
    message?: string | null
  }
}

export type MunicipalitiesWithPropertiesQueryVariables = Exact<{
  where?: InputMaybe<MunicipalityWhereInput>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type MunicipalitiesWithPropertiesQuery = {
  __typename?: 'Query'
  municipalities: Array<{
    __typename?: 'Municipality'
    id: string
    name: string
    normalizedName?: string | null
    _count?: { __typename?: 'MunicipalityCount'; properties: number } | null
  }>
}

export type LocationsWithGeoQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type LocationsWithGeoQuery = {
  __typename?: 'Query'
  locations: Array<{
    __typename?: 'Location'
    id: string
    location?: string | null
    town?: string | null
    area?: string | null
    municipalityId?: string | null
    municipalityName?: string | null
    province?: string | null
    provinceId?: string | null
    country?: string | null
    _count?: { __typename?: 'LocationCount'; properties: number } | null
  }>
}

export type MunicipalitiesWithLocationsQueryVariables = Exact<{
  where?: InputMaybe<MunicipalityWhereInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type MunicipalitiesWithLocationsQuery = {
  __typename?: 'Query'
  municipalities: Array<{
    __typename?: 'Municipality'
    id: string
    name: string
    normalizedName?: string | null
    locations: Array<{
      __typename?: 'Location'
      id: string
      municipalityId?: string | null
      provinceId?: string | null
      _count?: { __typename?: 'LocationCount'; properties: number } | null
    }>
    _count?: { __typename?: 'MunicipalityCount'; locations: number } | null
  }>
}

export type MunicipalitiesListQueryVariables = Exact<{
  where?: InputMaybe<MunicipalityWhereInput>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type MunicipalitiesListQuery = {
  __typename?: 'Query'
  municipalities: Array<{
    __typename?: 'Municipality'
    id: string
    name: string
    normalizedName?: string | null
  }>
}

export type OnboardBrokerMutationVariables = Exact<{
  input: OnboardBrokerInput
}>

export type OnboardBrokerMutation = {
  __typename?: 'Mutation'
  onboardBroker: {
    __typename?: 'OnboardBrokerResult'
    brokerId: string
    agencyId: string
    databaseName: string
    generatedPassword: string
    authUserId: string
    subscriptionId: string
    stepsCompleted: Array<string>
    smokeTest: {
      __typename?: 'OnboardBrokerSmokeTestResult'
      passed: boolean
      propertyCount: number
      error?: string | null
    }
    brokerSite?: {
      __typename?: 'StartBrokerSiteOnboardingResult'
      ok: boolean
      slug: string
      manifestPath: string
      commitSha?: string | null
      commitUrl?: string | null
      workflowActionsUrl: string
      message?: string | null
    } | null
  }
}

export type BrokersWithPaidExtrasQueryVariables = Exact<{ [key: string]: never }>

export type BrokersWithPaidExtrasQuery = {
  __typename?: 'Query'
  brokersWithPaidExtras: Array<{
    __typename?: 'BrokerWithPaidExtras'
    extrasCount: number
    broker: {
      __typename?: 'Broker'
      id: string
      name: string
      email?: string | null
      bannerUrl?: string | null
    }
  }>
}

export type AvailablePaidExtrasQueryVariables = Exact<{ [key: string]: never }>

export type AvailablePaidExtrasQuery = {
  __typename?: 'Query'
  availablePaidExtras: Array<{
    __typename?: 'AvailablePaidExtras'
    type: string
    label?: string | null
    description?: string | null
    defaultPrice: number
    currency: string
  }>
}

export type PaidExtrasByAgencyQueryVariables = Exact<{
  brokerId: Scalars['String']['input']
}>

export type PaidExtrasByAgencyQuery = {
  __typename?: 'Query'
  paidExtrasByAgency: Array<{
    __typename?: 'PaidExtra'
    id: string
    type: string
    description?: string | null
    price?: number | null
    currency: string
    validFrom?: any | null
    validTo?: any | null
    searchPrio: number
  }>
}

export type CreatePaidExtraMutationVariables = Exact<{
  input: CreatePaidExtraInput
}>

export type CreatePaidExtraMutation = {
  __typename?: 'Mutation'
  createPaidExtra: {
    __typename?: 'PaidExtra'
    id: string
    type: string
    description?: string | null
    price?: number | null
    currency: string
    validFrom?: any | null
    validTo?: any | null
    searchPrio: number
  }
}

export type DeletePaidExtraMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeletePaidExtraMutation = { __typename?: 'Mutation'; deletePaidExtra: boolean }

export type GetAvailablePaidExtrasListQueryVariables = Exact<{ [key: string]: never }>

export type GetAvailablePaidExtrasListQuery = {
  __typename?: 'Query'
  availablePaidExtrasWithUsage: Array<{
    __typename?: 'AvailablePaidExtrasWithUsage'
    id: string
    type: string
    defaultPrice: number
    label?: string | null
    currency: string
    description?: string | null
    category?: string | null
    iconUrl?: string | null
    promoBannerUrl?: string | null
    isActive: boolean
    usageCount: number
    createdAt: any
    updatedAt: any
    translations: Array<{
      __typename?: 'TranslationOutput'
      language: string
      description?: string | null
    }>
  }>
}

export type CreateAvailablePaidExtraMutationVariables = Exact<{
  data: CreateAvailablePaidExtrasInput
}>

export type CreateAvailablePaidExtraMutation = {
  __typename?: 'Mutation'
  createAvailablePaidExtra: {
    __typename?: 'AvailablePaidExtras'
    id: string
    type: string
    defaultPrice: number
    label?: string | null
    currency: string
    description?: string | null
    category?: string | null
    iconUrl?: string | null
    promoBannerUrl?: string | null
    isActive: boolean
    createdAt: any
    updatedAt: any
    translations: Array<{
      __typename?: 'AvailablePaidExtrasTranslation'
      language: string
      description?: string | null
    }>
  }
}

export type UpdateAvailablePaidExtraMutationVariables = Exact<{
  id: Scalars['String']['input']
  data: UpdateAvailablePaidExtrasInput
}>

export type UpdateAvailablePaidExtraMutation = {
  __typename?: 'Mutation'
  updateAvailablePaidExtra: {
    __typename?: 'AvailablePaidExtras'
    id: string
    type: string
    defaultPrice: number
    label?: string | null
    currency: string
    description?: string | null
    category?: string | null
    iconUrl?: string | null
    promoBannerUrl?: string | null
    isActive: boolean
    createdAt: any
    updatedAt: any
    translations: Array<{
      __typename?: 'AvailablePaidExtrasTranslation'
      language: string
      description?: string | null
    }>
  }
}

export type DeleteAvailablePaidExtraMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeleteAvailablePaidExtraMutation = {
  __typename?: 'Mutation'
  deleteAvailablePaidExtra: boolean
}

export type FetchPropertyQueryVariables = Exact<{
  selector?: InputMaybe<PropertyWhereInput>
}>

export type FetchPropertyQuery = {
  __typename?: 'Query'
  findFirstPropertyOrThrow?: {
    __typename?: 'Property'
    id: string
    externalId: string
    agencyRef?: string | null
    importedFrom?: string | null
    beds?: number | null
    minBeds?: number | null
    maxBeds?: number | null
    baths?: number | null
    minBaths?: number | null
    maxBaths?: number | null
    refId?: string | null
    slug?: string | null
    hasPool?: boolean | null
    hasParking?: boolean | null
    hasGarden?: boolean | null
    currency?: string | null
    price?: number | null
    priceTo?: number | null
    updatedAt: any
    gpsX?: string | null
    gpsY?: string | null
    locationNeighbourhood?: string | null
    country?: string | null
    virtualTourUrl?: string | null
    videoTour?: string | null
    status?: string | null
    draftStatus?: DraftStatus | null
    draftComment?: string | null
    ownProperty: boolean
    isNewDevelopment: boolean
    cronOpenai?: string | null
    priceHistory: Array<{
      __typename?: 'PriceHistory'
      date?: any | null
      price?: number | null
      priceFrom?: number | null
      priceTo?: number | null
      value?: number | null
    }>
    locationMunicipality?: { __typename?: 'Municipality'; id: string; name: string } | null
    locationProvince?: { __typename?: 'Province'; id: string; name: string } | null
    locationGeoCode?: {
      __typename?: 'LocationGeoCode'
      properties?: {
        __typename?: 'GeoProperties'
        context?: {
          __typename?: 'Context'
          locality?: { __typename?: 'Locality'; name: string } | null
          place?: { __typename?: 'Place'; name: string } | null
          region: { __typename?: 'GeoRegion'; name: string }
        } | null
      } | null
    } | null
    broker?: {
      __typename?: 'Broker'
      id: string
      name: string
      bannerUrl?: string | null
      pictureUrl?: string | null
      slugUrl?: string | null
    } | null
    images?: {
      __typename?: 'Images'
      large: Array<string>
      small: Array<string>
      rotations: Array<number>
    } | null
    imagesAI?: {
      __typename?: 'ImagesAI'
      approved: boolean
      enrichmentStatus?: string | null
      images: Array<{
        __typename?: 'AIImage'
        small: string
        large: string
        rotation?: number | null
        roomLabel: string
      }>
    } | null
    features: Array<{
      __typename?: 'Feature'
      id: string
      category: string
      name: string
      icon?: string | null
      paramName: string
      translation?: string | null
    }>
    location?: {
      __typename?: 'Location'
      id: string
      town?: string | null
      area?: string | null
      municipalityId?: string | null
      municipalityName?: string | null
      province?: string | null
      location?: string | null
    } | null
    propertyType?: {
      __typename?: 'PropertyType'
      id: string
      mainType?: string | null
      subType?: string | null
      translation?: string | null
    } | null
    propertyTypes: Array<{
      __typename?: 'PropertyType'
      id: string
      mainType?: string | null
      subType?: string | null
      translation?: string | null
    }>
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    propertyTitle: Array<{ __typename?: 'PropertyTitle'; language: string; title?: string | null }>
    surfaceArea?: {
      __typename?: 'SurfaceArea'
      built?: number | null
      plot?: number | null
      terrace?: number | null
    } | null
    propertyQuality?: {
      __typename?: 'PropertyQuality'
      condition?: PropertyCondition | null
      renovationQuality?: RenovationQuality | null
      kitchenQuality?: KitchenQuality | null
      bathroomQuality?: BathroomQuality | null
      hasBuiltInStorage?: boolean | null
      hasEnsuiteBathroom?: boolean | null
      hasWalkInCloset?: boolean | null
      structuralIssues?: boolean | null
      lastRenovationYear?: number | null
      maintenanceHistory?: MaintenanceHistory | null
      flooringTypes: Array<FlooringType>
    } | null
    rentalProperties?: {
      __typename?: 'RentalProperties'
      isRent?: boolean | null
      isRentShortterm?: boolean | null
      isRentLongterm?: boolean | null
      rentalPrice?: number | null
      currency?: string | null
      availableFrom?: any | null
      availableTo?: any | null
      securityDeposit?: number | null
      petsAllowed?: boolean | null
      smokingAllowed?: boolean | null
      parkingIncluded?: boolean | null
      storageIncluded?: boolean | null
      pax?: number | null
      maxOccupancy?: number | null
      rentalPricePeriod?: {
        __typename?: 'RentalPeriod'
        name?: string | null
        duration?: number | null
        multiplier?: number | null
      } | null
    } | null
  } | null
}

export type FetchPropertySafeQueryVariables = Exact<{
  selector?: InputMaybe<PropertyWhereInput>
}>

export type FetchPropertySafeQuery = {
  __typename?: 'Query'
  findFirstProperty?: {
    __typename?: 'Property'
    id: string
    refId?: string | null
    price?: number | null
    currency?: string | null
    locationNeighbourhood?: string | null
    images?: { __typename?: 'Images'; small: Array<string>; large: Array<string> } | null
    locationMunicipality?: { __typename?: 'Municipality'; id: string; name: string } | null
    locationProvince?: { __typename?: 'Province'; id: string; name: string } | null
    locationGeoCode?: {
      __typename?: 'LocationGeoCode'
      properties?: {
        __typename?: 'GeoProperties'
        context?: {
          __typename?: 'Context'
          locality?: { __typename?: 'Locality'; name: string } | null
          place?: { __typename?: 'Place'; name: string } | null
          region: { __typename?: 'GeoRegion'; name: string }
        } | null
      } | null
    } | null
    location?: {
      __typename?: 'Location'
      location?: string | null
      area?: string | null
      province?: string | null
      municipalityName?: string | null
    } | null
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      short?: string | null
      text?: string | null
    }>
  } | null
}

export type PropertiesForLocationsGroupQueryVariables = Exact<{
  where?: InputMaybe<PropertyWhereInput>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type PropertiesForLocationsGroupQuery = {
  __typename?: 'Query'
  properties: Array<{
    __typename?: 'Property'
    id: string
    provinceId?: string | null
    municipalityId?: string | null
    locationNeighbourhood?: string | null
    locationProvince?: { __typename?: 'Province'; id: string; name: string } | null
    locationMunicipality?: { __typename?: 'Municipality'; id: string; name: string } | null
  }>
}

export type FetchPropertiesQueryVariables = Exact<{
  where?: InputMaybe<PropertyWhereInput>
  orderBy?: InputMaybe<Array<PropertyOrderByWithRelationInput> | PropertyOrderByWithRelationInput>
  skip?: InputMaybe<Scalars['Int']['input']>
  take?: InputMaybe<Scalars['Int']['input']>
}>

export type FetchPropertiesQuery = {
  __typename?: 'Query'
  properties: Array<{
    __typename?: 'Property'
    id: string
    externalId: string
    agencyRef?: string | null
    refId?: string | null
    slug?: string | null
    status?: string | null
    price?: number | null
    currency?: string | null
    beds?: number | null
    minBeds?: number | null
    maxBeds?: number | null
    baths?: number | null
    minBaths?: number | null
    maxBaths?: number | null
    isNewDevelopment: boolean
    category?: string | null
    draftStatus?: DraftStatus | null
    draftComment?: string | null
    locationNeighbourhood?: string | null
    importedFrom?: string | null
    cronMapbox?: string | null
    cronOpenai?: string | null
    gpsX?: string | null
    gpsY?: string | null
    videoTour?: string | null
    virtualTour?: string | null
    hasPool?: boolean | null
    hasParking?: boolean | null
    hasGarden?: boolean | null
    createdAt: any
    updatedAt: any
    propertyType?: {
      __typename?: 'PropertyType'
      id: string
      mainType?: string | null
      subType?: string | null
      translation?: string | null
    } | null
    propertyTypes: Array<{ __typename?: 'PropertyType'; id: string }>
    locationMunicipality?: { __typename?: 'Municipality'; id: string; name: string } | null
    locationProvince?: { __typename?: 'Province'; id: string; name: string } | null
    locationGeoCode?: {
      __typename?: 'LocationGeoCode'
      properties?: {
        __typename?: 'GeoProperties'
        context?: {
          __typename?: 'Context'
          locality?: { __typename?: 'Locality'; name: string } | null
          place?: { __typename?: 'Place'; name: string } | null
          region: { __typename?: 'GeoRegion'; name: string }
        } | null
      } | null
    } | null
    location?: {
      __typename?: 'Location'
      id: string
      location?: string | null
      area?: string | null
      province?: string | null
      country?: string | null
      municipalityId?: string | null
      municipalityName?: string | null
    } | null
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    images?: { __typename?: 'Images'; large: Array<string>; small: Array<string> } | null
    broker?: {
      __typename?: 'Broker'
      id: string
      name: string
      bannerUrl?: string | null
      pictureUrl?: string | null
    } | null
    features: Array<{ __typename?: 'Feature'; id: string; name: string; category: string }>
    surfaceArea?: {
      __typename?: 'SurfaceArea'
      built?: number | null
      plot?: number | null
      terrace?: number | null
      gardenPlot?: number | null
      intFloorSpace?: number | null
    } | null
    propertyMeta?: {
      __typename?: 'PropertyMeta'
      uniqueVisitors: number
      fetchedTimes: number
    } | null
    rentalProperties?: {
      __typename?: 'RentalProperties'
      isRent?: boolean | null
      isRentShortterm?: boolean | null
      isRentLongterm?: boolean | null
      rentalPrice?: number | null
      currency?: string | null
    } | null
    leads: Array<{ __typename?: 'Lead'; id: string }>
  }>
}

export type UpdatePropertyMutationVariables = Exact<{
  where: PropertyWhereUniqueInput
  data: PropertyUpdateInput
}>

export type UpdatePropertyMutation = {
  __typename?: 'Mutation'
  updateProperty: {
    __typename?: 'Property'
    id: string
    externalId: string
    agencyRef?: string | null
    status?: string | null
    price?: number | null
    currency?: string | null
    updatedAt: any
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      short?: string | null
      text?: string | null
    }>
    images?: { __typename?: 'Images'; small: Array<string>; large: Array<string> } | null
    propertyMeta?: {
      __typename?: 'PropertyMeta'
      fetchedTimes: number
      uniqueVisitors: number
    } | null
  }
}

export type CreatePropertyMutationVariables = Exact<{
  data: PropertyCreateInput
}>

export type CreatePropertyMutation = {
  __typename?: 'Mutation'
  createProperty: {
    __typename?: 'Property'
    id: string
    externalId: string
    agencyRef?: string | null
    status?: string | null
    price?: number | null
    currency?: string | null
    createdAt: any
  }
}

export type DeletePropertyMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeletePropertyMutation = {
  __typename?: 'Mutation'
  deleteProperty: { __typename?: 'Property'; id: string }
}

export type DeleteMultiplePropertiesMutationVariables = Exact<{
  propertyIds: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type DeleteMultiplePropertiesMutation = {
  __typename?: 'Mutation'
  deleteMultipleProperties: Array<{ __typename?: 'Property'; id: string }>
}

export type TransferPropertyMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
  targetAgencyId: Scalars['String']['input']
  sourceAgencyId?: InputMaybe<Scalars['String']['input']>
}>

export type TransferPropertyMutation = {
  __typename?: 'Mutation'
  transferProperty: {
    __typename?: 'Property'
    id: string
    externalId: string
    refId?: string | null
    broker?: { __typename?: 'Broker'; id: string; name: string; agencyId?: string | null } | null
  }
}

export type TransferMultiplePropertiesMutationVariables = Exact<{
  propertyIds: Array<Scalars['String']['input']> | Scalars['String']['input']
  targetAgencyId: Scalars['String']['input']
  sourceAgencyId?: InputMaybe<Scalars['String']['input']>
}>

export type TransferMultiplePropertiesMutation = {
  __typename?: 'Mutation'
  transferMultipleProperties: Array<{
    __typename?: 'Property'
    id: string
    externalId: string
    refId?: string | null
    broker?: { __typename?: 'Broker'; id: string; name: string; agencyId?: string | null } | null
  }>
}

export type CountPropertiesQueryVariables = Exact<{
  where?: InputMaybe<PropertyWhereInput>
}>

export type CountPropertiesQuery = {
  __typename?: 'Query'
  aggregateProperty: {
    __typename?: 'AggregateProperty'
    _count?: { __typename?: 'PropertyCountAggregate'; _all: number } | null
  }
}

export type PropertyTypesQueryVariables = Exact<{ [key: string]: never }>

export type PropertyTypesQuery = {
  __typename?: 'Query'
  propertyTypes: Array<{
    __typename?: 'PropertyType'
    id: string
    mainType?: string | null
    subType?: string | null
    translation?: string | null
    externalId: string
  }>
}

export type FeaturesQueryVariables = Exact<{ [key: string]: never }>

export type FeaturesQuery = {
  __typename?: 'Query'
  features: Array<{
    __typename?: 'Feature'
    id: string
    name: string
    category: string
    icon?: string | null
  }>
}

export type SearchLocationsQueryVariables = Exact<{
  query: Scalars['String']['input']
  limit?: InputMaybe<Scalars['Int']['input']>
}>

export type SearchLocationsQuery = {
  __typename?: 'Query'
  searchLocationsByQuery: {
    __typename?: 'ValidatedLocationResponse'
    locations?: Array<{
      __typename?: 'LocationSuggestion'
      id: string
      label: string
      location?: string | null
      area?: string | null
      province?: string | null
      country?: string | null
    }> | null
  }
}

export type AllPropertyCardAdsQueryVariables = Exact<{ [key: string]: never }>

export type AllPropertyCardAdsQuery = {
  __typename?: 'Query'
  allPropertyCardAds: Array<{
    __typename?: 'PropertyCardAd'
    id: string
    brokerId?: string | null
    title: string
    subtitle?: string | null
    callToAction?: string | null
    price?: number | null
    currency?: string | null
    beds?: number | null
    baths?: number | null
    surfaceArea?: number | null
    propertyType?: string | null
    gpsX?: string | null
    gpsY?: string | null
    locationDisplay?: string | null
    locationOnly: boolean
    maxDistance?: number | null
    isActive: boolean
    priority: number
    adType?: string | null
    presentAtPosition?: number | null
    validFrom?: any | null
    validTo?: any | null
    targetUrl?: string | null
    href?: string | null
    language?: string | null
    advertiserId?: string | null
    impressions: number
    clicks: number
    createdAt: any
    updatedAt: any
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    images?: { __typename?: 'AdImages'; small: Array<string>; large: Array<string> } | null
    advertiser?: {
      __typename?: 'Advertiser'
      id: string
      name: string
      website?: string | null
      contact?: string | null
      type: string
    } | null
  }>
}

export type PropertyCardAdQueryVariables = Exact<{
  id: Scalars['String']['input']
}>

export type PropertyCardAdQuery = {
  __typename?: 'Query'
  propertyCardAd?: {
    __typename?: 'PropertyCardAd'
    id: string
    brokerId?: string | null
    title: string
    subtitle?: string | null
    callToAction?: string | null
    price?: number | null
    currency?: string | null
    beds?: number | null
    baths?: number | null
    surfaceArea?: number | null
    propertyType?: string | null
    gpsX?: string | null
    gpsY?: string | null
    locationDisplay?: string | null
    locationOnly: boolean
    maxDistance?: number | null
    isActive: boolean
    priority: number
    adType?: string | null
    presentAtPosition?: number | null
    validFrom?: any | null
    validTo?: any | null
    targetUrl?: string | null
    href?: string | null
    language?: string | null
    advertiserId?: string | null
    impressions: number
    clicks: number
    createdAt: any
    updatedAt: any
    descriptions: Array<{
      __typename?: 'Description'
      language: string
      text?: string | null
      short?: string | null
    }>
    images?: { __typename?: 'AdImages'; small: Array<string>; large: Array<string> } | null
    advertiser?: {
      __typename?: 'Advertiser'
      id: string
      name: string
      website?: string | null
      contact?: string | null
      type: string
    } | null
  } | null
}

export type CreatePropertyCardAdMutationVariables = Exact<{
  data: PropertyCardAdInput
}>

export type CreatePropertyCardAdMutation = {
  __typename?: 'Mutation'
  createPropertyCardAd: {
    __typename?: 'PropertyCardAd'
    id: string
    brokerId?: string | null
    title: string
    subtitle?: string | null
    callToAction?: string | null
    isActive: boolean
    priority: number
    adType?: string | null
    presentAtPosition?: number | null
    createdAt: any
  }
}

export type UpdatePropertyCardAdMutationVariables = Exact<{
  id: Scalars['String']['input']
  data: PropertyCardAdUpdateInput
}>

export type UpdatePropertyCardAdMutation = {
  __typename?: 'Mutation'
  updatePropertyCardAd: {
    __typename?: 'PropertyCardAd'
    id: string
    brokerId?: string | null
    title: string
    subtitle?: string | null
    callToAction?: string | null
    isActive: boolean
    priority: number
    adType?: string | null
    presentAtPosition?: number | null
    updatedAt: any
  }
}

export type DeletePropertyCardAdMutationVariables = Exact<{
  id: Scalars['String']['input']
}>

export type DeletePropertyCardAdMutation = {
  __typename?: 'Mutation'
  deletePropertyCardAd: boolean
}

export type RecordAdImpressionMutationVariables = Exact<{
  adId: Scalars['String']['input']
}>

export type RecordAdImpressionMutation = { __typename?: 'Mutation'; recordAdImpression: boolean }

export type RecordAdClickMutationVariables = Exact<{
  adId: Scalars['String']['input']
}>

export type RecordAdClickMutation = { __typename?: 'Mutation'; recordAdClick: boolean }

export type AllAdvertisersQueryVariables = Exact<{ [key: string]: never }>

export type AllAdvertisersQuery = {
  __typename?: 'Query'
  allAdvertisers: Array<{
    __typename?: 'Advertiser'
    id: string
    name: string
    website?: string | null
    contact?: string | null
    type: string
    _count?: { __typename?: 'AdvertiserCount'; propertyCardAds: number } | null
  }>
}

export type CreateAdvertiserMutationVariables = Exact<{
  data: AdvertiserInput
}>

export type CreateAdvertiserMutation = {
  __typename?: 'Mutation'
  createAdvertiser: {
    __typename?: 'Advertiser'
    id: string
    name: string
    website?: string | null
    contact?: string | null
    type: string
  }
}

export type PropertyImagesAiPreviewQueryVariables = Exact<{
  selector: PropertyWhereInput
}>

export type PropertyImagesAiPreviewQuery = {
  __typename?: 'Query'
  findFirstPropertyOrThrow?: {
    __typename?: 'Property'
    id: string
    images?: { __typename?: 'Images'; large: Array<string>; rotations: Array<number> } | null
    imagesAI?: {
      __typename?: 'ImagesAI'
      approved: boolean
      enrichmentStatus?: string | null
      images: Array<{
        __typename?: 'AIImage'
        small: string
        large: string
        rotation?: number | null
        roomLabel: string
        roomDescription: string
      }>
    } | null
  } | null
}

export type PropertyImageEnrichmentStatusQueryVariables = Exact<{
  propertyId: Scalars['String']['input']
}>

export type PropertyImageEnrichmentStatusQuery = {
  __typename?: 'Query'
  propertyImageEnrichmentStatus: {
    __typename?: 'PropertyImageEnrichmentStatus'
    status: string
    approved: boolean
    imageCount: number
    hasActivePaidExtra: boolean
    enrichmentStatus?: string | null
  }
}

export type TriggerPropertyImageEnrichmentMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
}>

export type TriggerPropertyImageEnrichmentMutation = {
  __typename?: 'Mutation'
  triggerPropertyImageEnrichment: {
    __typename?: 'PropertyImageEnrichmentStatus'
    status: string
    approved: boolean
    imageCount: number
    hasActivePaidExtra: boolean
    enrichmentStatus?: string | null
  }
}

export type ApprovePropertyImagesAiMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
  createPaidExtra?: InputMaybe<Scalars['Boolean']['input']>
}>

export type ApprovePropertyImagesAiMutation = {
  __typename?: 'Mutation'
  approvePropertyImagesAI: {
    __typename?: 'Property'
    id: string
    imagesAI?: {
      __typename?: 'ImagesAI'
      approved: boolean
      enrichmentStatus?: string | null
      images: Array<{
        __typename?: 'AIImage'
        small: string
        large: string
        rotation?: number | null
        roomLabel: string
        roomDescription: string
      }>
    } | null
  }
}

export type UpdatePropertyImagesAiRoomLabelsMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
  updates: Array<PropertyImageRoomLabelUpdateInput> | PropertyImageRoomLabelUpdateInput
}>

export type UpdatePropertyImagesAiRoomLabelsMutation = {
  __typename?: 'Mutation'
  updatePropertyImagesAIRoomLabels: {
    __typename?: 'Property'
    id: string
    imagesAI?: {
      __typename?: 'ImagesAI'
      images: Array<{
        __typename?: 'AIImage'
        roomLabel: string
        roomLabelConfirmed?: boolean | null
      }>
    } | null
  }
}

export type UpdatePropertyImagesAiGalleryMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
  images: Array<PropertyImagesAiGalleryItemInput> | PropertyImagesAiGalleryItemInput
}>

export type UpdatePropertyImagesAiGalleryMutation = {
  __typename?: 'Mutation'
  updatePropertyImagesAIGallery: {
    __typename?: 'Property'
    id: string
    imagesAI?: {
      __typename?: 'ImagesAI'
      images: Array<{
        __typename?: 'AIImage'
        small: string
        large: string
        rotation?: number | null
        roomLabel: string
        roomDescription: string
      }>
    } | null
  }
}

export type PropertyImageRoomLabelOptionsQueryVariables = Exact<{ [key: string]: never }>

export type PropertyImageRoomLabelOptionsQuery = {
  __typename?: 'Query'
  propertyImageRoomLabelOptions: Array<string>
}

export type TriggerOpenAiDescriptionsRerunMutationVariables = Exact<{
  propertyId: Scalars['String']['input']
}>

export type TriggerOpenAiDescriptionsRerunMutation = {
  __typename?: 'Mutation'
  triggerOpenAiDescriptionsRerun: {
    __typename?: 'OpenAiDescriptionsRerunResult'
    externalId: string
    resetAiMeta: boolean
    cronStatusCleared: boolean
    cacheCleared: boolean
    descriptionsStoreCleared: boolean
    queuedImmediately: boolean
    jobId?: string | null
    message: string
  }
}

export type PropertyReportsQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>
  limit?: InputMaybe<Scalars['Float']['input']>
  skip?: InputMaybe<Scalars['Float']['input']>
}>

export type PropertyReportsQuery = {
  __typename?: 'Query'
  propertyReports: Array<{
    __typename?: 'PropertyReport'
    id: string
    propertyId: string
    reportReason: ReportReason
    email: string
    description?: string | null
    status: string
    createdAt: any
    updatedAt: any
    property: {
      __typename?: 'Property'
      id: string
      refId?: string | null
      externalId: string
      status?: string | null
      broker?: { __typename?: 'Broker'; id: string; name: string; bannerUrl?: string | null } | null
      propertyType?: {
        __typename?: 'PropertyType'
        translation?: string | null
        mainType?: string | null
      } | null
      location?: {
        __typename?: 'Location'
        location?: string | null
        area?: string | null
        town?: string | null
      } | null
    }
  }>
}

export type PropertyReportsCountQueryVariables = Exact<{
  status?: InputMaybe<Scalars['String']['input']>
}>

export type PropertyReportsCountQuery = { __typename?: 'Query'; propertyReportsCount: number }

export type UpdatePropertyReportStatusMutationVariables = Exact<{
  reportId: Scalars['String']['input']
  status: Scalars['String']['input']
}>

export type UpdatePropertyReportStatusMutation = {
  __typename?: 'Mutation'
  updatePropertyReportStatus: {
    __typename?: 'PropertyReport'
    id: string
    status: string
    updatedAt: any
  }
}

export type ListRolesQueryVariables = Exact<{ [key: string]: never }>

export type ListRolesQuery = {
  __typename?: 'Query'
  listRoles: Array<{
    __typename?: 'RoleModel'
    id: string
    name: string
    description?: string | null
    permissions: Array<string>
    createdAt: any
    updatedAt: any
    isPredefined: boolean
  }>
}

export type GetRoleQueryVariables = Exact<{
  roleId: Scalars['String']['input']
}>

export type GetRoleQuery = {
  __typename?: 'Query'
  getRole?: {
    __typename?: 'RoleModel'
    id: string
    name: string
    description?: string | null
    permissions: Array<string>
    createdAt: any
    updatedAt: any
    isPredefined: boolean
  } | null
}

export type CreateRoleMutationVariables = Exact<{
  input: CreateRoleInput
}>

export type CreateRoleMutation = {
  __typename?: 'Mutation'
  createRole: {
    __typename?: 'RoleModel'
    id: string
    name: string
    description?: string | null
    permissions: Array<string>
    createdAt: any
    updatedAt: any
    isPredefined: boolean
  }
}

export type UpdateRoleMutationVariables = Exact<{
  roleId: Scalars['String']['input']
  input: UpdateRoleInput
}>

export type UpdateRoleMutation = {
  __typename?: 'Mutation'
  updateRole: {
    __typename?: 'RoleModel'
    id: string
    name: string
    description?: string | null
    permissions: Array<string>
    createdAt: any
    updatedAt: any
    isPredefined: boolean
  }
}

export type DeleteRoleMutationVariables = Exact<{
  roleId: Scalars['String']['input']
}>

export type DeleteRoleMutation = { __typename?: 'Mutation'; deleteRole: boolean }

export type AssignPermissionToRoleMutationVariables = Exact<{
  roleId: Scalars['String']['input']
  permissionId: Scalars['String']['input']
}>

export type AssignPermissionToRoleMutation = {
  __typename?: 'Mutation'
  assignPermissionToRole: boolean
}

export type RemovePermissionFromRoleMutationVariables = Exact<{
  roleId: Scalars['String']['input']
  permissionId: Scalars['String']['input']
}>

export type RemovePermissionFromRoleMutation = {
  __typename?: 'Mutation'
  removePermissionFromRole: boolean
}

export type GetRolePermissionsQueryVariables = Exact<{
  roleId: Scalars['String']['input']
}>

export type GetRolePermissionsQuery = {
  __typename?: 'Query'
  getRolePermissions: Array<{
    __typename?: 'PermissionModel'
    id: string
    name: string
    description?: string | null
    category?: string | null
    isPredefined: boolean
    createdAt: any
    updatedAt: any
  }>
}

export type ListPermissionsQueryVariables = Exact<{ [key: string]: never }>

export type ListPermissionsQuery = {
  __typename?: 'Query'
  listPermissions: Array<{
    __typename?: 'PermissionModel'
    id: string
    name: string
    description?: string | null
    category?: string | null
    isPredefined: boolean
    createdAt: any
    updatedAt: any
  }>
}

export type GetPermissionQueryVariables = Exact<{
  permissionId: Scalars['String']['input']
}>

export type GetPermissionQuery = {
  __typename?: 'Query'
  getPermission?: {
    __typename?: 'PermissionModel'
    id: string
    name: string
    description?: string | null
    category?: string | null
    isPredefined: boolean
    createdAt: any
    updatedAt: any
  } | null
}

export type CreatePermissionMutationVariables = Exact<{
  input: CreatePermissionInput
}>

export type CreatePermissionMutation = {
  __typename?: 'Mutation'
  createPermission: {
    __typename?: 'PermissionModel'
    id: string
    name: string
    description?: string | null
    category?: string | null
    isPredefined: boolean
    createdAt: any
    updatedAt: any
  }
}

export type UpdatePermissionMutationVariables = Exact<{
  permissionId: Scalars['String']['input']
  input: UpdatePermissionInput
}>

export type UpdatePermissionMutation = {
  __typename?: 'Mutation'
  updatePermission: {
    __typename?: 'PermissionModel'
    id: string
    name: string
    description?: string | null
    category?: string | null
    isPredefined: boolean
    createdAt: any
    updatedAt: any
  }
}

export type DeletePermissionMutationVariables = Exact<{
  permissionId: Scalars['String']['input']
}>

export type DeletePermissionMutation = { __typename?: 'Mutation'; deletePermission: boolean }

export type SubscriptionPackageOptionsQueryVariables = Exact<{ [key: string]: never }>

export type SubscriptionPackageOptionsQuery = {
  __typename?: 'Query'
  subscriptionPackageOptions: Array<{
    __typename?: 'SubscriptionPackageOption'
    plan: string
    name: string
    defaultSlotCount: number
    defaultSlotCountAgency: number
    defaultPriceEur: number
    customPricing: boolean
  }>
}

export type SubscriptionsQueryVariables = Exact<{
  where?: InputMaybe<SubscriptionWhereInput>
  orderBy?: InputMaybe<
    Array<SubscriptionOrderByWithRelationInput> | SubscriptionOrderByWithRelationInput
  >
}>

export type SubscriptionsQuery = {
  __typename?: 'Query'
  subscriptions: Array<{
    __typename?: 'Subscription'
    id: string
    brokerId: string
    plan: string
    status: string
    paymentStatus: string
    startDate: any
    endDate?: any | null
    slotCount: number
    usedSlots: number
    slotsActive: boolean
    slotCountAgency: number
    usedSlotsAgency: number
    slotsActiveAgency: boolean
    price: number
    currency: string
    discountPercentage: number
    discountEndDate?: any | null
    paymentMethod?: string | null
    paymentReference?: string | null
    paymentDate?: any | null
    autoRenew: boolean
    createdAt: any
    updatedAt: any
    broker: {
      __typename?: 'Broker'
      id: string
      name: string
      email?: string | null
      bannerUrl?: string | null
    }
  }>
}

export type SubscriptionStatsQueryVariables = Exact<{ [key: string]: never }>

export type SubscriptionStatsQuery = {
  __typename?: 'Query'
  subscriptions: Array<{
    __typename?: 'Subscription'
    id: string
    brokerId: string
    plan: string
    status: string
    paymentStatus: string
    startDate: any
    endDate?: any | null
    price: number
    currency: string
    discountPercentage: number
    slotCount: number
    usedSlots: number
    slotsActive: boolean
    slotCountAgency: number
    usedSlotsAgency: number
    slotsActiveAgency: boolean
    createdAt: any
    updatedAt: any
    broker: {
      __typename?: 'Broker'
      id: string
      name: string
      email?: string | null
      bannerUrl?: string | null
    }
  }>
}

export type SubscriptionQueryVariables = Exact<{
  where: SubscriptionWhereUniqueInput
}>

export type SubscriptionQuery = {
  __typename?: 'Query'
  subscription?: {
    __typename?: 'Subscription'
    id: string
    brokerId: string
    plan: string
    status: string
    paymentStatus: string
    startDate: any
    endDate?: any | null
    slotCount: number
    usedSlots: number
    slotsActive: boolean
    slotCountAgency: number
    usedSlotsAgency: number
    slotsActiveAgency: boolean
    price: number
    currency: string
    discountPercentage: number
    discountEndDate?: any | null
    paymentMethod?: string | null
    paymentReference?: string | null
    paymentDate?: any | null
    autoRenew: boolean
    createdAt: any
    updatedAt: any
  } | null
}

export type GetAgenciesForSubscriptionsQueryVariables = Exact<{ [key: string]: never }>

export type GetAgenciesForSubscriptionsQuery = {
  __typename?: 'Query'
  getAgencies?: Array<{
    __typename?: 'Broker'
    id: string
    name: string
    email?: string | null
    bannerUrl?: string | null
  }> | null
}

export type CreateSubscriptionMutationVariables = Exact<{
  data: CreateSubscriptionInput
}>

export type CreateSubscriptionMutation = {
  __typename?: 'Mutation'
  createSubscription: {
    __typename?: 'Subscription'
    id: string
    brokerId: string
    plan: string
    status: string
    paymentStatus: string
    startDate: any
    endDate?: any | null
    slotCount: number
    usedSlots: number
    slotsActive: boolean
    slotCountAgency: number
    usedSlotsAgency: number
    slotsActiveAgency: boolean
    price: number
    currency: string
  }
}

export type UpdateSubscriptionMutationVariables = Exact<{
  id: Scalars['String']['input']
  data: UpdateSubscriptionInput
}>

export type UpdateSubscriptionMutation = {
  __typename?: 'Mutation'
  updateSubscription: {
    __typename?: 'Subscription'
    id: string
    brokerId: string
    plan: string
    status: string
    paymentStatus: string
    startDate: any
    endDate?: any | null
    slotCount: number
    usedSlots: number
    slotsActive: boolean
    slotCountAgency: number
    usedSlotsAgency: number
    slotsActiveAgency: boolean
    price: number
    currency: string
    paymentDate?: any | null
    autoRenew: boolean
    updatedAt: any
  }
}

export type DeleteOneSubscriptionMutationVariables = Exact<{
  where: SubscriptionWhereUniqueInput
}>

export type DeleteOneSubscriptionMutation = {
  __typename?: 'Mutation'
  deleteOneSubscription?: { __typename?: 'Subscription'; id: string } | null
}

export type UpsertAgencySubscriptionMutationVariables = Exact<{
  input: UpsertSubscriptionInput
}>

export type UpsertAgencySubscriptionMutation = {
  __typename?: 'Mutation'
  upsertAgencySubscription: boolean
}

export type ListAllUsersQueryVariables = Exact<{
  filters?: InputMaybe<UserFilters>
  sort?: InputMaybe<SortOptions>
  pagination?: InputMaybe<PaginationOptions>
}>

export type ListAllUsersQuery = {
  __typename?: 'Query'
  listUsers: {
    __typename?: 'PaginatedUsersResponse'
    totalUsers: number
    currentPage: number
    totalPages: number
    hasNextPage: boolean
    hasPreviousPage: boolean
    users: Array<{
      __typename?: 'AdminUserModel'
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      roles: Array<string>
      agencyId?: string | null
      createdAt: any
      updatedAt: any
      lastLogin?: any | null
      deletedAt?: any | null
      active: boolean
      userPermissions?: Array<{
        __typename?: 'UserPermissionModel'
        id: string
        userId: string
        permissionId: string
        grantedAt: any
        grantedBy: string
        expiresAt?: any | null
        permission: {
          __typename?: 'PermissionModel'
          id: string
          name: string
          description?: string | null
          category?: string | null
          isPredefined: boolean
          createdAt: any
          updatedAt: any
        }
      }> | null
      userAgencies?: Array<{
        __typename?: 'AdminUserAgencyAssocModel'
        agencyId: string
        agencyName?: string | null
        userType: string
        createdAt: any
        updatedAt: any
      }> | null
    }>
  }
}

export type ListAllUsersAgentsQueryVariables = Exact<{ [key: string]: never }>

export type ListAllUsersAgentsQuery = {
  __typename?: 'Query'
  listAllAgents: Array<{
    __typename?: 'AgentModel'
    userId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    picUrl?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    agency?: {
      __typename?: 'Broker'
      id: string
      name: string
      descriptions: Array<{ __typename?: 'Description'; text?: string | null; language: string }>
    } | null
  }>
}

export type GetAgentByEmailQueryVariables = Exact<{
  email: Scalars['String']['input']
}>

export type GetAgentByEmailQuery = {
  __typename?: 'Query'
  agentByEmail?: {
    __typename?: 'AgentModel'
    userId: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    picUrl?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
  } | null
}

export type GetUserQueryVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type GetUserQuery = {
  __typename?: 'Query'
  getUser?: {
    __typename?: 'AdminUserModel'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    agencyId?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    active: boolean
    userPermissions?: Array<{
      __typename?: 'UserPermissionModel'
      id: string
      userId: string
      permissionId: string
      grantedAt: any
      grantedBy: string
      expiresAt?: any | null
      permission: {
        __typename?: 'PermissionModel'
        id: string
        name: string
        description?: string | null
        category?: string | null
        isPredefined: boolean
        createdAt: any
        updatedAt: any
      }
    }> | null
    userAgencies?: Array<{
      __typename?: 'AdminUserAgencyAssocModel'
      agencyId: string
      agencyName?: string | null
      userType: string
      createdAt: any
      updatedAt: any
    }> | null
    loginHistory?: Array<{
      __typename?: 'LoginHistoryModel'
      id: string
      userId: string
      ipAddress: string
      deviceInfo?: string | null
      userAgent?: string | null
      successful: boolean
      createdAt: any
    }> | null
  } | null
}

export type AddAgentMutationVariables = Exact<{
  input: SignupInput
}>

export type AddAgentMutation = {
  __typename?: 'Mutation'
  addAgent: {
    __typename?: 'AgentSignupResult'
    success: boolean
    message?: string | null
    agent: {
      __typename?: 'AgentModel'
      userId: string
      email: string
      firstName?: string | null
      lastName?: string | null
      roles: Array<string>
      picUrl?: string | null
      createdAt: any
      updatedAt: any
      lastLogin?: any | null
      deletedAt?: any | null
    }
  }
}

export type CreateUserMutationVariables = Exact<{
  input: CreateUserInput
}>

export type CreateUserMutation = {
  __typename?: 'Mutation'
  createUser: {
    __typename?: 'AdminUserModel'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    agencyId?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    active: boolean
  }
}

export type UpdateAgentMutationVariables = Exact<{
  agentId: Scalars['String']['input']
  input: SignupInput
}>

export type UpdateAgentMutation = { __typename?: 'Mutation'; updateAgent: boolean }

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['String']['input']
  input: UpdateUserInput
}>

export type UpdateUserMutation = {
  __typename?: 'Mutation'
  updateUser: {
    __typename?: 'AdminUserModel'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    agencyId?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    active: boolean
  }
}

export type RemoveAgentMutationVariables = Exact<{
  agentId: Scalars['String']['input']
}>

export type RemoveAgentMutation = { __typename?: 'Mutation'; removeAgent: boolean }

export type DeleteUserMutationVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type DeleteUserMutation = { __typename?: 'Mutation'; deleteUser: boolean }

export type ResetUserPasswordMutationVariables = Exact<{
  userId: Scalars['String']['input']
}>

export type ResetUserPasswordMutation = {
  __typename?: 'Mutation'
  resetUserPassword: {
    __typename?: 'PasswordResetResponse'
    success: boolean
    message: string
    email?: string | null
    method?: string | null
  }
}

export type BulkDeleteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input']
}>

export type BulkDeleteUsersMutation = {
  __typename?: 'Mutation'
  bulkDeleteUsers: {
    __typename?: 'BulkOperationResult'
    success: boolean
    message: string
    processedIds?: Array<string> | null
    failedIds?: Array<string> | null
  }
}

export type SearchUsersQueryVariables = Exact<{
  query: Scalars['String']['input']
}>

export type SearchUsersQuery = {
  __typename?: 'Query'
  searchUsers: Array<{
    __typename?: 'AdminUserModel'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    agencyId?: string | null
    createdAt: any
    updatedAt: any
    lastLogin?: any | null
    deletedAt?: any | null
    active: boolean
  }>
}

export type AdminLoginMutationVariables = Exact<{
  input: LoginInput
}>

export type AdminLoginMutation = {
  __typename?: 'Mutation'
  adminLogin: {
    __typename?: 'AdminLoginResponse'
    accessToken: string
    user: {
      __typename?: 'AdminUserModel'
      id: string
      email: string
      firstName?: string | null
      lastName?: string | null
      roles: Array<string>
      agencyId?: string | null
      createdAt: any
      updatedAt: any
    }
  }
}

export type AdminMeQueryVariables = Exact<{ [key: string]: never }>

export type AdminMeQuery = {
  __typename?: 'Query'
  adminMe?: {
    __typename?: 'AdminUserModel'
    id: string
    email: string
    firstName?: string | null
    lastName?: string | null
    roles: Array<string>
    agencyId?: string | null
    createdAt: any
    updatedAt: any
  } | null
}

export type AssignAgencyRoleMutationVariables = Exact<{
  userId: Scalars['String']['input']
  role: Scalars['String']['input']
  agencyId: Scalars['String']['input']
}>

export type AssignAgencyRoleMutation = { __typename?: 'Mutation'; assignAgencyRole: boolean }

export type RemoveAgencyRoleMutationVariables = Exact<{
  userId: Scalars['String']['input']
  role: Scalars['String']['input']
}>

export type RemoveAgencyRoleMutation = { __typename?: 'Mutation'; removeAgencyRole: boolean }

export const GetAgenciesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAgencies' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAgencies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contactInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whatsapp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'county' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'services' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerLeadContactMauticId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgenciesQuery, GetAgenciesQueryVariables>
export const UpsertBrokerLeadContactMauticDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertBrokerLeadContactMautic' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpsertBrokerLeadContactMauticInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertBrokerLeadContactMautic' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerLeadContactMauticId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertBrokerLeadContactMauticMutation,
  UpsertBrokerLeadContactMauticMutationVariables
>
export const BrokerLeadContactMauticPreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BrokerLeadContactMauticPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brokerLeadContactMauticPreview' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brokerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mauticContactId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayLabel' } },
                { kind: 'Field', name: { kind: 'Name', value: 'error' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  BrokerLeadContactMauticPreviewQuery,
  BrokerLeadContactMauticPreviewQueryVariables
>
export const GetAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contactInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whatsapp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'county' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'services' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureIds' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerLeadContactMauticId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgencyQuery, GetAgencyQueryVariables>
export const ListAllAgenciesAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAllAgenciesAgents' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAllAgents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'contactInfo' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'userIds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListAllAgenciesAgentsQuery, ListAllAgenciesAgentsQueryVariables>
export const CreateAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateAgencyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contactInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whatsapp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'county' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'services' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAgencyMutation, CreateAgencyMutationVariables>
export const UpdateAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateAgencyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'logoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contactInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mobile' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'facebook' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'twitter' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'linkedin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'instagram' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'whatsapp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'x' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'address' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'stateCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'county' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'district' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'street' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'services' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyTypeIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'featureIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAgencyMutation, UpdateAgencyMutationVariables>
export const DeleteAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteAgencyMutation, DeleteAgencyMutationVariables>
export const AssignUserToAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignUserToAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssignUserToAgencyInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignUserToAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignUserToAgencyMutation, AssignUserToAgencyMutationVariables>
export const RemoveUserFromAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveUserFromAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeUserFromAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveUserFromAgencyMutation, RemoveUserFromAgencyMutationVariables>
export const StartBrokerSiteOnboardingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'StartBrokerSiteOnboarding' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'StartBrokerSiteOnboardingInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'startBrokerSiteOnboarding' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'manifestPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commitSha' } },
                { kind: 'Field', name: { kind: 'Name', value: 'commitUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowActionsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  StartBrokerSiteOnboardingMutation,
  StartBrokerSiteOnboardingMutationVariables
>
export const BrokerSitesIndexDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BrokerSitesIndex' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'checkReachability' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brokerSitesIndex' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'checkReachability' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'checkReachability' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'displayName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'sourceWebsiteUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stagingUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'productionUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerOwnedDomain' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locales' } },
                { kind: 'Field', name: { kind: 'Name', value: 'manifestPath' } },
                { kind: 'Field', name: { kind: 'Name', value: 'manifestUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubRepoUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'githubRepoExists' } },
                { kind: 'Field', name: { kind: 'Name', value: 'workflowActionsUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clickupListName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clickupSpaceUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clickupListUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mattermostChannelName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mattermostChannelUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'staging' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reachability' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusCode' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'production' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'reachability' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'statusCode' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrokerSitesIndexQuery, BrokerSitesIndexQueryVariables>
export const DashboardStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'DashboardStats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dashboardStats' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'totalUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'activeUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customerCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalAgencies' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agenciesWithUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalRoles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPermissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recentActivities' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userGrowth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'last7Days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last30Days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last90Days' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agencyDistribution' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'managerCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regularUserCount' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recentActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DashboardStatsQuery, DashboardStatsQueryVariables>
export const AgencyStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AgencyStats' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agencyStats' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'managerCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'userCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'recentLogins' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastActivity' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userGrowth' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'last7Days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last30Days' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'last90Days' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'recentActivity' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AgencyStatsQuery, AgencyStatsQueryVariables>
export const LegacyDashboardStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LegacyDashboardStats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAllAgents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LegacyDashboardStatsQuery, LegacyDashboardStatsQueryVariables>
export const UserActivityDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'UserActivity' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          defaultValue: { kind: 'IntValue', value: '10' },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
      },
    },
  ],
} as unknown as DocumentNode<UserActivityQuery, UserActivityQueryVariables>
export const FetchDuplicatesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FetchDuplicates' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fetchDuplicates' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastEvaluatedKey' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'duplicates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageHash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exactHash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collidedPropertyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'duplicateGroups' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'hash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'items' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'imageHash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'exactHash' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'collidedPropertyId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'checkedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'actualDuplicates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fileName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'imageHash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'exactHash' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'collidedPropertyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'checkedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'count' } },
                { kind: 'Field', name: { kind: 'Name', value: 'actualDuplicateCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'duplicateGroupCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastEvaluatedKey' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasMore' } },
                { kind: 'Field', name: { kind: 'Name', value: 'requestId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchDuplicatesQuery, FetchDuplicatesQueryVariables>
export const LeadsListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadsList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'LeadOrderByWithRelationInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'leadsCount' },
            name: { kind: 'Name', value: 'aggregateLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '_all' } }],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'leads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'country' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_campaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_term' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'property' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'small' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mauticId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'leadSubmittedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mauticStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originallySubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFormName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inboxUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadScoring' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'osintPhoneFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailValid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadNotes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadsListQuery, LeadsListQueryVariables>
export const SearchLeadsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchLeads' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchLeads' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'search' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'search' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'personalData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'country' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_source' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_medium' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_campaign' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'utm_term' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyRef' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'property' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'small' } }],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mauticId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mauticStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originallySubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFormName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'inboxUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadScoring' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'osintPhoneFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailValid' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadNotes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchLeadsQuery, SearchLeadsQueryVariables>
export const LeadScoringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadScoring' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereUniqueInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadScoring' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'osintEmailFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintEmailSites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintGhuntFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintPhoneFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintUsernameFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintUsernameSites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailValid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLeadScoreComputed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintScoreBonus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLeadScoreFinal' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadScoringQuery, LeadScoringQueryVariables>
export const LeadDetailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadDetail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereUniqueInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brokerLeadContactMauticId' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mauticId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadScoring' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'osintEmailFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintEmailSites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintGhuntFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintPhoneFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintUsernameFound' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintUsernameSites' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailValid' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'verifiedEmailStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLeadScoreComputed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'osintScoreBonus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'totalLeadScoreFinal' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mauticFormData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'alias' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mauticMostRecentForm' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'formName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'submittedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'entries' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'question' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'answer' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'mauticStats' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'points' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'tagNames' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastActive' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'emailVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'phoneVerified' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originallySubmittedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'leadSource' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'originalFormName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadCrmInsights' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'marketingConsent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketConsentDate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'marketConsentVersion' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiIntentSummary' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiBuyerStage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiCallReadiness' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiPriority' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiLeadType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiScoreNotes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'aiUnmappedKeys' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'mauticUrl' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadNotes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadDetailQuery, LeadDetailQueryVariables>
export const LeadsGroupByAdminStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadsGroupByAdminStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupByLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'by' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'adminStatus' }] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '_all' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadsGroupByAdminStatusQuery, LeadsGroupByAdminStatusQueryVariables>
export const LeadsByAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadsByAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupByLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'by' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'brokerId' }] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '_all' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadsByAgencyQuery, LeadsByAgencyQueryVariables>
export const LeadsByPropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LeadsByProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groupByLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'by' },
                value: { kind: 'ListValue', values: [{ kind: 'EnumValue', value: 'propertyId' }] },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '_all' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LeadsByPropertyQuery, LeadsByPropertyQueryVariables>
export const UpdateLeadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereUniqueInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'assignedTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLeadMutation, UpdateLeadMutationVariables>
export const DeleteLeadDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteLead' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LeadWhereUniqueInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteLead' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteLeadMutation, DeleteLeadMutationVariables>
export const AddLeadNoteDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddLeadNote' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addLeadNote' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'note' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'note' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leadNotes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddLeadNoteMutation, AddLeadNoteMutationVariables>
export const UpdateLeadListPositionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLeadListPosition' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'listPosition' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLeadListPosition' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'listPosition' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'listPosition' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'listPosition' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateLeadListPositionMutation,
  UpdateLeadListPositionMutationVariables
>
export const AssignLeadToBrokerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignLeadToBroker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignLeadToBroker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brokerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignLeadToBrokerMutation, AssignLeadToBrokerMutationVariables>
export const UpdateLeadStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLeadStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLeadStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>
export const UpdateLeadAdminStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateLeadAdminStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'adminStatus' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateLeadAdminStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adminStatus' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'adminStatus' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adminStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateLeadAdminStatusMutation, UpdateLeadAdminStatusMutationVariables>
export const TriggerLeadScoringDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'TriggerLeadScoring' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerLeadScoring' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TriggerLeadScoringMutation, TriggerLeadScoringMutationVariables>
export const SendBrokerLeadNotificationEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SendBrokerLeadNotificationEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'leadId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'sendBrokerLeadNotificationEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'leadId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'leadId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SendBrokerLeadNotificationEmailMutation,
  SendBrokerLeadNotificationEmailMutationVariables
>
export const MunicipalitiesWithPropertiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'municipalitiesWithProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MunicipalityWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipalities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'properties' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MunicipalitiesWithPropertiesQuery,
  MunicipalitiesWithPropertiesQueryVariables
>
export const LocationsWithGeoDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'locationsWithGeo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'LocationWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'locations' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                { kind: 'Field', name: { kind: 'Name', value: 'town' } },
                { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                { kind: 'Field', name: { kind: 'Name', value: 'municipalityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'municipalityName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provinceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'properties' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LocationsWithGeoQuery, LocationsWithGeoQueryVariables>
export const MunicipalitiesWithLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'municipalitiesWithLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MunicipalityWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipalities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'where' },
                      value: { kind: 'ObjectValue', fields: [] },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'provinceId' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: '_count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'properties' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'locations' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  MunicipalitiesWithLocationsQuery,
  MunicipalitiesWithLocationsQueryVariables
>
export const MunicipalitiesListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'municipalitiesList' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'MunicipalityWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'municipalities' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'normalizedName' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<MunicipalitiesListQuery, MunicipalitiesListQueryVariables>
export const OnboardBrokerDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'OnboardBroker' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'OnboardBrokerInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'onboardBroker' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'databaseName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'generatedPassword' } },
                { kind: 'Field', name: { kind: 'Name', value: 'authUserId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subscriptionId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'stepsCompleted' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'smokeTest' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'passed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyCount' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'error' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'brokerSite' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'ok' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'manifestPath' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commitSha' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'commitUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'workflowActionsUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<OnboardBrokerMutation, OnboardBrokerMutationVariables>
export const BrokersWithPaidExtrasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'BrokersWithPaidExtras' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'brokersWithPaidExtras' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'extrasCount' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BrokersWithPaidExtrasQuery, BrokersWithPaidExtrasQueryVariables>
export const AvailablePaidExtrasDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AvailablePaidExtras' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availablePaidExtras' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AvailablePaidExtrasQuery, AvailablePaidExtrasQueryVariables>
export const PaidExtrasByAgencyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PaidExtrasByAgency' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'paidExtrasByAgency' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'brokerId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'brokerId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'searchPrio' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PaidExtrasByAgencyQuery, PaidExtrasByAgencyQueryVariables>
export const CreatePaidExtraDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePaidExtra' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePaidExtraInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPaidExtra' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'searchPrio' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePaidExtraMutation, CreatePaidExtraMutationVariables>
export const DeletePaidExtraDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePaidExtra' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePaidExtra' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePaidExtraMutation, DeletePaidExtraMutationVariables>
export const GetAvailablePaidExtrasListDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAvailablePaidExtrasList' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'availablePaidExtrasWithUsage' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoBannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'translations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'usageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAvailablePaidExtrasListQuery,
  GetAvailablePaidExtrasListQueryVariables
>
export const CreateAvailablePaidExtraDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateAvailablePaidExtra' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'CreateAvailablePaidExtrasInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAvailablePaidExtra' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoBannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'translations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  CreateAvailablePaidExtraMutation,
  CreateAvailablePaidExtraMutationVariables
>
export const UpdateAvailablePaidExtraDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAvailablePaidExtra' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'UpdateAvailablePaidExtrasInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAvailablePaidExtra' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPrice' } },
                { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'iconUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'promoBannerUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'translations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdateAvailablePaidExtraMutation,
  UpdateAvailablePaidExtraMutationVariables
>
export const DeleteAvailablePaidExtraDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteAvailablePaidExtra' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteAvailablePaidExtra' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteAvailablePaidExtraMutation,
  DeleteAvailablePaidExtraMutationVariables
>
export const FetchPropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findFirstPropertyOrThrow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importedFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minBeds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxBeds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minBaths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxBaths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPool' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasParking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasGarden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priceTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'priceHistory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'date' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceFrom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'priceTo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'value' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsY' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationNeighbourhood' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationMunicipality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationProvince' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationGeoCode' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'properties' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'context' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locality' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'place' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'region' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'slugUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rotations' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imagesAI' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrichmentStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rotation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabel' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'importedFrom' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'paramName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'town' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyTitle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualTourUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'videoTour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surfaceArea' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'built' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'plot' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terrace' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'ownProperty' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNewDevelopment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyQuality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'condition' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'renovationQuality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'kitchenQuality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bathroomQuality' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasBuiltInStorage' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasEnsuiteBathroom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'hasWalkInCloset' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'structuralIssues' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastRenovationYear' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maintenanceHistory' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'flooringTypes' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rentalProperties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isRent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRentShortterm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRentLongterm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rentalPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableFrom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'availableTo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'securityDeposit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'petsAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'smokingAllowed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'parkingIncluded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'storageIncluded' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pax' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'maxOccupancy' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'rentalPricePeriod' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'duration' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'multiplier' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'cronOpenai' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPropertyQuery, FetchPropertyQueryVariables>
export const FetchPropertySafeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchPropertySafe' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'findFirstProperty' },
            name: { kind: 'Name', value: 'findFirstPropertyOrThrow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationNeighbourhood' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationMunicipality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationProvince' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationGeoCode' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'properties' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'context' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locality' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'place' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'region' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPropertySafeQuery, FetchPropertySafeQueryVariables>
export const PropertiesForLocationsGroupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertiesForLocationsGroup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'properties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'provinceId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'municipalityId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationNeighbourhood' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationProvince' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationMunicipality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PropertiesForLocationsGroupQuery,
  PropertiesForLocationsGroupQueryVariables
>
export const FetchPropertiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'fetchProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'PropertyOrderByWithRelationInput' },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'properties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'take' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'take' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minBeds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxBeds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'minBaths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxBaths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isNewDevelopment' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'draftComment' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyType' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'mainType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyTypes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'locationNeighbourhood' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationMunicipality' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationProvince' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locationGeoCode' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'properties' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'context' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'locality' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'place' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'region' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'location' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'municipalityName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'importedFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cronMapbox' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cronOpenai' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pictureUrl' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'features' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'surfaceArea' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'built' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'plot' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'terrace' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'gardenPlot' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'intFloorSpace' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsY' } },
                { kind: 'Field', name: { kind: 'Name', value: 'videoTour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'virtualTour' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPool' } },
                { kind: 'Field', name: { kind: 'Name', value: 'importedFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasParking' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasGarden' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueVisitors' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fetchedTimes' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'rentalProperties' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'isRent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRentShortterm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isRentLongterm' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rentalPrice' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'leads' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FetchPropertiesQuery, FetchPropertiesQueryVariables>
export const UpdatePropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updateProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereUniqueInput' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'propertyMeta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'fetchedTimes' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'uniqueVisitors' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePropertyMutation, UpdatePropertyMutationVariables>
export const CreatePropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyCreateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyRef' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePropertyMutation, CreatePropertyMutationVariables>
export const DeletePropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePropertyMutation, DeletePropertyMutationVariables>
export const DeleteMultiplePropertiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deleteMultipleProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteMultipleProperties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DeleteMultiplePropertiesMutation,
  DeleteMultiplePropertiesMutationVariables
>
export const TransferPropertyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'transferProperty' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetAgencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceAgencyId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetAgencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetAgencyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceAgencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceAgencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TransferPropertyMutation, TransferPropertyMutationVariables>
export const TransferMultiplePropertiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'transferMultipleProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'targetAgencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sourceAgencyId' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'transferMultipleProperties' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyIds' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'targetAgencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'targetAgencyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sourceAgencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sourceAgencyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TransferMultiplePropertiesMutation,
  TransferMultiplePropertiesMutationVariables
>
export const CountPropertiesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'countProperties' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'aggregateProperty' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '_all' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CountPropertiesQuery, CountPropertiesQueryVariables>
export const PropertyTypesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyTypes' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyTypes' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'mainType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyTypesQuery, PropertyTypesQueryVariables>
export const FeaturesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'features' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'features' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'icon' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<FeaturesQuery, FeaturesQueryVariables>
export const SearchLocationsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'searchLocations' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchLocationsByQuery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'locations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'label' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'province' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchLocationsQuery, SearchLocationsQueryVariables>
export const AllPropertyCardAdsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPropertyCardAds' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPropertyCardAds' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surfaceArea' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsY' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationOnly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'presentAtPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'advertiserId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'advertiser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'impressions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clicks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllPropertyCardAdsQuery, AllPropertyCardAdsQueryVariables>
export const PropertyCardAdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyCardAd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyCardAd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'descriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'short' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'beds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'baths' } },
                { kind: 'Field', name: { kind: 'Name', value: 'surfaceArea' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsX' } },
                { kind: 'Field', name: { kind: 'Name', value: 'gpsY' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationDisplay' } },
                { kind: 'Field', name: { kind: 'Name', value: 'locationOnly' } },
                { kind: 'Field', name: { kind: 'Name', value: 'maxDistance' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'presentAtPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validFrom' } },
                { kind: 'Field', name: { kind: 'Name', value: 'validTo' } },
                { kind: 'Field', name: { kind: 'Name', value: 'targetUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'href' } },
                { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                { kind: 'Field', name: { kind: 'Name', value: 'advertiserId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'advertiser' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'impressions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'clicks' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyCardAdQuery, PropertyCardAdQueryVariables>
export const CreatePropertyCardAdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createPropertyCardAd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyCardAdInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPropertyCardAd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'presentAtPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePropertyCardAdMutation, CreatePropertyCardAdMutationVariables>
export const UpdatePropertyCardAdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePropertyCardAd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyCardAdUpdateInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyCardAd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'subtitle' } },
                { kind: 'Field', name: { kind: 'Name', value: 'callToAction' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'priority' } },
                { kind: 'Field', name: { kind: 'Name', value: 'adType' } },
                { kind: 'Field', name: { kind: 'Name', value: 'presentAtPosition' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePropertyCardAdMutation, UpdatePropertyCardAdMutationVariables>
export const DeletePropertyCardAdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'deletePropertyCardAd' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePropertyCardAd' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePropertyCardAdMutation, DeletePropertyCardAdMutationVariables>
export const RecordAdImpressionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'recordAdImpression' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'adId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordAdImpression' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'adId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordAdImpressionMutation, RecordAdImpressionMutationVariables>
export const RecordAdClickDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'recordAdClick' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'adId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'recordAdClick' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'adId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'adId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RecordAdClickMutation, RecordAdClickMutationVariables>
export const AllAdvertisersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allAdvertisers' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allAdvertisers' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: '_count' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'propertyCardAds' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AllAdvertisersQuery, AllAdvertisersQueryVariables>
export const CreateAdvertiserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'createAdvertiser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'AdvertiserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createAdvertiser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'website' } },
                { kind: 'Field', name: { kind: 'Name', value: 'contact' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateAdvertiserMutation, CreateAdvertiserMutationVariables>
export const PropertyImagesAiPreviewDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyImagesAIPreview' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'PropertyWhereInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'findFirstPropertyOrThrow' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'selector' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'images' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'rotations' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imagesAI' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrichmentStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rotation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyImagesAiPreviewQuery, PropertyImagesAiPreviewQueryVariables>
export const PropertyImageEnrichmentStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyImageEnrichmentStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyImageEnrichmentStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasActivePaidExtra' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrichmentStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PropertyImageEnrichmentStatusQuery,
  PropertyImageEnrichmentStatusQueryVariables
>
export const TriggerPropertyImageEnrichmentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'triggerPropertyImageEnrichment' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerPropertyImageEnrichment' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                { kind: 'Field', name: { kind: 'Name', value: 'imageCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasActivePaidExtra' } },
                { kind: 'Field', name: { kind: 'Name', value: 'enrichmentStatus' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TriggerPropertyImageEnrichmentMutation,
  TriggerPropertyImageEnrichmentMutationVariables
>
export const ApprovePropertyImagesAiDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'approvePropertyImagesAI' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'createPaidExtra' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'approvePropertyImagesAI' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'createPaidExtra' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'createPaidExtra' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imagesAI' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'approved' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'enrichmentStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rotation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ApprovePropertyImagesAiMutation,
  ApprovePropertyImagesAiMutationVariables
>
export const UpdatePropertyImagesAiRoomLabelsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePropertyImagesAIRoomLabels' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'updates' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'PropertyImageRoomLabelUpdateInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyImagesAIRoomLabels' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'updates' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'updates' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imagesAI' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabelConfirmed' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePropertyImagesAiRoomLabelsMutation,
  UpdatePropertyImagesAiRoomLabelsMutationVariables
>
export const UpdatePropertyImagesAiGalleryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'updatePropertyImagesAIGallery' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'images' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'PropertyImagesAIGalleryItemInput' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyImagesAIGallery' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'images' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'images' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'imagesAI' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'images' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'small' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'large' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'rotation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomLabel' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'roomDescription' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePropertyImagesAiGalleryMutation,
  UpdatePropertyImagesAiGalleryMutationVariables
>
export const PropertyImageRoomLabelOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'propertyImageRoomLabelOptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'propertyImageRoomLabelOptions' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  PropertyImageRoomLabelOptionsQuery,
  PropertyImageRoomLabelOptionsQueryVariables
>
export const TriggerOpenAiDescriptionsRerunDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'triggerOpenAiDescriptionsRerun' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerOpenAiDescriptionsRerun' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'propertyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'propertyId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'resetAiMeta' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cronStatusCleared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'cacheCleared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'descriptionsStoreCleared' } },
                { kind: 'Field', name: { kind: 'Name', value: 'queuedImmediately' } },
                { kind: 'Field', name: { kind: 'Name', value: 'jobId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  TriggerOpenAiDescriptionsRerunMutation,
  TriggerOpenAiDescriptionsRerunMutationVariables
>
export const PropertyReportsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PropertyReports' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Float' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyReports' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'limit' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'limit' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'skip' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'skip' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'propertyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'reportReason' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'property' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'refId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'broker' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'propertyType' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'translation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'mainType' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'location' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'location' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'area' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'town' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyReportsQuery, PropertyReportsQueryVariables>
export const PropertyReportsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'PropertyReportsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'propertyReportsCount' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PropertyReportsCountQuery, PropertyReportsCountQueryVariables>
export const UpdatePropertyReportStatusDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePropertyReportStatus' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePropertyReportStatus' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'reportId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'reportId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'status' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'status' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpdatePropertyReportStatusMutation,
  UpdatePropertyReportStatusMutationVariables
>
export const ListRolesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListRoles' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listRoles' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListRolesQuery, ListRolesQueryVariables>
export const GetRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRoleQuery, GetRoleQueryVariables>
export const CreateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateRoleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateRoleMutation, CreateRoleMutationVariables>
export const UpdateRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateRoleInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'permissions' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateRoleMutation, UpdateRoleMutationVariables>
export const DeleteRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteRoleMutation, DeleteRoleMutationVariables>
export const AssignPermissionToRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignPermissionToRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignPermissionToRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'permissionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AssignPermissionToRoleMutation,
  AssignPermissionToRoleMutationVariables
>
export const RemovePermissionFromRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemovePermissionFromRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removePermissionFromRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'permissionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  RemovePermissionFromRoleMutation,
  RemovePermissionFromRoleMutationVariables
>
export const GetRolePermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRolePermissions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRolePermissions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'roleId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'roleId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetRolePermissionsQuery, GetRolePermissionsQueryVariables>
export const ListPermissionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListPermissions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listPermissions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListPermissionsQuery, ListPermissionsQueryVariables>
export const GetPermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetPermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getPermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'permissionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetPermissionQuery, GetPermissionQueryVariables>
export const CreatePermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreatePermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreatePermissionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createPermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreatePermissionMutation, CreatePermissionMutationVariables>
export const UpdatePermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdatePermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdatePermissionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updatePermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'permissionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdatePermissionMutation, UpdatePermissionMutationVariables>
export const DeletePermissionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeletePermission' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deletePermission' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'permissionId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'permissionId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeletePermissionMutation, DeletePermissionMutationVariables>
export const SubscriptionPackageOptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubscriptionPackageOptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptionPackageOptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultSlotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultSlotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'defaultPriceEur' } },
                { kind: 'Field', name: { kind: 'Name', value: 'customPricing' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SubscriptionPackageOptionsQuery,
  SubscriptionPackageOptionsQueryVariables
>
export const SubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Subscriptions' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SubscriptionWhereInput' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
          type: {
            kind: 'ListType',
            type: {
              kind: 'NonNullType',
              type: {
                kind: 'NamedType',
                name: { kind: 'Name', value: 'SubscriptionOrderByWithRelationInput' },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'orderBy' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'orderBy' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlotsAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActiveAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentReference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoRenew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionsQuery, SubscriptionsQueryVariables>
export const SubscriptionStatsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SubscriptionStats' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscriptions' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'broker' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlotsAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActiveAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionStatsQuery, SubscriptionStatsQueryVariables>
export const SubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'Subscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubscriptionWhereUniqueInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'subscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlotsAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActiveAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountPercentage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'discountEndDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentMethod' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentReference' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoRenew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SubscriptionQuery, SubscriptionQueryVariables>
export const GetAgenciesForSubscriptionsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAgenciesForSubscriptions' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getAgencies' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'bannerUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GetAgenciesForSubscriptionsQuery,
  GetAgenciesForSubscriptionsQueryVariables
>
export const CreateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlotsAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActiveAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateSubscriptionMutation, CreateSubscriptionMutationVariables>
export const UpdateSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'data' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'data' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'brokerId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'plan' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentStatus' } },
                { kind: 'Field', name: { kind: 'Name', value: 'startDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'endDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCount' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlots' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotCountAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'usedSlotsAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'slotsActiveAgency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'paymentDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'autoRenew' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>
export const DeleteOneSubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteOneSubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SubscriptionWhereUniqueInput' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteOneSubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'where' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteOneSubscriptionMutation, DeleteOneSubscriptionMutationVariables>
export const UpsertAgencySubscriptionDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpsertAgencySubscription' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpsertSubscriptionInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'upsertAgencySubscription' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  UpsertAgencySubscriptionMutation,
  UpsertAgencySubscriptionMutationVariables
>
export const ListAllUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAllUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'UserFilters' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'SortOptions' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PaginationOptions' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'users' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userPermissions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'permissionId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'grantedAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'grantedBy' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'permission' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userAgencies' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'agencyName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'totalUsers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
                { kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListAllUsersQuery, ListAllUsersQueryVariables>
export const ListAllUsersAgentsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ListAllUsersAgents' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'listAllAgents' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agency' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'descriptions' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'text' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'language' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ListAllUsersAgentsQuery, ListAllUsersAgentsQueryVariables>
export const GetAgentByEmailDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetAgentByEmail' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agentByEmail' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'email' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetAgentByEmailQuery, GetAgentByEmailQueryVariables>
export const GetUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userPermissions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'permissionId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grantedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'grantedBy' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'expiresAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'permission' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'category' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'isPredefined' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'userAgencies' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'loginHistory' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceInfo' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'userAgent' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'successful' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>
export const AddAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AddAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SignupInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'addAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'agent' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'userId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'picUrl' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AddAgentMutation, AddAgentMutationVariables>
export const CreateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CreateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'CreateUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'createUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>
export const UpdateAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'SignupInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agentId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateAgentMutation, UpdateAgentMutationVariables>
export const UpdateUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UpdateUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'UpdateUserInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'updateUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>
export const RemoveAgentDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveAgent' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agentId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeAgent' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agentId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agentId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveAgentMutation, RemoveAgentMutationVariables>
export const DeleteUserDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DeleteUser' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'deleteUser' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>
export const ResetUserPasswordDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ResetUserPassword' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'resetUserPassword' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'method' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ResetUserPasswordMutation, ResetUserPasswordMutationVariables>
export const BulkDeleteUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'BulkDeleteUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'bulkDeleteUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userIds' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userIds' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'message' } },
                { kind: 'Field', name: { kind: 'Name', value: 'processedIds' } },
                { kind: 'Field', name: { kind: 'Name', value: 'failedIds' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<BulkDeleteUsersMutation, BulkDeleteUsersMutationVariables>
export const SearchUsersDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'SearchUsers' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'searchUsers' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'query' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'query' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastLogin' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deletedAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>
export const AdminLoginDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AdminLogin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'LoginInput' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminLogin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'user' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'accessToken' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminLoginMutation, AdminLoginMutationVariables>
export const AdminMeDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AdminMe' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'adminMe' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                { kind: 'Field', name: { kind: 'Name', value: 'roles' } },
                { kind: 'Field', name: { kind: 'Name', value: 'agencyId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
                { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AdminMeQuery, AdminMeQueryVariables>
export const AssignAgencyRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignAgencyRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignAgencyRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'agencyId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'agencyId' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignAgencyRoleMutation, AssignAgencyRoleMutationVariables>
export const RemoveAgencyRoleDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'RemoveAgencyRole' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'removeAgencyRole' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'userId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'userId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'role' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'role' } },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<RemoveAgencyRoleMutation, RemoveAgencyRoleMutationVariables>
